
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5zs0K", function(module, exports) {
$parcel$export(module.exports, "EnterpriseContactSalesPage", function () { return $e1f31a069d086db8$export$2202168fcdf44c37; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oLEw");
var $1AtJz = parcelRequire("1AtJz");
const $e1f31a069d086db8$export$2202168fcdf44c37 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1AtJz.EnterpriseContactSalesPageTemplate), {});

});
parcelRegister("1oLEw", function(module, exports) {
$parcel$export(module.exports, "EnterpriseContactSalesPageTemplate", function () { return (parcelRequire("1AtJz")).EnterpriseContactSalesPageTemplate; });

var $1AtJz = parcelRequire("1AtJz");

});
parcelRegister("1AtJz", function(module, exports) {
$parcel$export(module.exports, "EnterpriseContactSalesPageTemplate", function () { return $dbc224b0e5c61a42$export$4ae072e91f67c1c7; });

var $7VQPk = parcelRequire("7VQPk");

var $8LaTa = parcelRequire("8LaTa");
parcelRequire("6E42A");
var $6VSBC = parcelRequire("6VSBC");

var $a7Sh0 = parcelRequire("a7Sh0");
const $dbc224b0e5c61a42$export$4ae072e91f67c1c7 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6VSBC.EnterprisePageProductNav), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a7Sh0.default), {})
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("6E42A", function(module, exports) {
$parcel$export(module.exports, "EnterprisePageProductNav", function () { return (parcelRequire("6VSBC")).EnterprisePageProductNav; });
parcelRequire("7IS0o");
parcelRequire("lYqKy");
parcelRequire("jwbFO");
parcelRequire("1vLxv");
parcelRequire("iDNJX");
parcelRequire("fuhhv");
parcelRequire("6cCqM");
parcelRequire("lk2q3");
parcelRequire("u4tJt");
parcelRequire("97gok");
parcelRequire("lZygM");
parcelRequire("evuYk");
parcelRequire("6VSBC");
parcelRequire("EJqLv");

});
parcelRegister("7IS0o", function(module, exports) {
/* cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $4Jdkw = parcelRequire("4Jdkw");
const $11580cc2f6e77cb1$export$a241c84f183c05c2 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-cta",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            className: (0, $2jatx.default)([
                "_1itk11ql _ca0q1ylp _u5f3idpf _n3td1ylp _19bvidpf _vd3yidpf _mla21wug _kubfidpf _3x9r1wug"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Jdkw.ADG4CtaWithPolygonBackground), {
                header: intl.formatMessage({
                    id: "EnterpriseLandingPage.CallToActionSection.header",
                    defaultMessage: "Build your system of work with Atlassian"
                }),
                ctaText: intl.formatMessage({
                    id: "EnterpriseLandingPage.CallToActionSection.buttonText",
                    defaultMessage: "Contact sales"
                }),
                ctaUrl: (0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features"),
                ctaLabel: "Contact sales",
                productKey: "enterprise"
            })
        })
    });
};
const $11580cc2f6e77cb1$var$ctaSectionContainerStyle = null;

});

parcelRegister("lYqKy", function(module, exports) {
/* data-center.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $2140f2fe8e065770$export$3e74b76dd9e071d6 = ()=>{
    const intl = (0, $8e22h.default)();
    const dataCenterSectionContent = {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.headerText",
            defaultMessage: "Not ready to move to cloud?"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.bodyText",
            defaultMessage: "Atlassian Data Center is our self-managed, enterprise-grade offering designed for organizations with strict security and compliance requirements."
        }),
        linkText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.linkText",
            defaultMessage: "Learn about Data Center"
        }),
        href: (0, $kooLp.useLocalizedHref)("/enterprise/data-center")
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-dataCenter",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            className: (0, $2jatx.default)([
                "_bfhk17fj _ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _quu713sl _3int1tcg _4fugzwfg _1ynq1tcg _1j3nzwfg _4sdyiec4 _12ce3739 _1tsvgktf _fd8v1txw _1bwb1q9c _1iievrvc _68jdvle5 _9u9rnxnw _19q81txw _12dhx19p _19pe1h6o _lmm31y6m _1yusvle5 _1hkovle5 _30721txw _y1mj1g80 _4vzb1w8u _m5gb1y6m _12vwzwfg _1crqcv93 _leujidpf _14zaidpf _1il1idpf _fs5uidpf _p5u7ftgi _bpkv1ul9 _1r27idpf _2lgdidpf _6wouidpf _1c7pidpf _1ppp1ogm _1lywftgi _5k731txw _1c2n1osq _5hes1j6v _qc6e1k8s _gvxubfng _nd0zzwfg _1mmnzwfg _awmxzwfg _1xi6zwfg _l7qw1g80 _ar0r1h6o _1p7u1osq _1ubi1h6o _18q6esu3 _1vumzwfg _fls593m8 _2uu193m8 _zbwo1txw _o3yo1g80 _i5yc1osq _13ku1h6o _dbaqidpf _1qoridpf _1a5bidpf _1rafidpf _1f1p1h6o _1j211tcg _1wfzidpf _212widpf _15d21crf _vh6pidpf _1nr81wug _1h01idpf _cc93idpf _e7z31crf _1u52idpf _14hs1osq _pd60glyw _fnxl1txw _rc231h6o _1ogs1osq"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: "data-center-container",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: "img-container",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-data-center-icon-3736035258.webp",
                                    alt: ""
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: "text-container",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                    children: dataCenterSectionContent.headerText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: dataCenterSectionContent.bodyText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    href: dataCenterSectionContent.href,
                                    text: dataCenterSectionContent.linkText,
                                    type: "primary",
                                    dataEventProps: {
                                        "data-label": dataCenterSectionContent.linkText,
                                        "data-product-key": "enterprise",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "dataCenterSection",
                                        "data-event": "clicked",
                                        "data-label-english": "Learn about Data Center"
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
const $2140f2fe8e065770$var$dataCenterSectionContainerStyle = null;

});

parcelRegister("jwbFO", function(module, exports) {
/* gartner-disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $5b60474b1056b2e6$var$finePrintStyles = null;
const $5b60474b1056b2e6$export$46ba377055e90871 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-disclaimer",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_syazfesn _18s81jx0",
                    "fine-print"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "EnterpriseLandingPage.gartnerDisclaimer",
                    defaultMessage: "* Gartner, Magic Quadrant for DevOps Platforms, Manjunath Bhat, Thomas Murphy, Joachim Herschmann, Daniel Betts, Chris Saunderson, Hassan Ennaciri, Bill Holz, Peter Hyde, 5 June 2023.  {br}{br} Gartner, Magic Quadrant for Enterprise Agile Planning Tools, Bill Blosen, Mike West, Keith Mann, Deacon D.K Wan, Akis Sklavounakis, Hassan Ennaciri, Sarah Davies, 25 April 2022.  {br}{br} Gartner, Voice of the Customer for Enterprise Agile Planning Tools, By Peer Contributors, 13 December 2023.  {br}{br} Gartner does not endorse any vendor, product or service depicted in its research publications, and does not advise technology users to select only those vendors with the highest ratings or other designation. Gartner research publications consist of the opinions of Gartner\u2019s research organization and should not be construed as statements of fact. Gartner disclaims all warranties, expressed or implied, with respect to this research, including any warranties of merchantability or fitness for a particular purpose.  {br}{br} Gartner Peer Insights content consists of the opinions of individual end users based on their own experiences with the vendors listed on the platform, should not be construed as statements of fact, nor do they represent the views of Gartner or its affiliates. Gartner does not endorse any vendor, product or service depicted in this content nor makes any warranties, expressed or implied, with respect to this content, about its accuracy or completeness, including any warranties of merchantability or fitness for a particular purpose.  {br}{br} GARTNER is a registered trademark and service mark, and the GARTNER PEER INSIGHTS CUSTOMERS\u2019 CHOICE badge, MAGIC QUADRANT and PEER INSIGHTS are trademarks and service marks, of Gartner, Inc. and/or its affiliates in the U.S. and internationally and are used herein with permission. All rights reserved.",
                    values: (0, $kooLp.DEFAULT_VALUES)
                })
            })
        })
    });

});

parcelRegister("1vLxv", function(module, exports) {
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $5qUgh = parcelRequire("5qUgh");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $d426652f1eda45bf$export$4489c2ed11909944 = ()=>{
    const intl = (0, $8e22h.default)();
    const heroSectionHeaderText = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "EnterpriseLandingPage.Hero.Title",
        defaultMessage: "Transform <span>teamwork at scale</span> with Atlassian",
        values: (0, $kooLp.DEFAULT_VALUES)
    });
    const heroSectionButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.Hero.ContactSales",
        defaultMessage: "Contact sales"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-hero",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1xusidpf _pdfi1ul9 _hfczidpf _t0uc1ul9 _1humidpf _vxqx1wqb _m3vkidpf _l2as1wqb _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                alignItems: "center",
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1j444cyy _10j0ubw4 _1cbbgktf _l9wpidpf _f4o91wqb _14dmidpf _xgqm1zx8 _2h35g6j5 _bzzima1m _18jm1wqb _qji6idpf _ms0l1wqb _v5weidpf _1bl41w8u _b2g01l0k _13hpuihq _1isq1ikj _y3gn1h6o _kqswh2mm _19it1i89 _2rkogktf _19pk1wqb _2hwxidpf _otyr1wqb _18u0idpf _1reo15vq _18m915vq _1tke1edt _1itk105u _ouxlvvtf _12vemgnk _1lrw9efu _1e8sbxu3 _psnd1osr _q4ef6276 _18tn1fw0 _dkzuidpf _17f71wug _at0e1ul9 _1nx01wug _bpsp1nn1"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                            className: "superhero-contrast",
                            children: heroSectionHeaderText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                            variant: "primary",
                            href: (0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features"),
                            dataEventProps: {
                                "data-product-key": "enterprise",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-event": "clicked",
                                "data-label": heroSectionButtonText,
                                "data-label-english": "Contact sales"
                            },
                            children: heroSectionButtonText
                        })
                    ]
                })
            })
        })
    });
};
const $d426652f1eda45bf$var$heroStyle = null;
const $d426652f1eda45bf$var$heroSectionBoxStyle = null;

});

parcelRegister("iDNJX", function(module, exports) {
/* hero-takeover-turbo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $5qUgh = parcelRequire("5qUgh");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
const $774d158b0a94a674$export$5f34b2edc97abcd5 = ()=>{
    const intl = (0, $8e22h.default)();
    const ctaLink = (0, $kooLp.useLocalizedHref)("/enterprise/atlassian-williams-racing");
    const turboBodyText = intl.formatMessage({
        id: "HomePage.hero-turbo.body-text",
        defaultMessage: "Introducing Atlassian Williams Racing. Two teamwork powerhouses join forces to usher in a new era of Formula 1 racing."
    });
    const turboFeatureGate = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp5046TurboBannerEnterprise);
    if (turboFeatureGate) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-turbo",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1reo15vq _18m915vq _11q7jk2v _18s8zucw _mkrz95kk"
            ]),
            style: {
                "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e0c1txw _4cvr1h6o _zulptudo _1bsb1fra _p12f1osq _1yt415v9 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _na0i1bp4 _gu181h6o _dh1a1h6o _2osnpxbi _o5kc1h6o _6ssjnl7l"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1e0c1txw _zulp1ejb _2lx21bp4 _4cvr1y6m _1bsb9tyk _acte1nn1 _qpk8yn4p _dd34idpf _l0uhidpf _ldjiidpf _g49yidpf _mihdcjiy _m78dcd5j _1tc71693 _1qf11ule _1hzvviql _vubcviql _125xcd5j _q7gqoxwj _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _txws1k92 _1kt119ii _19qkdgin _ov511osq _1s4p1wug _8fz6dgin _6ssj1e2i _gu181h6o _dh1a1h6o _o5kc1h6o"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: "hero hero-turbo",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "HomePage.hero-turbo.heading",
                                    defaultMessage: "Unleash the <strong>power of teamwork</strong>",
                                    values: (0, $kooLp.DEFAULT_VALUES)
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: "turbo",
                                children: turboBodyText
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                variant: "primary",
                                color: "yellow",
                                size: "large",
                                href: ctaLink,
                                dataEventProps: {
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    // @ts-ignore
                                    "data-event-container": "turboHero",
                                    "data-product-key": "home",
                                    "data-label-english": "Find out more"
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "HomePage.hero-turbo.cta-link-livery",
                                    defaultMessage: "Find out more"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1yt41jx0 _1bsb16tw _mezj1osq _bna71wug _18zx1kb5 _1s4p1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                            image: {
                                alt: "",
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4l06vv7x28fd2whw3f1i721165ooydn4.webp"
                            }
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
};
const $774d158b0a94a674$var$heroTurboCSS = null;
const $774d158b0a94a674$var$containingWidth = null;
const $774d158b0a94a674$var$leftHero = null;
const $774d158b0a94a674$var$rightHero = null;
$774d158b0a94a674$export$5f34b2edc97abcd5.displayName = "HeroEnterpriseTakeoverTurbo";

});

parcelRegister("fuhhv", function(module, exports) {
/* platform.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $fl7Kz = parcelRequire("fl7Kz");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $f2e85d00bdce9b0b$export$156caa82c28797f7 = ()=>{
    const intl = (0, $8e22h.default)();
    const platformCardsCrossProductExperience = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.collaboration.headerText",
                defaultMessage: "Collaboration"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.collaboration.bodyText",
                defaultMessage: "Keep work flowing across teams and tools."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/platform/collaboration"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.intelligence.headerText",
                defaultMessage: "Intelligence"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.intelligence.bodyText",
                defaultMessage: "Transform teamwork with the power of AI-human collaboration."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/artificial-intelligence"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.automation.headerText",
                defaultMessage: "Automation"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.automation.bodyText",
                defaultMessage: "Replace manual, time-consuming work with modern workflows."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/platform/automation"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.analytics.headerText",
                defaultMessage: "Analytics"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.analytics.bodyText",
                defaultMessage: "Make faster decisions with accessible data-informed insights."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/platform/analytics"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.extensibility.headerText",
                defaultMessage: "Extensibility"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.extensibility.bodyText",
                defaultMessage: "Customize your tools to meet the unique needs of each team."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: "https://marketplace.atlassian.com/",
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        }
    ];
    const platformCardsEnterpriseGradeCapabilities = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.resilience.headerText",
                defaultMessage: "Resilience at scale"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.resilience.bodyText",
                defaultMessage: "Adapt to any challenge with software designed to dynamically scale to meet the needs of any team, regardless of size or complexity."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/trust/resilience"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.security.headerText",
                defaultMessage: "Security and compliance"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.security.bodyText",
                defaultMessage: "Meet regulatory requirements and effectively manage your organization's data using comprehensive controls."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/trust/data-protection"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-platformSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_ca0q1ylp _u5f3idpf _n3td1ylp _19bvidpf _1sc1zwfg _1o2nzwfg _16zdidpf _jvlqidpf _1j3nzwfg _4fugzwfg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o _q7gqgktf _w77horz4 _clfdftgi _11pq1wug _q0a5ftgi _c3k81wug"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            children: intl.formatMessage({
                                id: "EnterpriseLandingPage.Platform.headerText",
                                defaultMessage: "Unify your teams on one powerful platform"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_bfhk1t97 _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1h6o _1x1tidpf _s9kqidpf _4wztidpf _98csidpf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.crossProductExperince.headerText",
                                        defaultMessage: "Experiences built to help work flow"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_19pkzwfg _2hwx1wug _otyrzwfg _18u01wug _1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _1n261q9c _zulpzwfg _ohma7vkz _iz1bzlre _1seo1wug _ox5hglyw _1f7i1osq _1r6y7vkz _1d9j7vkz _tuj67vkz _1cae7vkz _1m5l7vkz _bapsidpf _24o4idpf _ru7pidpf _1pqjidpf _1oan1fw0 _ax17ftgi _2axr1osq _1swwidpf _bzvvidpf _1dr6idpf _1o9tidpf _7dyf1j6v _scyo1k8s _1xaw1g80 _1rrc1tcg _1sgw17i6 _161z1osq"
                                    ]),
                                    children: platformCardsCrossProductExperience.map((cardProps, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $fl7Kz.default), {
                                            className: "platform-row-one-card",
                                            ...cardProps
                                        }, index))
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ip65idpf _g8ou1wug _1opiidpf _1x951wug _dmb7idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_bfhkcs0v _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1h6o _1x1tidpf _s9kqidpf _4wztidpf _98csidpf _clfd7vkz _11pq1wug _q0a57vkz _c3k81wug _w77horz4 _kckd1w8u _19tb1j6v _1la11k8s _bpspbfng"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.commonDataModel.headerText",
                                        defaultMessage: "A common data model designed to unlock key insights"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.commonDataModel.bodyText",
                                        defaultMessage: "Unify Atlassian and third-party data to connect teams, deepen collaboration, and drive results."
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    type: "primary",
                                    href: (0, $kooLp.useLocalizedHref)("/platform"),
                                    text: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.commonDataModel.linkText",
                                        defaultMessage: "Learn about our platform"
                                    }),
                                    dataEventProps: {
                                        "data-product-key": "enterprise",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "platformSection",
                                        "data-event": "clicked",
                                        "data-label": intl.formatMessage({
                                            id: "EnterpriseLandingPage.Platform.commonDataModel.dataLabel",
                                            defaultMessage: "Learn about our platform"
                                        }),
                                        "data-label-english": "Learn about our platform"
                                    }
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ip65idpf _g8ou1wug _1opiidpf _1x951wug _dmb7idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_bfhk1ymo _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1h6o _1x1tidpf _s9kqidpf _4wztidpf _98csidpf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilites.headerText",
                                        defaultMessage: "All built on enterprise-grade foundations"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_19pkzwfg _2hwx1wug _otyrzwfg _18u01wug _1bsb1w8u _1e0c1txw _1bah1h6o _1n261q9c _zulpzwfg _1wa17vkz _1ull1ssb _10ql1wug _tlbsglyw _lz7x1osq _knw07vkz _w3mz7vkz _14877vkz _6mwl7vkz _xc0a7vkz _19elidpf _wsnuidpf _1lioidpf _rkcxidpf _14uv1fw0 _x8poftgi _2fdk1osq _6qlpidpf _7m8oidpf _196hidpf _47ltidpf _1b8g1j6v _1xzh1k8s _1qza1osq _11901g80 _17duzwfg _kyxpidpf _3x14zwfg _p8qcidpf _rvvr1osq"
                                    ]),
                                    children: platformCardsEnterpriseGradeCapabilities.map((cardProps, index)=>{
                                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fl7Kz.default), {
                                            className: "platform-row-three-card",
                                            ...cardProps
                                        }, index);
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
const $f2e85d00bdce9b0b$var$platformSectionBoxContainer = null;
const $f2e85d00bdce9b0b$var$platformBoxContainer = null;
const $f2e85d00bdce9b0b$var$platformSectionHeaderContainerStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionBoxRowOneStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionRowOneCardContainerStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionBoxRowTwoStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionBoxRowThreeStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionRowThreeCardContainerStyle = null;

});

parcelRegister("6cCqM", function(module, exports) {
/* resources.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $a415d9d03629612e$export$3f0336208d56829f = ()=>{
    const intl = (0, $8e22h.default)();
    const tileList = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.trustCenter.headerText",
                defaultMessage: "Trust Center"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.trustCenter.bodyText",
                defaultMessage: "Keep your organization\u2019s data secure, maintain compliance, and achieve resilience at scale."
            }),
            imageProps: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/trust-center-cloud-icon-3087608378.webp",
                alt: ""
            },
            linkProps: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.Resources.card.trustCenter.linkText",
                    defaultMessage: "Visit our Trust Center"
                }),
                href: (0, $kooLp.useLocalizedHref)("/trust"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "resourcesSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.Resources.card.trustCenter.dataLabel",
                        defaultMessage: "Visit our Trust Center"
                    }),
                    "data-label-english": "Visit our Trust Center"
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.publicRoadmap.headerText",
                defaultMessage: "Public Roadmap"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.publicRoadmap.bodyText",
                defaultMessage: "Discover the latest features in the Atlassian cloud and see what we\u2019re working on next."
            }),
            imageProps: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/curved-arrow-icon-3497580723.webp",
                alt: ""
            },
            linkProps: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.Resources.card.publicRoadmap.linkText",
                    defaultMessage: "Check out the Cloud Roadmap"
                }),
                href: (0, $kooLp.useLocalizedHref)("/roadmap/cloud"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "resourcesSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.Resources.card.publicRoadmap.dataLabel",
                        defaultMessage: "Check out the Cloud Roadmap"
                    }),
                    "data-label-english": "Check out the Cloud Roadmap"
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.community.headerText",
                defaultMessage: "Enterprise Community"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.community.bodyText",
                defaultMessage: "Ask questions and learn best practices for our products at scale from Atlassian advocates."
            }),
            imageProps: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/community-bubble-icon-3561157108.webp",
                alt: ""
            },
            linkProps: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.Resources.card.community.linkText",
                    defaultMessage: "Join the Enterprise Community"
                }),
                href: "https://community.atlassian.com/t5/Enterprise/gh-p/Enterprise",
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "resourcesSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.Resources.card.community.dataLabel",
                        defaultMessage: "Join the Enterprise Community"
                    }),
                    "data-label-english": "Join the Enterprise Community"
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-resourcesSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_ca0qzwfg _u5f3idpf _n3tdidpf _19bvidpf _1afj1h6o _l5k11fw0 _16qeidpf _3ontidpf _19szidpf _i5bbidpf _cw8vusvi _hycy1txw _pg7i1bp4 _ezjiidpf _n5mbidpf _ypkd1tcg _1a0jidpf _14tm1ule _ix4uidpf _1gb7mhvn _64bp1osq _41c21txw _1iyj1osq _1kkgftgi _zkiw1e5h _fhnp1bp4 _1jxlzwfg _uuujidpf _1tu71fw0 _wft81crf _1jklidpf _1l021osq _178z1tcg _zlemidpf _ibgk1ul9 _o6yp1j6v _1syj1k8s _1chlbfng _wsbmf6fq _irte1j6v _w2lm1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        children: intl.formatMessage({
                            id: "EnterpriseLandingPage.Resources.sectionHeader",
                            defaultMessage: "Teamwork starts with trust"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "4-4-4",
                    children: tileList.map((content, index)=>{
                        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: "resources-section-container",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: "img-section",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                        src: content.imageProps.src,
                                        alt: content.imageProps.alt,
                                        className: (0, $2jatx.default)([
                                            "_1h1t1fut _5ral1f51",
                                            "enterprise-resources-card-image"
                                        ])
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: "text-section",
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                            children: content.headerText
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: "contentBlock-body",
                                            children: content.bodyText
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: "contentBlock-linkFlex",
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                                text: content.linkProps.text,
                                                href: content.linkProps.href,
                                                dataEventProps: content.linkProps.dataEventProps,
                                                type: "primary"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
const $a415d9d03629612e$var$resourcesSectionContainerStyle = null;

});

parcelRegister("lk2q3", function(module, exports) {

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $4Fnxt = parcelRequire("4Fnxt");

var $32ng3 = parcelRequire("32ng3");
const $34a1992600616f27$export$49e22b3583223277 = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    const intl = (0, $8e22h.default)();
    const statsProps = {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.stats.header",
            defaultMessage: "High-performing enterprises run on Atlassian"
        }),
        bigStat: {
            stat: "200",
            statText: intl.formatMessage({
                id: "EnterpriseLandingPage.stats.bigText",
                defaultMessage: "countries around the world where Atlassian software helps power enterprise"
            }),
            statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
            statSymbol: {
                symbolCharacter: "+",
                symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: "44",
                statText: intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText1",
                    defaultMessage: "of enterprise customers are able to make faster data-driven decisions after moving to the cloud"
                }),
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            },
            {
                stat: "79",
                statText: gwp7518NavIconUpdates ? intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText2-gwp-7518",
                    defaultMessage: "of enterprise customers are satisfied with Atlassian cloud apps"
                }) : intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText2",
                    defaultMessage: "of enterprise customers are satisfied with Atlassian cloud products"
                }),
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-stats",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Fnxt.Stats), {
                ...statsProps
            })
        })
    });
};

});

parcelRegister("u4tJt", function(module, exports) {
/* support.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $fl7Kz = parcelRequire("fl7Kz");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $906e979b456f42a3$export$17b1756ef4d0cdd6 = ()=>{
    const intl = (0, $8e22h.default)();
    const cardList = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.headerText.advisoryServices",
                defaultMessage: "Advisory Services"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.bodyText.advisoryServices",
                defaultMessage: "Maximize your Atlassian investment and achieve your goals with strategic, technical, and practice guidance from Atlassian\u2019s in-house experts."
            }),
            iconName: "lightning",
            iconSize: "small",
            clickableCardUrl: (0, $kooLp.useLocalizedHref)("/enterprise/services/advisory-services"),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/enterprise/services/advisory-services"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "supportSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.headerText.enterprisePartners",
                defaultMessage: "Enterprise Partners"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.bodyText.enterprisePartners",
                defaultMessage: "Consulting, hands-on technical implementation, and best practices to optimize your Atlassian portfolio and ensure your success."
            }),
            iconName: "partners",
            iconSize: "small",
            clickableCardUrl: (0, $kooLp.useLocalizedHref)("/enterprise/enterprise-partners"),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/enterprise/enterprise-partners"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "supportSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.headerText.customerSupport",
                defaultMessage: "Customer Support"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.bodyText.customerSupport",
                defaultMessage: "Get 24/7 support with 30-minute response times for critical issues included with Cloud Enterprise and Data Center subscriptions."
            }),
            iconName: "sparkle",
            iconSize: "small",
            clickableCardUrl: (0, $kooLp.useLocalizedHref)("/enterprise/support-services"),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/enterprise/support-services"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "supportSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-supportSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_bfhk17fj _85i51ylp _94n51n1a _1afj1h6o _l5k11fw0 _1eavgktf _7qsbtlke _4mdwglyw _nmva14mp _8mry16gf _ajae1tcg _17s71tcg _1uza1tcg _18bc1tcg _bo1n1osq _1gm71fw0 _5hjp1osq _1xi9idpf _1yay1j6v _1k931k8s _cwu5jojz _9rk41fp4 _wxo81jeb _1qj31yy8"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        children: intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.headerText",
                            defaultMessage: "Support designed for every enterprise"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "4-4-4",
                    children: cardList.map((CardProps, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $fl7Kz.default), {
                            className: `support-section-card support-section-card-${index}`,
                            headerType: "h4",
                            ...CardProps
                        }, index))
                })
            ]
        })
    });
};
const $906e979b456f42a3$var$SupportSectionContainerStyles = null;
var $906e979b456f42a3$export$2e2bcd8739ae039 = $906e979b456f42a3$export$17b1756ef4d0cdd6;

});

parcelRegister("97gok", function(module, exports) {

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");
parcelRequire("6hzTZ");
var $c0p5s = parcelRequire("c0p5s");
parcelRequire("jy5WX");
var $l4cHn = parcelRequire("l4cHn");
var $2EsR9 = parcelRequire("2EsR9");
var $8uEmY = parcelRequire("8uEmY");
var $3Fv2O = parcelRequire("3Fv2O");
const $aefc41f18298c8bf$export$502de1d4d55224c1 = ()=>{
    const intl = (0, $8e22h.default)();
    const tabs = [
        {
            id: "tab1",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.softwareDevelopment",
                defaultMessage: "Software development"
            }),
            englishLabel: "Software development",
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2EsR9.EnterpriseSoftwareDevelopment), {})
        },
        {
            id: "tab2",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.Service management",
                defaultMessage: "Service management"
            }),
            englishLabel: "Service management",
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4cHn.EnterpriseServiceManagement), {})
        },
        {
            id: "tab3",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterpriseStrategyAndPlanning",
                defaultMessage: "Enterprise strategy & planning"
            }),
            englishLabel: "Enterprise strategy & planning",
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8uEmY.EnterpriseStrategyAndPlanning), {})
        },
        {
            id: "tab4",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.workManagement",
                defaultMessage: "Work management"
            }),
            englishLabel: "Work management",
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Fv2O.EnterpriseWorkManagement), {})
        }
    ];
    const solutionsHeader = intl.formatMessage({
        id: "EnterpriseLandingPage.solutions.header",
        defaultMessage: "Industry-leading solutions to accelerate your business"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-tabs",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $c0p5s.TabsWithCards), {
            h2Text: solutionsHeader,
            tabsData: tabs
        })
    });
};

});
parcelRegister("6hzTZ", function(module, exports) {
$parcel$export(module.exports, "TabsWithCards", function () { return (parcelRequire("c0p5s")).TabsWithCards; });
parcelRequire("c0p5s");

});

parcelRegister("jy5WX", function(module, exports) {
$parcel$export(module.exports, "EnterpriseStrategyAndPlanning", function () { return (parcelRequire("8uEmY")).EnterpriseStrategyAndPlanning; });
$parcel$export(module.exports, "EnterpriseServiceManagement", function () { return (parcelRequire("l4cHn")).EnterpriseServiceManagement; });
$parcel$export(module.exports, "EnterpriseSoftwareDevelopment", function () { return (parcelRequire("2EsR9")).EnterpriseSoftwareDevelopment; });
$parcel$export(module.exports, "EnterpriseWorkManagement", function () { return (parcelRequire("3Fv2O")).EnterpriseWorkManagement; });

var $8uEmY = parcelRequire("8uEmY");

var $l4cHn = parcelRequire("l4cHn");

var $2EsR9 = parcelRequire("2EsR9");

var $3Fv2O = parcelRequire("3Fv2O");

});
parcelRegister("8uEmY", function(module, exports) {
$parcel$export(module.exports, "EnterpriseStrategyAndPlanning", function () { return $bf6dd4cff04406bb$export$b230c8e7621aa6c7; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");

var $hcrIp = parcelRequire("hcrIp");
const $bf6dd4cff04406bb$export$b230c8e7621aa6c7 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.makeAllWorkVisible",
                    defaultMessage: "Make all work visible in real-time"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.makeAllWorkVisible.bodytext",
                    defaultMessage: "Spot and solve blockers faster with visibility into all work from teams across your enterprise."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.alignEveryTeam",
                    defaultMessage: "Align every team to strategy"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.alignEveryTeam.bodyText",
                    defaultMessage: "Get everyone on the same page so you can solve for dependencies, scope, and roadmaps across teams and portfolios."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.stayFocusedOnCustomerValue",
                    defaultMessage: "Stay focused on customer value"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.stayFocusedOnCustomerValue.bodyText",
                    defaultMessage: "Map investments to customer value creation so you can make confident decisions at make-or-break moments."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.StrategyAndPlanning.learnMore",
                defaultMessage: "Learn about enterprise strategy & planning"
            }),
            link: (0, $kooLp.useLocalizedHref)("/software/jira/align"),
            linkLabel: "Learn about enterprise strategy & planning",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1tu5g7e71x67ptt70udllxtw5705vl17.webp",
                alt: "",
                width: 1544,
                height: 1092
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.StrategyAndPlanning.resources",
            defaultMessage: "Enterprise strategy & planning resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport",
                    defaultMessage: "Report"
                }),
                headerText: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport.headerText",
                    defaultMessage: 'Gartner<sup>\xae</sup> Predicts 2024: Strategic Portfolio Leaders Must Plan for the "Never Normal"',
                    values: (0, $hcrIp.formatRegisteredSymbol)
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("software/jira/align/resources/gartner-strategic-portfolio-management"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/kx4vls2kbgf442m7wq2p88a182k0sy20.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar",
                    defaultMessage: "Demo center"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar.headerText",
                    defaultMessage: "Learn how to boost Enterprise Strategy & Planning with Jira Align"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar.linkText",
                        defaultMessage: "Explore demos"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/jira/align/demo"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Explore demos"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-02-demo@2x-3880751788.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide",
                    defaultMessage: "Webinar"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide.headerText",
                    defaultMessage: "Transformations Across Hybrid Environments"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide.linkText",
                        defaultMessage: "Watch webinar"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/webinars/agile-at-scale/transformations-across-hybrid-environments"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Watch webinar"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/kv2eo50o020nn5amk6ahukj52h35405s.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});
parcelRegister("hcrIp", function(module, exports) {
$parcel$export(module.exports, "formatRegisteredSymbol", function () { return $0b8f8eb27e7a388e$export$7c6a07146a40a24d; });
/* utils.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $0b8f8eb27e7a388e$export$7c6a07146a40a24d = {
    sup: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("sup", {
            className: (0, $2jatx.default)([
                "_vwz4idpf"
            ]),
            children: chunks
        })
};

});


parcelRegister("l4cHn", function(module, exports) {
$parcel$export(module.exports, "EnterpriseServiceManagement", function () { return $acbe78da1a3d03fc$export$851060687c9906bd; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");
const $acbe78da1a3d03fc$export$851060687c9906bd = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.deliverValue",
                    defaultMessage: "Deliver value fast"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.deliverValue.bodytext",
                    defaultMessage: "Replace costly legacy tools and deploy faster with a powerful, easy-to-use platform that has transparent pricing."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.accelerateDevOps",
                    defaultMessage: "Accelerate dev and ops"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.accelerateDevOps.bodyText",
                    defaultMessage: "Instead of siloed tools, increase visibility and the flow of work by connecting Development and IT Operations teams on a single platform."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.empowerServiceForAll",
                    defaultMessage: "Empower service for all"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.empowerServiceForAll.bodyText",
                    defaultMessage: "Help every team take ownership of their service experience and scale practices - without costly add-ons or confusing deployments."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.serviceManagement.learnMore",
                defaultMessage: "Learn about service management"
            }),
            link: (0, $kooLp.useLocalizedHref)("/solutions/itsm"),
            linkLabel: "Learn about service management",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/x2s3unwoyy1xp3222df5pu0j23fx7lki.webp",
                alt: "",
                width: 1544,
                height: 1092
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.serviceManagement.resources",
            defaultMessage: "Service management resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport",
                    defaultMessage: "Forrester report"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport.headerText",
                    defaultMessage: "Atlassian is a Leader in Enterprise Service Management, Q4 2023"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/forrester/wave-enterprise-service-management"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/forresterWave-3356930698.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar",
                    defaultMessage: "ROI resources"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar.headerText",
                    defaultMessage: "The Total Economic Impact of Jira Service Management"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar.linkText",
                        defaultMessage: "Explore resources"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/jira/service-management/total-economic-impact-hub"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Explore resources"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/totEconomicImpact-1137923345.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide",
                    defaultMessage: "Guide"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide.headerText",
                    defaultMessage: "ITSM for high-velocity teams"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide.linkText",
                        defaultMessage: "Download guide"
                    }),
                    href: "https://wac-cdn.atlassian.com/it/dam/jcr:4ec50253-90f1-4d6c-98e2-2ff994cf94db/Jira-Service-Management-Overview-Datasheet.pdf?cdnVersion=1275#:~:text=Jira%20Service%20Management%20offers%20business,approach%20of%20legacy%20ITSM%20solutions.&text=Empower%20all%20teams%20across%20IT,business%20with%20intuitive%2C%20flexible%20workflows.&text=Make%20work%20visible%20through%20the%20open%20and%20collaborative%20Jira%20platform.",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Download guide"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/itServiceMngmt-1552092334.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});

parcelRegister("2EsR9", function(module, exports) {
$parcel$export(module.exports, "EnterpriseSoftwareDevelopment", function () { return $94aadbde708c2ed9$export$24da22834a2c8907; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");

var $hcrIp = parcelRequire("hcrIp");
const $94aadbde708c2ed9$export$24da22834a2c8907 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.supercharge",
                    defaultMessage: "Supercharge dev productivity"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.supercharge.bodytext",
                    defaultMessage: "Reduce bottlenecks and keep your software teams in the flow with everything you need to discover, plan, build, and operate world-class software."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.eliminateSilos",
                    defaultMessage: "Eliminate knowledge silos"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.eliminateSilos.bodyText",
                    defaultMessage: "Create better harmony between software and business teams by keeping work visible across your entire organization."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.accelerateDevops.driveBetterOutcomes",
                    defaultMessage: "Drive better business outcomes"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.accelerateDevops.driveBetterOutcomes.bodyText",
                    defaultMessage: "Connect and visualize data from all of your Atlassian and third-party tools to make faster and more informed decisions."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.softwareDevelopment.learnMore",
                defaultMessage: "Learn about software development"
            }),
            link: (0, $kooLp.useLocalizedHref)("/teams/software-development"),
            linkLabel: "Learn about software development",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5kq1t5b8yd8rfi6b617314esnw1mt5ra.webp",
                alt: "",
                width: 1544,
                height: 1092
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.softwareDevelopment.resources",
            defaultMessage: "Software development resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps",
                    defaultMessage: "Solutions"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps.headerText",
                    defaultMessage: "Open DevOps: Keep your tools, ditch the setup"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/solutions/devops"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Learn more"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-01-solutions@2x-310314428.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant",
                    defaultMessage: "Report"
                }),
                headerText: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant.headerText",
                    defaultMessage: "Atlassian named a Leader in the 2024 Gartner<sup>\xae</sup> Magic Quadrant\u2122 for DevOps Platforms",
                    values: (0, $hcrIp.formatRegisteredSymbol)
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/gartner/magic-quadrant-devops"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-01-report@2x-1971220130.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo",
                    defaultMessage: "Demo"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo.headerText",
                    defaultMessage: "Maximize Developer Experience Demo"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo.linkText",
                        defaultMessage: "Watch on-demand"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/webinars/enterprise-cloud/Maximize-Developer-Experience-with-Atlassian"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Watch on-demand"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-03-demo@2x-531224759.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});

parcelRegister("3Fv2O", function(module, exports) {
$parcel$export(module.exports, "EnterpriseWorkManagement", function () { return $70db6bec80cf2dea$export$26da8c8cc9d60467; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");
const $70db6bec80cf2dea$export$26da8c8cc9d60467 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.planForSuccess",
                    defaultMessage: "Plan for success"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.planForSuccess.bodytext",
                    defaultMessage: "Create, communicate, and organize your plans and content to make it easier for all teams to discover your org\u2019s most important work."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.collaborateOnSharedGoals",
                    defaultMessage: "Collaborate on shared goals"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.collaborateOnSharedGoals.bodyText",
                    defaultMessage: "Track and communicate your goals by sharing project status to keep everyone across your organization has visibility into work being done."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.flexYourWays",
                    defaultMessage: "Flex your ways of working"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.flexYourWays.bodyText",
                    defaultMessage: "Let your teams work the way they prefer, using their own process, language, and views while still staying connected to other team\u2019s projects."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.WorkManagement.learnMore",
                defaultMessage: "Learn about work management"
            }),
            link: (0, $kooLp.useLocalizedHref)("/solutions/work-management"),
            linkLabel: "Learn about work management",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/65p0f3lsvwv2tt0v473y166n7i4147ad.webp",
                alt: "",
                width: 1519,
                height: 1093
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.WorkManagement.resources",
            defaultMessage: "Work management resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools",
                    defaultMessage: "Solutions"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools.headerText",
                    defaultMessage: "Atlassian Work Management solutions and tools"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/solutions/work-management"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Learn more"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-01-solutions@2x-3900037778.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt",
                    defaultMessage: "Guide"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt.headerText",
                    defaultMessage: "A Comprehensive Guide to Work Management"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt.linkText",
                        defaultMessage: "Get the guide"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/blog/work-management/guide-to-work-management-2024"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Get the guide"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-02-guide@2x-511342337.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide",
                    defaultMessage: "Report"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide.headerText",
                    defaultMessage: "The economic benefits of improving work management with Atlassian"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/whitepapers/esg-work-management-report"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-03-report@2x-1528241620.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});



parcelRegister("lZygM", function(module, exports) {
/* carousel-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");
parcelRequire("7rz8I");
var $h8tN9 = parcelRequire("h8tN9");

var $dweoU = parcelRequire("dweoU");
const $98754143592a1482$export$5edf3752a9da9c72 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4nbubfng"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
            name: "enterprise-page-testimonials",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h8tN9.ADG4CustomerTestimonials), {
                bgColor: "black",
                heading: intl.formatMessage({
                    id: "EnterpriseLandingPage.carousel.heading",
                    defaultMessage: "Trusted by over 80% of the Fortune 500"
                }),
                cta: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.carousel.heading.cta",
                        defaultMessage: "Explore all customers stories"
                    }),
                    url: (0, $kooLp.useLocalizedHref)("/customers?filterByEnterprise=true"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "customersSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.carousel.heading.ctaDataLabel",
                            defaultMessage: "Explore all customers stories"
                        }),
                        "data-label-english": "Explore all customers stories"
                    }
                },
                testimonials: $98754143592a1482$var$Testimonials(),
                className: "customer-stories-carousel"
            })
        })
    });
};
const $98754143592a1482$var$Testimonials = ()=>{
    const intl = (0, $8e22h.default)();
    const testimonials = [
        {
            name: "Sun Life Employee",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialSunLife), {}),
            title: "",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 SunLife on Black 2x 1-2143605095.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial1.quote",
                defaultMessage: "Jira Cloud and Confluence Cloud are a big step in the right direction from the previous tools we were using. All the new functionality really improved my day to day."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial1.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/sunlife"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial1.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Sun Life"
        },
        {
            name: "Mehmet Sari",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialMercedesBenz), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial2.title",
                defaultMessage: "Modern Collaboration Platform Team, Mercedes-Benz"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 Mercedes-Benz on Black 2x 1-2641411897.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial2.quote",
                defaultMessage: "Atlassian cloud is the solution for high performance, high security, high availability, and the newest features."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial2.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/mercedes-benz"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial2.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Mercedes Benz"
        },
        {
            name: "Ryan Mosley",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialDHCS), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial3.title",
                defaultMessage: "Chief of Factory & Engineering Modernization, DHCS"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 DHCS on Black 2x 1-2317410165.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial3.quote",
                defaultMessage: "By tracking everything in Jira and all of our developer tools, we reduced the cost to get the team set up and deliver the product from $2.8 million to $600,000."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial3.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/dhcs"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial3.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "DHCS California Department of Health Care Services"
        },
        {
            name: "Mai Lian Scarlett",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialLumen), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial4.title",
                defaultMessage: "Former Senior Director, Agile Transformation Office, Lumen"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 Lumen on Black 2x 1-2939378294.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial4.quote",
                defaultMessage: "Our partnership with Atlassian has really been an accelerator and an enabler to our digital transformation\u2026We\u2019re excited to see Atlassian\u2019s commitment to the cloud platform."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial4.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/lumen"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial4.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Lumen"
        },
        {
            name: "Oxana Trotsenko",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialUnited), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial5.title",
                defaultMessage: "Chief of Staff of Digital Technology, United Airlines"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 United on Black 2x 1-995190318.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial5.quote",
                defaultMessage: "Atlassian cloud provides you flexibility, cost savings over time, and efficiency\u2026When I think about technology in the modern world, we would not consider anything else."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial5.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/united-airlines"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial5.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "United Airlines"
        },
        {
            name: "Evan Lerer",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialRedfin), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial6.title",
                defaultMessage: "Director of Engineering, Redfin"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 Redfin on Black 2x 1-8548123.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial6.quote",
                defaultMessage: "We trust Atlassian to help our team deliver world-class products that redefine real estate in the customer\u2019s favor."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial6.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/redfin"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial6.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Redfin"
        }
    ];
    return testimonials;
};
const $98754143592a1482$var$carouselSectionStyles = null;

});
parcelRegister("7rz8I", function(module, exports) {
$parcel$export(module.exports, "ADG4CustomerTestimonials", function () { return (parcelRequire("h8tN9")).ADG4CustomerTestimonials; });

var $h8tN9 = parcelRequire("h8tN9");

});


parcelRegister("evuYk", function(module, exports) {
/* badges.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $7cbd5ae14e10bec6$export$a81af8b662eb2b7 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-badges",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_6rth8ved"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_y3gn1h6o _6rth19bv",
                        "eyebrow-md"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "EnterpriseLandingPage.badges.eyebrow",
                        defaultMessage: "Recognized by world-class analysts"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                    layout: "3-3-3-3",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($7cbd5ae14e10bec6$var$Badge, {
                            href: (0, $kooLp.useLocalizedHref)("/forrester/wave-enterprise-service-management"),
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/forrester_wave_leader_2023-3286669196.webp",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge1",
                                defaultMessage: "Atlassian is a Leader in The Forrester Wave\u2122: Enterprise Service Management, Q4 2023."
                            }),
                            badgeLabel: "Atlassian is a Leader in The Forrester Wave\u2122: Enterprise Service Management, Q4 2023."
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($7cbd5ae14e10bec6$var$Badge, {
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner_logo.svg",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge2",
                                defaultMessage: "A Leader in the 2023 Gartner\xae Magic Quadrant\u2122 for DevOps Platforms*"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($7cbd5ae14e10bec6$var$Badge, {
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner_logo.svg",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge3",
                                defaultMessage: "A Leader in the 2023 Gartner\xae Magic Quadrant\u2122 for Enterprise Agile Planning Tools*"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($7cbd5ae14e10bec6$var$Badge, {
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Peer-Insights-Customers-Choice-2023.svg",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge4",
                                defaultMessage: "A Gartner\xae Peer Insights\u2122 Customers' Choice for Enterprise Agile Planning Tools."
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $7cbd5ae14e10bec6$var$badgeSectionStyles = null;
const $7cbd5ae14e10bec6$var$divStyles = null;
const $7cbd5ae14e10bec6$var$Badge = ({ href: href, imageUrl: imageUrl, imageAlt: imageAlt, badgeText: badgeText, badgeLabel: badgeLabel })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1ml653f4 _kmx4ys9h _q1391ule _1cac1wug _14fh1wug _gdebo7ao _qgibo7ao _1bsa1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
            href: href,
            "data-product-key": "enterprise",
            "data-event-component": "link",
            "data-event-container": "badgesSection",
            "data-event": "clicked",
            "data-label": badgeText,
            "data-label-english": badgeLabel,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "image-container",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: imageUrl,
                        alt: imageAlt
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "badge-text body-sm",
                    children: badgeText
                })
            ]
        })
    });
};
const $7cbd5ae14e10bec6$var$BadgeStyles = null;

});

parcelRegister("EJqLv", function(module, exports) {

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $i0Jom = parcelRequire("i0Jom");

var $4Im8f = parcelRequire("4Im8f");

var $8hNiC = parcelRequire("8hNiC");

var $liM7f = parcelRequire("liM7f");
const $ca865e303881e7c7$export$11abae89ba61f3a8 = 8000;
const $ca865e303881e7c7$export$cd8aff68574ce209 = ()=>{
    const intl = (0, $8e22h.default)();
    const tabs = [
        {
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8hNiC.EnterpriseTabContent), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterprise",
                defaultMessage: "Enterprise"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterprise.caption",
                defaultMessage: "Atlassian\u2019s System of Work"
            }),
            englishLabel: "enterprise",
            id: "enterprise"
        },
        {
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $liM7f.ProductTabContent), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.product",
                defaultMessage: "Product"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.product.caption",
                defaultMessage: "Atlassian\u2019s latest AI innovation"
            }),
            englishLabel: "product",
            id: "product"
        },
        {
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Im8f.AnalystsTabContent), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.analysts",
                defaultMessage: "Analysts"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.analysts.caption",
                defaultMessage: "Gartner Magic Quadrant Leader"
            }),
            englishLabel: "analysts",
            id: "analysts"
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i0Jom.EnterpriseTabsWithCards), {
        tabsData: tabs,
        tabSwitchInterval: $ca865e303881e7c7$export$11abae89ba61f3a8
    });
};

});
parcelRegister("i0Jom", function(module, exports) {
$parcel$export(module.exports, "EnterpriseTabsWithCards", function () { return $81937f6de4338711$export$255fc2fb2ce9d4ee; });
/* enterprise-tabs-with-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $9s3Hk = parcelRequire("9s3Hk");

var $90TSV = parcelRequire("90TSV");

var $ilkqI = parcelRequire("ilkqI");

var $iyOcM = parcelRequire("iyOcM");
const $81937f6de4338711$var$Tab = ({ title: title, caption: caption, isSelected: isSelected, dataEventProps: dataEventProps })=>{
    const eyebrowStyle = null;
    const captionStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        ...dataEventProps,
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bsb1ns9 _4t3i1osq _1tkekz1e _p12f5jys _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _2lx21bp4 _4cvr1y6m _80omtlke _16jlkb7n _2rkogktf _19itglyw _11q7u66n _16qss1rx _ect4lnmy _k48p1nn1 _1wybgktf _syaz1iem _152tr8pp _v5641gvb _1mdbkz1e _uhd05jys _1j96zwfg _jvmrzwfg _k0mszwfg _1b7pzwfg _1x6l13rr _j6qupd6w _xut117n1 _ceho8wlv _jx4017n1 _1i7q122r _1dbzyicz",
            isSelected && "_19it1oen _16qsyicz _syazr3uz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect48q0o _1wybdlk8 _zg8l4jg8 _k48p1nn1 _vwz4f6fq _1p1dangw _19pkidpf _2hwxidpf _otyr7vkz _18u0idpf"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect4kipj _1wybf6fq _zg8l4jg8 _k48p1fw0 _vwz41tcg _y3gn1e5h _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1fhb _1bsb1osq"
                ]),
                children: caption
            })
        ]
    });
};
const $81937f6de4338711$export$255fc2fb2ce9d4ee = ({ tabsData: tabsData, tabSwitchInterval: tabSwitchInterval })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "tabs",
        className: (0, $2jatx.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $iyOcM.Adg4Tabs), {
            tabSwitchInterval: tabSwitchInterval,
            loop: true,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1ule"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $ilkqI.Adg4TabPanel), {
                            panelIndex: index,
                            id: tab.id,
                            children: tab.tabComponent
                        }, index))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1ule _1pbycs5v _152tr8pp"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $90TSV.Adg4DraggableTabList), {
                        rowGap: "12px",
                        className: (0, $2jatx.default)([
                            "_ca0qidpf _u5f31wqb _n3td1qjk _19bv1wqb _1e0c1txw _4cvr1fhb _zulpzwfg _1kmxidpf _1ggmzwfg _1ykz1ul9 _1maezwfg",
                            "tab-list"
                        ]),
                        children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $9s3Hk.Adg4DraggableTab), {
                                tabIndex: index,
                                className: "round-tab",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($81937f6de4338711$var$Tab, {
                                    title: tab.title,
                                    caption: tab.caption,
                                    dataEventProps: {
                                        "data-product-key": "home",
                                        "data-event": "clicked",
                                        "data-event-component": "button",
                                        "data-event-container": "tabsMenu",
                                        "data-label": tab.title,
                                        "data-label-english": tab.englishLabel
                                    }
                                })
                            }, index))
                    })
                })
            ]
        })
    });
};
const $81937f6de4338711$var$topSectionStyles = null;
const $81937f6de4338711$var$bottomSectionStyles = null;
const $81937f6de4338711$var$sectionStyles = null;
const $81937f6de4338711$var$tabList = null;
const $81937f6de4338711$var$tabStyles = null;
const $81937f6de4338711$var$currentStyle = null;

});

parcelRegister("4Im8f", function(module, exports) {
$parcel$export(module.exports, "AnalystsTabContent", function () { return $a799074227eeb47f$export$bfe5f81b459a55ca; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $flDFL = parcelRequire("flDFL");

var $kooLp = parcelRequire("kooLp");
const $a799074227eeb47f$export$bfe5f81b459a55ca = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $flDFL.EnterpriseHero), {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.analysts.header",
            defaultMessage: "Atlassian named a Leader in DevOps Platforms by Gartner"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.analysts.body",
            defaultMessage: "Learn about our unified DevOps platform that connects engineering, IT Ops, and business teams"
        }),
        textAlign: "right",
        cta: {
            text: intl.formatMessage({
                id: "EnterpriseLandingPage.hero.analysts.cta",
                defaultMessage: "Read the report"
            }),
            dataEventProps: {
                "data-product-key": "enterprise",
                "data-event-component": "linkButton",
                "data-event-container": "heroSection",
                "data-event": "clicked",
                "data-label": "enterprise-hero-analysts-cta",
                "data-label-english": "Read the report"
            },
            href: (0, $kooLp.useLocalizedHref)("/gartner/magic-quadrant-devops")
        },
        ctaType: "button",
        color: "light",
        backgroundImgSrc: {
            xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-xs.webp",
            sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-sm.webp",
            md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-md.webp",
            lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-lg.webp"
        }
    });
};

});
parcelRegister("flDFL", function(module, exports) {
$parcel$export(module.exports, "EnterpriseHero", function () { return $69fdc043b04a07d0$export$9d702f5b43ea4715; });
/* enterprise-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lmQGF = parcelRequire("lmQGF");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $69fdc043b04a07d0$var$contentMaxWidth = {
    center: {
        xs: "378px",
        sm: "534px",
        md: "568px",
        lg: "568px"
    },
    left: {
        xs: "378px",
        sm: "421px",
        md: "514px",
        lg: "568px"
    },
    right: {
        xs: "378px",
        sm: "365px",
        md: "514px",
        lg: "668px"
    }
};
const $69fdc043b04a07d0$export$9d702f5b43ea4715 = ({ headerText: headerText, bodyText: bodyText, textAlign: textAlign = "center", color: color = "light", cta: cta, ctaType: ctaType, backgroundImgSrc: backgroundImgSrc })=>{
    const textColor = color === "light" ? (0, $kbpa7.wacToken)("color.neutral.light0") : (0, $kbpa7.wacToken)("color.primary.black");
    const inlineStart = textAlign === "left" ? "199.5px" : textAlign === "right" ? "-140px" : "0";
    const alignItems = textAlign === "left" ? "flex-start" : textAlign === "right" ? "flex-end" : "center";
    const justifyContent = textAlign === "left" ? "flex-start" : textAlign === "right" ? "flex-end" : "center";
    const containerStyle = null;
    const { md: md, lg: lg } = $69fdc043b04a07d0$var$contentMaxWidth[textAlign];
    const contentStyle = null;
    const headerStyle = null;
    const bodyStyle = null;
    const ctaStyle = null;
    const CallToAction = ()=>{
        if (!cta) return null;
        if (ctaType === "button") {
            const { text: text, href: href, dataEventProps: dataEventProps } = cta;
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lmQGF.Adg4Button), {
                variant: "primary",
                size: "small",
                color: "yellow",
                href: href,
                dataEventProps: dataEventProps,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1wpzn3xj _es5ofn2t _1gwbyfnk"
                ]),
                style: {
                    "--_k2wmiu": (0, $6ZVlx.default)(alignItems),
                    "--_2idk6s": (0, $6ZVlx.default)(textAlign === "center" ? "center" : "flex-start"),
                    "--_1t1mgkw": (0, $6ZVlx.default)(textAlign === "right" ? "center" : alignItems)
                },
                children: text
            });
        } else if (ctaType === "link") {
            const { text: text, href: href, dataEventProps: dataEventProps } = cta;
            return(// eslint-disable-next-line @atlassian/a11y/anchor-has-content,@atlassian/a11y/link-name
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                type: "external",
                href: href,
                text: text,
                dataEventProps: dataEventProps
            }));
        }
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: cta
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_y44v19jp _11q7xprm _p12fklux _4t3i1c5i _1o9zidpf _kqswh2mm _19pk1wqb _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3zwfg _n3tdidpf _19bvzwfg _1e0c1txw _1bahjlb8 _4cvr1h6o _yj3y1b9g _1d4udzi4 _1j96idpf _jvmr1wqb _k0msidpf _1b7p1wqb _ibctnzkm _v8ts8nql _2ysd8nql"
        ]),
        style: {
            "--_n0tana": (0, $6ZVlx.default)(backgroundImgSrc?.xs, ")", "url("),
            "--_1ecqhzh": (0, $6ZVlx.default)(justifyContent),
            "--_188fmqn": (0, $6ZVlx.default)(textAlign === "right" ? "center" : justifyContent),
            "--_c4618e": (0, $6ZVlx.default)(textAlign === "right" ? `url(${backgroundImgSrc?.xs}) 50% / 100% 100% no-repeat` : `url(${backgroundImgSrc?.sm}) 50% / cover no-repeat`),
            "--_450zrg": (0, $6ZVlx.default)(backgroundImgSrc?.md, ")", "url("),
            "--_11tlo2t": (0, $6ZVlx.default)(backgroundImgSrc?.lg, ")", "url(")
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1e0c1txw _2lx21bp4 _1bahkeqs _4cvrn3xj _18s81any _y3gn2i2r _p12f1oh5 _7bccng7t _b14zybpo _sfxvybpo _10vrkeqs _yir31oh5 _1rsv1oh5 _1190gb00 _ytj9ydnc"
            ]),
            style: {
                "--_ux0pmw": (0, $6ZVlx.default)(textAlign),
                "--_k2wmiu": (0, $6ZVlx.default)(alignItems),
                "--_1x9bz3": (0, $6ZVlx.default)(textAlign === "center" ? "0 auto" : "0"),
                "--_xk83tk": (0, $6ZVlx.default)(textAlign === "center" ? "center" : "left"),
                "--_14ulcc6": (0, $6ZVlx.default)(textAlign === "right" ? "center" : textAlign),
                "--_1itq52x": (0, $6ZVlx.default)(inlineStart),
                "--_1ndsstv": (0, $6ZVlx.default)(textAlign === "right" ? "668px" : "568px")
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_ect41pz4 _1wybigbc _zg8l4jg8 _k48p9y44 _vwz4v9r7 _18s81khp _syaz1u00 _50pk12am _167l1ady _1sg4idpf _maxsidpf _1jvh1f4h _1ucaidpf _b14zybpo _17gq8vuz _1s18ckbl _15flidpf _1d2widpf _1svy7vkz _seovidpf",
                        "enterprise-hero-header-text"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                        "--_j86zen": (0, $6ZVlx.default)(textAlign === "right" ? "10vw" : "44px"),
                        "--_1l1q5sn": (0, $6ZVlx.default)(textAlign === "right" ? "12vw" : "50px"),
                        "--_192zam2": (0, $6ZVlx.default)(textAlign === "right" ? "0 0 5vw 0" : "0 0 28px 0"),
                        "--_srel9g": (0, $6ZVlx.default)(textColor),
                        "--_14ulcc6": (0, $6ZVlx.default)(textAlign === "right" ? "center" : textAlign)
                    },
                    children: headerText
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_ect4bzd7 _1wyb7vkz _zg8l4jg8 _k48p1nn1 _vwz41tcg _4t3i1ns9 _c71lt9kd _1bsb1ns9 _19pkidpf _2hwxidpf _otyr1f4h _18u0idpf _syaz1u00 _b14zybpo _1dxp1yu0 _1sg4idpf _maxsidpf _1jvhzwfg _1ucaidpf _b8yq1ns9 _1s18gktf _17gq1f4h"
                    ]),
                    style: {
                        "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                        "--_srel9g": (0, $6ZVlx.default)(textColor),
                        "--_14ulcc6": (0, $6ZVlx.default)(textAlign === "right" ? "center" : textAlign)
                    },
                    children: bodyText
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)(CallToAction, {})
            ]
        })
    });
};

});


parcelRegister("8hNiC", function(module, exports) {
$parcel$export(module.exports, "EnterpriseTabContent", function () { return $4e88cce0cf69ea64$export$6b3a3100e0e8582e; });
/* eslint-disable local/no-non-orangelogic-images-eslint */ 
var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $flDFL = parcelRequire("flDFL");
const $4e88cce0cf69ea64$export$6b3a3100e0e8582e = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $flDFL.EnterpriseHero), {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.enterprise-new.headerText",
            defaultMessage: "Forward Together"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.enterprise-new.bodyText",
            defaultMessage: "Discover how Atlassian Williams Racing is accelerating teamwork transformation on the grid using the Atlassian Cloud Platform."
        }),
        cta: {
            text: intl.formatMessage({
                id: "EnterpriseLandingPage.hero.enterprise.cta",
                defaultMessage: "Watch video"
            }),
            dataEventProps: {
                "data-product-key": "enterprise",
                "data-event-component": "linkButton",
                "data-event-container": "heroSection",
                "data-event": "clicked",
                "data-label": "enterprise-hero-enterprise-cta",
                "data-label-english": "Watch video"
            },
            href: "https://www.youtube.com/watch?v=sSKY7pNdlvI"
        },
        ctaType: "link",
        color: "dark",
        backgroundImgSrc: {
            xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-sm-107626183.webp",
            sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-md-2984500272.webp",
            md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-lg-2107118674.webp",
            lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-1621379571.webp"
        }
    });
};

});

parcelRegister("liM7f", function(module, exports) {
$parcel$export(module.exports, "ProductTabContent", function () { return $f4ffa76e12bb7992$export$36e1444062b1b431; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $flDFL = parcelRequire("flDFL");

var $kooLp = parcelRequire("kooLp");
const $f4ffa76e12bb7992$export$36e1444062b1b431 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $flDFL.EnterpriseHero), {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.product.header",
            defaultMessage: "Say Hello to Rovo"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.product.body",
            defaultMessage: "Atlassian's AI-powered solution that makes teamwork easier and faster."
        }),
        textAlign: "center",
        cta: {
            text: intl.formatMessage({
                id: "EnterpriseLandingPage.hero.product.cta",
                defaultMessage: "Learn more"
            }),
            dataEventProps: {
                "data-product-key": "enterprise",
                "data-event-component": "linkButton",
                "data-event-container": "heroSection",
                "data-event": "clicked",
                "data-label": "enterprise-hero-product-cta",
                "data-label-english": "Learn more"
            },
            href: (0, $kooLp.useLocalizedHref)("/software/rovo")
        },
        ctaType: "button",
        color: "dark",
        backgroundImgSrc: {
            xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-mobile@2x-1408243573.webp",
            sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-tablet@2x-1411287807.webp",
            md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-desktop-S@2x-1748573145.webp",
            lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-desktop-L@2x-2396412742.webp"
        }
    });
};

});



parcelRegister("a7Sh0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9fd18bfe4f963e55$export$2e2bcd8739ae039; });
/* constant-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $hhv63 = parcelRequire("hhv63");

var $21NKE = parcelRequire("21NKE");

var $bskue = parcelRequire("bskue");

var $9Dk5S = parcelRequire("9Dk5S");

var $g06pB = parcelRequire("g06pB");

var $5mbMi = parcelRequire("5mbMi");
const $9fd18bfe4f963e55$var$wrapperStyle = null;
const $9fd18bfe4f963e55$var$mainContainerStyle = null;
const $9fd18bfe4f963e55$var$rowStyle = null;
const $9fd18bfe4f963e55$var$formStyle = null;
const $9fd18bfe4f963e55$var$selectorStyle = null;
const $9fd18bfe4f963e55$var$ConstantSelector = ()=>{
    const intl = (0, $8e22h.default)();
    const discussText = intl.formatMessage({
        id: "constant-selector.main.discuss",
        defaultMessage: "I'd like to discuss "
    });
    const productFeaturesText = intl.formatMessage({
        id: "constant-selector.main.product-features",
        defaultMessage: "product features"
    });
    const pricingQuotesText = intl.formatMessage({
        id: "constant-selector.main.pricing-quotes",
        defaultMessage: "pricing & quotes"
    });
    const migrationOptionsText = intl.formatMessage({
        id: "constant-selector.main.migration-options",
        defaultMessage: "migration options"
    });
    const billingLicensingText = intl.formatMessage({
        id: "constant-selector.main.billing-licensing",
        defaultMessage: "billing & licensing"
    });
    const technicalSupportText = intl.formatMessage({
        id: "constant-selector.main.technical-support",
        defaultMessage: "technical support"
    });
    const urlParams = new URLSearchParams(window.location.search);
    const formType = urlParams.get("formType");
    const formTypeOptions = {
        "product-features": "product features",
        "pricing-quotes": "pricing & quotes",
        "migration-options": "migration options",
        "billing-licensing": "billing & licensing",
        "technical-support": "technical support"
    };
    const formTypeOption = formTypeOptions[formType || "product-features"];
    const [selectedOption, setSelectedOption] = (0, $1oC0p.useState)(formTypeOption);
    const handleChange = (event)=>{
        setSelectedOption(event.target.value);
        const newParams = new URLSearchParams(window.location.search);
        newParams.set("formType", event.target.value.replace(/&/g, "").replace(/\s+/g, "-"));
        window.history.pushState({}, "", `?${newParams.toString()}`);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hhv63.ConsentHubClientConfigProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _ahbq1wug _12l21wug _1pfhidpf _1q5146v8"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _vchhusvi _1e0c1ule _6rth1ylp"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_12l21wug _ahbq1wug _p12f1fra"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_ahbqgktf _vwz411ph _1wybbs2l _1bsb1osq _ect4du8v _k48pbfng _1dyz165v _s7n410ig _syaz1bqd _2u5gusvi _suga1ule _1rfm1a5k"
                            ]),
                            children: discussText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
                            value: selectedOption,
                            onChange: handleChange,
                            className: (0, $2jatx.default)([
                                "_1h6d1j28 _189et94y _vchhusvi _ect4du8v _p12fdgin _ca0q1skh _u5f38vuz _n3td1crf _19bv1crf _k48p1nn1 _1wybahaf _vwz4cjiy _2rko14y2 _y3gn1e5h _4cvr1h6o _syazrbzz _bfhk1hxd _1p1d1qyh _wstuglyw _80omtlke _1itk31me _1lrw1xbb _ouxlm83n _12vemgnk _irr3uzct _11cg7vkz _1rkb1a5k"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                    value: "product features",
                                    children: productFeaturesText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                    value: "pricing & quotes",
                                    children: pricingQuotesText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                    value: "migration options",
                                    children: migrationOptionsText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                    value: "billing & licensing",
                                    children: billingLicensingText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                                    value: "technical support",
                                    children: technicalSupportText
                                })
                            ]
                        }),
                        selectedOption === "product features" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g06pB.default), {}),
                        selectedOption === "pricing & quotes" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9Dk5S.default), {}),
                        selectedOption === "migration options" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bskue.default), {}),
                        selectedOption === "billing & licensing" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $21NKE.default), {}),
                        selectedOption === "technical support" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5mbMi.default), {})
                    ]
                })
            })
        })
    });
};
var $9fd18bfe4f963e55$export$2e2bcd8739ae039 = $9fd18bfe4f963e55$var$ConstantSelector;

});
parcelRegister("21NKE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26bcf019da5598a3$export$2e2bcd8739ae039; });
/* billing-licensing.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $fJP6M = parcelRequire("fJP6M");

var $kooLp = parcelRequire("kooLp");
const $26bcf019da5598a3$var$containerStyle = null;
const $26bcf019da5598a3$var$innerContainerStyle = null;
const $26bcf019da5598a3$var$textContainer = null;
const $26bcf019da5598a3$var$buttonStyle = null;
const $26bcf019da5598a3$var$buttonContainer = null;
const $26bcf019da5598a3$var$BillingLicensing = ()=>{
    const intl = (0, $8e22h.default)();
    const contactSupportText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.billing-licensing.contact-support",
        defaultMessage: "Contact support"
    });
    const billingText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.billing-licensing.billing",
        defaultMessage: `If you\u{2019}re wondering how billing works for a product you\u{2019}d like to purchase, select \u{201C}pricing & quotes\u{201D}.`
    });
    const assistanceText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.billing-licensing.assitance",
        defaultMessage: "For assistance with products you already own, please raise a support ticket."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _p12f1fra _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4y94u"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _p12f1c1k _1ul91ssb"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syazvwuj"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: billingText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: assistanceText
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_1pfh1ylp"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.default), {
                        text: contactSupportText,
                        "aria-label": contactSupportText,
                        color: "darkblue",
                        url: (0, $kooLp.useLocalizedHref)("/company/contact/purchasing-licensing"),
                        dataEventProps: {
                            "data-product-key": "jiraSoftwareFeature",
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-label": contactSupportText
                        },
                        className: (0, $2jatx.default)([
                            "_18s81ag2 _k48pbfng _1tke1ylp _3fcw1g80 _s7n41q9y _d5ymcfaq _ect4lnmy _6rth1tcg"
                        ])
                    })
                })
            ]
        })
    });
};
var $26bcf019da5598a3$export$2e2bcd8739ae039 = $26bcf019da5598a3$var$BillingLicensing;

});

parcelRegister("bskue", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d0aa98f0fec04aa1$export$2e2bcd8739ae039; });
/* migration-options.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $lX14w = parcelRequire("lX14w");
var $ff3wF = parcelRequire("ff3wF");
var $igGC3 = parcelRequire("igGC3");
var $gacwQ = parcelRequire("gacwQ");
var $kR3EL = parcelRequire("kR3EL");

var $9BG80 = parcelRequire("9BG80");

var $8KJ2x = parcelRequire("8KJ2x");

var $fJP6M = parcelRequire("fJP6M");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $1rGpC = parcelRequire("1rGpC");

var $2ve7k = parcelRequire("2ve7k");

var $lBgvn = parcelRequire("lBgvn");

var $3bkHm = parcelRequire("3bkHm");

var $izhAl = parcelRequire("izhAl");

var $e0MOs = parcelRequire("e0MOs");

var $ai7AF = parcelRequire("ai7AF");

var $9xhTf = parcelRequire("9xhTf");

var $8Fvhz = parcelRequire("8Fvhz");
const $d0aa98f0fec04aa1$var$dropdownSelectorStyle = null;
const $d0aa98f0fec04aa1$var$MigratingFromDropdown = ({ onChangeHandler: onChangeHandler })=>{
    const [selectedOption, setSelectedOption] = (0, $1oC0p.useState)("");
    const onClick = (event)=>{
        const selected = String(event.target.value);
        setSelectedOption(selected);
        onChangeHandler?.(selected);
    };
    const intl = (0, $8e22h.default)();
    const serverToCloud = intl.formatMessage({
        id: "migrationOptions.serverToCloud",
        defaultMessage: "Server to Cloud"
    });
    const serverToDataCenter = intl.formatMessage({
        id: "migrationOptions.serverToDataCenter",
        defaultMessage: "Server to Data Center"
    });
    const dataCenterToCloud = intl.formatMessage({
        id: "migrationOptions.dataCenterToCloud",
        defaultMessage: "Data Center to Cloud"
    });
    const iDontKnowYet = intl.formatMessage({
        id: "migrationOptions.iDontKnowYet",
        defaultMessage: "I don't know yet"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
        id: "options",
        value: selectedOption,
        onChange: onClick,
        "data-testid": "migration-options",
        className: (0, $2jatx.default)([
            "_4cvr1h6o _vchhusvi _1e0c1ule _ca0q1skh _u5f38vuz _n3td1crf _19bv1crf _1tkeckbl _1reoewfl _18m9ewfl _1bsb1osq _ect418gv _1iqs4jg8 _66a41wug _1pyn1wug _1wyb7vkz _1nx91osq _zg8l4jg8 _k48p1nn1 _1dyz4jg8 _vwz4cjiy _y3gn1e5h _azhwidpf _w19jglyw _1p1dglyw _3fcw1q9c _d5ymcfaq _1ccq4jg8 _syaz1bqd _bfhk1hxd _2rko14y2 _1itk1kto _1xys1hni _uokl1vk8 _12veeva1 _1lrw1yzm _lv3yidpf _wii51fhb _1rx61osq _19itglyw _80omtlke _wstuglyw _irr3uzct _nt751r31 _49pcglyw _1hvw1o36 _1ohht94y _1ya5nqa1 _858uu7gi _mizu1r31 _ra3xglyw _128m1o36 _1lwit94y _10knnqa1 _pojju7gi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: ""
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "Server to cloud",
                children: serverToCloud
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "Server to Data Center",
                children: serverToDataCenter
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "Data Center to Cloud",
                children: dataCenterToCloud
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "I don\u2019t know",
                children: iDontKnowYet
            })
        ]
    });
};
const $d0aa98f0fec04aa1$var$LearnAboutMigrationsDropdown = ({ onChangeHandler: onChangeHandler })=>{
    const [selectedOption, setSelectedOption] = (0, $1oC0p.useState)("");
    const onClick = (event)=>{
        const selected = String(event.target.value);
        setSelectedOption(selected);
        onChangeHandler?.(selected);
    };
    const intl = (0, $8e22h.default)();
    const pricingAndQuotes = intl.formatMessage({
        id: "migrationOptions.pricingAndQuotes",
        defaultMessage: "Pricing and quotes"
    });
    const securityAndCompliance = intl.formatMessage({
        id: "migrationOptions.securityAndCompliance",
        defaultMessage: "Security and compliance"
    });
    const productFeatures = intl.formatMessage({
        id: "migrationOptions.productFeatures",
        defaultMessage: "Product features"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
        id: "options",
        value: selectedOption,
        onChange: onClick,
        "data-testid": "migration-learn-options",
        className: (0, $2jatx.default)([
            "_4cvr1h6o _vchhusvi _1e0c1ule _ca0q1skh _u5f38vuz _n3td1crf _19bv1crf _1tkeckbl _1reoewfl _18m9ewfl _1bsb1osq _ect418gv _1iqs4jg8 _66a41wug _1pyn1wug _1wyb7vkz _1nx91osq _zg8l4jg8 _k48p1nn1 _1dyz4jg8 _vwz4cjiy _y3gn1e5h _azhwidpf _w19jglyw _1p1dglyw _3fcw1q9c _d5ymcfaq _1ccq4jg8 _syaz1bqd _bfhk1hxd _2rko14y2 _1itk1kto _1xys1hni _uokl1vk8 _12veeva1 _1lrw1yzm _lv3yidpf _wii51fhb _1rx61osq _19itglyw _80omtlke _wstuglyw _irr3uzct _nt751r31 _49pcglyw _1hvw1o36 _1ohht94y _1ya5nqa1 _858uu7gi _mizu1r31 _ra3xglyw _128m1o36 _1lwit94y _10knnqa1 _pojju7gi"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: ""
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "Pricing and quotes",
                children: pricingAndQuotes
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "Security and compliance",
                children: securityAndCompliance
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                value: "Product features",
                children: productFeatures
            })
        ]
    });
};
const $d0aa98f0fec04aa1$var$containerStyle = null;
const $d0aa98f0fec04aa1$var$innerContainerStyle = null;
// tech debt that should be addressed separately
const $d0aa98f0fec04aa1$var$formStyle = null;
const $d0aa98f0fec04aa1$var$textContainer = null;
const $d0aa98f0fec04aa1$var$MigrationOptions = ()=>{
    const intl = (0, $8e22h.default)();
    const userInfo = (0, $2ve7k.useLoggedInUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [fieldHasError, setFieldHasError] = (0, $1oC0p.useState)({});
    const [errorMessageText, setErrorMessageText] = (0, $1oC0p.useState)("");
    const [selectedProduct] = (0, $1oC0p.useState)("");
    const [isInvalid, setIsInvalid] = (0, $1oC0p.useState)(true);
    const [showProductField, setShowProductField] = (0, $1oC0p.useState)(false);
    const [changeContactInfo, setChangeContactInfo] = (0, $1oC0p.useState)(false);
    const [migrationDirection, setMigrationDirection] = (0, $1oC0p.useState)("");
    const NEXT_PUBLIC_IDENTITY_BASE_URL = "https://id.atlassian.com";
    const getSwitchAccountURL = (continueUrlParam)=>{
        const continueUrl = continueUrlParam ? continueUrlParam : window.location.href;
        return `${NEXT_PUBLIC_IDENTITY_BASE_URL}/login/select-account?continue=${encodeURIComponent(continueUrl)}`;
    };
    /* 
     Prompts
  */ const yourCompanyEmailPrompt = intl.formatMessage({
        id: "migrationOptions.yourCompanyEmail",
        defaultMessage: "Your company email"
    });
    const personalEmailDomainsErrorPrompt = intl.formatMessage({
        id: "migrationOptions.personalEmailDomainsPrompt",
        defaultMessage: "Personal email domains will result in an error."
    });
    const learnAboutMigrationsPrompt = intl.formatMessage({
        id: "migrationOptions.learnAboutMigrationsPrompt",
        defaultMessage: "This sets some context for our conversation."
    });
    /*
      Error Messages
  */ const firstNameErrorMessage = intl.formatMessage({
        id: "migrationOptions.firstNameErrorMessage",
        defaultMessage: "Your first name is required."
    });
    const lastNameErrorMessage = intl.formatMessage({
        id: "migrationOptions.lastNameErrorMessage",
        defaultMessage: "Your last name is required."
    });
    const companyErrorMessage = intl.formatMessage({
        id: "migrationOptions.companyErrorMessage",
        defaultMessage: "Your company name is required."
    });
    const jobTitleErrorMessage = intl.formatMessage({
        id: "migrationOptions.jobTitleErrorMessage",
        defaultMessage: "Your job title is required."
    });
    const migratingFromErrorMessage = intl.formatMessage({
        id: "migrationOptions.migratingFromErrorMessage",
        defaultMessage: "Select a migration path to continue."
    });
    const productErrorMessage = intl.formatMessage({
        id: "migrationOptions.productErrorMessage",
        defaultMessage: "Select a product or service to continue."
    });
    const notEmailErrorMessage = intl.formatMessage({
        id: "migrationOptions.notEmailErrorMessage",
        defaultMessage: "Enter a valid email address."
    });
    const personalDomainErrorMessage = intl.formatMessage({
        id: "migrationOptions.personalDomainErrorMessage",
        defaultMessage: "Enter an email with a company domain."
    });
    const whatDoYouWantToLearnErrorMessage = intl.formatMessage({
        id: "migrationOptions.whatDoYouWantToLearnErrorMessage",
        defaultMessage: "Select a topic to continue."
    });
    const yourQuestionErrorMessage = intl.formatMessage({
        id: "migrationOptions.yourQuestionErrorMessage",
        defaultMessage: "Enter a quick description of your question."
    });
    const userCountGreaterThan5000Error = intl.formatMessage({
        id: "migrationOptions.userCountErrorMessage",
        defaultMessage: "Enter a number that\u2019s less than 5,000,000."
    });
    const companyNameLengthError = intl.formatMessage({
        id: "migrationOptions.companyNameLengthErrorMessage",
        defaultMessage: "Enter a company name that\u2019s at least two characters."
    });
    const isPersonalDomain = (value)=>{
        const emailDomain = value.split("@")[1];
        return (0, $ai7AF.default).has(String(emailDomain));
    };
    // @ts-ignore
    const handleBlurEvent = (event)=>{
        const { name: name, value: value } = event.currentTarget;
        if (name === "email") {
            if (!value) {
                setFieldHasError({
                    ...fieldHasError,
                    [name]: true
                });
                setErrorMessageText("NOT_EMAIL");
                setIsInvalid(true);
            } else if ((0, $9xhTf.isEmailFormat)(value) && !isPersonalDomain(value)) {
                setFieldHasError({
                    ...fieldHasError,
                    [name]: false
                });
                setErrorMessageText("IS_VALID");
                setIsInvalid(false);
            } else {
                setFieldHasError({
                    ...fieldHasError,
                    [name]: true
                });
                setIsInvalid(true);
                if (!(0, $9xhTf.isEmailFormat)(value)) setErrorMessageText("NOT_EMAIL");
                else if (isPersonalDomain(value)) setErrorMessageText("PERSONAL_DOMAIN");
            }
        } else {
            setFieldHasError({
                ...fieldHasError,
                [name]: !value
            });
            setIsInvalid(!value);
        }
    };
    // eslint-disable-next-line complexity
    const handleSubmit = (form)=>{
        const errors = {};
        // eslint-disable-next-line @typescript-eslint/no-for-in-array
        for(const field in form)if (form[field] === undefined || fieldHasError[field]) switch(field){
            case "email":
                if (fieldHasError[field]) {
                    if (isPersonalDomain(form[field])) errors["email"] = personalDomainErrorMessage;
                }
                errors["email"] = notEmailErrorMessage;
                break;
            case "firstName":
                errors["firstName"] = firstNameErrorMessage;
                break;
            case "lastName":
                errors["lastName"] = lastNameErrorMessage;
                break;
            case "company":
                errors["company"] = companyErrorMessage;
                break;
            case "title":
                errors["title"] = jobTitleErrorMessage;
                break;
            case "migrationPath":
                errors["migrationPath"] = migratingFromErrorMessage;
                break;
            case "product":
                errors["product"] = productErrorMessage;
                break;
            case "numberOfUsers":
                errors["numberOfUsers"] = numberOfUsersProductErrorMessage;
                break;
            case "formChoices":
                errors["formChoices"] = whatDoYouWantToLearnErrorMessage;
                break;
            case "opportunity_Description__c":
                errors["opportunity_Description__c"] = yourQuestionErrorMessage;
                break;
        }
        if (Object.keys(errors).length > 0) return errors;
        else return (0, $9xhTf.submitContactForm)(form, "migration-options", createAnalyticsEvent).then(()=>{
            window.location.assign(redirectPath);
        }).catch(()=>{
            document.querySelector(".post-submit")?.classList.replace("post-submit", "post-submit-error");
        });
    };
    const localizedContactLink = (0, $kooLp.useLocalizedHref)("/contact");
    const redirectPath = (0, $kooLp.useLocalizedHref)(`/enterprise/contact-thanks?formType=migration-options`);
    const SubTextSection = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syazvwuj"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "migrationOptions.formBestFitMigrationPathSubText",
                        defaultMessage: "We can help you assess which migration path is the best fit for your Server or Data Center licenses."
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "migrationOptions.decidedToAlreadyMigrateSubText",
                        defaultMessage: "<span>If you've already decided to migrate, please <raiseASupportTicketLink>raise a support ticket</raiseASupportTicketLink> for help with migration planning and execution.</span>",
                        values: {
                            ...(0, $kooLp.DEFAULT_VALUES),
                            raiseASupportTicketLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    "aria-label": text,
                                    text: text,
                                    href: localizedContactLink,
                                    type: "inline"
                                })
                        }
                    })
                })
            ]
        });
    const MigrationFromField = (setFieldValue)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1q51ftgi"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                name: "migrationPath",
                label: intl.formatMessage({
                    id: "migrationOptions.migratingFrom",
                    defaultMessage: "Where are you migrating from?"
                }) + " *",
                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($d0aa98f0fec04aa1$var$MigratingFromDropdown, {
                                ...fieldProps,
                                onChangeHandler: (migrationPath)=>{
                                    setFieldValue("migrationPath", migrationPath);
                                    setShowProductField(true);
                                    setMigrationDirection(migrationPath);
                                    fieldProps.onChange;
                                }
                            }),
                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                children: migratingFromErrorMessage
                            })
                        ]
                    })
            })
        });
    };
    const ProductSelectorDropdown = ({ onChangeHandler: onChangeHandler })=>{
        const [selectedOption, setSelectedOption] = (0, $1oC0p.useState)("");
        const onClick = (event)=>{
            const selected = String(event.target.value);
            setSelectedOption(selected);
            onChangeHandler?.(selected);
        };
        const intl = (0, $8e22h.default)();
        const jiraSoftwareOption = intl.formatMessage({
            id: migrationDirection !== "Server to Data Center" ? "migrationOptions.jira" : "migrationOptions.jiraSoftware",
            defaultMessage: migrationDirection !== "Server to Data Center" ? "Jira" : "Jira Software"
        });
        const confluenceOption = intl.formatMessage({
            id: "migrationOptions.confluence",
            defaultMessage: "Confluence"
        });
        const bitbucketOption = intl.formatMessage({
            id: "migrationOptions.bitbucket",
            defaultMessage: "Bitbucket"
        });
        const crowdOption = intl.formatMessage({
            id: "migrationOptions.crowd",
            defaultMessage: "Crowd"
        });
        const jsmOption = intl.formatMessage({
            id: "migrationOptions.jsm",
            defaultMessage: "Jira Service Management"
        });
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("select", {
            id: "options",
            value: selectedOption,
            onChange: onClick,
            "data-testid": "migration-options-product-dropdown",
            className: (0, $2jatx.default)([
                "_4cvr1h6o _vchhusvi _1e0c1ule _ca0q1skh _u5f38vuz _n3td1crf _19bv1crf _1tkeckbl _1reoewfl _18m9ewfl _1bsb1osq _ect418gv _1iqs4jg8 _66a41wug _1pyn1wug _1wyb7vkz _1nx91osq _zg8l4jg8 _k48p1nn1 _1dyz4jg8 _vwz4cjiy _y3gn1e5h _azhwidpf _w19jglyw _1p1dglyw _3fcw1q9c _d5ymcfaq _1ccq4jg8 _syaz1bqd _bfhk1hxd _2rko14y2 _1itk1kto _1xys1hni _uokl1vk8 _12veeva1 _1lrw1yzm _lv3yidpf _wii51fhb _1rx61osq _19itglyw _80omtlke _wstuglyw _irr3uzct _nt751r31 _49pcglyw _1hvw1o36 _1ohht94y _1ya5nqa1 _858uu7gi _mizu1r31 _ra3xglyw _128m1o36 _1lwit94y _10knnqa1 _pojju7gi"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                    value: ""
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                    value: jiraSoftwareOption,
                    children: jiraSoftwareOption
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                    value: "Confluence",
                    children: confluenceOption
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                    value: "Bitbucket",
                    children: bitbucketOption
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                    value: "Crowd",
                    children: crowdOption
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("option", {
                    value: "Jira Service Management",
                    children: jsmOption
                })
            ]
        });
    };
    const ProductField = (setFieldValue)=>{
        return showProductField && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1q5114no"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                name: "product",
                label: intl.formatMessage({
                    id: "migrationOptions.product",
                    defaultMessage: "Which product are you inquiring about?"
                }) + " *",
                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)(ProductSelectorDropdown, {
                                ...fieldProps,
                                onChangeHandler: (product)=>{
                                    setFieldValue("product", product);
                                    fieldProps.onChange;
                                }
                            }),
                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                children: productErrorMessage
                            }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                children: intl.formatMessage({
                                    id: "migrationOptions.productHelper",
                                    defaultMessage: "If you want to migrate multiple products, select the one with the most users."
                                })
                            })
                        ]
                    })
            })
        });
    };
    const numberOfUsersProductErrorMessage = (0, $8e22h.default)().formatMessage({
        id: "migrationOptions.numberOfUsersProductErrorMessage",
        defaultMessage: "Enter the number of users for this product."
    });
    const WhatDoYouWantToLearnField = (setFieldValue)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1q5114no _85i514no"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                name: "formChoices",
                label: intl.formatMessage({
                    id: "migrationOptions.whatDoYouWantToLearn",
                    defaultMessage: "What do you want to learn about migrations?"
                }) + " *",
                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($d0aa98f0fec04aa1$var$LearnAboutMigrationsDropdown, {
                                ...fieldProps,
                                onChangeHandler: (formChoice)=>{
                                    setFieldValue("formChoices", formChoice);
                                    fieldProps.onChange;
                                }
                            }),
                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                children: whatDoYouWantToLearnErrorMessage
                            }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                children: learnAboutMigrationsPrompt
                            })
                        ]
                    })
            })
        });
    const FooterSection = (onSubmit)=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), {
                        inputType: "button",
                        text: intl.formatMessage({
                            id: "migrationOptions.submit",
                            defaultMessage: "Submit"
                        }),
                        type: "primary",
                        color: isInvalid ? "gray" : "darkblue",
                        onClick: ()=>{
                            onSubmit();
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "post-submit",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        children: intl.formatMessage({
                            id: "migrationOptions.submitError",
                            defaultMessage: "An error has occurred. Please try again later."
                        })
                    })
                })
            ]
        });
    const loggedOutView = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.SelectedProductProvider), {
        selectedProduct: selectedProduct,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_syazvwuj _vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4q6fz _k48pbfng _vwz41tcg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _1ul91ssb _p12f1o9t"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)(SubTextSection, {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                            onSubmit: handleSubmit,
                            children: ({ formProps: formProps, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                                    ...formProps,
                                    className: (0, $2jatx.default)([
                                        "_1bsb1osq _18dc18gv _ytel1j6v _jgjs8pqr _wdh21du8 _mg90ftgi _10wcidpf _ruzhftgi _19tgidpf _hi82bfng _lmjx1k92 _1noh18gv _tyq318gv _1oya1j6v _18961du8 _1pxw1tcg _10rvglyw _1vua18gv _y9t31j6v _1krm1j6v _dmb71tcg _9bbqidpf _1qqcidpf _wzdj1hxd _yh561j28 _ud0z14y2 _1c1o8pqr _1iiy18gv _1c251nn1 _1h2z17ve _iu668pqr _s58r1jbj _1kmwmzrp _dvul17ve _bxhfviql _v71b14y2 _1jd91hrf _16w9idpf _lyghidpf _x68d1hxd _1c8s1j28 _wqgkviql _15re1k8s _1kylkwu8 _v0s8cs5v _1o6rg42f _1hod15vq _1rzv15vq _1k52kb7n _l85aj6kd _upgaglyw _mnhm1ule _rr0p1du8"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                name: "email",
                                                label: yourCompanyEmailPrompt + " *",
                                                validate: (value)=>{
                                                    setFieldValue("email", value);
                                                },
                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                ...fieldProps,
                                                                value: fieldProps.value || "",
                                                                onBlur: handleBlurEvent
                                                            }),
                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                children: errorMessageText === "NOT_EMAIL" ? notEmailErrorMessage : errorMessageText === "PERSONAL_DOMAIN" ? personalDomainErrorMessage : error
                                                            }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                children: personalEmailDomainsErrorPrompt
                                                            })
                                                        ]
                                                    })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                                                    layout: "6-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                            name: "firstName",
                                                            label: intl.formatMessage({
                                                                id: "migrationOptions.forename",
                                                                defaultMessage: "First name"
                                                            }) + " *",
                                                            children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                            ...fieldProps,
                                                                            value: fieldProps.value || "",
                                                                            onBlur: handleBlurEvent
                                                                        }),
                                                                        error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                            children: firstNameErrorMessage
                                                                        })
                                                                    ]
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                            name: "lastName",
                                                            label: intl.formatMessage({
                                                                id: "migrationOptions.surname",
                                                                defaultMessage: "Last name"
                                                            }) + " *",
                                                            children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                            ...fieldProps,
                                                                            value: fieldProps.value || "",
                                                                            onBlur: handleBlurEvent
                                                                        }),
                                                                        error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                            children: lastNameErrorMessage
                                                                        })
                                                                    ]
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                                                    layout: "6-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                            name: "company",
                                                            label: intl.formatMessage({
                                                                id: "migrationOptions.company",
                                                                defaultMessage: "Company"
                                                            }) + " *",
                                                            children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                            ...fieldProps,
                                                                            value: fieldProps.value || "",
                                                                            onBlur: handleBlurEvent
                                                                        }),
                                                                        error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                            children: companyErrorMessage
                                                                        })
                                                                    ]
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                            name: "title",
                                                            label: intl.formatMessage({
                                                                id: "migrationOptions.title",
                                                                defaultMessage: "Job title"
                                                            }) + " *",
                                                            children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                            ...fieldProps,
                                                                            value: fieldProps.value || "",
                                                                            onBlur: handleBlurEvent
                                                                        }),
                                                                        error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                            children: jobTitleErrorMessage
                                                                        })
                                                                    ]
                                                                })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
                                            children: [
                                                MigrationFromField(setFieldValue),
                                                ProductField(setFieldValue),
                                                (0, $3bkHm.NumberOfUsersField)(setFieldValue),
                                                WhatDoYouWantToLearnField(setFieldValue),
                                                (0, $e0MOs.QuestionField)("migration-options", handleBlurEvent)
                                            ]
                                        }),
                                        (0, $lBgvn.ConsentInfo)(setFieldValue),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gacwQ.default), {
                                            align: "start",
                                            children: FooterSection(formProps.onSubmit)
                                        })
                                    ]
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Fvhz.default), {})
            ]
        })
    });
    const loggedInView = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.SelectedProductProvider), {
        selectedProduct: selectedProduct,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_syazvwuj _vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4q6fz _k48pbfng _vwz41tcg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _1ul91ssb _p12f1o9t"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)(SubTextSection, {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                            onSubmit: handleSubmit,
                            children: ({ formProps: formProps, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                                    ...formProps,
                                    className: (0, $2jatx.default)([
                                        "_1bsb1osq _18dc18gv _ytel1j6v _jgjs8pqr _wdh21du8 _mg90ftgi _10wcidpf _ruzhftgi _19tgidpf _hi82bfng _lmjx1k92 _1noh18gv _tyq318gv _1oya1j6v _18961du8 _1pxw1tcg _10rvglyw _1vua18gv _y9t31j6v _1krm1j6v _dmb71tcg _9bbqidpf _1qqcidpf _wzdj1hxd _yh561j28 _ud0z14y2 _1c1o8pqr _1iiy18gv _1c251nn1 _1h2z17ve _iu668pqr _s58r1jbj _1kmwmzrp _dvul17ve _bxhfviql _v71b14y2 _1jd91hrf _16w9idpf _lyghidpf _x68d1hxd _1c8s1j28 _wqgkviql _15re1k8s _1kylkwu8 _v0s8cs5v _1o6rg42f _1hod15vq _1rzv15vq _1k52kb7n _l85aj6kd _upgaglyw _mnhm1ule _rr0p1du8"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            children: intl.formatMessage({
                                                id: "migrationOptions.contactInfo",
                                                defaultMessage: "You're logged in as:"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                            children: setFieldValue("email", userInfo.email)
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                            children: setFieldValue("name", userInfo.name)
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                            className: (0, $2jatx.default)([
                                                "_1wyb1k92"
                                            ]),
                                            children: [
                                                userInfo.name,
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                                userInfo.email
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1wyboqnp _syazrbzz _59381r31 _yha2glyw _1nmznqa1 _43dsrbzz _1hw71o8l _1r8v1ul9 _1enu1j6v _6b8d1j28"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                                    href: "#changeContactInfo",
                                                    onClick: ()=>setChangeContactInfo(true),
                                                    children: [
                                                        intl.formatMessage({
                                                            id: "migrationOptions.updateInfo",
                                                            defaultMessage: "Update contact info"
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_z6uan7od"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                                                label: ""
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                                    href: getSwitchAccountURL(),
                                                    children: [
                                                        intl.formatMessage({
                                                            id: "migrationOptions.differentAccount",
                                                            defaultMessage: "Log in with a different Atlassian account"
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_z6uan7od"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                                                label: ""
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                name: "title",
                                                label: intl.formatMessage({
                                                    id: "migrationOptions.yourJobTitle",
                                                    defaultMessage: "Your job title"
                                                }) + " *",
                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                ...fieldProps,
                                                                value: fieldProps.value || "",
                                                                onBlur: handleBlurEvent
                                                            }),
                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                children: jobTitleErrorMessage
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                children: intl.formatMessage({
                                                                    id: "migrationOptions.yourJobTitleHelper",
                                                                    defaultMessage: "We ask this to connect you to the best expert for your role."
                                                                })
                                                            })
                                                        ]
                                                    })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
                                            children: [
                                                MigrationFromField(setFieldValue),
                                                ProductField(setFieldValue),
                                                (0, $3bkHm.NumberOfUsersField)(setFieldValue),
                                                WhatDoYouWantToLearnField(setFieldValue),
                                                (0, $e0MOs.QuestionField)("migration-options", handleBlurEvent)
                                            ]
                                        }),
                                        (0, $lBgvn.ConsentInfo)(setFieldValue),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gacwQ.default), {
                                            align: "start",
                                            children: FooterSection(formProps.onSubmit)
                                        })
                                    ]
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Fvhz.default), {})
            ]
        })
    });
    if (userInfo.isUserLoggedIn && userInfo.email) {
        if (isPersonalDomain(userInfo.email) || userInfo.email.includes("atlassian.com") || changeContactInfo) return loggedOutView;
        else return loggedInView;
    }
    return loggedOutView;
};
var $d0aa98f0fec04aa1$export$2e2bcd8739ae039 = $d0aa98f0fec04aa1$var$MigrationOptions;

});
parcelRegister("lBgvn", function(module, exports) {
$parcel$export(module.exports, "ConsentInfo", function () { return $1d00cd15230eb761$export$99cac8d72a646928; });
/* consent-info.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");
var $kR3EL = parcelRequire("kR3EL");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $hhv63 = parcelRequire("hhv63");
const $1d00cd15230eb761$var$privacyPolicyParagraphStyle = null;
const $1d00cd15230eb761$var$linkStyle = null;
const $1d00cd15230eb761$var$consentBoxTextStyle = null;
const $1d00cd15230eb761$export$99cac8d72a646928 = (setFieldValue)=>{
    const locale = (0, $hhv63.useConsentHubClientConfig)();
    const intl = (0, $8e22h.default)();
    const privacyLink = (0, $kooLp.useLocalizedHref)("/legal/privacy-policy");
    const [showConsent, setShowConsent] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        if (!locale.localeRequiresMarketingCommunicationOptIn) {
            setShowConsent(false);
            setFieldValue("consent", true);
        }
    }, [
        locale.localeRequiresMarketingCommunicationOptIn,
        setFieldValue
    ]);
    const PrivacyPolicyComponent = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            className: (0, $2jatx.default)([
                "_syazvwuj"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "enterpriseContactSales.privacyPolicy",
                defaultMessage: "By submitting this form, I acknowledge receipt of Atlassian's <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.",
                values: {
                    ...(0, $kooLp.DEFAULT_VALUES),
                    privacyPolicyLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                            text: text,
                            href: privacyLink,
                            type: "inline",
                            className: (0, $2jatx.default)([
                                "_30l3r3uz _1up4glyw _9oik1r31 _1bnx8stv _jf4cnqa1"
                            ])
                        })
                }
            })
        })
    });
    const ConsentComponent = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
        name: "consent",
        children: ({ fieldProps: { isRequired: isRequired, isDisabled: isDisabled, isInvalid: isInvalid, ...validProps } })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                        type: "checkbox",
                        ...validProps
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                        htmlFor: "consent",
                        className: (0, $2jatx.default)([
                            "_ect4hikz _1wyb7vkz _k48pbfng _vwz4bs82 _syazvwuj"
                        ]),
                        children: intl.formatMessage({
                            id: "enterpriseContactSales.consent",
                            defaultMessage: "Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates."
                        })
                    })
                ]
            })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
            children: [
                PrivacyPolicyComponent,
                showConsent && ConsentComponent
            ]
        })
    });
};

});

parcelRegister("3bkHm", function(module, exports) {
$parcel$export(module.exports, "NumberOfUsersField", function () { return $9a66b9fcb0b09791$export$350ae1f4a524679c; });
$parcel$export(module.exports, "NumberOfUsersInput", function () { return $9a66b9fcb0b09791$export$ff93b145cbbace9e; });
/* number-of-users-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $ff3wF = parcelRequire("ff3wF");
var $igGC3 = parcelRequire("igGC3");
const $9a66b9fcb0b09791$export$bc90e1fab1ccc92 = {
    id: "migrationOptions.numberOfUsersProductErrorMessage",
    defaultMessage: "Enter the number of users for this product."
};
const $9a66b9fcb0b09791$export$350ae1f4a524679c = (setFieldValue)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1q5114no"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            name: "numberOfUsers",
            label: (0, $8e22h.default)().formatMessage({
                id: "migrationOptions.numberOfUsersForProduct",
                defaultMessage: "Number of users for this product"
            }) + " *",
            children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($9a66b9fcb0b09791$export$ff93b145cbbace9e, {
                            ...fieldProps,
                            onChangeHandler: (numberOfUsers)=>{
                                setFieldValue("numberOfUsers", Number(numberOfUsers));
                                fieldProps.onChange;
                            }
                        }),
                        error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                            children: intl.formatMessage($9a66b9fcb0b09791$export$bc90e1fab1ccc92)
                        })
                    ]
                })
        })
    });
};
const $9a66b9fcb0b09791$export$ff93b145cbbace9e = ({ onChangeHandler: onChangeHandler })=>{
    const [numberOfUsers, setNumberOfUsers] = (0, $1oC0p.useState)("");
    const inputStyle = null;
    const handleChange = (event)=>{
        const inputValue = event.target.value;
        setNumberOfUsers(inputValue);
        onChangeHandler?.(inputValue);
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
        type: "number",
        min: "1",
        value: numberOfUsers,
        onChange: handleChange,
        className: (0, $2jatx.default)([
            "_vchhusvi _1e0c1ule _bozgw1gv _y4tigktf _1tkeckbl _1bsb1osq _k48p1nn1 _1dyz4jg8 _y3gnv2br _vwz4cs5v _2rko14y2 _syaz1bqd _bfhk1hxd _19itglyw _lv3yidpf _wii51fhb _1rx61osq _80om1kdv _wstuglyw _858uu7gi _1ya5nqa1 _1mb8t94y _nt751r31 _49pcglyw _1hvwidpf _pojju7gi _10knnqa1 _1wyst94y _mizu1r31 _ra3xglyw _128midpf"
        ])
    });
};

});

parcelRegister("izhAl", function(module, exports) {
$parcel$export(module.exports, "SelectedProductProvider", function () { return $fc81eb68b85a0e06$export$62e7d2f649413b82; });
$parcel$export(module.exports, "ProductSelector", function () { return $fc81eb68b85a0e06$export$2e2ab7553631f1f9; });
/* product-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $3L8ZR = parcelRequire("3L8ZR");

var $5RBBI = parcelRequire("5RBBI");

var $99VqK = parcelRequire("99VqK");
var $4HBPY = parcelRequire("4HBPY");

var $lawKK = parcelRequire("lawKK");
var $9T4IS = parcelRequire("9T4IS");
var $6dioi = parcelRequire("6dioi");

var $2tb46 = parcelRequire("2tb46");

var $32ng3 = parcelRequire("32ng3");

var $9xhTf = parcelRequire("9xhTf");

var $89erU = parcelRequire("89erU");
const $fc81eb68b85a0e06$var$SelectedProductContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    selectedProduct: ""
});
const $fc81eb68b85a0e06$export$387e1da2bc9c93cc = ()=>{
    const context = (0, $1oC0p.useContext)($fc81eb68b85a0e06$var$SelectedProductContext);
    if (!context) throw new Error("useSelectedProduct must be used within a SelectedProductProvider");
    return context;
};
const $fc81eb68b85a0e06$export$62e7d2f649413b82 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($fc81eb68b85a0e06$var$SelectedProductContext.Provider, {
        value: {
            selectedProduct: props.selectedProduct
        },
        children: props.children
    });
};
const $fc81eb68b85a0e06$var$prefillableProducts = {
    rovo: "Rovo"
};
const $fc81eb68b85a0e06$var$cloudPlatform = "Cloud";
const $fc81eb68b85a0e06$var$customTabStyles = (0, $4HBPY.xcss)({
    alignItems: "flex-start",
    boxSizing: "border-box",
    display: "block",
    fontFamily: `"Charlie Text", -apple-system, "system-ui", "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`,
    fontFeatureSettings: "normal",
    fontKerning: "auto",
    fontOpticalSizing: "auto",
    fontSize: "16px",
    fontStretch: "100%",
    fontStyle: "normal",
    fontVariationSettings: "normal",
    fontWeight: "400",
    letterSpacing: "normal",
    lineHeight: "normal",
    textAlign: "center",
    textIndent: "0px",
    textShadow: "none",
    textTransform: "none",
    wordSpacing: "0px"
});
const $fc81eb68b85a0e06$var$getDataEventProps = (text, key)=>{
    return {
        "data-label": text || "",
        "data-product-key": key || "",
        "data-event-component": "link",
        "data-event-container": "productSelector",
        "data-event": "clicked",
        "data-label-english": text
    };
};
const $fc81eb68b85a0e06$var$CustomTab = ({ label: label })=>{
    const tabAttributes = (0, $6dioi.useTab)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $99VqK.default), {
        xcss: $fc81eb68b85a0e06$var$customTabStyles,
        ...tabAttributes,
        children: label
    });
};
const $fc81eb68b85a0e06$export$e8adbb537d20ae7e = "Data Center";
const $fc81eb68b85a0e06$export$d82021d7cba718da = [
    {
        key: "jira-software",
        text: "Jira Software",
        dataEventProps: {
            "data-product-key": "jiraSoftware"
        }
    },
    {
        key: "confluence",
        text: "Confluence",
        dataEventProps: {
            "data-product-key": "confluence"
        }
    },
    {
        key: "jira-service-management",
        text: "Jira Service Management",
        dataEventProps: {
            "data-product-key": "jiraServiceManagement"
        }
    },
    {
        key: "bitbucket",
        text: "Bitbucket",
        dataEventProps: {
            "data-product-key": "bitbucket"
        }
    },
    {
        key: "bamboo",
        text: "Bamboo",
        dataEventProps: {
            "data-product-key": "bamboo"
        }
    },
    {
        key: "crowd",
        text: "Crowd",
        dataEventProps: {
            "data-product-key": "crowd"
        }
    }
];
const $fc81eb68b85a0e06$var$DCTab = ({ onClick: onClick })=>{
    const intl = (0, $8e22h.default)();
    const premierSupportText = intl.formatMessage({
        id: "migrationProductSelector.premierSupport",
        defaultMessage: "Premier Support"
    });
    const prioritySupportText = intl.formatMessage({
        id: "migrationProductSelector.prioritySupport",
        defaultMessage: "Priority Support"
    });
    const advisoryServicesText = intl.formatMessage({
        id: "migrationProductSelector.advisoryServices",
        defaultMessage: "Advisory Services"
    });
    const tabPanelAttributes = (0, $6dioi.useTabPanel)();
    const dataCenterProductsText = intl.formatMessage({
        id: "migrationProductSelector.dataCenterProducts",
        defaultMessage: "Data Center Products"
    });
    const dataCenterServicesLinkButtonProps = [
        {
            key: "premier-support",
            // text is internationalized here, but we don't want to use the internalized text
            // for the data-label-english attribute; but do we want to use it for the data-label
            // attribute? i think we should use the internalized text for the data-label attribute
            // but currently in prod it isn't internationalized
            text: premierSupportText,
            dataEventProps: {
                "data-label": "Premier Support",
                "data-label-english": "Premier Support",
                "data-product-key": "support"
            }
        },
        {
            key: "priority-support",
            text: prioritySupportText,
            dataEventProps: {
                "data-label": "Priority Support",
                "data-label-english": "Priority Support",
                "data-product-key": "support"
            }
        },
        {
            key: "advisory-services",
            text: advisoryServicesText,
            dataEventProps: {
                "data-label": "Advisory Services",
                "data-label-english": "Advisory Services",
                "data-product-key": "support"
            }
        }
    ];
    const servicesText = intl.formatMessage({
        id: "migrationProductSelector.services",
        defaultMessage: "Services"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ...tabPanelAttributes,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                headerType: "h5",
                headerText: dataCenterProductsText,
                bodyComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: $fc81eb68b85a0e06$export$d82021d7cba718da.map(({ key: key, text: text, dataEventProps: dataEventProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $89erU.Option), {
                            ...$fc81eb68b85a0e06$var$getDataEventProps(text, key),
                            ...dataEventProps,
                            onClick: onClick($fc81eb68b85a0e06$export$e8adbb537d20ae7e),
                            children: text
                        }, key))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                headerText: servicesText,
                headerType: "h5",
                bodyComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: dataCenterServicesLinkButtonProps.map(({ key: key, text: text, dataEventProps: dataEventProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $89erU.Option), {
                            ...$fc81eb68b85a0e06$var$getDataEventProps(text, key),
                            ...dataEventProps,
                            onClick: onClick($fc81eb68b85a0e06$export$e8adbb537d20ae7e),
                            children: text
                        }, key))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthgktf"
                ])
            })
        ]
    });
};
const $fc81eb68b85a0e06$var$CloudTab = ({ pageType: pageType, onClick: onClick })=>{
    const intl = (0, $8e22h.default)();
    const removeRovoFromPricingPage = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp5682RemoveRovoFromPricingForm);
    const isOpsgenieEOL = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp6474RemoveOpsgenieContactSalesForm);
    const isTwCEnabled = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-twc");
    const isStrategyCollectionEnabled = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-strategy-collection");
    const isServiceCollectionEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8165EnterpriseContactServiceCollection);
    const isBackupRestoreEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9763BackupRestoreContactForm);
    const isAdditionalSandboxEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9608AdditionalSandboxContactForm);
    const isAtlassianIsolatedCloudEnabled = (0, $9xhTf.isAtlassianIsolatedCloudContactFormEnabled)();
    const sunsetCompass = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp1072SunsetCompass);
    const cloudProductsText = intl.formatMessage({
        id: "migrationProductSelector.cloudProducts",
        defaultMessage: "Cloud Products"
    });
    const servicesText = intl.formatMessage({
        id: "migrationProductSelector.services",
        defaultMessage: "Services"
    });
    const advisoryServicesText = intl.formatMessage({
        id: "migrationProductSelector.advisoryServices",
        defaultMessage: "Advisory Services"
    });
    const cloudProductsLinkButtonProps = [
        {
            key: "atlassian-access",
            text: "Atlassian Guard",
            dataEventProps: {
                "data-product-key": "atlassianGuard"
            }
        },
        ...isAtlassianIsolatedCloudEnabled ? [
            {
                key: "atlassian-isolated-cloud",
                text: (0, $9xhTf.ATLASSIAN_ISOLATED_CLOUD_PRODUCT),
                dataEventProps: {
                    "data-product-key": "atlassianIsolatedCloud"
                }
            }
        ] : [],
        {
            key: "bitbucket",
            text: "Bitbucket",
            dataEventProps: {
                "data-product-key": "bitbucket"
            }
        },
        ...!sunsetCompass ? [
            {
                key: "compass",
                text: "Compass",
                dataEventProps: {
                    "data-product-key": "compass"
                }
            }
        ] : [],
        {
            key: "confluence",
            text: "Confluence",
            dataEventProps: {
                "data-product-key": "confluence"
            }
        },
        ...isBackupRestoreEnabled ? [
            {
                key: "confluence-cloud-backup-restore",
                text: "Confluence Cloud Backup and Restore",
                dataEventProps: {
                    "data-product-key": "confluenceCloudBackupRestore"
                }
            }
        ] : [],
        ...isAdditionalSandboxEnabled ? [
            {
                key: "confluence-additional-sandbox",
                text: "Confluence Additional Sandbox",
                dataEventProps: {
                    "data-product-key": "confluenceAdditionalSandbox"
                }
            }
        ] : [],
        {
            key: "jira",
            text: "Jira",
            dataEventProps: {
                "data-product-key": "jira"
            }
        },
        ...!isTwCEnabled ? [
            {
                key: "jira-align",
                text: "Jira Align",
                dataEventProps: {
                    "data-product-key": "jiraAlign"
                }
            }
        ] : [],
        ...isBackupRestoreEnabled ? [
            {
                key: "jira-cloud-backup-restore",
                text: "Jira Cloud Backup and Restore",
                dataEventProps: {
                    "data-product-key": "jiraCloudBackupRestore"
                }
            }
        ] : [],
        {
            key: "jira-product-discovery",
            text: "Jira Product Discovery",
            dataEventProps: {
                "data-product-key": "jiraProductDiscovery"
            }
        },
        {
            key: "jira-service-management",
            text: "Jira Service Management",
            dataEventProps: {
                "data-product-key": "jiraServiceManagement"
            }
        },
        {
            key: "jira-service-management-assets",
            text: "Jira Service Management Assets",
            dataEventProps: {
                "data-product-key": "jiraServiceManagementAssets"
            }
        },
        {
            key: "jira-service-management-virtual-service-agent",
            text: "Jira Service Management Virtual Service Agent",
            dataEventProps: {
                "data-product-key": "jiraServiceManagementVirtualServiceAgent"
            }
        },
        ...isBackupRestoreEnabled ? [
            {
                key: "jira-service-management-cloud-backup-restore",
                text: "Jira Service Management Cloud Backup and Restore",
                dataEventProps: {
                    "data-product-key": "jiraServiceManagementCloudBackupRestore"
                }
            }
        ] : [],
        ...isAdditionalSandboxEnabled ? [
            {
                key: "jira-additional-sandbox",
                text: "Jira Additional Sandbox",
                dataEventProps: {
                    "data-product-key": "jiraAdditionalSandbox"
                }
            }
        ] : [],
        ...isAdditionalSandboxEnabled ? [
            {
                key: "jira-product-discovery-additional-sandbox",
                text: "Jira Product Discovery Additional Sandbox",
                dataEventProps: {
                    "data-product-key": "jiraProductDiscoveryAdditionalSandbox"
                }
            }
        ] : [],
        ...isAdditionalSandboxEnabled ? [
            {
                key: "jira-service-management-additional-sandbox",
                text: "Jira Service Management Additional Sandbox",
                dataEventProps: {
                    "data-product-key": "jiraServiceManagementAdditionalSandbox"
                }
            }
        ] : [],
        {
            key: "loom",
            text: "Loom",
            dataEventProps: {
                "data-product-key": "loom"
            }
        },
        ...!isOpsgenieEOL ? [
            {
                key: "opsgenie",
                text: "Opsgenie",
                dataEventProps: {
                    "data-product-key": "opsgenie"
                }
            }
        ] : [],
        ...!removeRovoFromPricingPage || pageType !== "pricing-quotes" ? [
            {
                key: "rovo",
                text: "Rovo",
                dataEventProps: {
                    "data-product-key": "rovo"
                }
            }
        ] : [],
        ...isServiceCollectionEnabled ? [
            {
                key: "service-collection",
                text: "Service Collection",
                dataEventProps: {
                    "data-product-key": "serviceCollection"
                }
            }
        ] : [],
        ...isStrategyCollectionEnabled ? [
            {
                key: "strategy-collection",
                text: "Strategy Collection",
                dataEventProps: {
                    "data-product-key": "strategyCollection"
                }
            }
        ] : [],
        ...isTwCEnabled ? [
            {
                key: "teamwork-collection",
                text: "Teamwork Collection",
                dataEventProps: {
                    "data-product-key": "teamworkCollection"
                }
            }
        ] : [],
        {
            key: "trello",
            text: "Trello",
            dataEventProps: {
                "data-product-key": "trello"
            }
        }
    ];
    const tabPanelAttributes = (0, $6dioi.useTabPanel)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ...tabPanelAttributes,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                headerType: "h5",
                orientation: "vertical",
                headerText: cloudProductsText,
                bodyComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: cloudProductsLinkButtonProps.map(({ key: key, text: text, dataEventProps: dataEventProps })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $89erU.Option), {
                            ...$fc81eb68b85a0e06$var$getDataEventProps(text, key),
                            ...dataEventProps,
                            onClick: onClick($fc81eb68b85a0e06$var$cloudPlatform),
                            children: text
                        }, key))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                headerText: servicesText,
                headerType: "h5",
                orientation: "vertical",
                bodyComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $89erU.Option), {
                        ...$fc81eb68b85a0e06$var$getDataEventProps(advisoryServicesText, "advisoryServices"),
                        "data-label": "Advisory Services",
                        "data-label-english": "Advisory Services",
                        onClick: onClick($fc81eb68b85a0e06$var$cloudPlatform),
                        children: advisoryServicesText
                    }, "advisoryServices")
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthgktf"
                ])
            })
        ]
    });
};
const $fc81eb68b85a0e06$export$2e2ab7553631f1f9 = ({ onChangeHandler: onChangeHandler, pageType: pageType })=>{
    const [isOpen, setIsOpen] = (0, $1oC0p.useState)(false);
    const toggleOpen = ()=>{
        setIsOpen(!isOpen);
    };
    const [selectedOption, setSelectedOption] = (0, $1oC0p.useState)("");
    (0, $1oC0p.useEffect)(()=>{
        if (selectedOption === "") {
            const urlParams = new URLSearchParams(window.location.search);
            const initialProduct = urlParams.get("product")?.toLowerCase();
            if (initialProduct && $fc81eb68b85a0e06$var$prefillableProducts[initialProduct]) {
                setSelectedOption($fc81eb68b85a0e06$var$prefillableProducts[initialProduct]);
                onChangeHandler?.(initialProduct, $fc81eb68b85a0e06$var$cloudPlatform);
            }
        }
    }, [
        onChangeHandler,
        selectedOption
    ]);
    const productSelectorButtonStyle = [
        isOpen && null,
        !isOpen && null
    ];
    const productSelectorStyle = [
        isOpen && null,
        !isOpen && null
    ];
    const divCss = null;
    const onClick = (platform)=>(event)=>{
            const selected = String(event.currentTarget.dataset["label"]);
            setSelectedOption(selected);
            onChangeHandler?.(selected, platform);
            toggleOpen();
        };
    const tabs = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lawKK.default), {
        id: "product-selector",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9T4IS.default), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($fc81eb68b85a0e06$var$CustomTab, {
                        label: "Cloud"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($fc81eb68b85a0e06$var$CustomTab, {
                        label: "Data Center"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($fc81eb68b85a0e06$var$CloudTab, {
                pageType: pageType || "product-features",
                onClick: onClick
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($fc81eb68b85a0e06$var$DCTab, {
                onClick: onClick
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ect41flk _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1bsb1osq",
            "product-selector"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                type: "button",
                onClick: toggleOpen,
                className: (0, $2jatx.default)([
                    isOpen && "_1h6d1j28 _2rko1y44 _80omtlke _1e0c1txw _2lx2vrvc _1bah1yb4 _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4cvr1h6o _1qi0cs5v _tgs01j6v _rkvr1j6v _rywr1r31 _q4l3glyw _1ruunqa1 _n75918gv _1tp5usic _mdp01sub",
                    !isOpen && "_1h6d1j28 _2rko1y44 _80omtlke _1e0c1txw _2lx2vrvc _1bah1yb4 _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4cvr1h6o _1qi0cs5v _tgs01j6v _rkvr1j6v _rywr1r31 _q4l3glyw _1ruunqa1 _n75918gv _1tp5usic"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: "selected-option",
                        children: selectedOption
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: "arrow-down-icon",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RBBI))), {
                            label: isOpen ? "close menu" : "open menu"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    isOpen && "_1e0c1txw _2lx21bp4 _10ojagmp _1bsb1osq _1c3y1txw _5sqh1bp4 _1b2k11yk _hkvy1j6v _1yhx1nn1 _1qupo7ao _1v7hftgi _mcleo7ao _1at0ftgi _1ay04jg8 _1uf74jg8 _1quzr3uz _18z11y6m _1brjusvi _1cqa1ule _r10m4jg8 _26ke1wug _grvr1wug _1bh11osq _1snl4jg8 _rsv71h6o _g8j8idpf _wpl2glyw _143dglyw _1805idpf _1oazrbzz _163zrbzz _1n21tlke _1lpynqa1 _m2u8o7ao _1xi1ftgi _90o8o7ao _44jqftgi _18qtnkcj _12kz1j6v _aodzidpf _1k241j6v _1r6eidpf _hyslidpf _zvomidpf _xwbgidpf _esyridpf _o7cbnsd6 _mvqe18gv _auaybfng _aazrangw _ixhlt94y _1j8d1crf _1nazoqnp _1ee81txw _11of1bp4 _ow6u1y6m _1k99ftgi _13hxidpf _1f22ftgi _e0zmidpf _11c81nn1 _efjridpf _zqslidpf _3bxtidpf _1w8gidpf _8xawidpf _144pidpf _la7qidpf _ier6idpf _1d2yr3uz _115iglyw _5dta1r31 _69rz8stv _k2o0nqa1 _a8d3idpf",
                    !isOpen && "_1e0cglyw _10ojagmp _1bsb1osq _1c3y1txw _5sqh1bp4 _12kz1j6v _aodzidpf _1k241j6v _1r6eidpf _hyslidpf _zvomidpf _xwbgidpf _esyridpf _o7cbnsd6 _mvqe18gv _auaybfng _aazrangw _ixhlt94y _1j8d1crf _1nazoqnp _1ee81txw _11of1bp4 _ow6u1y6m _11c81nn1 _efjridpf _zqslidpf _3bxtidpf _1w8gidpf _8xawidpf _144pidpf _la7qidpf _ier6idpf _1d2yr3uz _115iglyw _5dta1r31 _69rz8stv _k2o0nqa1 _a8d3idpf"
                ]),
                children: tabs
            })
        ]
    });
};

});
parcelRegister("lawKK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f693f033a1373d3c$export$2e2bcd8739ae039; });

var $j7Iem = parcelRequire("j7Iem");

var $8Aq0Q = parcelRequire("8Aq0Q");

var $byC10 = parcelRequire("byC10");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $gJJny = parcelRequire("gJJny");

var $hdvAu = parcelRequire("hdvAu");

var $btjy5 = parcelRequire("btjy5");

var $bJ4Xk = parcelRequire("bJ4Xk");

var $34TA1 = parcelRequire("34TA1");
function $f693f033a1373d3c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f693f033a1373d3c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f693f033a1373d3c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $j7Iem.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f693f033a1373d3c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f693f033a1373d3c$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    maxWidth: '100%',
    minHeight: '0%',
    flexBasis: '100%',
    flexDirection: 'column',
    flexGrow: 1
});
var $f693f033a1373d3c$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "@atlaskit/tabs",
    packageVersion: "13.4.9"
};
var $f693f033a1373d3c$var$getTabPanelWithContext = function getTabPanelWithContext(_ref) {
    var tabPanel = _ref.tabPanel, index = _ref.index, isSelected = _ref.isSelected, tabsId = _ref.tabsId;
    return(// Ensure tabPanel exists in case it has been removed
    tabPanel && (0, $3dJ4i.jsx)((0, $btjy5.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: "".concat(tabsId, "-").concat(index, "-tab"),
            hidden: isSelected ? undefined : true,
            'aria-labelledby': "".concat(tabsId, "-").concat(index),
            onMouseDown: (0, $34TA1.onMouseDownBlur),
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel));
};
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $f693f033a1373d3c$var$Tabs = function Tabs(props) {
    var _props$shouldUnmountT = props.shouldUnmountTabPanelOnChange, shouldUnmountTabPanelOnChange = _props$shouldUnmountT === void 0 ? false : _props$shouldUnmountT, SelectedType = props.selected, defaultSelected = props.defaultSelected, onChangeProp = props.onChange, id = props.id, analyticsContext = props.analyticsContext, children = props.children, testId = props.testId;
    var _useGlobalTheme = (0, $hdvAu.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var _useState = (0, $1oC0p.useState)(SelectedType || defaultSelected || 0), _useState2 = (0, $byC10.default)(_useState, 2), selectedState = _useState2[0], setSelected = _useState2[1];
    var selected = SelectedType === undefined ? selectedState : SelectedType;
    var childrenArray = (0, $1oC0p.Children).toArray(children)// Don't include any conditional children
    .filter(function(child) {
        return Boolean(child);
    });
    // First child should be a tabList followed by tab panels
    var _childrenArray = (0, $8Aq0Q.default)(childrenArray), tabList = _childrenArray[0], tabPanels = _childrenArray.slice(1);
    // Keep track of visited and add to a set
    var visited = (0, $1oC0p.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    var onChange = (0, $1oC0p.useCallback)(function(index, analyticsEvent) {
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    var onChangeAnalytics = (0, $gJJny.usePlatformLeafEventHandler)($f693f033a1373d3c$var$_objectSpread({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $f693f033a1373d3c$var$analyticsAttributes));
    var tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $f693f033a1373d3c$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map(function(tabIndex) {
        return $f693f033a1373d3c$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        });
    });
    var tabsStyles = (0, $1oC0p.useMemo)(function() {
        return (0, $bJ4Xk.getTabsStyles)(mode);
    }, [
        mode
    ]);
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    (0, $3dJ4i.jsx)("div", {
        "data-testid": testId,
        css: [
            $f693f033a1373d3c$var$baseStyles,
            tabsStyles
        ]
    }, (0, $3dJ4i.jsx)((0, $btjy5.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, tabPanelsWithContext)));
};
var $f693f033a1373d3c$export$2e2bcd8739ae039 = $f693f033a1373d3c$var$Tabs;

});
parcelRegister("j7Iem", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dec0fb12a6d80200$export$2e2bcd8739ae039; });

var $1Is3D = parcelRequire("1Is3D");
function $dec0fb12a6d80200$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $1Is3D.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("1Is3D", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $13ffaa29f3e72dda$export$2e2bcd8739ae039; });

var $6SGpS = parcelRequire("6SGpS");

var $iGtKL = parcelRequire("iGtKL");
function $13ffaa29f3e72dda$export$2e2bcd8739ae039(t) {
    var i = (0, $iGtKL.default)(t, "string");
    return "symbol" == (0, $6SGpS.default)(i) ? i : i + "";
}

});
parcelRegister("6SGpS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5028b03d47610007$export$2e2bcd8739ae039; });
function $5028b03d47610007$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5028b03d47610007$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5028b03d47610007$export$2e2bcd8739ae039(o);
}

});

parcelRegister("iGtKL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d9a33a9952a28b73$export$2e2bcd8739ae039; });

var $6SGpS = parcelRequire("6SGpS");
function $d9a33a9952a28b73$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $6SGpS.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $6SGpS.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("8Aq0Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6405dd1367361b80$export$2e2bcd8739ae039; });

var $9KY7p = parcelRequire("9KY7p");

var $5QptS = parcelRequire("5QptS");

var $e8Voo = parcelRequire("e8Voo");

var $cHARL = parcelRequire("cHARL");
function $6405dd1367361b80$export$2e2bcd8739ae039(r) {
    return (0, $9KY7p.default)(r) || (0, $5QptS.default)(r) || (0, $e8Voo.default)(r) || (0, $cHARL.default)();
}

});
parcelRegister("9KY7p", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $71a70b38d303abc3$export$2e2bcd8739ae039; });
function $71a70b38d303abc3$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("5QptS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $44159310e7a1e433$export$2e2bcd8739ae039; });
function $44159310e7a1e433$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("e8Voo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a4be54f9b16ccc80$export$2e2bcd8739ae039; });

var $gzFz8 = parcelRequire("gzFz8");
function $a4be54f9b16ccc80$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $gzFz8.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $gzFz8.default)(r, a) : void 0;
    }
}

});
parcelRegister("gzFz8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c110284c081a3195$export$2e2bcd8739ae039; });
function $c110284c081a3195$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("cHARL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $93f6190cbc02d0d6$export$2e2bcd8739ae039; });
function $93f6190cbc02d0d6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("byC10", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $86a05bb24d4182bc$export$2e2bcd8739ae039; });

var $9KY7p = parcelRequire("9KY7p");

var $8wcBx = parcelRequire("8wcBx");

var $e8Voo = parcelRequire("e8Voo");

var $cHARL = parcelRequire("cHARL");
function $86a05bb24d4182bc$export$2e2bcd8739ae039(r, e) {
    return (0, $9KY7p.default)(r) || (0, $8wcBx.default)(r, e) || (0, $e8Voo.default)(r, e) || (0, $cHARL.default)();
}

});
parcelRegister("8wcBx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $633b16db9548e32f$export$2e2bcd8739ae039; });
function $633b16db9548e32f$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});


parcelRegister("hdvAu", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", function () { return $c88c272cbfedcd20$export$7692396083754928; });

var $XxKRx = parcelRequire("XxKRx");
// Create default global light theme
var $c88c272cbfedcd20$var$_createTheme = (0, $XxKRx.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $c88c272cbfedcd20$var$Provider = $c88c272cbfedcd20$var$_createTheme.Provider, $c88c272cbfedcd20$var$Consumer = $c88c272cbfedcd20$var$_createTheme.Consumer, $c88c272cbfedcd20$export$7692396083754928 = $c88c272cbfedcd20$var$_createTheme.useTheme;
var $c88c272cbfedcd20$export$2e2bcd8739ae039 = {
    Provider: $c88c272cbfedcd20$var$Provider,
    Consumer: $c88c272cbfedcd20$var$Consumer
};

});
parcelRegister("XxKRx", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $0b2fb1cfed45ef9a$export$25d302a5b900a763; });

var $lqqfW = parcelRequire("lqqfW");

var $1oC0p = parcelRequire("1oC0p");
var $0b2fb1cfed45ef9a$var$_excluded = [
    "children"
];
function $0b2fb1cfed45ef9a$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $lqqfW.default)(props, $0b2fb1cfed45ef9a$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});
parcelRegister("lqqfW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f99064943d659d9b$export$2e2bcd8739ae039; });

var $f5kkK = parcelRequire("f5kkK");
function $f99064943d659d9b$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $f5kkK.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("f5kkK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $afb7187aa6028664$export$2e2bcd8739ae039; });
function $afb7187aa6028664$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});




parcelRegister("btjy5", function(module, exports) {
$parcel$export(module.exports, "TabContext", function () { return $85a1911bdf59ecbd$export$5a5d356ca5f10a0a; });
$parcel$export(module.exports, "TabListContext", function () { return $85a1911bdf59ecbd$export$aa6907f9fd69e93b; });
$parcel$export(module.exports, "TabPanelContext", function () { return $85a1911bdf59ecbd$export$2054129d247c3102; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1oC0p = parcelRequire("1oC0p");
var $85a1911bdf59ecbd$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $85a1911bdf59ecbd$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $85a1911bdf59ecbd$export$2054129d247c3102 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("bJ4Xk", function(module, exports) {
$parcel$export(module.exports, "getTabsStyles", function () { return $8897bdcf3df5d3c2$export$dd5afd2190fb792c; });
$parcel$export(module.exports, "getTabListStyles", function () { return $8897bdcf3df5d3c2$export$42a3c683c377bcb2; });

var $j7Iem = parcelRequire("j7Iem");

var $3dJ4i = parcelRequire("3dJ4i");

var $6w3Ij = parcelRequire("6w3Ij");
function $8897bdcf3df5d3c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8897bdcf3df5d3c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8897bdcf3df5d3c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $j7Iem.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8897bdcf3df5d3c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8897bdcf3df5d3c2$var$tabLeftRightPadding = "var(--ds-space-100, 8px)";
var $8897bdcf3df5d3c2$var$tabTopBottomPadding = "var(--ds-space-050, 4px)";
// TODO this should probably be `border.width.indicator`
var $8897bdcf3df5d3c2$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
var $8897bdcf3df5d3c2$var$highContrastFocusStyles = {
    outline: "var(--ds-border-width, 1px)".concat(" solid")
};
// Required so the focus ring is visible in high contrast mode
var $8897bdcf3df5d3c2$var$highContrastFocusRing = {
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': $8897bdcf3df5d3c2$var$highContrastFocusStyles,
        '@supports not selector(*:focus-visible)': {
            '&:focus': $8897bdcf3df5d3c2$var$highContrastFocusStyles
        }
    }
};
var $8897bdcf3df5d3c2$var$tabFocusStyles = function tabFocusStyles(mode) {
    return {
        boxShadow: "0 0 0 2px ".concat((0, $6w3Ij.getTabPanelFocusColor)(mode), " inset"),
        borderRadius: "var(--ds-border-radius, 3px)",
        outline: 'none'
    };
};
var $8897bdcf3df5d3c2$var$getTabPanelStyles = function getTabPanelStyles(mode) {
    return $8897bdcf3df5d3c2$var$_objectSpread({
        flexGrow: 1,
        /*
      NOTE min-height set to 0% because of Firefox bug
      FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
    */ minHeight: '0%',
        display: 'flex',
        padding: "0 ".concat($8897bdcf3df5d3c2$var$tabLeftRightPadding),
        '&:focus-visible': $8897bdcf3df5d3c2$var$tabFocusStyles(mode),
        '@supports not selector(*:focus-visible)': {
            '&:focus': $8897bdcf3df5d3c2$var$tabFocusStyles(mode)
        }
    }, $8897bdcf3df5d3c2$var$highContrastFocusRing);
};
var $8897bdcf3df5d3c2$export$dd5afd2190fb792c = function getTabsStyles(mode) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $3dJ4i.css)({
        '& [role="tabpanel"]': $8897bdcf3df5d3c2$var$getTabPanelStyles(mode),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '& > [hidden]': {
            display: 'none'
        }
    }));
};
var $8897bdcf3df5d3c2$var$tabLineStyles = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    left: $8897bdcf3df5d3c2$var$tabLeftRightPadding,
    right: $8897bdcf3df5d3c2$var$tabLeftRightPadding
};
var $8897bdcf3df5d3c2$export$42a3c683c377bcb2 = function getTabListStyles(mode) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $3dJ4i.css)({
        '& [role="tab"]': $8897bdcf3df5d3c2$export$916c8b0fccbb37d2(mode),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        '&::before': $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({}, $8897bdcf3df5d3c2$var$tabLineStyles), {}, {
            height: $8897bdcf3df5d3c2$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            backgroundColor: (0, $6w3Ij.getTabLineColor)(mode).lineColor
        })
    }));
};
var $8897bdcf3df5d3c2$var$tabPanelFocusStyles = function tabPanelFocusStyles(mode) {
    var colors = (0, $6w3Ij.getTabColors)(mode);
    return {
        boxShadow: "0 0 0 2px ".concat(colors.focusBorderColor, " inset"),
        borderRadius: "var(--ds-border-radius, 3px)",
        outline: 'none',
        // Hide TabLine on focus
        '&::after': {
            opacity: 0
        }
    };
};
var $8897bdcf3df5d3c2$export$916c8b0fccbb37d2 = function getTabStyles(mode) {
    var colors = (0, $6w3Ij.getTabColors)(mode);
    return $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({
        color: colors.labelColor,
        cursor: 'pointer',
        lineHeight: 1.8,
        margin: 0,
        padding: "".concat($8897bdcf3df5d3c2$var$tabTopBottomPadding, " ").concat($8897bdcf3df5d3c2$var$tabLeftRightPadding),
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({}, $8897bdcf3df5d3c2$var$tabLineStyles), {}, {
                borderBottom: "".concat($8897bdcf3df5d3c2$var$underlineHeight, " solid ").concat((0, $6w3Ij.getTabLineColor)(mode).hoveredColor),
                height: 0
            })
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({}, $8897bdcf3df5d3c2$var$tabLineStyles), {}, {
                borderBottom: "".concat($8897bdcf3df5d3c2$var$underlineHeight, " solid ").concat((0, $6w3Ij.getTabLineColor)(mode).activeColor),
                height: 0
            })
        },
        '&:focus-visible': $8897bdcf3df5d3c2$var$tabPanelFocusStyles(mode),
        '@supports not selector(*:focus-visible)': {
            '&:focus': $8897bdcf3df5d3c2$var$tabPanelFocusStyles(mode)
        }
    }, $8897bdcf3df5d3c2$var$highContrastFocusRing), {}, {
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': $8897bdcf3df5d3c2$var$_objectSpread($8897bdcf3df5d3c2$var$_objectSpread({}, $8897bdcf3df5d3c2$var$tabLineStyles), {}, {
                // This line is a border so it is visible in high contrast mode
                borderBottom: "".concat($8897bdcf3df5d3c2$var$underlineHeight, " solid ").concat((0, $6w3Ij.getTabLineColor)(mode).selectedColor),
                height: 0
            })
        }
    });
};

});
parcelRegister("6w3Ij", function(module, exports) {
$parcel$export(module.exports, "getTabColors", function () { return $4be89cb811b70b40$export$8a53023232713127; });
$parcel$export(module.exports, "getTabLineColor", function () { return $4be89cb811b70b40$export$eff40d6a7c078cf; });
$parcel$export(module.exports, "getTabPanelFocusColor", function () { return $4be89cb811b70b40$export$5b33c784b26b1d3f; });

var $9ALL1 = parcelRequire("9ALL1");
var $4be89cb811b70b40$var$tabColorMap = {
    light: {
        labelColor: "var(--ds-text-subtle, ".concat((0, $9ALL1.N500), ")"),
        activeLabelColor: "var(--ds-text, ".concat((0, $9ALL1.B500), ")"),
        hoverLabelColor: "var(--ds-text-subtle, ".concat((0, $9ALL1.B400), ")"),
        selectedColor: "var(--ds-text-selected, ".concat((0, $9ALL1.B400), ")"),
        focusBorderColor: "var(--ds-border-focused, ".concat((0, $9ALL1.B100), ")")
    },
    dark: {
        labelColor: "var(--ds-text-subtle, ".concat((0, $9ALL1.DN400), ")"),
        activeLabelColor: "var(--ds-text, ".concat((0, $9ALL1.B200), ")"),
        hoverLabelColor: "var(--ds-text-subtle, ".concat((0, $9ALL1.B75), ")"),
        selectedColor: "var(--ds-text-selected, ".concat((0, $9ALL1.B75), ")"),
        focusBorderColor: "var(--ds-border-focused, ".concat((0, $9ALL1.B75), ")")
    }
};
var $4be89cb811b70b40$export$8a53023232713127 = function getTabColors(mode) {
    return $4be89cb811b70b40$var$tabColorMap[mode];
};
var $4be89cb811b70b40$var$tabLineColorMap = {
    light: {
        lineColor: "var(--ds-border, ".concat((0, $9ALL1.N30), ")"),
        hoveredColor: "var(--ds-border, transparent)",
        activeColor: "var(--ds-border, transparent)",
        selectedColor: "var(--ds-border-selected, ".concat((0, $9ALL1.B400), ")")
    },
    dark: {
        lineColor: "var(--ds-border, ".concat((0, $9ALL1.DN0), ")"),
        hoveredColor: "var(--ds-border, transparent)",
        activeColor: "var(--ds-border, transparent)",
        selectedColor: "var(--ds-border-selected, ".concat((0, $9ALL1.B75), ")")
    }
};
var $4be89cb811b70b40$export$eff40d6a7c078cf = function getTabLineColor(mode) {
    return $4be89cb811b70b40$var$tabLineColorMap[mode];
};
var $4be89cb811b70b40$var$tabPanelFocusColorMap = {
    light: "var(--ds-border-focused, ".concat((0, $9ALL1.B100), ")"),
    dark: "var(--ds-border-focused, ".concat((0, $9ALL1.B75), ")")
};
var $4be89cb811b70b40$export$5b33c784b26b1d3f = function getTabPanelFocusColor(mode) {
    return $4be89cb811b70b40$var$tabPanelFocusColorMap[mode];
};

});
parcelRegister("9ALL1", function(module, exports) {
$parcel$export(module.exports, "B75", function () { return $6fbc857b7a544148$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $6fbc857b7a544148$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $6fbc857b7a544148$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $6fbc857b7a544148$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $6fbc857b7a544148$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N30", function () { return $6fbc857b7a544148$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N500", function () { return $6fbc857b7a544148$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N30A", function () { return $6fbc857b7a544148$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $6fbc857b7a544148$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN0", function () { return $6fbc857b7a544148$export$3d4f271a500072a; });
$parcel$export(module.exports, "skeleton", function () { return $6fbc857b7a544148$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5RIxF = parcelRequire("5RIxF");
var $6fbc857b7a544148$export$4b84fd0e2c617bd = '#FFEBE6';
var $6fbc857b7a544148$export$b34b069eff244586 = '#FFBDAD';
var $6fbc857b7a544148$export$be802dd0d8b57f35 = '#FF8F73';
var $6fbc857b7a544148$export$60847d42f9da92a6 = '#FF7452';
var $6fbc857b7a544148$export$4a7404f376229999 = '#FF5630';
var $6fbc857b7a544148$export$2010d0fb4295b346 = '#DE350B';
var $6fbc857b7a544148$export$2837b5a1a71d5c02 = '#BF2600';
var $6fbc857b7a544148$export$8d9596b529bbb9cf = '#FFFAE6';
var $6fbc857b7a544148$export$41060a744ab0b7ae = '#FFF0B3';
var $6fbc857b7a544148$export$1cc05bbbf340e559 = '#FFE380';
var $6fbc857b7a544148$export$5aae31392d72caaa = '#FFC400';
var $6fbc857b7a544148$export$c6930421db9fa514 = '#FFAB00';
var $6fbc857b7a544148$export$59619663aa6500fb = '#FF991F';
var $6fbc857b7a544148$export$874739ea9e379ab6 = '#FF8B00';
var $6fbc857b7a544148$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $6fbc857b7a544148$export$69a3bf21b9686c2b = '#ABF5D1';
var $6fbc857b7a544148$export$afbce1382ec95f73 = '#79F2C0';
var $6fbc857b7a544148$export$747d86715d4175de = '#57D9A3';
var $6fbc857b7a544148$export$940e1f69e873f202 = '#36B37E';
var $6fbc857b7a544148$export$a49394138f7b8e85 = '#00875A';
var $6fbc857b7a544148$export$6fa04827ac68a4fb = '#006644';
var $6fbc857b7a544148$export$226de0355ed012f8 = '#DEEBFF';
var $6fbc857b7a544148$export$8c13c2ee36917869 = '#B3D4FF';
var $6fbc857b7a544148$export$ecfc1dff386a3e7a = '#4C9AFF';
var $6fbc857b7a544148$export$215b7063051591f1 = '#2684FF';
var $6fbc857b7a544148$export$e62e8919cca44969 = '#0065FF';
var $6fbc857b7a544148$export$b3de0ae08da2ce64 = '#0052CC';
var $6fbc857b7a544148$export$a6ee3d71bc067634 = '#0747A6';
var $6fbc857b7a544148$export$363e4475840015bb = '#EAE6FF';
var $6fbc857b7a544148$export$4b0a4417ed59760f = '#C0B6F2';
var $6fbc857b7a544148$export$6011520a64d9a187 = '#998DD9';
var $6fbc857b7a544148$export$a7175d4e9206bc80 = '#8777D9';
var $6fbc857b7a544148$export$b48405b95304b5a1 = '#6554C0';
var $6fbc857b7a544148$export$c71e4279dd54a18d = '#5243AA';
var $6fbc857b7a544148$export$147899de772240ec = '#403294';
var $6fbc857b7a544148$export$2cf711fe14c66f06 = '#E6FCFF';
var $6fbc857b7a544148$export$7a8f4d33f6f9772c = '#B3F5FF';
var $6fbc857b7a544148$export$776c9c497ef08533 = '#79E2F2';
var $6fbc857b7a544148$export$69cb3ca10c1e330e = '#00C7E6';
var $6fbc857b7a544148$export$9dc1ef0f3f48059b = '#00B8D9';
var $6fbc857b7a544148$export$7c835c78b6fcdef8 = '#00A3BF';
var $6fbc857b7a544148$export$6036577f95c3877e = '#008DA6';
var $6fbc857b7a544148$export$29a4f05edc054374 = '#FFFFFF';
var $6fbc857b7a544148$export$e655ef011c4aa1a2 = '#FAFBFC';
var $6fbc857b7a544148$export$9fdfb749e33cdf97 = '#F4F5F7';
var $6fbc857b7a544148$export$3e51e8f1440314ba = '#EBECF0';
var $6fbc857b7a544148$export$1ce2d1575d444ceb = '#DFE1E6';
var $6fbc857b7a544148$export$8754fc7e6d8b3000 = '#C1C7D0';
var $6fbc857b7a544148$export$c2e91cbeada39b8b = '#B3BAC5';
var $6fbc857b7a544148$export$5f71e19f3a7ad9de = '#A5ADBA';
var $6fbc857b7a544148$export$eaa8c8a70ac22806 = '#97A0AF';
var $6fbc857b7a544148$export$7c87d337fb91a97d = '#8993A4';
var $6fbc857b7a544148$export$d6447c357493214f = '#7A869A';
var $6fbc857b7a544148$export$f563ee71e9ee74cd = '#6B778C';
var $6fbc857b7a544148$export$e2ef2124cf4024b1 = '#5E6C84';
var $6fbc857b7a544148$export$eece5f492e429f08 = '#505F79';
var $6fbc857b7a544148$export$c39c0fe0f26207ae = '#42526E';
var $6fbc857b7a544148$export$7090862dc3038a9f = '#344563';
var $6fbc857b7a544148$export$ad0bacf983b7ddaa = '#253858';
var $6fbc857b7a544148$export$7d61b15e0da132af = '#172B4D';
var $6fbc857b7a544148$export$fbda843f0a27fe96 = '#091E42';
var $6fbc857b7a544148$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $6fbc857b7a544148$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $6fbc857b7a544148$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $6fbc857b7a544148$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $6fbc857b7a544148$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $6fbc857b7a544148$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $6fbc857b7a544148$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $6fbc857b7a544148$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $6fbc857b7a544148$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $6fbc857b7a544148$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $6fbc857b7a544148$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $6fbc857b7a544148$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $6fbc857b7a544148$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $6fbc857b7a544148$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $6fbc857b7a544148$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $6fbc857b7a544148$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $6fbc857b7a544148$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $6fbc857b7a544148$export$2f6319cf7d736c2a = '#E6EDFA';
var $6fbc857b7a544148$export$95126bc8884d6634 = '#DCE5F5';
var $6fbc857b7a544148$export$8338d8c35d44ff1 = '#CED9EB';
var $6fbc857b7a544148$export$5368d76ae4fbbda7 = '#B8C7E0';
var $6fbc857b7a544148$export$9f0a771d16ec8d36 = '#ABBBD6';
var $6fbc857b7a544148$export$abcf8c38338b4aa5 = '#9FB0CC';
var $6fbc857b7a544148$export$97e81faa16a182c7 = '#8C9CB8';
var $6fbc857b7a544148$export$bfe21c59123ecf33 = '#7988A3';
var $6fbc857b7a544148$export$ee82aa2ea6a1558 = '#67758F';
var $6fbc857b7a544148$export$682927c6ed76be02 = '#56637A';
var $6fbc857b7a544148$export$91fd9994c5be9757 = '#455166';
var $6fbc857b7a544148$export$d281fbfe3cff2df6 = '#3B475C';
var $6fbc857b7a544148$export$3902c91d8b98a753 = '#313D52';
var $6fbc857b7a544148$export$8e8133c1ba5845b5 = '#283447';
var $6fbc857b7a544148$export$33ff357f6620b39 = '#202B3D';
var $6fbc857b7a544148$export$633847cf062b69e0 = '#1B2638';
var $6fbc857b7a544148$export$9776a6e503bdbf76 = '#121A29';
var $6fbc857b7a544148$export$6c813d5160dff5db = '#0E1624';
var $6fbc857b7a544148$export$3d4f271a500072a = '#0D1424';
var $6fbc857b7a544148$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $6fbc857b7a544148$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $6fbc857b7a544148$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $6fbc857b7a544148$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $6fbc857b7a544148$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $6fbc857b7a544148$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $6fbc857b7a544148$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $6fbc857b7a544148$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $6fbc857b7a544148$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $6fbc857b7a544148$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $6fbc857b7a544148$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $6fbc857b7a544148$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $6fbc857b7a544148$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $6fbc857b7a544148$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $6fbc857b7a544148$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $6fbc857b7a544148$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $6fbc857b7a544148$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $6fbc857b7a544148$export$8ce1fd94bee2f412 = (0, $5RIxF.default)({
    light: "var(--ds-surface, ".concat($6fbc857b7a544148$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($6fbc857b7a544148$export$633847cf062b69e0, ")")
});
var $6fbc857b7a544148$export$b861914ea877b580 = (0, $5RIxF.default)({
    light: "var(--ds-background-selected, ".concat($6fbc857b7a544148$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($6fbc857b7a544148$export$8c13c2ee36917869, ")")
});
var $6fbc857b7a544148$export$3f1b020df94387af = (0, $5RIxF.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($6fbc857b7a544148$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($6fbc857b7a544148$export$d281fbfe3cff2df6, ")")
});
var $6fbc857b7a544148$export$c0183dbab98ca63e = (0, $5RIxF.default)({
    light: "var(--ds-surface-overlay, ".concat($6fbc857b7a544148$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($6fbc857b7a544148$export$8e8133c1ba5845b5, ")")
});
var $6fbc857b7a544148$export$6f093cfa640b7166 = (0, $5RIxF.default)({
    light: "var(--ds-text, ".concat($6fbc857b7a544148$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($6fbc857b7a544148$export$5368d76ae4fbbda7, ")")
});
var $6fbc857b7a544148$export$42f8e9c698766e7a = (0, $5RIxF.default)({
    light: "var(--ds-text, ".concat($6fbc857b7a544148$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($6fbc857b7a544148$export$5368d76ae4fbbda7, ")")
});
var $6fbc857b7a544148$export$c2d157ca1c34b6e3 = (0, $5RIxF.default)({
    light: "var(--ds-text-selected, ".concat($6fbc857b7a544148$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($6fbc857b7a544148$export$b3de0ae08da2ce64, ")")
});
var $6fbc857b7a544148$export$1905ba28d7cf066f = (0, $5RIxF.default)({
    light: "var(--ds-text-subtlest, ".concat($6fbc857b7a544148$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($6fbc857b7a544148$export$97e81faa16a182c7, ")")
});
var $6fbc857b7a544148$export$bd9002130d306d39 = (0, $5RIxF.default)({
    light: "var(--ds-text-subtlest, ".concat($6fbc857b7a544148$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($6fbc857b7a544148$export$bfe21c59123ecf33, ")")
});
var $6fbc857b7a544148$export$46e4a324ac90507f = (0, $5RIxF.default)({
    light: "var(--ds-text, ".concat($6fbc857b7a544148$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($6fbc857b7a544148$export$5368d76ae4fbbda7, ")")
});
var $6fbc857b7a544148$export$79f3f2b82beb0d36 = (0, $5RIxF.default)({
    light: "var(--ds-text-subtlest, ".concat($6fbc857b7a544148$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($6fbc857b7a544148$export$97e81faa16a182c7, ")")
});
var $6fbc857b7a544148$export$7bb0d5c671655cc4 = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$9fdfb749e33cdf97,
    dark: $6fbc857b7a544148$export$8e8133c1ba5845b5
});
var $6fbc857b7a544148$export$9c30223ca0a664fb = (0, $5RIxF.default)({
    light: "var(--ds-link, ".concat($6fbc857b7a544148$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($6fbc857b7a544148$export$ecfc1dff386a3e7a, ")")
});
var $6fbc857b7a544148$export$7ed258b0728b004b = (0, $5RIxF.default)({
    light: "var(--ds-link-pressed, ".concat($6fbc857b7a544148$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($6fbc857b7a544148$export$215b7063051591f1, ")")
});
var $6fbc857b7a544148$export$dfa920d8decc8a59 = (0, $5RIxF.default)({
    light: "var(--ds-link-pressed, ".concat($6fbc857b7a544148$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($6fbc857b7a544148$export$ecfc1dff386a3e7a, ")")
});
var $6fbc857b7a544148$export$6069e6ad5c78f632 = (0, $5RIxF.default)({
    light: "var(--ds-border-focused, ".concat($6fbc857b7a544148$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($6fbc857b7a544148$export$215b7063051591f1, ")")
});
var $6fbc857b7a544148$export$9ad721cf3b3debe0 = (0, $5RIxF.default)({
    light: "var(--ds-background-brand-bold, ".concat($6fbc857b7a544148$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($6fbc857b7a544148$export$ecfc1dff386a3e7a, ")")
});
var $6fbc857b7a544148$export$2aa0182783e7e9de = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$b3de0ae08da2ce64,
    dark: $6fbc857b7a544148$export$ecfc1dff386a3e7a
});
var $6fbc857b7a544148$export$8bf7dff220b82b4a = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$9dc1ef0f3f48059b,
    dark: $6fbc857b7a544148$export$69cb3ca10c1e330e
});
var $6fbc857b7a544148$export$e13cce2a2d16a9d4 = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$b48405b95304b5a1,
    dark: $6fbc857b7a544148$export$6011520a64d9a187
});
var $6fbc857b7a544148$export$a90204d1394caf30 = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$4a7404f376229999,
    dark: $6fbc857b7a544148$export$4a7404f376229999
});
var $6fbc857b7a544148$export$594c5a8758200c32 = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$c6930421db9fa514,
    dark: $6fbc857b7a544148$export$c6930421db9fa514
});
var $6fbc857b7a544148$export$955a2ebd2fb142ae = (0, $5RIxF.default)({
    light: $6fbc857b7a544148$export$940e1f69e873f202,
    dark: $6fbc857b7a544148$export$940e1f69e873f202
});
var $6fbc857b7a544148$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($6fbc857b7a544148$export$8d43898f60b96a82, ")");
};

});
parcelRegister("5RIxF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $44547421330cbf41$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $e8i1O = parcelRequire("e8i1O");
// Unpack custom variants, and get correct value for the current theme
function $44547421330cbf41$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $e8i1O.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $44547421330cbf41$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $44547421330cbf41$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $e8i1O.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("e8i1O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a49fcc18574d5592$export$2e2bcd8739ae039; });

var $f3iYWl = parcelRequire("f3iYWl");
function $a49fcc18574d5592$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $f3iYWl.CHANNEL) in props.theme) return props.theme[0, $f3iYWl.CHANNEL];
        else if ('mode' in props.theme && (0, $f3iYWl.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $f3iYWl.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("f3iYWl", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $af55dc3c37cd9861$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $af55dc3c37cd9861$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $af55dc3c37cd9861$export$6ba72c8346b4c57e; });

var $igwZj = parcelRequire("igwZj");

var $9ALL1 = parcelRequire("9ALL1");
var $af55dc3c37cd9861$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $af55dc3c37cd9861$export$c93026a968943f95 = 'light';
var $af55dc3c37cd9861$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $af55dc3c37cd9861$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $af55dc3c37cd9861$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $af55dc3c37cd9861$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $af55dc3c37cd9861$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $af55dc3c37cd9861$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $af55dc3c37cd9861$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $af55dc3c37cd9861$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $9ALL1.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $af55dc3c37cd9861$export$6d8204c2cb2e06b8() / 4;
    (0, $igwZj.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $af55dc3c37cd9861$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $af55dc3c37cd9861$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $af55dc3c37cd9861$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $igwZj.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $af55dc3c37cd9861$export$ba1d834b86d72a09 = $af55dc3c37cd9861$export$a1b3edb637fb4f35;
var $af55dc3c37cd9861$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $9ALL1.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $9ALL1.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $9ALL1.N30A), ")")
            }
        }
    };
};

});
parcelRegister("igwZj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4c34f586c8959d0$export$2e2bcd8739ae039; });

var $2hYAn = parcelRequire("2hYAn");

var $7t0tI = parcelRequire("7t0tI");
function $d4c34f586c8959d0$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $2hYAn.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $d4c34f586c8959d0$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("2hYAn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1aac2a57efff957f$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $1aac2a57efff957f$var$printed = {};
function $1aac2a57efff957f$export$2e2bcd8739ae039(message) {
    if ($1aac2a57efff957f$var$printed[message]) return;
    $1aac2a57efff957f$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});








parcelRegister("34TA1", function(module, exports) {
$parcel$export(module.exports, "onMouseDownBlur", function () { return $23dcdbd655f15e6a$export$1aedf39a68fc0142; });
// Prevent a focus ring if clicked
var $23dcdbd655f15e6a$export$1aedf39a68fc0142 = function onMouseDownBlur(e) {
    var currentTarget = e.currentTarget;
    var focusedDuringMouseDown = currentTarget === document.activeElement;
    requestAnimationFrame(function() {
        if (focusedDuringMouseDown && currentTarget !== document.activeElement && document.body.contains(currentTarget)) {
            currentTarget.focus();
            return;
        }
        if (!focusedDuringMouseDown && document.body.contains(currentTarget)) currentTarget.blur();
    });
};

});


parcelRegister("9T4IS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $732ce9f1d0fdbdd6$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $hdvAu = parcelRequire("hdvAu");

var $6dioi = parcelRequire("6dioi");

var $btjy5 = parcelRequire("btjy5");

var $bJ4Xk = parcelRequire("bJ4Xk");

var $34TA1 = parcelRequire("34TA1");
var $732ce9f1d0fdbdd6$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    padding: "var(--ds-space-0, 0px)",
    position: 'relative'
});
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $732ce9f1d0fdbdd6$var$TabList = function TabList(_ref) {
    var children = _ref.children;
    var _useGlobalTheme = (0, $hdvAu.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var _useTabList = (0, $6dioi.useTabList)(), tabsId = _useTabList.tabsId, selected = _useTabList.selected, onChange = _useTabList.onChange;
    var ref = /*#__PURE__*/ (0, $1oC0p.createRef)();
    // Don't include any conditional children
    var childrenArray = (0, $1oC0p.Children).toArray(children).filter(Boolean);
    var length = childrenArray.length;
    var tabListStyles = (0, $1oC0p.useMemo)(function() {
        return (0, $bJ4Xk.getTabListStyles)(mode);
    }, [
        mode
    ]);
    var selectTabByIndex = (0, $1oC0p.useCallback)(function(index) {
        var _ref$current;
        var newSelectedNode = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector("[id='".concat(tabsId, "-").concat(index, "']"));
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        var lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            var _newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(_newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        var selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        var modifier = e.key === 'ArrowRight' ? 1 : -1;
        var newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    var getTabWithContext = (0, $1oC0p.useCallback)(function(_ref2) {
        var tab = _ref2.tab, isSelected = _ref2.isSelected, index = _ref2.index;
        return (0, $3dJ4i.jsx)((0, $btjy5.TabContext).Provider, {
            value: {
                onClick: function onClick() {
                    return onChange(index);
                },
                onMouseDown: (0, $34TA1.onMouseDownBlur),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: "".concat(tabsId, "-").concat(index),
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': "".concat(tabsId, "-").concat(index, "-tab"),
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab);
    }, [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    (0, $3dJ4i.jsx)("div", {
        role: "tablist",
        ref: ref,
        css: [
            $732ce9f1d0fdbdd6$var$baseStyles,
            tabListStyles
        ]
    }, childrenArray.map(function(child, index) {
        return getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        });
    })));
};
var $732ce9f1d0fdbdd6$export$2e2bcd8739ae039 = $732ce9f1d0fdbdd6$var$TabList;

});
parcelRegister("6dioi", function(module, exports) {
$parcel$export(module.exports, "useTab", function () { return $48623902a0996682$export$fdf4756d5b8ef90a; });
$parcel$export(module.exports, "useTabList", function () { return $48623902a0996682$export$773e389e644c5874; });
$parcel$export(module.exports, "useTabPanel", function () { return $48623902a0996682$export$fae0121b5afe572d; });

var $1oC0p = parcelRequire("1oC0p");

var $btjy5 = parcelRequire("btjy5");
var $48623902a0996682$export$fdf4756d5b8ef90a = function useTab() {
    var tabData = (0, $1oC0p.useContext)((0, $btjy5.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
var $48623902a0996682$export$773e389e644c5874 = function useTabList() {
    var tabListData = (0, $1oC0p.useContext)((0, $btjy5.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
var $48623902a0996682$export$fae0121b5afe572d = function useTabPanel() {
    var tabPanelData = (0, $1oC0p.useContext)((0, $btjy5.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("9xhTf", function(module, exports) {
$parcel$export(module.exports, "ATLASSIAN_ISOLATED_CLOUD_PRODUCT", function () { return $54ff13c389f0ffff$export$7a6bc4df4fe0bea; });
$parcel$export(module.exports, "isAtlassianIsolatedCloudContactFormEnabled", function () { return $54ff13c389f0ffff$export$4243e959d06b0bbc; });
$parcel$export(module.exports, "isEmailFormat", function () { return $54ff13c389f0ffff$export$ca3873bda3d4c03b; });
$parcel$export(module.exports, "isPersonalDomain", function () { return $54ff13c389f0ffff$export$fb4ff965f818da6; });
$parcel$export(module.exports, "submitContactForm", function () { return $54ff13c389f0ffff$export$dc48f71ddf9c5e1c; });
$parcel$export(module.exports, "getProductPlans", function () { return $54ff13c389f0ffff$export$8b8bd1c6772f09e0; });

var $PE2DD = parcelRequire("PE2DD");

var $ai7AF = parcelRequire("ai7AF");

var $32ng3 = parcelRequire("32ng3");

var $2gCne = parcelRequire("2gCne");

var $Ie188 = parcelRequire("Ie188");
const $54ff13c389f0ffff$var$STARGATE_BASE_URL = "https://www.atlassian.com/gateway/api";
const $54ff13c389f0ffff$var$stargateClient = new (0, $PE2DD.BxpWebStargateClient)({
    baseUrl: $54ff13c389f0ffff$var$STARGATE_BASE_URL
});
const $54ff13c389f0ffff$var$streamhubClient = new (0, $Ie188.StreamhubClient)();
const $54ff13c389f0ffff$export$7a6bc4df4fe0bea = "Atlassian Isolated Cloud";
const $54ff13c389f0ffff$export$4243e959d06b0bbc = ()=>(0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp11663AtlassianIsolatedCloudContactForm);
const $54ff13c389f0ffff$export$ca3873bda3d4c03b = (value)=>{
    if (value) {
        const emailRegex = new RegExp(/^[\w-]+(\.[\w-]+)*@([a-z0-9-]+\.)+[a-z]{2,7}$/);
        return emailRegex.test(value);
    }
    return false;
};
const $54ff13c389f0ffff$export$fb4ff965f818da6 = (value)=>{
    if (value) {
        if (!$54ff13c389f0ffff$export$ca3873bda3d4c03b(value)) return false;
        const emailDomain = value.split("@")[1];
        return (0, $ai7AF.default).has(String(emailDomain));
    }
    return false;
};
const $54ff13c389f0ffff$var$submitSuccess = (state, createAnalyticsEvent)=>{
    if (state.status === 200) window.location.href = state.redirect + window.location.search;
    else {
        state.mainFormContainer.style.display = "none";
        state.postSubmitMessage.style.display = "block";
    }
    createAnalyticsEvent({
        event: "Contact Sales Form",
        action: "Submitted",
        actionSubject: "Contact Sales Form",
        eventType: "ui",
        origin: "web",
        platform: "web",
        product: "marketing",
        source: "none",
        userIdType: "atlassianAccount",
        attributes: {
            atlJSVersion: "1.0.0",
            event: "Submitted",
            eventComponent: "Contact Sales Form",
            page_path: location.pathname,
            url: location.href
        }
    }).fire();
};
const $54ff13c389f0ffff$var$submitFailure = (createAnalyticsEvent)=>{
    createAnalyticsEvent({
        event: "Contact Sales Form",
        action: "Failed",
        actionSubject: "Contact Sales Form",
        eventType: "ui",
        origin: "web",
        platform: "web",
        product: "marketing",
        source: "none",
        userIdType: "atlassianAccount",
        attributes: {
            event: "Failed",
            eventComponent: "Contact Sales Form",
            page_path: location.pathname,
            url: location.href,
            atlJSVersion: "1.0.0"
        }
    }).fire();
};
const $54ff13c389f0ffff$var$getCookie = (name)=>{
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(";").shift();
    return "";
};
// @ts-ignore
const $54ff13c389f0ffff$var$sendToStreamhub = async (formValues, formType, createAnalyticsEvent)=>{
    const currentTime = new Date();
    const random = Math.round(Math.random() * 10000);
    const { locale: locale } = await $54ff13c389f0ffff$var$stargateClient.getConsentConfig();
    const formTypeMap = {
        "pricing-quotes": "Pricing & Quotes",
        "migration-options": "Migration Options",
        "product-features": "Product Features"
    };
    const streamHubInfo = {
        gmoiLocale: String(locale),
        formType: formTypeMap[formType],
        formDef: "contactSales",
        formSubmissionId: random + currentTime.getTime(),
        created_at: currentTime,
        marketoCookieId: $54ff13c389f0ffff$var$getCookie("_mkto_trk") || "",
        anonymousId: $54ff13c389f0ffff$var$getCookie("ajs_anonymous_id")?.replace(/%22/g, "") || "",
        atlassianId: $54ff13c389f0ffff$var$getCookie("ajs_user_id")?.replace(/%22/g, "") || "",
        submitted: currentTime.toString(),
        source_sequence: currentTime.getTime(),
        userAgent: window.navigator.userAgent,
        isIntercomTracking: false,
        intercomAppId: "",
        intercomMapping: {}
    };
    const payload = Object.assign(formValues, streamHubInfo);
    const streamhubEndpoint = "contactsalesv2";
    await $54ff13c389f0ffff$var$streamhubClient.postObject(payload, streamhubEndpoint, (state)=>$54ff13c389f0ffff$var$submitSuccess(state, createAnalyticsEvent));
};
const $54ff13c389f0ffff$export$dc48f71ddf9c5e1c = async (form, formType, createAnalyticsEvent)=>{
    let editionValue = "";
    if (form["edition"]) {
        const value = form["edition"].split(" ")[1];
        if (value) editionValue = value;
    }
    if (form["name"]) {
        form["firstName"] = form["name"].split(" ")[0];
        form["lastName"] = form["name"].split(" ").slice(1).join(" ");
    }
    if (!form["company"]) {
        const parsedEmail = form["email"].split("@")[1];
        form["company"] = parsedEmail.split(".")[0];
    }
    const marketingContext = (0, $2gCne.getLocalStorage)("marketingContext", true);
    let parsedMarketingContext;
    try {
        parsedMarketingContext = marketingContext ? JSON.parse(marketingContext) : null;
    } catch (error) {
        console.error("Failed to parse marketingContext from localStorage");
    }
    const { sfdcCampaignId: sfdcCampaignId = "", source: source = "", medium: medium = "", campaign: campaign = "", content: content = "" } = parsedMarketingContext?.utm || {};
    form["utm_sfdc-campaign_id"] = sfdcCampaignId;
    form["utm_source"] = source;
    form["utm_medium"] = medium;
    form["utm_campaign"] = campaign;
    form["utm_content"] = content;
    const formValues = {
        ...form,
        edition: editionValue ? editionValue : undefined
    };
    try {
        await $54ff13c389f0ffff$var$sendToStreamhub(formValues, formType, createAnalyticsEvent);
    } catch (error) {
        console.error("Failed to submit form", error);
        $54ff13c389f0ffff$var$submitFailure(createAnalyticsEvent);
        throw error;
    }
};
const $54ff13c389f0ffff$export$8b8bd1c6772f09e0 = (selectedProduct)=>{
    if (selectedProduct === "Atlassian Guard" || selectedProduct === "Bitbucket" || selectedProduct === "Jira Product Discovery") {
        const isKeynoteEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).team26Keynote);
        return [
            {
                name: "plan",
                label: "Cloud Standard",
                value: "Cloud Standard"
            },
            {
                name: "plan",
                label: "Cloud Premium",
                value: "Cloud Premium"
            },
            ...selectedProduct === "Jira Product Discovery" && isKeynoteEnabled ? [
                {
                    name: "plan",
                    label: "Cloud Enterprise (coming in October 2026)",
                    value: "Cloud Enterprise"
                }
            ] : []
        ];
    } else if (selectedProduct === "Loom") return [
        {
            name: "plan",
            label: "Loom Business",
            value: "Loom Business"
        },
        {
            name: "plan",
            label: "Loom Business + AI",
            value: "Loom Business + AI"
        },
        {
            name: "plan",
            label: "Loom Enterprise",
            value: "Loom Enterprise"
        }
    ];
    else if (selectedProduct === "Jira Cloud Backup and Restore" || selectedProduct === "Jira Service Management Cloud Backup and Restore" || selectedProduct === "Confluence Cloud Backup and Restore") // Backup and Restore products have Cloud Premium and Cloud Enterprise
    return [
        {
            name: "plan",
            label: "Cloud Premium",
            value: "Cloud Premium"
        },
        {
            name: "plan",
            label: "Cloud Enterprise",
            value: "Cloud Enterprise"
        }
    ];
    else if (selectedProduct === "Jira Additional Sandbox" || selectedProduct === "Confluence Additional Sandbox" || selectedProduct === "Jira Service Management Additional Sandbox" || selectedProduct === "Jira Product Discovery Additional Sandbox") // Additional Sandbox products have Cloud Premium and Cloud Enterprise
    return [
        {
            name: "plan",
            label: "Cloud Premium",
            value: "Cloud Premium"
        },
        {
            name: "plan",
            label: "Cloud Enterprise",
            value: "Cloud Enterprise"
        }
    ];
    else // Default plans for other products
    return [
        {
            name: "plan",
            label: "Cloud Standard",
            value: "Cloud Standard"
        },
        {
            name: "plan",
            label: "Cloud Premium",
            value: "Cloud Premium"
        },
        {
            name: "plan",
            label: "Cloud Enterprise",
            value: "Cloud Enterprise"
        }
    ];
};

});
parcelRegister("ai7AF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8acea9a2b2a9060b$export$2e2bcd8739ae039; });
/**
 * Set of personal email domains, retrieved from the database.
 * @type {Set<string>}
 */ const $8acea9a2b2a9060b$var$personalEmailsDomains = new Set([
    "proinbox.com",
    "telkomsa.net",
    "whoever.com",
    "deliveryman.com",
    "bio-muesli.info",
    "correo.terra.com.gt",
    "fxsmails.com",
    "ghosttexter.de",
    "goldtoolbox.com",
    "hoopsmail.com",
    "icrazy.com",
    "linktrader.com",
    "mail2bio.com",
    "mail2don.com",
    "mail2jason.com",
    "mail2megan.com",
    "mail2missouri.com",
    "mail2sensual.com",
    "mail2single.com",
    "policeoffice.com",
    "test.de",
    "the-gentleman.com",
    "velnet.co.uk",
    "wehshee.com",
    "yapped.net",
    "googlemail.com",
    "126.com",
    "gmx.com",
    "hotmal.com",
    "netplus.ch",
    "tempomail.fr",
    "mydomain.com",
    "noavar.com",
    "mail2minnesota.com",
    "freezone.co.uk",
    "me.fr",
    "macmail.com",
    "20mail.it",
    "asheville.com",
    "buerotiger.de",
    "check1check.com",
    "chickmail.com",
    "crazymailing.com",
    "freeweb.org",
    "habmalnefrage.de",
    "kumarweb.com",
    "laoeq.com",
    "mail2uruguay.com",
    "nybella.com",
    "outlook.pt",
    "thewebpros.co.uk",
    "yuuhuu.net",
    "zwallet.com",
    "bol.com.br",
    "postmail.ch",
    "personal.ro",
    "rn.com",
    "izadpanah.com",
    "mail2fun.com",
    "asiansonly.net",
    "assamesemail.com",
    "bmlsports.net",
    "dispose.it",
    "fastmail.co.uk",
    "frommiami.com",
    "fromnebraska.com",
    "gyorsposta.com",
    "inbax.tk",
    "mail2beach.com",
    "mail2massachusetts.com",
    "mail2southdakota.com",
    "mail2splash.com",
    "mail2webtop.com",
    "mail2zoologist.com",
    "onet.com.pl",
    "raakim.com",
    "throwam.com",
    "portugalmail.pt",
    "spambog.com",
    "email.si",
    "fishburne.org",
    "lycosmail.com",
    "appraiser.net",
    "dutchmail.com",
    "exg6.exghost.com",
    "feyenoorder.com",
    "ffanet.com",
    "forpresident.com",
    "gothere.uk.com",
    "in-box.net",
    "konx.com",
    "mail2guard.com",
    "mail2mouseketeer.com",
    "pacific-ocean.com",
    "schoolemail.com",
    "schoolsucks.com",
    "syriamail.com",
    "the-gremlin.com",
    "theinternetemail.com",
    "whoopymail.com",
    "yahoo.com.co",
    "comcast.com",
    "iname.com",
    "ua.pt",
    "post.harvard.edu",
    "in.com",
    "emailengine.net",
    "mail2colorado.com",
    "anonymous.to",
    "city-of-manchester.com",
    "finebody.com",
    "fromcalifornia.com",
    "heerschap.com",
    "lroid.com",
    "mail2moon.com",
    "mail2ronnie.com",
    "our-office.com",
    "pakistanmail.com",
    "palestinemail.com",
    "search.ua",
    "slamdunkfan.com",
    "spambob.com",
    "yahoo.co.il",
    "outlook.com.br",
    "i.softbank.jp",
    "swissonline.ch",
    "bestmail.us",
    "slingshot.com",
    "spray.no",
    "mail2ahoy.com",
    "burnthespam.info",
    "cntv.cn",
    "crosswinds.net",
    "disign-concept.eu",
    "educacao.te.pt",
    "email.biz",
    "emailforyou.net",
    "england.edu",
    "galaxyhit.com",
    "i12.com",
    "isellcars.com",
    "mail2astronomer.com",
    "mail2girl.com",
    "mail2highschool.com",
    "mail2lawyer.com",
    "mail2newjersey.com",
    "netc.eu",
    "nikopage.com",
    "shitmail.de",
    "the-italian.com",
    "live.at",
    "qip.ru",
    "us.army.mil",
    "alibaba.com",
    "50mail.com",
    "mail2composer.com",
    "mailin8r.com",
    "auctioneer.net",
    "brazilmail.com.br",
    "casino.com",
    "cracker.hu",
    "earthalliance.com",
    "ich-will-net.de",
    "ihateyoualot.info",
    "invalid.com",
    "lovefootball.com",
    "mail2fat.com",
    "mail2vince.com",
    "metalfan.com",
    "mfsa.ru",
    "susi.ml",
    "yahoo.fi",
    "ya.ru",
    "bigpond.com",
    "o2online.de",
    "yahoo.com.my",
    "bigpond.com.au",
    "bolt.com",
    "acninc.net",
    "dubaimail.com",
    "emeil.in",
    "highmilton.com",
    "ididitmyway.com",
    "imapmail.org",
    "mail2arkansas.com",
    "mail2customs.com",
    "mail2emergency.com",
    "mail2milan.com",
    "netby.dk",
    "rockfan.com",
    "spoofmail.de",
    "ukmail.org",
    "uolmail.com",
    "wales2000.net",
    "weinenvorglueck.de",
    "zxcvbnm.com",
    "hotmail.no",
    "hotmail.de",
    "freemail.hu",
    "tpg.com.au",
    "cableone.net",
    "webmail.co.za",
    "shitmail.me",
    "catlover.com",
    "aknet.kg",
    "027168.com",
    "bartender.net",
    "celtic.com",
    "charmedmail.com",
    "fiberia.com",
    "goldenmail.ru",
    "idigjesus.com",
    "ignazio.it",
    "iheartspam.org",
    "loh.pp.ua",
    "mail.vasarhely.hu",
    "mail2computers.com",
    "mail2cry.com",
    "mail2daughter.com",
    "mail2downtown.com",
    "mail2lyle.com",
    "mail2paul.com",
    "mail2pediatrician.com",
    "mail2peru.com",
    "mail2singapore.com",
    "nakedgreens.com",
    "piracha.net",
    "qv7.info",
    "rr.com",
    "student.su",
    "telepac.pt",
    "tempmail2.com",
    "veryrealemail.com",
    "wegas.ru",
    "wegwerf-emails.de",
    "xms.nl",
    "internet.lu",
    "fuse.net",
    "ggaweb.ch",
    "gmx.li",
    "wavecable.com",
    "zehnminutenmail.de",
    "mail2winner.com",
    "mail2canada.com",
    "allergist.com",
    "attymail.com",
    "from-europe.com",
    "internet-mail.org",
    "ist-willig.de",
    "mail-filter.com",
    "mail.de",
    "mail2andorra.com",
    "mail2beyond.com",
    "mail2joey.com",
    "mail2millennium.com",
    "mail2persephone.com",
    "mail2republican.com",
    "mail2ronald.com",
    "mail2store.com",
    "mail2test.com",
    "sagra.lu",
    "shitmail.org",
    "sudomail.biz",
    "teachermail.net",
    "telpage.net",
    "the-spaceman.com",
    "terra.com.br",
    "mail.ee",
    "internetmailing.net",
    "bsnow.net",
    "mail2actor.com",
    "c2.hu",
    "dyndns.org",
    "fetchmail.co.uk",
    "fromillinois.com",
    "hitmail.com",
    "immo-gerance.info",
    "irelandmail.com",
    "mail2buy.com",
    "mail2rabbi.com",
    "mail2soccerfan.com",
    "nagpal.net",
    "oneoffmail.com",
    "petlover.com",
    "spameater.com",
    "spaminator.de",
    "teamtulsa.net",
    "the-professional.com",
    "unbounded.com",
    "universal.pt",
    "wegwerpmailadres.nl",
    "whipmail.com",
    "hetnet.nl",
    "ameritech.net",
    "sasktel.net",
    "inode.at",
    "about.com",
    "boom.com",
    "idirect.com",
    "mail2dream.com",
    "norika-fujiwara.com",
    "mail2fantasy.com",
    "cyber-phone.eu",
    "estranet.it",
    "fatflap.com",
    "free-online.net",
    "frommaine.net",
    "karachian.com",
    "km.ru",
    "mail2christy.com",
    "mail2lacrosse.com",
    "mail2libra.com",
    "mail2lloyd.com",
    "mail2navy.com",
    "mail2pan.com",
    "mail2paralegal.com",
    "mail2state.com",
    "myiris.com",
    "passwordmail.com",
    "quickwebmail.com",
    "spamkill.info",
    "mail.missouri.edu",
    "upcmail.nl",
    "9online.fr",
    "spaml.de",
    "devnullmail.com",
    "meltmail.com",
    "sanfranmail.com",
    "mail2alien.com",
    "otakumail.com",
    "yalla.com",
    "16mail.com",
    "buyersusa.com",
    "cyber-innovation.club",
    "gamno.config.work",
    "irj.hu",
    "kaffeeschluerfer.com",
    "killermail.com",
    "mail2anesthesiologist.com",
    "mail2iris.com",
    "mail2manhunter.com",
    "mail2rugby.com",
    "mail2taxi.com",
    "xyzfree.net",
    "gmail.com",
    "katamail.com",
    "gportal.hu",
    "omaninfo.com",
    "cyberservices.com",
    "fortuncity.com",
    "general-hospital.com",
    "golfemail.com",
    "ikbenspamvrij.nl",
    "italymail.com",
    "liberomail.com",
    "lovethecowboys.com",
    "mail2airport.com",
    "mail2bank.com",
    "mail2maggie.com",
    "mail2safe.com",
    "mail2school.com",
    "mail2wendy.com",
    "mailpick.biz",
    "mutantweb.com",
    "mynamedot.com",
    "nabc.biz",
    "outlook.ph",
    "uk2.net",
    "students.fhu.edu",
    "jubiimail.dk",
    "ny.com",
    "mail2ares.com",
    "columbusrr.com",
    "for-president.com",
    "gigileung.org",
    "lahoreoye.com",
    "legalrc.loan",
    "mail2chad.com",
    "mail2gordon.com",
    "mail2lithuania.com",
    "mail2nuclear.com",
    "mail2passion.com",
    "mail2tina.com",
    "net-c.com",
    "outlook.be",
    "remail.ga",
    "uni.de",
    "hotmai.com",
    "fastmail.fm",
    "telusplanet.net",
    "vodafone.it",
    "mail-page.com",
    "email.ee",
    "mail-temporaire.fr",
    "arcotronics.bg",
    "fastsuzuki.com",
    "from-argentina.com",
    "from-russia.com",
    "hkg.net",
    "inet.com",
    "kaazoo.com",
    "keyemail.com",
    "ksee24mail.com",
    "mail2aunt.com",
    "mail2dustin.com",
    "mail2exciting.com",
    "mail2sky.com",
    "mail2wisconsin.com",
    "mailshuttle.com",
    "millionaireintraining.com",
    "recyclermail.com",
    "tbwt.com",
    "the-chinese.com",
    "the-fool.com",
    "yahoofs.com",
    "gmx.at",
    "yaho.com",
    "cd2.com",
    "bugmenot.com",
    "cashette.com",
    "mail2albania.com",
    "123mail.org",
    "bimla.net",
    "boxbg.com",
    "calidifontain.be",
    "flipcode.com",
    "garbage.com",
    "lovethebroncos.com",
    "mail2doris.com",
    "mail2eris.com",
    "mail2hollywood.com",
    "mail2site.com",
    "mail2travel.com",
    "nafe.com",
    "parvazi.com",
    "pcsrock.com",
    "roanokemail.com",
    "space-ship.com",
    "spacemart.com",
    "stop-my-spam.pp.ua",
    "sudanmail.net",
    "uol.com.ve",
    "wearab.net",
    "web-ideal.fr",
    "online.no",
    "lineone.net",
    "nus.edu.sg",
    "japan.com",
    "guerrillamailblock.com",
    "fbi.hu",
    "freemail.it",
    "2trom.com",
    "anymoment.com",
    "bluesfan.com",
    "bollywoodz.com",
    "callsign.net",
    "fan.com",
    "getonemail.net",
    "infohq.com",
    "isonfire.com",
    "m-a-i-l.com",
    "mail2congo.com",
    "mail2jacob.com",
    "mail2melissa.com",
    "mail2pete.com",
    "mail2runner.com",
    "mail2worship.com",
    "pagons.org",
    "startkeys.com",
    "onet.pl",
    "mail.net.sa",
    "onlinehome.de",
    "mailcatch.com",
    "yahoo.cn",
    "gmx.eu",
    "post.ru",
    "fastimap.com",
    "mail2alexa.com",
    "mail2indonesia.com",
    "bio-muesli.net",
    "snail-mail.net",
    "8mail.ml",
    "antwerpen.com",
    "domforfb2.tk",
    "fromwisconsin.com",
    "krim.ws",
    "mail2caroline.com",
    "mail2kelly.com",
    "mail2tammy.com",
    "nameplanet.com",
    "nettemail.com",
    "outlook.com.gr",
    "partynight.at",
    "religious.com",
    "the-frenchman.com",
    "totalmusic.net",
    "vinbazar.com",
    "yahoo.com.ru",
    "net2000.ch",
    "tiscali.it",
    "cogeco.ca",
    "softhome.net",
    "mail-central.com",
    "spammotel.com",
    "mail2tanya.com",
    "socamail.com",
    "getonemail.com",
    "uboot.com",
    "1webave.com",
    "20mail.in",
    "discard.email",
    "gci.net",
    "geeklife.com",
    "mail2columbia.com",
    "mail2douglas.com",
    "mail2handhelds.com",
    "mail2marc.com",
    "mail2stan.com",
    "mail2tenderness.com",
    "phone.net",
    "soccermomz.com",
    "unihome.com",
    "worldnet.att.net",
    "za.com",
    "189.cn",
    "inwind.it",
    "temporarioemail.com.br",
    "megamail.pt",
    "netian.com",
    "x5g.com",
    "mail2boston.com",
    "1funplace.com",
    "3mail.ga",
    "consumerriot.com",
    "directbox.com",
    "earthonline.net",
    "ednatx.com",
    "fast-email.com",
    "getairmail.ga",
    "groupmail.com",
    "mail2airbag.com",
    "mail2boreas.com",
    "mail2bug.com",
    "mail2elvis.com",
    "mail2freddie.com",
    "mail2howard.com",
    "mail2lost.com",
    "mail2lynn.com",
    "mail2mycell.com",
    "mail2toby.com",
    "mailsurf.com",
    "nonspammer.de",
    "nzoomail.com",
    "reconmail.com",
    "suisse.org",
    "vip.citiz.net",
    "vp.pl",
    "mail.usf.edu",
    "net.hr",
    "prodigy.net.mx",
    "blueyonder.co.uk",
    "swbell.net",
    "bendbroadband.com",
    "owlpic.com",
    "mail2dennis.com",
    "zubee.com",
    "mail2mypc.com",
    "2d2i.com",
    "abwesend.de",
    "clubvdo.net",
    "gratisweb.com",
    "jetable.pp.ua",
    "mail2jones.com",
    "mail2myphone.com",
    "mail2taylor.com",
    "reggaefan.com",
    "rsub.com",
    "trash2010.com",
    "vjtimail.com",
    "yahoo.co.kr",
    "atlanticbb.net",
    "san.rr.com",
    "safe-mail.net",
    "mail2syria.com",
    "awsom.net",
    "cortinet.com",
    "honduras.com",
    "mail2beatles.com",
    "mail2chile.com",
    "mail2classifieds.com",
    "mail2darling.com",
    "mail2holland.com",
    "mail2marshallislands.com",
    "mail2tycoon.com",
    "mezimages.net",
    "netti.fi",
    "reallymymail.com",
    "sandelf.de",
    "thegolfcourse.com",
    "mail2pharmacist.com",
    "mail2prince.com",
    "mail2robert.com",
    "daha.com",
    "kitznet.at",
    "mail2oscars.com",
    "naseej.com",
    "fastmail.uk",
    "thai.com",
    "berlinexpo.de",
    "mail2saudiarabia.com",
    "mail2gold.com",
    "email.com",
    "mail2hongkong.com",
    "liverpoolfans.com",
    "4email.com",
    "chequemail.com",
    "hush.ai",
    "mail2human.com",
    "mail2airforce.com",
    "mail2santa.com",
    "mail2barbara.com",
    "waumail.com",
    "mail2recycle.com",
    "mail2pluto.com",
    "fsmail.net",
    "online.de",
    "yahoo.pl",
    "netvigator.com",
    "berlin.com",
    "onelinkpr.net",
    "antispam.de",
    "carioca.net",
    "einrot.de",
    "interburp.com",
    "koreamail.com",
    "mail2diehard.com",
    "mail2gambia.com",
    "mail2hannah.com",
    "mail2hermes.com",
    "mail2wonder.com",
    "mailbox.as",
    "meine-urlaubsfotos.de",
    "orthodontist.net",
    "outlook.lv",
    "psv-supporter.com",
    "qrio.com",
    "racingmail.com",
    "scifianime.com",
    "shitaway.ga",
    "swiftdesk.com",
    "telebot.com",
    "whatpaas.com",
    "yesey.net",
    "zydecofan.com",
    "investormail.com",
    "tfz.net",
    "mail2medieval.com",
    "mail2mini.com",
    "mail2danielle.com",
    "zhaowei.net",
    "the-davis-home.com",
    "cityofcardiff.net",
    "elitemail.org",
    "mail2delaware.com",
    "mail2eurus.com",
    "box.az",
    "mail2beast.com",
    "chattown.com",
    "mail2melody.com",
    "mail2monica.com",
    "mail2sweetheart.com",
    "nc.rr.com",
    "lhsdv.com",
    "4worldmail.com",
    "wonder-net.com",
    "frommichigan.com",
    "anjungcafe.com",
    "nauticom.net",
    "madrid.com",
    "posteo.de",
    "fwnb.com",
    "ihwy.com",
    "spam.la",
    "businessweekmail.com",
    "nobulk.com",
    "internode.on.net",
    "stribmail.com",
    "sx172.com",
    "emailstuff.com",
    "mail2washington.com",
    "xoommail.com",
    "chauhanweb.com",
    "counsellor.com",
    "geecities.com",
    "varbizmail.com",
    "medicinemail.com",
    "mail2northpole.com",
    "nyc.rr.com",
    "mail2somalia.com",
    "fastacura.com",
    "imposter.co.uk",
    "planetarymotion.net",
    "mail2wendell.com",
    "cybergrrl.com",
    "5star.com",
    "internet-club.com",
    "from-korea.com",
    "netcabo.pt",
    "brokenvalve.com",
    "center-mail.de",
    "mail2rss.org",
    "mailcat.biz",
    "photographer.net",
    "shieldedmail.com",
    "toast.com",
    "zzz.com",
    "mail2gabriel.com",
    "dawsonmail.com",
    "grandecom.net",
    "f1fans.net",
    "firehost.com",
    "officedomain.com",
    "kbjrmail.com",
    "zensearch.net",
    "repairman.com",
    "mail2banker.com",
    "bisons.com",
    "infinito.it",
    "mail2connect.com",
    "mail2charles.com",
    "hotmial.com",
    "emailsensei.com",
    "besonet.ch",
    "mantramail.com",
    "sci.fi",
    "ip3.com",
    "sialkotcity.com",
    "cegetel.net",
    "breadtimes.press",
    "tankpolice.com",
    "z1p.biz",
    "hotmail.co.uk",
    "hamburg.de",
    "ybb.ne.jp",
    "empal.com",
    "inorbit.com",
    "mail2world.com",
    "uggsrock.com",
    "myplace.com",
    "mail.net",
    "vipmail.ru",
    "getairmail.gq",
    "mail2cardinal.com",
    "mail2darren.com",
    "mail2georgia.com",
    "mail2kiss.com",
    "mail2mary.com",
    "mail2uptown.com",
    "resource.calendar.google.com",
    "secretservices.net",
    "sporttruckdriver.com",
    "supermail.ru",
    "yalla.com.lb",
    "yahoo.com.tw",
    "nifty.com",
    "ma.ru",
    "yahoo.com.tr",
    "netmadeira.com",
    "sendme.cz",
    "kittymail.com",
    "hol.gr",
    "whatever.com",
    "clubbers.net",
    "thewatercooler.com",
    "mail2pope.com",
    "1nsyncfan.com",
    "alloymail.com",
    "fastkawasaki.com",
    "imap-mail.com",
    "mail2filmfestival.com",
    "mail2karma.com",
    "mail2king.com",
    "mail2life.com",
    "mailbox80.biz",
    "mohammed.com",
    "mystupidjob.com",
    "netscapeonline.co.uk",
    "nirvanafan.com",
    "outlook.at",
    "planetout.com",
    "secure-mail.biz",
    "servermaps.net",
    "violinmakers.co.uk",
    "w3.to",
    "outlook.es",
    "yahoo.com.cn",
    "post.cz",
    "vodafone.es",
    "fastemail.us",
    "pookmail.com",
    "canoemail.com",
    "trash-amil.com",
    "chaiyomail.com",
    "echina.com",
    "england.com",
    "fromhawaii.net",
    "geopia.com",
    "mail2amazing.com",
    "mail2aquarius.com",
    "mail2claude.com",
    "mail2danny.com",
    "mail2free.com",
    "mail2herman.com",
    "mail2isaac.com",
    "mail2shirley.com",
    "renren.com",
    "scubadiving.com",
    "techspot.com",
    "truckracer.com",
    "live.de",
    "telenet.be",
    "volny.cz",
    "pandora.be",
    "freestart.hu",
    "airmail.net",
    "nb.sympatico.ca",
    "uol.com.ar",
    "maffia.hu",
    "surimail.com",
    "contractor.net",
    "facebookmail.gq",
    "fortunecity.com",
    "fuorissimo.com",
    "gaybrighton.co.uk",
    "lmxmail.sk",
    "mail2kuwait.com",
    "mail2malta.com",
    "mail2member.com",
    "mail2redhead.com",
    "mail2yemen.com",
    "mailbr.com.br",
    "outlook.ie",
    "tennismail.com",
    "mail.ru",
    "yahoo.com.br",
    "neuf.fr",
    "hotmail.co.jp",
    "student.swin.edu.au",
    "registerednurses.com",
    "financier.com",
    "breathe.com",
    "yapost.com",
    "99experts.com",
    "accountant.com",
    "cheatmail.de",
    "city-of-westminster.net",
    "emailgo.de",
    "f-m.fm",
    "globalsite.com.br",
    "hang-ten.com",
    "iowaemail.com",
    "mail2adorable.com",
    "mail2blind.com",
    "mail2gabon.com",
    "mail2joel.com",
    "martindalemail.com",
    "mm.st",
    "nowhere.org",
    "radiologist.net",
    "sebil.com",
    "st-davids.net",
    "ultapulta.com",
    "vodafonethuis.nl",
    "xww.ro",
    "yalook.com",
    "caiway.nl",
    "kpnmail.nl",
    "citromail.hu",
    "hot.rr.com",
    "37.com",
    "netposta.net",
    "mail2russia.com",
    "farifluset.mailexpire.com",
    "fromutah.com",
    "iamwaiting.com",
    "iroid.com",
    "liveradio.tk",
    "mail2australia.com",
    "mail2colombia.com",
    "mail2deanna.com",
    "mail2ethiopia.com",
    "mail2ok.com",
    "mycabin.com",
    "r-o-o-t.com",
    "reborn.com",
    "rickymail.com",
    "superstachel.de",
    "windrivers.net",
    "youmailr.com",
    "videotron.ca",
    "bell.net",
    "dr.com",
    "montevideo.com.uy",
    "mailbolt.com",
    "trashmail.ws",
    "mail2triallawyer.com",
    "mail2expert.com",
    "fastsubaru.com",
    "iobox.fi",
    "mail2aeolus.com",
    "mail2christmas.com",
    "mail2hygeia.com",
    "mail2ian.com",
    "mail2jail.com",
    "mail2peggy.com",
    "mail2stanley.com",
    "premium-mail.fr",
    "rastogi.net",
    "the-police.com",
    "vollbio.de",
    "xsecurity.org",
    "hochsitze.com",
    "fmguy.com",
    "singmail.com",
    "ak47.hu",
    "wx88.net",
    "bodhi.lawlita.com",
    "domforfb5.tk",
    "dontmesswithtexas.com",
    "dostmail.com",
    "fastservice.com",
    "friendsfan.com",
    "linkmaster.com",
    "mail2afghanistan.com",
    "mail2eric.com",
    "mail2erica.com",
    "mail2indian.com",
    "mail2kyrgyzstan.com",
    "mail2maurice.com",
    "mail2oliver.com",
    "mail2samantha.com",
    "mail2scorpio.com",
    "mail2studio54.com",
    "mailgenie.net",
    "mailtothis.com",
    "mlb.bounce.ed10.net",
    "mr-potatohead.com",
    "net-c.es",
    "ntlhelp.net",
    "pepbot.com",
    "popsmail.com",
    "sentrismail.com",
    "gmx.es",
    "live.fr",
    "t-email.hu",
    "cust.in",
    "email.wsu.edu",
    "insightbb.com",
    "email.ro",
    "canada-11.com",
    "biggerbadder.com",
    "email.org",
    "mail.com.tr",
    "mail2club.com",
    "mail2craig.com",
    "mail2florida.com",
    "mail2games.com",
    "mail2newzealand.com",
    "mail2nike.com",
    "mail2noelle.com",
    "mail2policewoman.com",
    "mail2unsubscribe.com",
    "mail2uzbekistan.com",
    "mail2waycool.com",
    "mostlysunny.com",
    "nemra1.com",
    "starplace.com",
    "t.psh.me",
    "talkinator.com",
    "uomail.com",
    "wingnutz.com",
    "sina.cn",
    "voila.fr",
    "aol.nl",
    "stanfordalumni.org",
    "c3.hu",
    "fmail.co.uk",
    "9.cn",
    "myspace.com",
    "uno.it",
    "1freeemail.com",
    "domforfb6.tk",
    "federalcontractors.com",
    "ghostmail.com",
    "gofree.co.uk",
    "jourrapide.com",
    "mail.org.uk",
    "mail2attitude.com",
    "mail2blake.com",
    "mail2cathy.com",
    "mail2earl.com",
    "mail2nicaragua.com",
    "mail2paris.com",
    "mail2planet.com",
    "mail2sail.com",
    "mail2susan.com",
    "mail2vanessa.com",
    "mail2venus.com",
    "net-c.pl",
    "odaymail.com",
    "our-computer.com",
    "papierkorb.me",
    "raubtierbaendiger.de",
    "thraml.com",
    "tidni.com",
    "twc.com",
    "hotmail.es",
    "post.com",
    "euronet.nl",
    "op.pl",
    "yahoo.com.sg",
    "nate.com",
    "lycos.co.uk",
    "fizmail.com",
    "bombdiggity.com",
    "bsdmail.com",
    "citlink.net",
    "disign-revelation.com",
    "earthcam.net",
    "ieatspam.info",
    "mail2africa.com",
    "mail2chinese.com",
    "mail2hera.com",
    "mail2janet.com",
    "mail2kenneth.com",
    "mail2trump.com",
    "mash4077.com",
    "mohmal.com",
    "postfach.cc",
    "spils.com",
    "theoffice.net",
    "aol.co.uk",
    "socal.rr.com",
    "sibmail.com",
    "q.com",
    "mailandftp.com",
    "portugalmail.com",
    "theend.hu",
    "h.mintemail.com",
    "8mail.ga",
    "armyspy.com",
    "asean-mail.com",
    "aussiemail.com.au",
    "bresnan.net",
    "city-of-cambridge.com",
    "handbag.com",
    "iamyours.com",
    "mail2austria.com",
    "mail2grandma.com",
    "mail2help.com",
    "mail2michelle.com",
    "mail2rock.com",
    "mail2spanish.com",
    "mail2tonga.com",
    "mail2tunisia.com",
    "mail2v.com",
    "mail2vamoose.com",
    "mancity.net",
    "moldova.com",
    "netlane.com",
    "skrx.tk",
    "yopweb.com",
    "sapo.pt",
    "columbus.rr.com",
    "freeserve.co.uk",
    "dingbone.com",
    "mail2nowhere.com",
    "lucidonline.co.uk",
    "mail2hindu.com",
    "blogmyway.org",
    "bouncr.com",
    "colleges.com",
    "digital-filestore.de",
    "dragoncon.net",
    "ezrs.com",
    "flashmail.net",
    "furnitureprovider.com",
    "goemailgo.com",
    "mail.htl22.at",
    "mail2spare.com",
    "mail2zipper.com",
    "mailclub.net",
    "mailfs.com",
    "mailslapping.com",
    "solar-impact.pro",
    "sudomail.net",
    "live.se",
    "bluemail.ch",
    "i.ua",
    "hot.ee",
    "dbzmail.com",
    "123.com",
    "intermail.co.il",
    "spymac.com",
    "mail2iran.com",
    "birdlover.com",
    "chef.net",
    "cynetcity.com",
    "emailage.ga",
    "fake-mail.cf",
    "gencmail.com",
    "home.no.net",
    "ilse.nl",
    "jobbikszimpatizans.hu",
    "mail2justin.com",
    "mail2max.com",
    "mail2neil.com",
    "mail2oregon.com",
    "mail2patty.com",
    "mail2soccer.com",
    "mail2swaziland.com",
    "nmail.cf",
    "office-email.com",
    "privy-mail.com",
    "whatiaas.com",
    "mail.mcgill.ca",
    "post.sk",
    "mail2brunei.com",
    "netster.com",
    "bullsgame.com",
    "email.ua",
    "geek.com",
    "goodstick.com",
    "ip6.pp.ua",
    "mail2dominic.com",
    "mail2kentucky.com",
    "mail2mail4.com",
    "mail2presbyterian.com",
    "mail2rob.com",
    "mail2stewart.com",
    "mail2tim.com",
    "mailwire.com",
    "meine-diashow.de",
    "okmagic.com",
    "olympist.net",
    "pianomail.com",
    "politician.com",
    "siteposter.net",
    "snakebite.com",
    "techscout.com",
    "the-stock-market.com",
    "thewizzkid.com",
    "wxs.net",
    "tele2.se",
    "primposta.hu",
    "bostonoffice.com",
    "thirdage.com",
    "1coolplace.com",
    "addcom.de",
    "airforce.net",
    "box.ua",
    "dotcom.fr",
    "dumpmail.de",
    "duskmail.com",
    "e-mail.com.tr",
    "elvisfan.com",
    "etranquil.com",
    "fnbmail.co.za",
    "from-australia.com",
    "luso.pt",
    "mail2billionaire.com",
    "mail2demeter.com",
    "mail2mrright.com",
    "mail2rap.com",
    "mail2shane.com",
    "manager.de",
    "quakemail.com",
    "sags-per-mail.de",
    "scarlet.nl",
    "spam.care",
    "the-army.com",
    "vip.126.com",
    "zuvio.com",
    "aol.de",
    "inbox.lv",
    "netvision.net.il",
    "bellaliant.net",
    "seed.net.tw",
    "inmail24.com",
    "ausi.com",
    "incognitomail.org",
    "dropzone.com",
    "centralpets.com",
    "chat.ru",
    "keko.com.ar",
    "movemail.com",
    "as-if.com",
    "bellair.net",
    "bigger.com",
    "dawnsonmail.com",
    "infospacemail.com",
    "mail2ernie.com",
    "mail2frank.com",
    "mail2gary.com",
    "mail2headhunter.com",
    "mail2irene.com",
    "mail2love.com",
    "mail2rusty.com",
    "mail2tony.com",
    "mehtaweb.com",
    "mynetstore.de",
    "quantentunnel.de",
    "regbypass.com",
    "space-man.com",
    "spl.at",
    "wormseo.cn",
    "wrongmail.com",
    "yahoo.ro",
    "your-mail.com",
    "web.de",
    "email.it",
    "europe.com",
    "space.com",
    "citiz.net",
    "dodgit.com",
    "slopsbox.com",
    "yuurok.com",
    "mail2hell.com",
    "arabia.com",
    "die-genossen.de",
    "dog.com",
    "handleit.com",
    "job4u.com",
    "listomail.com",
    "llandudno.com",
    "mail2arnold.com",
    "mail2disco.com",
    "mail2dive.com",
    "mail2economist.com",
    "mail2jed.com",
    "mail2louisiana.com",
    "mail2mba.com",
    "mail2sagittarius.com",
    "mail2samoa.com",
    "mail2suzie.com",
    "mail2tennis.com",
    "mns.ru",
    "mosaicfx.com",
    "most-wanted.com",
    "nchoicemail.com",
    "nexxmail.com",
    "slippery.email",
    "topsurf.com",
    "unofree.it",
    "compuserve.com",
    "keepmymail.com",
    "1chuan.com",
    "bizhosting.com",
    "dallasmail.com",
    "hitthe.net",
    "in2jesus.com",
    "mail2dinner.com",
    "mail2fancy.com",
    "mail2ny.com",
    "mail2slovakia.com",
    "mail2try.com",
    "netexpressway.com",
    "olemail.com",
    "project2k.com",
    "tritium.net",
    "wbdet.com",
    "weg-werf-email.de",
    "women-at-work.org",
    "wouldilie.com",
    "mail2panama.com",
    "fudgerub.com",
    "wi.rr.com",
    "yahoo.no",
    "mail2vickie.com",
    "tmailinator.com",
    "technologist.com",
    "liquidinformation.net",
    "wrexham.net",
    "yahoo.com.ph",
    "soon.com",
    "linuxfreemail.com",
    "bobmail.info",
    "classicalfan.com",
    "centrum.sk",
    "asia-links.com",
    "leonlai.net",
    "realradiomail.com",
    "mantrafreenet.com",
    "allmail.net",
    "ec.rr.com",
    "1netdrive.com",
    "gaza.net",
    "adexec.com",
    "kalpoint.com",
    "enter.net",
    "3email.com",
    "cumbriamail.com",
    "adfarrow.com",
    "webdream.com",
    "mail2tennessee.com",
    "from-holland.com",
    "eposta.hu",
    "deneg.net",
    "london.com",
    "columnist.com",
    "mail2environmentalist.com",
    "highveldmail.co.za",
    "gmail.om",
    "interfree.it",
    "spamavert.com",
    "emailaccount.com",
    "go.com",
    "mail2uncle.com",
    "atmc.net",
    "businessman.net",
    "chong-mail.com",
    "examnotes.net",
    "fromidaho.com",
    "ghanamail.com",
    "mail2egypt.com",
    "mail2israel.com",
    "mail2katie.com",
    "mail2mexican.com",
    "mail2surfer.com",
    "mail2trekkie.com",
    "muell.icu",
    "nimail.com",
    "the-african.com",
    "sympatico.ca",
    "alice-dsl.net",
    "go2.pl",
    "sina.com.cn",
    "slingshot.co.nz",
    "uk7.net",
    "brasilia.net",
    "busta-rhymes.com",
    "curio-city.com",
    "from-canada.com",
    "fromoregon.net",
    "hu2.ru",
    "ich-bin-verrueckt-nach-dir.de",
    "mail2coastguard.com",
    "mail2intense.com",
    "mail2jenny.com",
    "mail2kristin.com",
    "mail2ron.com",
    "mail2skater.com",
    "mail2zambia.com",
    "marijuana.com",
    "miho-nakayama.com",
    "outlook.com.pe",
    "parkjiyoon.com",
    "skeefmail.com",
    "tmail.ws",
    "ig.com.br",
    "optimum.net",
    "wanadoo.es",
    "spambog.de",
    "fmailbox.com",
    "5iron.com",
    "surfy.net",
    "phayze.com",
    "mail2rich.com",
    "alternativagratis.com",
    "catcha.com",
    "cooooool.com",
    "fastmail.se",
    "footard.com",
    "lavache.com",
    "mail2jessie.com",
    "mail2keen.com",
    "mail2webtv.com",
    "mail2westvirginia.com",
    "muskelshirt.de",
    "mythirdage.com",
    "n2software.com",
    "net-shopping.com",
    "royal.net",
    "rubyridge.com",
    "stipte.nl",
    "webtopmail.com",
    "hanmail.net",
    "centurylink.net",
    "carolina.rr.com",
    "yours.com",
    "mail2kurt.com",
    "lovemail.com",
    "8848.net",
    "brew-meister.com",
    "cybercafemaui.com",
    "fastmitsubishi.com",
    "fishfuse.com",
    "imstations.com",
    "mail2cell.com",
    "mail2firm.com",
    "mail2fred.com",
    "mail2hercules.com",
    "mail2ice-cream.com",
    "mail2stockholm.com",
    "mail2taxidermist.com",
    "mail2valentines.com",
    "mail2vietnam.com",
    "mailchoose.co",
    "meetingmall.com",
    "navy.org",
    "olypmall.ru",
    "partyheld.de",
    "sunsgame.com",
    "survivormail.com",
    "dandikmail.com",
    "fromarizona.com",
    "eqqu.com",
    "melodymail.com",
    "iwmail.com",
    "mail15.com",
    "mail2whether.com",
    "mail2coach.com",
    "fakeinbox.com",
    "the-american.com",
    "freemail.org.mk",
    "btinternet.com",
    "mail2sara.com",
    "mail2trick.com",
    "presidency.com",
    "ubbi.com.br",
    "mail2mime.com",
    "virtualmail.com",
    "mailroom.com",
    "malayalamtelevision.net",
    "ureach.com",
    "alive.cz",
    "mail2margie.com",
    "laposte.net",
    "posteo.us",
    "anti-social.com",
    "mail2atom.com",
    "mail2heather.com",
    "bharatmail.com",
    "subram.com",
    "truckers.com",
    "ace-of-base.com",
    "itmom.com",
    "foxmail.com",
    "mail2namibia.com",
    "mail2psycho.com",
    "mail2adore.com",
    "m-hmail.com",
    "automotiveauthority.com",
    "oceanfree.net",
    "swissinfo.org",
    "sailormoon.com",
    "email.nu",
    "me.com",
    "oldies104mail.com",
    "mail2venezuela.com",
    "mail2edwin.com",
    "hey.to",
    "tvcablenet.be",
    "wegwerfemail.de",
    "nfmail.com",
    "pobox.hu",
    "mail2pilot.com",
    "peopleweb.com",
    "anote.com",
    "mttestdriver.com",
    "mail2russell.com",
    "smileyface.comsmithemail.net",
    "fnmail.com",
    "rattle-snake.com",
    "indyracers.com",
    "host-it.com.sg",
    "studenti.unisannio.it",
    "popaccount.com",
    "cotas.net",
    "fire-brigade.com",
    "mail2oslo.com",
    "hamptonroads.com",
    "theraces.com",
    "the-madman.com",
    "ozemail.com.au",
    "yourwap.com",
    "rrohio.com",
    "metacrawler.com",
    "vikenfiber.no",
    "mail2register.com",
    "posteo.es",
    "deltanet.com",
    "boom.ru",
    "libertysurf.fr",
    "guessmail.com",
    "fastmail.es",
    "netspeedway.com",
    "mypad.com",
    "mail2amanda.com",
    "mail2earth.com",
    "mail2artemus.com",
    "ranmamail.com",
    "dunlopdriver.com",
    "yoursubdomain.findhere.com",
    "forfree.at",
    "yoursubdomain.zzn.com",
    "ewetel.net",
    "mail2italy.com",
    "from-mexico.com",
    "okname.net",
    "frompennsylvania.com",
    "mail2webmaster.com",
    "spartapiet.com",
    "city-of-lichfield.com",
    "glendale.net",
    "osite.com.br",
    "students.swinburne.edu.my",
    "nandomail.com",
    "gmail.comm",
    "freeaccess.nl",
    "snowboarding.com",
    "mail2timothy.com",
    "mail2ryan.com",
    "mail2tara.com",
    "1me.net",
    "earthlink.net",
    "mail2socialist.com",
    "mail2estonia.com",
    "mail2michigan.com",
    "lexis-nexis-mail.com",
    "ilovechocolate.com",
    "aliceposta.it",
    "davegracey.com",
    "mail2www.com",
    "oso.com",
    "asurfer.com",
    "netgenie.com",
    "geekmail.com",
    "spamfree24.eu",
    "promessage.com",
    "mail.entrepeneurmag.com",
    "epost.de",
    "gardener.com",
    "icmsconsultants.com",
    "mail2why.com",
    "ngs.ru",
    "netsquare.com",
    "msn.cn",
    "mygo.com",
    "fastemailer.com",
    "orange.nl",
    "educastmail.com",
    "live.dk",
    "mail2sudan.com",
    "mail.r-o-o-t.com",
    "sohu.com",
    "pacbell.net",
    "uniroma1.it",
    "centurytel.net",
    "insurer.com",
    "indiatimes.com",
    "pediatrician.com",
    "mail2john.com",
    "anytimenow.com",
    "batuta.net",
    "bleib-bei-mir.de",
    "blushmail.com",
    "fastmail.in",
    "instant-mail.de",
    "mail2bryan.com",
    "mail2optometrist.com",
    "plusmail.com.br",
    "slo.net",
    "vodafone.nl",
    "webprogramming.com",
    "yourteacher.net",
    "onenet.com.ar",
    "covad.net",
    "mail2grandpa.com",
    "mail2sandra.com",
    "singapore.com",
    "web-mail.com.ar",
    "live.com.pt",
    "e-mail.ru",
    "websurfer.co.za",
    "une.net.co",
    "mail2seychelles.com",
    "urgentmail.biz",
    "mail2courtney.com",
    "mail2whitney.com",
    "i-mail.com.au",
    "telia.com",
    "mail2virgo.com",
    "mail2director.com",
    "mail2tracy.com",
    "libero.it",
    "hotamail.com",
    "tampabay.rr.com",
    "cluemail.com",
    "4warding.net",
    "chance2mail.com",
    "china.com",
    "financemail.net",
    "ilkposta.com",
    "krunis.com",
    "lags.us",
    "mail2brian.com",
    "mail2croatia.com",
    "mail2female.com",
    "mail2french.com",
    "mail2julian.com",
    "mail2volleyball.com",
    "mailbomb.net",
    "mailzi.ru",
    "naplesnews.net",
    "reallyfast.info",
    "reply.ticketmaster.com",
    "sweetville.net",
    "mail2azerbaijan.com",
    "primposta.com",
    "wolf-web.com",
    "vote-republicans.com",
    "hotmail.it",
    "mail2greg.com",
    "mail2no.com",
    "mail2yes.com",
    "4warding.org",
    "mail2policeman.com",
    "mail2southcarolina.com",
    "atlink.com",
    "mail2lucky.com",
    "di-ve.com",
    "hotmail.cl",
    "hotmail.sg",
    "uol.com.co",
    "thegooner.com",
    "034.pfr.ru",
    "imstressed.com",
    "mail2convict.com",
    "pharmacymail.com",
    "hotmail.ch",
    "0-mail.com",
    "index.ua",
    "physicist.net",
    "shitware.nl",
    "tempmaildemo.com",
    "mail2taz.com",
    "aol.in",
    "mailservice.ms",
    "smoothmail.com",
    "mail2czechrepublic.com",
    "hackermail.net",
    "from-outerspace.com",
    "mail2tiffany.com",
    "mail2tv.com",
    "mailhood.com",
    "mail2capeverde.com",
    "frommissouri.com",
    "playersodds.com",
    "fastmail.com",
    "votenet.com",
    "fut.es",
    "email.ru",
    "thedoghousemail.com",
    "mypersonalemail.com",
    "mail2traveler.com",
    "t-online.de",
    "temporaryinbox.com",
    "the-astronaut.com",
    "tyldd.com",
    "sp.nl",
    "myopera.com",
    "sialkotoye.com",
    "mail2memphis.com",
    "snip.net",
    "mail2hungry.com",
    "mail2podiatrist.com",
    "mail2capricorn.com",
    "iprimus.com.au",
    "mycool.com",
    "coxinet.net",
    "mail2france.com",
    "mail2truck.com",
    "posteo.pl",
    "mail2platinum.com",
    "takuyakimura.com",
    "mailhaven.com",
    "qudsmail.com",
    "myremarq.com",
    "yahoo.com",
    "online.fr",
    "footballmail.com",
    "mailstart.com",
    "zcities.com",
    "premiumservice.com",
    "vjmail.com",
    "care2.com",
    "luukku.com",
    "mail2elizabeth.com",
    "rocketmail.com",
    "excite.co.jp",
    "mail2dude.com",
    "1mail.net",
    "atozasia.com",
    "city-of-edinburgh.com",
    "computer-freak.com",
    "cornells.com",
    "expressasia.com",
    "mail2chocolate.com",
    "mail2dinosaur.com",
    "mail2everything.com",
    "mail2jerry.com",
    "mail2sanmarino.com",
    "mailingweb.com",
    "mailsac.com",
    "pconnections.net",
    "servemymail.com",
    "tcc.on.ca",
    "valemail.net",
    "xagloo.com",
    "gmail.ru",
    "alum.mit.edu",
    "ziggo.nl",
    "narod.ru",
    "africamail.com",
    "clubhonda.net",
    "thankyou2010.com",
    "212.com",
    "disposemail.com",
    "starspath.com",
    "backpackers.com",
    "bounces.amazon.com",
    "doclist.bounces.google.com",
    "every1.net",
    "joinme.com",
    "kube93mail.com",
    "mail2bride.com",
    "mail2thailand.com",
    "mail2virginia.com",
    "net4you.at",
    "outlook.de",
    "showslow.de",
    "swedenmail.com",
    "vickaentb.tk",
    "globo.com",
    "spamherelots.com",
    "lavabit.com",
    "w.cn",
    "2-mail.com",
    "telkom.net",
    "mail2queen.com",
    "mail2ray.com",
    "mail2franklin.com",
    "boximail.com",
    "emailproxsy.com",
    "eyepaste.com",
    "gonavy.net",
    "herediano.com",
    "mail2eastend.com",
    "mail2joseph.com",
    "mail2secretagent.com",
    "resgedvgfed.tk",
    "send.hu",
    "suhabi.com",
    "topmail.com.ar",
    "typemail.com",
    "forthnet.gr",
    "skynet.be",
    "dfwatson.com",
    "icqmail.com",
    "netradiomail.com",
    "altavista.net",
    "gmail.co.uk",
    "moonman.com",
    "wp.pl",
    "animalhouse.com",
    "mail2la.com",
    "uaemail.com",
    "yourlover.net",
    "doityourself.com",
    "hotmail.se",
    "timein.net",
    "trashmail.at",
    "live.missouristate.edu",
    "gospelfan.com",
    "mail2bradley.com",
    "mailtag.com",
    "fastermail.com",
    "club4x4.net",
    "the-pentagon.com",
    "turkey.com",
    "integra.net",
    "lakmail.com",
    "mini-mail.com",
    "dazedandconfused.com",
    "foodmail.com",
    "ourbrisbane.com",
    "hccnet.nl",
    "caere.it",
    "bitmail.com",
    "astroboymail.com",
    "cartestraina.ro",
    "spamify.com",
    "mail2jon.com",
    "mail.gvsu.edu",
    "inicia.es",
    "mail2nebraska.com",
    "acmemail.net",
    "mail-box.cz",
    "mail2rainmaker.com",
    "mail2latvia.com",
    "polbox.com",
    "mail2touch.com",
    "sify.com",
    "mail.sisna.com",
    "acm.org",
    "front.ru",
    "buryfans.com",
    "marsattack.com",
    "mail2dancer.com",
    "gazeta.pl",
    "mail2music.com",
    "rednecks.com",
    "dangerous-minds.com",
    "bellnet.ca",
    "mail2evelyn.com",
    "parsmail.com",
    "netzero.net",
    "mierdamail.com",
    "mail2shuttle.com",
    "www.com",
    "ukmax.com",
    "mail2djibouti.com",
    "mahmoodweb.com",
    "lovingjesus.com",
    "cataloniamail.com",
    "collegebeat.com",
    "snowdonia.net",
    "mekhong.com",
    "samerica.com",
    "mail.telepac.pt",
    "posteo.be",
    "mail2milkyway.com",
    "mail2dealer.com",
    "thepokerface.com",
    "basketballmail.com",
    "teleline.es",
    "fromthestates.com",
    "progressmail.net",
    "mail2myplane.com",
    "mail2simon.com",
    "mighty.co.za",
    "moldovacc.com",
    "mail2aphrodite.com",
    "mail2sports.com",
    "mail.by",
    "ono.com",
    "busymail.com",
    "felicitymail.com",
    "dispostable.com",
    "amrer.net",
    "mail2samurai.com",
    "mail2raymond.com",
    "xtra.co.nz",
    "pousa.com",
    "mail2nun.com",
    "kc.rr.com",
    "mail2richard.com",
    "theteebox.com",
    "concentric.net",
    "icloud.com",
    "rambler.ru",
    "o2.pl",
    "tiscali.nl",
    "r7.com",
    "warpmail.net",
    "poetic.com",
    "navigator.lv",
    "croeso.com",
    "alskens.dk",
    "mail2graham.com",
    "74.ru",
    "7mail.ga",
    "asiancityweb.com",
    "bounce.net",
    "bumpymail.com",
    "cmail.net",
    "fdfdsfds.com",
    "inbox.si",
    "m4ilweb.info",
    "mail2anything.com",
    "mail2farmer.com",
    "mail2george.com",
    "mail2jimmy.com",
    "mail2matt.com",
    "mail2nepal.com",
    "mail2tennisfan.com",
    "mail2wilbur.com",
    "married-not.com",
    "messages.to",
    "quikmail.com",
    "ratt-n-roll.com",
    "thaimail.net",
    "wosaddict.com",
    "yomail.info",
    "aol.com",
    "yahoo.it",
    "facebook.com",
    "freenet.de",
    "teletu.it",
    "hush.com",
    "mailnew.com",
    "avia-tonic.fr",
    "corporatedirtbag.com",
    "emailasso.net",
    "fast-mail.fr",
    "fromnevada.com",
    "info-media.de",
    "mail2ashley.com",
    "mail2janice.com",
    "mail2jew.com",
    "mail2kenya.com",
    "mail2mankind.com",
    "mail2peter.com",
    "mail2sos.com",
    "mindless.com",
    "momslife.com",
    "the-country.com",
    "yahoo.ch",
    "suremail.info",
    "dublin.com",
    "graffiti.net",
    "emailuser.net",
    "worldemail.com",
    "brfree.com.br",
    "tenderkiss.com",
    "crazysexycool.com",
    "emailem.com",
    "from-israel.com",
    "hockeymail.com",
    "hot-mail.gq",
    "kiwibox.com",
    "levele.com",
    "louiskoo.com",
    "mail2color.com",
    "mail2kimberly.com",
    "mail2pennsylvania.com",
    "mailproxsy.com",
    "miesto.sk",
    "msgbox.com",
    "public.usa.com",
    "radicalz.com",
    "tempmail.us",
    "gotmail.com",
    "kabelmail.de",
    "live.co.kr",
    "broadpark.no",
    "airpost.net",
    "vnn.vn",
    "discardmail.com",
    "imail.ru",
    "mailsent.net",
    "mail2army.com",
    "20minutemail.com",
    "spaml.com",
    "alumni.com",
    "art-en-ligne.pro",
    "byom.de",
    "critterpost.com",
    "fromsouthcarolina.com",
    "gentlemansclub.de",
    "guju.net",
    "info66.com",
    "keg-party.com",
    "lowandslow.com",
    "mail2fond.com",
    "mail2whitehouse.com",
    "milmail.com",
    "nicebush.com",
    "sndt.net",
    "spambog.net",
    "speedrules.com",
    "sportsmail.com",
    "the-monkey.com",
    "thedorm.com",
    "free.fr",
    "mail.bg",
    "email.de",
    "me.de",
    "clerk.com",
    "postinbox.com",
    "yahoo.ru",
    "alpenjodel.de",
    "angelic.com",
    "antispam24.de",
    "city-of-liverpool.com",
    "europemail.com",
    "flashbox.5july.org",
    "ijustdontcare.com",
    "mail2america.com",
    "mail2casey.com",
    "mail2kansas.com",
    "mail2karate.com",
    "mail2liberia.com",
    "mail2marines.com",
    "mail2marty.com",
    "mail2rave.com",
    "netizen.com.ar",
    "shinedyoureyes.com",
    "snkmail.com",
    "the-galaxy.net",
    "the-whitehouse.net",
    "themillionare.net",
    "yehey.com",
    "netscape.net",
    "vip.sina.com",
    "aon.at",
    "writeme.com",
    "getmail.no",
    "geologist.com",
    "fastwebmail.it",
    "ymail.ru",
    "spamfree24.org",
    "csinibaba.hu",
    "artlover.com.au",
    "cookiemonster.com",
    "cyclefanz.com",
    "domforfb1.tk",
    "eastmail.com",
    "eurosport.com",
    "ezmail.ru",
    "from-belgium.com",
    "ignmail.com",
    "mail2biker.com",
    "mail2finance.com",
    "mail2jeffrey.com",
    "mail2lust.com",
    "mail2maryland.com",
    "mail2northcarolina.com",
    "mailme24.com",
    "netbounce.com",
    "perso.be",
    "postaweb.com",
    "pwrby.com",
    "richmondhill.com",
    "scotland.com",
    "zionweb.org",
    "10minutemail.co.za",
    "ist-ganz-allein.de",
    "outlook.jp",
    "plus.com",
    "shockinmytown.cu.cc",
    "live.ca",
    "yahoo.dk",
    "satx.rr.com",
    "yahoo.com.vn",
    "veryspeedy.net",
    "mail.gr",
    "wowmail.com",
    "badtzmail.com",
    "mail2nathan.com",
    "everyday.com.kh",
    "adelphia.net",
    "bright.net",
    "bumerang.ro",
    "celineclub.com",
    "clubnetnoir.com",
    "collegeclub.com",
    "disposable.com",
    "domforfb7.tk",
    "etrademail.com",
    "extended.com",
    "friendlymail.co.uk",
    "mail2affection.com",
    "mail2allison.com",
    "mail2alyssa.com",
    "mail2art.com",
    "mail2ca.com",
    "mail2illinois.com",
    "mail2portugal.com",
    "mail2seth.com",
    "mail2venous.com",
    "music.com",
    "muslim.com",
    "netc.pl",
    "outlook.nl",
    "temp.headstrong.de",
    "tempemail.biz",
    "the-captain.com",
    "webmail.co.yu",
    "shaw.ca",
    "eim.ae",
    "yahoo.ie",
    "yetnet.ch",
    "mynet.com",
    "nospammail.net",
    "hawaiiantel.net",
    "clubducati.com",
    "mail.co.za",
    "kulturbetrieb.info",
    "briefemail.com",
    "communityconnect.com",
    "from-germany.net",
    "fromminnesota.com",
    "insidebaltimore.net",
    "ist-einmalig.de",
    "jaydemail.com",
    "mail2country.com",
    "mail2farm.com",
    "mail2henry.com",
    "mail2italian.com",
    "mail2jeremy.com",
    "mail2ken.com",
    "mail2soldier.com",
    "medscape.com",
    "merda.usa.cc",
    "netbroadcaster.com",
    "telinco.net",
    "themail.com",
    "topmail-files.de",
    "hotmail.ca",
    "bellsouth.net",
    "forum.dk",
    "gotomy.com",
    "switzerland.org",
    "belice.com",
    "forgetmail.com",
    "fromkansas.com",
    "kommespaeter.de",
    "lolito.tk",
    "mail-awu.de",
    "mail2dough.com",
    "mail2pat.com",
    "mail2princess.com",
    "mail2togo.com",
    "mailimate.com",
    "nonpartisan.com",
    "outlook.it",
    "spoko.pl",
    "the-marine.com",
    "turual.com",
    "vaasfc4.tk",
    "email.women.com",
    "teleserve.dynip.com",
    "mail2connecticut.com",
    "mail.com",
    "gawab.com",
    "theracetrack.com",
    "mail2party.com",
    "filzmail.com",
    "mail2sean.com",
    "eastcoast.co.za",
    "hotepmail.com",
    "mailme.dk",
    "sol.dk",
    "xuno.com",
    "azimiweb.com",
    "brefmail.com",
    "fromvermont.com",
    "bullsfan.com",
    "live.co.za",
    "mail2bolivia.com",
    "thoic.com",
    "torchmail.com",
    "lawyer.com",
    "mail2calvin.com",
    "quackquack.com",
    "emailacc.com",
    "iwan-fals.com",
    "prodigy.net",
    "verizonmail.com",
    "mail2chicago.com",
    "gamebox.net",
    "mp4.it",
    "dabsol.net",
    "mail2kim.com",
    "infomart.or.jp",
    "dodgeit.com",
    "mail2devotion.com",
    "mail2irving.com",
    "mail2willie.com",
    "teamdiscovery.com",
    "dslextreme.com",
    "anonbox.net",
    "klzlk.com",
    "coolgoose.ca",
    "freemail.c3.hu",
    "live.ru",
    "mail.freetown.com",
    "hongkong.com",
    "mail2elsalvador.com",
    "hoymail.com",
    "aberystwyth.com",
    "mailru.com",
    "mail2dyke.com",
    "unican.es",
    "m4.org",
    "ivillage.com",
    "mail2mel.com",
    "cmpmail.com",
    "mail2dirk.com",
    "mail2dreamer.com",
    "mail2april.com",
    "sweb.cz",
    "ahaa.dk",
    "mail2saudi.com",
    "selfdestructingmail.com",
    "mail2tickets.com",
    "posteo.jp",
    "rediffmailpro.com",
    "iol.pt",
    "academycougars.com",
    "plasa.com",
    "terra.com.ar",
    "praize.com",
    "www2000.net",
    "gmx.fr",
    "winning.com",
    "mail2cute.com",
    "insorg-mail.info",
    "sociologist.com",
    "3126.com",
    "alphafrau.de",
    "baptistmail.com",
    "cghost.s-a-d.de",
    "chirk.com",
    "deadlymob.org",
    "fahr-zur-hoelle.org",
    "mail2brazil.com",
    "mail2caterer.com",
    "mail2cory.com",
    "mail2jonathan.com",
    "mail2luxury.com",
    "mail2racer.com",
    "pcusers.otherinbox.com",
    "swingfan.com",
    "virginbroadband.com.au",
    "webm4il.info",
    "yahoo.pt",
    "zahadum.com",
    "emailigo.de",
    "yahoo.co.jp",
    "netcourrier.com",
    "frisurf.no",
    "mail2mom.com",
    "goplay.com",
    "glay.org",
    "15meg4free.com",
    "careerbuildermail.com",
    "cyber-africa.net",
    "docs.google.com",
    "e-mails.ru",
    "goldmail.ru",
    "graduate.org",
    "grandmasmail.com",
    "imgv.de",
    "iqemail.com",
    "mail2dylan.com",
    "mail2kennedy.com",
    "mail2liz.com",
    "mail2norman.com",
    "mytemp.email",
    "pfui.ru",
    "purpleturtle.com",
    "usermail.com",
    "dump-email.info",
    "spamspot.com",
    "student.unsw.edu.au",
    "yahoo.es",
    "chello.at",
    "consultant.com",
    "maine.rr.com",
    "fibertel.com.ar",
    "volcanomail.com",
    "0815.su",
    "amorki.pl",
    "asianavenue.com",
    "cyberdude.com",
    "falseaddress.com",
    "fornow.eu",
    "hotletter.com",
    "indo-mail.com",
    "mail2marriage.com",
    "mail2suriname.com",
    "minister.com",
    "netnet.com.sg",
    "outlook.sk",
    "qwestoffice.net",
    "zoemail.org",
    "bigfoot.com",
    "weekmail.com",
    "fastmail.tw",
    "another.com",
    "mail3000.com",
    "mail2bernard.com",
    "mail2honduras.com",
    "mail2fighter.com",
    "mail2mike.com",
    "mail2gail.com",
    "sesmail.com",
    "x-mail.net",
    "grabmail.com",
    "mail2smith.com",
    "imailbox.com",
    "keromail.com",
    "4newyork.com",
    "mail.md",
    "mail2patricia.com",
    "mail2oasis.com",
    "yandex.com",
    "hotmail.dk",
    "tut.by",
    "mweb.co.za",
    "ix.netcom.com",
    "optushome.com.au",
    "cgac.es",
    "justemail.net",
    "donemail.ru",
    "mail2online.com",
    "mail2consultant.com",
    "3g.ua",
    "abusemail.de",
    "atheist.com",
    "bigramp.com",
    "emails.ru",
    "hilarious.com",
    "instructor.net",
    "mail2donald.com",
    "mail2java.com",
    "mail2nigeria.com",
    "mail2noel.com",
    "mail2sierraleone.com",
    "mail2sylvia.com",
    "mailops.com",
    "thecriminals.com",
    "visualcities.com",
    "email.unc.edu",
    "supermailer.jp",
    "mail2greece.com",
    "mail2biologist.com",
    "1webhighway.com",
    "mail2india.com",
    "o-tay.com",
    "go.ro",
    "mail2democrat.com",
    "mail2texas.com",
    "freeler.nl",
    "mail2oops.com",
    "okbank.com",
    "anfmail.com",
    "mail2imam.com",
    "mail2architect.com",
    "deskpilot.com",
    "coxmail.com",
    "dailypioneer.com",
    "uk2k.com",
    "freedomlover.com",
    "oaklandas-fan.com",
    "posteo.ie",
    "dragracer.com",
    "einrot.com",
    "lazyinbox.com",
    "mailme.gq",
    "polandmail.com",
    "qmail.com",
    "schafmail.de",
    "scottsboro.org",
    "shortmail.com",
    "sweetxxx.de",
    "cs.com",
    "mailftp.com",
    "australiamail.com",
    "tempalias.com",
    "smellfear.com",
    "mac.me",
    "ac20mail.in",
    "amuro.net",
    "arcticmail.com",
    "aristotle.org",
    "billsfan.com",
    "dodo.com.au",
    "dogmail.co.uk",
    "fastchevy.com",
    "findmail.com",
    "fromjupiter.com",
    "gtmc.net",
    "interlap.com.ar",
    "junkmail.com",
    "mail2algeria.com",
    "mail2dow.com",
    "mail2juan.com",
    "mail2marilyn.com",
    "myfastmail.com",
    "okmad.com",
    "opoczta.pl",
    "outlook.co.il",
    "outlook.co.th",
    "outlook.com.au",
    "picusnet.com",
    "sms.at",
    "stinkefinger.net",
    "verlass-mich-nicht.de",
    "vote-hillary.com",
    "wefjo.grn.cc",
    "wongfaye.com",
    "zoemail.com",
    "zzom.co.uk",
    "mail2trex.com",
    "mail2mars.com",
    "slotter.com",
    "pickupman.com",
    "mail2homer.com",
    "mail2bookmark.com",
    "freeola.net",
    "ole.com",
    "ya.com",
    "newmail.com",
    "mail2fever.com",
    "bornnaked.com",
    "mail2sydney.com",
    "fastmail.fr",
    "kayafmmail.co.za",
    "shuf.com",
    "emailengine.org",
    "beethoven.com",
    "helter-skelter.com",
    "mail2vanuatu.com",
    "housemail.com",
    "freemail.com.pk",
    "yahoo.cl",
    "hotmail.co.th",
    "sharklasers.com",
    "iwon.com",
    "despam.it",
    "mail2dallas.com",
    "freemail.et",
    "lex.bg",
    "ballyfinance.com",
    "docmail.cz",
    "free-org.com",
    "fresnomail.com",
    "llangollen.com",
    "lycos.ne.jp",
    "mail2chuck.com",
    "mail2crazy.com",
    "mail2geneva.com",
    "mail2golfer.com",
    "mail2iraq.com",
    "mailingaddress.org",
    "mittalweb.com",
    "office-dateien.de",
    "singles4jesus.com",
    "soulfoodcookbook.com",
    "viewcastmedia.com",
    "vivavelocity.com",
    "zzz.pl",
    "tempthe.net",
    "sprintmail.com",
    "cosmorph.com",
    "mail.kmsp.com",
    "freepizzamail.org",
    "usa.net",
    "mail.goo.ne.jp",
    "mailworks.org",
    "mt2009.com",
    "mail2president.com",
    "progetplus.it",
    "yyhmail.com",
    "allsaintsfan.com",
    "atlaswebmail.com",
    "bigassweb.com",
    "freenet.kg",
    "i-france.com",
    "labetteraverouge.at",
    "mail2marvin.com",
    "mail2sexy.com",
    "mail2technician.com",
    "ntelos.net",
    "theplate.com",
    "topgamers.co.uk",
    "uswestmail.net",
    "felicity.com",
    "nhmail.com",
    "188.com",
    "myrambler.ru",
    "partybombe.de",
    "zoominternet.net",
    "techemail.com",
    "jetable.com",
    "powdahound.com",
    "bangkok2000.com",
    "probemail.com",
    "snail-mail.ney",
    "dwp.net",
    "mail2son.com",
    "freewebemail.com",
    "orbitel.bg",
    "fastmail.ca",
    "jokes.com",
    "homelocator.com",
    "globetrotter.net",
    "mariahc.com",
    "ziplip.com",
    "sabreshockey.com",
    "ml1.net",
    "mail2telephone.com",
    "coldmail.com",
    "mail2way.com",
    "hotmail.co.il",
    "mail2cliff.com",
    "mail2salaam.com",
    "friends-cafe.com",
    "comcast.net",
    "airtel.in",
    "live.no",
    "mail.pt",
    "n2business.com",
    "mail2baby.com",
    "mail2bahamas.com",
    "mail2leo.com",
    "mail2faith.com",
    "postaccesslite.com",
    "saintly.com",
    "mail2shoot.com",
    "canwetalk.com",
    "ultrapostman.com",
    "mail2taboo.com",
    "mail2hal.com",
    "wanadoo.nl",
    "virginmedia.com",
    "spamfree24.com",
    "virgilio.it",
    "live.in",
    "munich.com",
    "hispavista.com",
    "uk8.net",
    "dublin.ie",
    "musicscene.org",
    "ass.pp.ua",
    "digibel.be",
    "infomail.es",
    "iremail.de",
    "mail2armenia.com",
    "mail2bulgaria.com",
    "mail2maine.com",
    "mail2mississippi.com",
    "mail2rent.com",
    "mail2rome.com",
    "mail2srilanka.com",
    "mail2wally.com",
    "privymail.de",
    "regspaces.tk",
    "schreib-doch-mal-wieder.de",
    "yert.ye.vc",
    "alice.it",
    "embarqmail.com",
    "saudia.com",
    "hotmail.ru",
    "chemist.com",
    "mail2english.com",
    "0sg.net",
    "autograf.pl",
    "azazazatashkent.tk",
    "calendar-server.bounces.google.com",
    "fathersrightsne.org",
    "freeaccount.com",
    "gazibooks.com",
    "gotti.otherinbox.com",
    "kapoorweb.com",
    "mail2blonde.com",
    "mail2culture.com",
    "mail2football.com",
    "mail2german.com",
    "mail2musician.com",
    "mail2oman.com",
    "mail2russian.com",
    "message.myspace.com",
    "migmail.net",
    "postmark.net",
    "skafan.com",
    "spam.2012-2016.ru",
    "spamfree24.info",
    "the-dutchman.com",
    "thezhangs.net",
    "xmastime.com",
    "livemail.tw",
    "poczta.fm",
    "centrum.cz",
    "spamgourmet.com",
    "yahoo.co.th",
    "ubbi.com",
    "punkass.com",
    "mail2persian.com",
    "sniper.hu",
    "beddly.com",
    "fromtennessee.com",
    "grungecafe.com",
    "ieh-mail.de",
    "kinki-kids.com",
    "lobbyist.com",
    "lopezclub.com",
    "mail2dance.com",
    "mail2hephaestus.com",
    "mail2madagascar.com",
    "mail2noah.com",
    "mail2stockmarket.com",
    "mail2ukraine.com",
    "roosh.com",
    "seekstoyboy.com",
    "sexmagnet.com",
    "dacoolest.com",
    "mail2idaho.com",
    "web-police.com",
    "mail2finland.com",
    "animal.net",
    "y7mail.com",
    "cia-agent.com",
    "trust-me.com",
    "htp-tel.de",
    "mail2switzerland.com",
    "seductive.com",
    "packersfan.com",
    "mail2doug.com",
    "land.ru",
    "get2mail.fr",
    "sent.as",
    "mail2crystal.com",
    "online.ie",
    "mail2mindreader.com",
    "youareadork.com",
    "hardcorefreak.com",
    "email.wm.edu",
    "mail2hestia.com",
    "stockracer.com",
    "lycos.com",
    "visitweb.com",
    "mail2patrick.com",
    "conexcol.com",
    "live.nl",
    "apmail.com",
    "mikrotamanet.com",
    "mail2brunette.com",
    "marijuana.nl",
    "vivianhsu.net",
    "earthling.net",
    "love.com",
    "mail2utah.com",
    "hotvoice.com",
    "doctor.com",
    "usit.net",
    "priest.com",
    "mail2laurie.com",
    "mail2wired.com",
    "canadianmail.com",
    "lycosemail.com",
    "mail2lebanon.com",
    "snoopymail.com",
    "bellatlantic.net",
    "flashemail.com",
    "zdnetmail.com",
    "perthmail.com",
    "singpost.com",
    "dallas.theboys.com",
    "mac.fr",
    "postino.ch",
    "gamespotmail.com",
    "mail2leon.com",
    "mail2bobby.com",
    "pchome.com.tw",
    "tempemail.net",
    "discofan.com",
    "coollist.com",
    "china.net.vg",
    "mail2nelson.com",
    "email.cz",
    "myself.com",
    "wwdg.com",
    "mail2southpole.com",
    "mail2smooth.com",
    "iinet.net.au",
    "jetable.net",
    "telus.net",
    "mail2nevada.com",
    "your-house.com",
    "america.hm",
    "cia.hu",
    "mail2iowa.com",
    "123qwe.co.uk",
    "cyberbabies.com",
    "mail2sweden.com",
    "mail2belize.com",
    "portugalnet.com",
    "kabelfoon.nl",
    "zoznam.sk",
    "rogers.com",
    "mail2floyd.com",
    "uymail.com",
    "thewizzard.com",
    "bitpage.net",
    "bigfoot.de",
    "yourssincerely.com",
    "athenachu.net",
    "mail2swim.com",
    "mail2hope.com",
    "mail2007.com",
    "mailbox.hu",
    "mail2ophthalmologist.com",
    "globalpagan.com",
    "altavista.se",
    "mail2southkorea.com",
    "n2.com",
    "aol.es",
    "10mail.org",
    "aircraftmail.com",
    "hab-verschlafen.de",
    "lastmail.co",
    "soodomail.com",
    "viditag.com",
    "yahoo.de",
    "home.nl",
    "hispeed.ch",
    "zonnet.nl",
    "live.com.my",
    "arnet.com.ar",
    "cutey.com",
    "petml.com",
    "acceso.or.cr",
    "she.com",
    "2911.net",
    "atl.lv",
    "beeebank.com",
    "cabacabana.com",
    "clubmember.org",
    "emeil.ir",
    "fastnissan.com",
    "freeandsingle.com",
    "internetdrive.com",
    "mail2black.com",
    "mail2kathleen.com",
    "mail2kosher.com",
    "mail2matthew.com",
    "mail2potatohead.com",
    "mailquack.com",
    "mailrock.biz",
    "press.co.jp",
    "sky.com",
    "azet.sk",
    "students.towson.edu",
    "consolidated.net",
    "0815.ru",
    "thisisnotmyrealemail.com",
    "spambox.us",
    "legislator.com",
    "centermail.at",
    "emailz.ga",
    "everymail.net",
    "funkfan.com",
    "hello.net.au",
    "joelonsoftware.com",
    "mail2artist.com",
    "mail2barter.com",
    "mail2harold.com",
    "mail2louis.com",
    "mail2model.com",
    "mail2sa.com",
    "mail2u4me.com",
    "mail2whip.com",
    "radiku.ye.vc",
    "ruttolibero.com",
    "rvshop.com",
    "sudoweb.net",
    "the-snake.com",
    "trashdevil.de",
    "usaaccess.net",
    "yourlifesucks.cu.cc",
    "ualberta.ca",
    "ftml.net",
    "me.com.br",
    "no-spam.ws",
    "the-fastest.net",
    "mail2anna.com",
    "mail2broker.com",
    "baldpapa.de",
    "bladesmail.net",
    "burstmail.info",
    "cyberleports.com",
    "from-america.com",
    "get.pp.ua",
    "grandmamail.com",
    "justicemail.com",
    "lionsfan.com.au",
    "mail2computer.com",
    "mail2diana.com",
    "mail2k.ru",
    "mail2madrid.com",
    "mail2psychiatrist.com",
    "mailinatar.com",
    "orgmail.net",
    "pinoymail.com",
    "shootmail.com",
    "vip.onet.pl",
    "vkcode.ru",
    "vote4gop.org",
    "hotmail.com.br",
    "aim.com",
    "excite.com",
    "live.com.sg",
    "xsmail.com",
    "ayna.com",
    "bonbon.net",
    "mail2dana.com",
    "123box.net",
    "dasdasdascyka.tk",
    "fatcock.net",
    "fromcolorado.com",
    "fromoklahoma.com",
    "gocollege.com",
    "gyorsposta.hu",
    "ipoo.org",
    "lolfreak.net",
    "mail2aaron.com",
    "mail2christian.com",
    "mail2cyprus.com",
    "mail2government.com",
    "nervhq.org",
    "oikrach.com",
    "opayq.com",
    "sinnlos-mail.de",
    "upf.org",
    "volloeko.de",
    "vorsicht-scharf.de",
    "wilemail.com",
    "wombles.com",
    "bkkmail.com",
    "ckaazaza.tk",
    "emailage.gq",
    "littleapple.com",
    "ro.ru",
    "will-hier-weg.de",
    "yahoo.co.za",
    "hotmail.con",
    "arcor.de",
    "usa.com",
    "hotmail.om",
    "mail2network.com",
    "60minutemail.com",
    "aamail.net",
    "aichi.com",
    "h-mail.us",
    "hotfire.net",
    "kansascity.com",
    "mail2american.com",
    "mail2andrea.com",
    "mail2baptist.com",
    "mail2catwalk.com",
    "mail2devoted.com",
    "mail2emily.com",
    "mail2in.com",
    "mail2jake.com",
    "mail2nasdaq.com",
    "message.hu",
    "reply.hu",
    "saynotospams.com",
    "seanet.com",
    "shitaway.gq",
    "the-airforce.com",
    "the18th.com",
    "thecoolguy.com",
    "daum.net",
    "ptd.net",
    "tele2.nl",
    "execs.com",
    "swissmail.net",
    "mailpride.com",
    "ciaoweb.it",
    "amnetsal.com",
    "dearriba.com",
    "elvis.com",
    "ezcybersearch.com",
    "mail2aries.com",
    "mail2darlene.com",
    "mail2eddie.com",
    "mail2irwin.com",
    "mail2martin.com",
    "mail2stock.com",
    "mail4trash.com",
    "nonspam.eu",
    "nxt.ru",
    "okhuman.com",
    "outlook.com.tr",
    "saintmail.net",
    "smapxsmap.net",
    "yahoo.com.is",
    "zzn.com",
    "billsfan.net",
    "stones.com",
    "juniormail.com",
    "speedymail.org",
    "baseballmail.com",
    "posteo.co.uk",
    "posteo.cr",
    "fetchmail.com",
    "socceramerica.net",
    "inoutbox.com",
    "home-email.com",
    "i-plus.net",
    "163.com",
    "msn.com",
    "bbox.fr",
    "superonline.com",
    "mailmight.com",
    "mail2juggler.com",
    "jazzandjava.com",
    "cooperationtogo.net",
    "cybertrains.org",
    "deagot.com",
    "inmano.com",
    "mail2billy.com",
    "mail2donna.com",
    "mail2spectrum.com",
    "mail2terri.com",
    "maxmail.co.uk",
    "my.com",
    "our.st",
    "partlycloudy.com",
    "telstra.com",
    "twinstarsmail.com",
    "zipido.com",
    "xs4all.nl",
    "ntlworld.com",
    "mail2beauty.com",
    "mail2rhodeisland.com",
    "berlin.de",
    "tatanova.com",
    "mail2diamond.com",
    "rock.com",
    "mail2perry.com",
    "mail2carolyn.com",
    "mail2brussels.com",
    "yebox.com",
    "mail2gemini.com",
    "mailite.com",
    "xmsnet.nl",
    "html.tou.com",
    "yahoo.com.ar",
    "adam.com.au",
    "msa.hinet.net",
    "snet.net",
    "yahoo.jp",
    "ttml.co.in",
    "mail2uae.com",
    "dumpyemail.com",
    "kuwait-mail.com",
    "mail2dentist.com",
    "mail2ethan.com",
    "mail2milton.com",
    "mail2visionary.com",
    "mauritius.com",
    "planetaccess.com",
    "strongguy.com",
    "hismail.cc",
    "herono1.com",
    "mail2leslie.com",
    "prolaunch.com",
    "mail2southafrica.com",
    "mail2myboat.com",
    "wkbwmail.com",
    "netsero.net",
    "seguros.com.br",
    "fromwyoming.com",
    "zeepost.nl",
    "mscold.com",
    "mail2admiral.com",
    "monemail.fr.nf",
    "iespana.es",
    "mail2philippines.com",
    "ezmail.egine.com",
    "ados.fr",
    "pigpig.net",
    "mail2mexico.com",
    "qprfans.com",
    "mail2cherry.com",
    "me.it",
    "fmgirl.com",
    "city-of-bath.org",
    "444.net",
    "amuromail.com",
    "uole.com.ve",
    "ukdreamcast.com",
    "telecomitalia.it",
    "windstream.net",
    "mchsi.com",
    "t-online.hu",
    "eastlink.ca",
    "1mum.com",
    "pro.hu",
    "6mail.cf",
    "email.su",
    "go2net.com",
    "imtoosexy.com",
    "mail2mildred.com",
    "mailforspam.com",
    "mailpost.zzn.com",
    "pezeshkpour.com",
    "serga.com.ar",
    "sportemail.com",
    "t2mail.com",
    "teenagedirtbag.com",
    "trickmail.net",
    "yemenmail.com",
    "oxidiser.net",
    "wh4f.org",
    "techseek.com",
    "zeeks.com",
    "telebot.net",
    "incognitomail.net",
    "altavista.com",
    "emailmiser.com",
    "bluemail.dk",
    "dygo.com",
    "epix.net",
    "lovergirl.com",
    "mail2alcoholic.com",
    "mail2cynthia.com",
    "mail2desert.com",
    "mail2grab.com",
    "mail2guatemala.com",
    "mail2kirk.com",
    "mail2malawi.com",
    "mail2normal.com",
    "mail2victor.com",
    "mailboom.com",
    "talkcity.com",
    "the-boss.com",
    "risquemail.com",
    "live.cl",
    "musician.org",
    "korea.com",
    "uku.co.uk",
    "baptized.com",
    "coolmail.net",
    "dadacasa.com",
    "data54.com",
    "existiert.net",
    "heartthrob.com",
    "hotpop3.com",
    "mail2andy.com",
    "mail2anne.com",
    "mail2concert.com",
    "mail2costarica.com",
    "mail2cowgirl.com",
    "mail2joan.com",
    "mail2mambo.com",
    "mail2newmexico.com",
    "mail2park.com",
    "mail2phoenix.com",
    "mail2think.com",
    "mail2wyoming.com",
    "mail2xfiles.com",
    "rin.ru",
    "sbcglobal.com",
    "the-newsletter.net",
    "posteo.is",
    "simnet.is",
    "mail2dillon.com",
    "onet.eu",
    "posta.ro",
    "lopl.co.cc",
    "fromiowa.com",
    "webave.com",
    "tom.com",
    "mail2cowboy.com",
    "telerymd.com",
    "mail2helen.com",
    "fromwestvirginia.com",
    "scarlet.be",
    "gmail.com.br",
    "jordanmail.com",
    "gua.net",
    "mortaza.com",
    "flashmail.com",
    "recycler.com",
    "popstar.com",
    "aliyun.com",
    "mail2scott.com",
    "bunko.com",
    "mailinator2.com",
    "operamail.com",
    "maileater.com",
    "mail2rachel.com",
    "webmail.hu",
    "classicmail.co.za",
    "mail2ralph.com",
    "looksmart.com",
    "mail2lao.com",
    "mail2roberta.com",
    "cornerpub.com",
    "btopenworld.co.uk",
    "happemail.com",
    "mail2marcia.com",
    "hehe.com",
    "mail2poet.com",
    "kgb.hu",
    "mundomail.net",
    "veryfast.biz",
    "aliceadsl.fr",
    "stdmail.kku.ac.th",
    "mail2blues.com",
    "aaahmail.com",
    "from-asia.com",
    "mail2bruce.com",
    "dmailman.com",
    "end-war.com",
    "nativeweb.net",
    "freemail.nl",
    "mynetaddress.com",
    "vcmail.com",
    "mail.theboys.com",
    "deutschland-net.com",
    "freesurf.nl",
    "throwawayemailaddress.com",
    "andylau.net",
    "mailisent.com",
    "fromflorida.net",
    "mail2one.com",
    "mail2wine.com",
    "student.umass.edu",
    "mail2yahalla.com",
    "psi.net",
    "web-mail-service.de",
    "mail2kenny.com",
    "olg.com",
    "jazzfan.com",
    "usma.net",
    "alltel.net",
    "positive-thinking.com",
    "mail2leone.com",
    "internet-police.com",
    "caramail.com",
    "mail2eos.com",
    "mail2miami.com",
    "hotmail.fr",
    "nativestar.net",
    "mail2hypnos.com",
    "mail2erin.com",
    "mail2jordan.com",
    "skizo.hu",
    "ifoward.com",
    "mail2diplomat.com",
    "yam.com",
    "jippii.fi",
    "mail2travis.com",
    "interaccess.com",
    "fromnewjersey.com",
    "internetemails.net",
    "mail2brook.com",
    "online.nl",
    "mail2wow.com",
    "fastmail.nl",
    "mailexcite.com",
    "posteo.no",
    "jakuza.hu",
    "gmai.com",
    "mail4u.nl",
    "yahoo.co.nz",
    "mail2christie.com",
    "mail2rose.com",
    "netzero.com",
    "150ml.com",
    "mail2rwanda.com",
    "mail2letter.com",
    "mail2idontknow.com",
    "guy.com",
    "studiocom.com",
    "zeelandnet.nl",
    "knology.net",
    "bofthew.com",
    "zippymail.info",
    "beefmilk.com",
    "zybermail.com",
    "vodamail.co.za",
    "hotmail.com.tr",
    "mail2tourist.com",
    "legalactions.com",
    "mail2hungary.com",
    "mail2steve.com",
    "mobilbatam.com",
    "norikomail.com",
    "blackplanet.com",
    "mail2sabrina.com",
    "net4b.pt",
    "mail2sam.com",
    "city-of-swansea.com",
    "coid.biz",
    "tsamail.co.za",
    "3ammagazine.com",
    "mail2curt.com",
    "writemeback.com",
    "cinci.rr.com",
    "gmx.us",
    "wanadoo.fr",
    "publicist.com",
    "mail2lawrence.com",
    "adios.net",
    "rezai.com",
    "desertmail.com",
    "mail2ask.com",
    "sale-sale-sale.com",
    "fromnewhampshire.com",
    "newyork.com",
    "mail2northdakota.com",
    "mailcan.com",
    "mail2mandy.com",
    "over-the-rainbow.com",
    "start.com.au",
    "freemail.de",
    "accessgcc.com",
    "mail2hugh.com",
    "jazzgame.com",
    "the-englishman.com",
    "mail2mp3.com",
    "mailpanda.com",
    "pmail.net",
    "copacabana.com",
    "mail2litigator.com",
    "noos.fr",
    "nospam4.us",
    "mail2eros.com",
    "strompost.com",
    "operafan.com",
    "mail2larry.com",
    "linuxmail.org",
    "mail2keith.com",
    "boatracers.com",
    "mail2nancy.com",
    "crwmail.com",
    "cubiclink.com",
    "mail2dorothy.com",
    "mail2tyler.com",
    "pcpostal.com",
    "mauimail.com",
    "letsgomets.net",
    "mail2race.com",
    "mail2brittany.com",
    "fastmail.jp",
    "mail2recruiter.com",
    "3dmail.com",
    "comprendemail.com",
    "itesm.mx",
    "doglover.com",
    "virgin.net",
    "firemail.de",
    "buckeyemail.osu.edu",
    "qatarmail.com",
    "scottishmail.co.uk",
    "mail2joy.com",
    "mail2michael.com",
    "mail2student.com",
    "mail2lionel.com",
    "24horas.com",
    "parrot.com",
    "rescueteam.com",
    "cityoflondon.org",
    "ns.sympatico.ca",
    "a1.net",
    "wowway.com",
    "mailnator.com",
    "anonymbox.com",
    "courrieltemporaire.com",
    "bluewin.ch",
    "sc.rr.com",
    "iol.it",
    "cybernet.it",
    "mail2aha.com",
    "connect4free.net",
    "depechemode.com",
    "donjuan.com",
    "gustr.com",
    "hopemail.biz",
    "hypernautica.com",
    "karbasi.com",
    "love.cz",
    "net-c.ca",
    "nur-fuer-spam.de",
    "ourklips.com",
    "the-russian.com",
    "uk2net.com",
    "xzapmail.com",
    "scryptmail.com",
    "email.sc.edu",
    "gwmail.gwu.edu",
    "mail2hawaii.com",
    "tech4peace.org",
    "mail2zeus.com",
    "cyberforeplay.net",
    "oddpost.com",
    "talk21.com",
    "warrior.hu",
    "shaniastuff.com",
    "mail2poland.com",
    "austrosearch.net",
    "ummah.org",
    "stade.fr",
    "mail2bob.com",
    "mail2flexible.com",
    "bikeracers.net",
    "temporaryemail.net",
    "hotamil.com",
    "mailmetrash.com",
    "ca.rr.com",
    "jumpy.it",
    "mail2tango.com",
    "antongijsen.com",
    "casablancaresort.com",
    "ethos.st",
    "filipinolinks.com",
    "free.com.pe",
    "from-china.net",
    "gamegeek.com",
    "golfmail.be",
    "gorontalo.net",
    "indexa.fr",
    "l33r.eu",
    "maennerversteherin.de",
    "mail-me.com",
    "mail2ballerina.com",
    "mail2galaxy.com",
    "mail2heaven.com",
    "mail2moslem.com",
    "maltesemail.com",
    "ralib.com",
    "surfree.com",
    "the-big-apple.com",
    "188mail.com",
    "amilegit.com",
    "ymail.com",
    "bigmir.net",
    "zipmail.com",
    "diplomats.com",
    "aeiou.pt",
    "sofort-mail.de",
    "mail2usa.com",
    "hotbrev.com",
    "mail2create.com",
    "123india.com",
    "aaronkwok.net",
    "domozmail.com",
    "fakemailz.com",
    "hollywoodkids.com",
    "last-chance.pro",
    "mail2kyle.com",
    "mail2ship.com",
    "mailto.de",
    "migumail.com",
    "onlinewiz.com",
    "shitaway.cu.cc",
    "sialkotian.com",
    "u2club.com",
    "walkmail.ru",
    "web-mail.pp.ua",
    "mail.dk",
    "mail.pf",
    "hotmail.com.au",
    "aol.fr",
    "detik.com",
    "the-quickest.com",
    "mail2pop.com",
    "dezigner.ru",
    "from-japan.net",
    "fromtexas.com",
    "gol.com",
    "mail2abc.com",
    "mail2cuba.com",
    "mail2eva.com",
    "mail2liquid.com",
    "mail2oklahoma.com",
    "mail2phil.com",
    "mail2rita.com",
    "mailseal.de",
    "racingfan.com.au",
    "sudomail.com",
    "tech-center.com",
    "yournightmare.com",
    "mail2many.com",
    "mail2maybe.com",
    "mail2tommy.com",
    "mail2lovable.com",
    "realemail.net",
    "iki.fi",
    "ihug.co.nz",
    "4warding.com",
    "kickassmail.com",
    "freeukisp.co.uk",
    "centoper.it",
    "gramszu.net",
    "engineer.com",
    "riopreto.com.br",
    "geocities.com",
    "coolkiwi.com",
    "nenter.com",
    "fromohio.com",
    "mail2sevenseas.com",
    "workmail.com",
    "mail2sailor.com",
    "tfanus.com.er",
    "mac.com",
    "yandex.ru",
    "spambob.net",
    "city-of-lincoln.com",
    "clubalfa.com",
    "rome.com",
    "perfectmail.com",
    "ismart.net",
    "mail2join.com",
    "mail2mauritania.com",
    "mail2dc.com",
    "mail2kelsey.com",
    "powerfan.com",
    "roughnet.com",
    "fakeinformation.com",
    "ist-allein.info",
    "mailismagic.com",
    "millionairemail.com",
    "outlook.dk",
    "wo.com.cn",
    "rcn.com",
    "mailup.net",
    "mytrashmail.com",
    "coder.hu",
    "uyuyuy.com",
    "autoescuelanerja.com",
    "cheyenneweb.com",
    "enel.net",
    "mail2atlas.com",
    "mail2bombay.com",
    "mail2dawn.com",
    "mail2jamaica.com",
    "mail2jeweler.com",
    "mail2kay.com",
    "mail2lois.com",
    "mail2minister.com",
    "mail2niger.com",
    "mail2senate.com",
    "mail2tramp.com",
    "offroadwarrior.com",
    "shitaway.tk",
    "spacetowns.com",
    "storksite.com",
    "sudolife.me",
    "vomoto.com",
    "www.e4ward.com",
    "posteo.si",
    "qis.net",
    "email.cbes.net",
    "facebookmail.com",
    "sudoverse.com",
    "astrosfan.net",
    "2bmail.co.uk",
    "mailenvelopes.com",
    "buzzlemail.com",
    "frontiernet.net",
    "jnxjn.com",
    "mail2tanzania.com",
    "mail2sound.com",
    "globomail.com",
    "mailzilla.org",
    "dynamitemail.com",
    "jmail.co.za",
    "emailinfive.com",
    "mail2botswana.com",
    "blackburnmail.com",
    "mail2oceanographer.com",
    "birdowner.net",
    "mail2kendall.com",
    "mixmail.com",
    "mail2glen.com",
    "chek.com",
    "mail2stephanie.com",
    "cuemail.com",
    "mailstartplus.com",
    "naz.com",
    "mail2eu.com",
    "amele.com",
    "haltospam.com",
    "test.com",
    "students.ecu.edu",
    "webstation.com",
    "space-travel.com",
    "hotpop.com",
    "caltanet.it",
    "mail2parker.com",
    "mail2xox.com",
    "ukr.net",
    "postafree.com",
    "mailasia.com",
    "switchboardmail.com",
    "mail2guy.com",
    "mail2resort.com",
    "cais.net",
    "brittonsign.com",
    "kimo.com",
    "mail2miracle.com",
    "pobox.sk",
    "mail2jasmine.com",
    "latemodels.com",
    "mail2iceland.com",
    "netmongol.com",
    "mail2sleek.com",
    "mail2painter.com",
    "tradermail.info",
    "loveable.com",
    "mail.uc.edu",
    "moldova.cc",
    "mail2japanese.com",
    "windowslive.com",
    "city-of-york.net",
    "jump.com",
    "dbmail.com",
    "deal-maker.com",
    "mail2alpha.com",
    "neo.rr.com",
    "mail2skier.com",
    "macbox.com",
    "019.pfr.ru",
    "doramail.com",
    "mail2northamerica.com",
    "live.hk",
    "sammimail.com",
    "stealthmail.com",
    "lick101.com",
    "spamex.com",
    "heesun.net",
    "gee-wiz.com",
    "tempinbox.co.uk",
    "letterbox.com",
    "tot.net",
    "mail.byte.it",
    "hotmail.com.mx",
    "posteo.uk",
    "netcom.no",
    "fansonlymail.com",
    "hailmail.net",
    "kiwitown.com",
    "levele.hu",
    "mail2lance.com",
    "snafu.de",
    "emailpinoy.com",
    "miatadriver.com",
    "coolmail.com",
    "littleblueroom.com",
    "mail2zephir.com",
    "mundo-r.com",
    "xoom.com",
    "headbone.com",
    "email2me.net",
    "astrolover.com",
    "junk1e.com",
    "e4ward.com",
    "hhdevel.com",
    "interia.pl",
    "mail2jaime.com",
    "mail2jamie.com",
    "mail2libertarian.com",
    "adinet.com.uy",
    "mail2nicole.com",
    "mail2warren.com",
    "wyrm.supernews.com",
    "hotmail.co",
    "trashymail.com",
    "ehmail.com",
    "yahoo.gr",
    "hotmail.gr",
    "mail2laugh.com",
    "mail2mongolia.com",
    "cliffhanger.com",
    "kellychen.com",
    "mail2jessica.com",
    "hotbot.com",
    "ematic.com",
    "marchmail.com",
    "mail2popular.com",
    "mail2lola.com",
    "mail2weird.com",
    "mail2reggie.com",
    "mail2married.com",
    "okuk.com",
    "india.com",
    "mail2kazakhstan.com",
    "tele2.ch",
    "versatel.nl",
    "nepwk.com",
    "prtnx.com",
    "mail2agent.com",
    "yahoo.fr",
    "shahweb.net",
    "mail2fondness.com",
    "4email.net",
    "mail2freudian.com",
    "tele2.at",
    "nowmymail.com",
    "mail2valerie.com",
    "mail2pm.com",
    "truthmail.com",
    "stalag13.com",
    "mail2green.com",
    "umpire.com",
    "posteo.eu",
    "the-hooligan.com",
    "hsuchi.net",
    "mail2edgar.com",
    "krongthip.com",
    "mail2mali.com",
    "live.cn",
    "mail2rodney.com",
    "erols.com",
    "medmail.com",
    "oi.com.br",
    "ovi.com",
    "ihateclowns.com",
    "dartmail.net",
    "263.net",
    "maxleft.com",
    "mail2rosie.com",
    "mail.be",
    "mail2millionaire.com",
    "vodafone.de",
    "mail2wild.com",
    "mail2cindy.com",
    "pacific.net.sg",
    "mail2ballplayer.com",
    "iraqmail.com",
    "ravemail.com",
    "highquality.com",
    "mjfrogmail.com",
    "hawaii.rr.com",
    "mail2phonecall.com",
    "freeuk.net",
    "freesurf.fr",
    "mail2mark.com",
    "ttmail.com",
    "myphantomemail.com",
    "advalvas.be",
    "dc.rr.com",
    "mail2cat.com",
    "assala.com",
    "ksanmail.com",
    "mail2paula.com",
    "unitybox.de",
    "mail2athena.com",
    "from-france.net",
    "mail2therapy.com",
    "abv.bg",
    "deskmail.com",
    "bettergolf.net",
    "mail2search.com",
    "mail2films.com",
    "modomail.com",
    "mail2my.com",
    "mail2josh.com",
    "soccermail.com",
    "mailoye.com",
    "mail2missionary.com",
    "freemail.gr",
    "easy.to",
    "s-mail.com",
    "mail2mozambique.com",
    "wowgirl.com",
    "mail2stacy.com",
    "archaeologist.com",
    "aol.jp",
    "inbox.ru",
    "sbcglobal.net",
    "mail2mauritius.com",
    "e-tapaal.com",
    "fromconnecticut.com",
    "mail2marhaba.com",
    "mail2paraguay.com",
    "the-genius.com",
    "mail2ghana.com",
    "mail2golfclub.com",
    "spacebank.com",
    "chinamail.com",
    "coolsite.net",
    "gelitik.in",
    "herr-der-mails.de",
    "humanoid.net",
    "merda.flu.cc",
    "web-contact.info",
    "mail2clark.com",
    "geek.hu",
    "pakistanoye.com",
    "scandalmail.com",
    "mail2joanna.com",
    "mail2sharon.com",
    "mail2justme.com",
    "mail2robin.com",
    "emailgroups.net",
    "mail2yachtclub.com",
    "mail2phyllis.com",
    "mail2pickup.com",
    "mail2morocco.com",
    "mail2becky.com",
    "fromgeorgia.com",
    "infovia.com.ar",
    "mailpuppy.com",
    "netpiper.com",
    "frommaryland.com",
    "mail2rex.com",
    "mail2catlover.com",
    "mail2swimmer.com",
    "sunrise.ch",
    "teleworm.com",
    "wuzupmail.net",
    "fr33mail.info",
    "seznam.cz",
    "atlas.cz",
    "gurlmail.com",
    "gmail.fr",
    "ajacied.com",
    "netlimit.com",
    "mail2liechtenstein.com",
    "approvers.net",
    "mail2angela.com",
    "aeneasmail.com",
    "icestorm.com",
    "everyone.net",
    "mail2arabic.com",
    "mail2maxwell.com",
    "mail2politician.com",
    "tiscali.co.uk",
    "mail2mason.com",
    "atina.cl",
    "mail2jay.com",
    "mail2jazz.com",
    "hookup.net",
    "weedmail.com",
    "mailas.com",
    "mail2gavin.com",
    "gt.rr.com",
    "10minutemail.com",
    "edtnmail.com",
    "eml.cc",
    "fightallspam.com",
    "inet.net.au",
    "mailcc.com",
    "medical.net.au",
    "ntscan.com",
    "online.ms",
    "outlook.kr",
    "xaker.ru",
    "posteo.se",
    "mail.spaceports.com",
    "yahoo.co.id",
    "yopmail.com",
    "yeah.net",
    "lyse.net",
    "c2i.net",
    "pochta.ru",
    "poste.it",
    "latinmail.com",
    "mail2slim.com",
    "spamthis.co.uk",
    "ajaxapp.net",
    "boyzoneclub.com",
    "chez.com",
    "churchusa.com",
    "fromnorthdakota.com",
    "hidzz.com",
    "i.am",
    "isp9.net",
    "machinecandy.com",
    "mail2aether.com",
    "mail2horse.com",
    "mail2leonard.com",
    "mail2plato.com",
    "mail2sarah.com",
    "mail2taiwan.com",
    "mail2turkmenistan.com",
    "mox.pp.ua",
    "tiscali.se",
    "posteo.dk",
    "talktalk.co.uk",
    "mail2gloria.com",
    "123mail.cl",
    "frontier.com",
    "deseretmail.com",
    "internetbiz.com",
    "backstreet-boys.com",
    "boardermail.com",
    "science.com.au",
    "speedpost.net",
    "mail2judge.com",
    "mail2belgium.com",
    "mail2marries.com",
    "mail2chemist.com",
    "mail2sanfrancisco.com",
    "pool-sharks.com",
    "razormail.com",
    "fea.st",
    "mail2palau.com",
    "outlook.com",
    "posteo.af",
    "happycounsel.com",
    "mac.hush.com",
    "dott.it",
    "heremail.com",
    "popmail.com",
    "swingeasyhithard.com",
    "csi.com",
    "kinglibrary.net",
    "trashymail.net",
    "mail2laura.com",
    "mail2fireman.com",
    "trash-mail.de",
    "leehom.net",
    "mail2europe.com",
    "mail2eat.com",
    "spamday.com",
    "mail2amber.com",
    "spinfinder.com",
    "wheelweb.com",
    "unforgettable.com",
    "telefonica.net",
    "rediff.com",
    "stu.owensboro.kyschools.us",
    "quicknet.nl",
    "mail2dad.com",
    "mail2breakfast.com",
    "from-england.com",
    "soldier.hu",
    "onebox.com",
    "yahoo.co.uk",
    "gmx.net",
    "yahoo.com.hk",
    "gishpuppy.com",
    "newmail.ru",
    "euskaltel.net",
    "add3000.pp.ua",
    "free-email.ga",
    "frommassachusetts.com",
    "mail2debbie.com",
    "mail2diver.com",
    "mail2irresistible.com",
    "mail2pakistan.com",
    "mail2slovenia.com",
    "mail2stlouis.com",
    "tkcity.com",
    "yada-yada.com",
    "cute-girl.com",
    "happypuppy.com",
    "cyber4all.com",
    "protonmail.com",
    "mail2apollo.com",
    "mail2haiti.com",
    "mail2vermont.com",
    "mail2genes.com",
    "afreeinternet.com",
    "scientist.com",
    "mail2ruth.com",
    "mail2white.com",
    "barcelona.com",
    "arabtop.net",
    "mail2malaysia.com",
    "pobox.com",
    "thisgirl.com",
    "mail2netherlands.com",
    "deadaddress.com",
    "collegemail.com",
    "binkmail.com",
    "wiz.cc",
    "close2you.net",
    "id-base.com",
    "racefanz.com",
    "mail2rebecca.com",
    "duno.com",
    "mail2jackie.com",
    "mail2ted.com",
    "blazemail.com",
    "conk.com",
    "fastmail.org",
    "speedrulz.com",
    "marketing.lu",
    "hotmail.nl",
    "rediffmail.com",
    "eyou.com",
    "asia.com",
    "live.ie",
    "tin.it",
    "new.rr.com",
    "mailbox.co.za",
    "city-of-coventry.com",
    "frommontana.com",
    "mail.wtf",
    "mail2lee.com",
    "mail2maldives.com",
    "mail2ride.com",
    "mochamail.com",
    "mycity.com",
    "ournet.md",
    "reality-concept.club",
    "samilan.net",
    "sogou.com",
    "the-ministry.com",
    "vorsicht-bissig.de",
    "wahoye.com",
    "gmail.it",
    "mail2found.com",
    "fastmessaging.com",
    "spamfree24.net",
    "yclub.com",
    "mail2newyork.com",
    "naver.com",
    "camidge.com",
    "freedom.usa.com",
    "ukbuilder.com",
    "bradfordfans.com",
    "mail2college.com",
    "coolsend.com",
    "abcflash.net",
    "mail2bahrain.com",
    "mail2delicious.com",
    "live.com",
    "iamawoman.com",
    "horrormail.com",
    "incredimail.com",
    "newmail.net",
    "mail2elliot.com",
    "gamail.com",
    "mail2woman.com",
    "hushmail.com",
    "tiscalinet.it",
    "freemail.lt",
    "nwldx.com",
    "dplanet.ch",
    "teewars.org",
    "magicmail.co.za",
    "4mg.com",
    "aport2000.ru",
    "bagherpour.com",
    "bolando.com",
    "dontgotmail.com",
    "fromalaska.com",
    "iamwasted.com",
    "isleuthmail.com",
    "jovem.te.pt",
    "looksmart.co.uk",
    "mail.bulgaria.com",
    "mail2dilemma.com",
    "mail2dominica.com",
    "mail2florence.com",
    "mail2gene.com",
    "mail2jennifer.com",
    "mail2muslim.com",
    "mail2sat.com",
    "mailfa.tk",
    "myworldmail.com",
    "searchwales.com",
    "vote-democrats.com",
    "worldmailer.com",
    "catsrule.garfield.com",
    "youvegotmail.net",
    "2ndmail.com",
    "swift-mail.com",
    "bluehyppo.com",
    "mail2ohio.com",
    "the-brazilian.com",
    "zuzzurello.com",
    "clearwire.net",
    "the-mailinglist.com",
    "emailx.net",
    "mail2romania.com",
    "mail2chef.com",
    "mail2star.com",
    "mail2methodist.com",
    "callnetuk.com",
    "asiapoint.net",
    "mail2beth.com",
    "mail2hyperspace.com",
    "mail2open.com",
    "beep.ru",
    "spacewar.com",
    "guyanafriends.com",
    "mail2kevin.com",
    "mail2victoria.com",
    "mail2bankrupt.com",
    "incognitomail.com",
    "rccgmail.org",
    "fastmail.mx",
    "live.com.ar",
    "muellemail.com",
    "hotmail.be",
    "netcologne.de",
    "139.com",
    "zipmail.com.br",
    "sent.com",
    "webspeed.dk",
    "nycap.rr.com",
    "mailforce.net",
    "zmail.ru",
    "optician.com",
    "antisocial.com",
    "beenhad.com",
    "big1.us",
    "cool.br",
    "curryworld.de",
    "earthdome.com",
    "getairmail.com",
    "jsrsolutions.com",
    "localbar.com",
    "looksmart.com.au",
    "mail2dionysos.com",
    "mail2engineer.com",
    "mail2hespera.com",
    "mail2linux.com",
    "northgates.net",
    "onobox.com",
    "tvstar.com",
    "abcdefghijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyzabcdefghijk.com",
    "anotherdomaincyka.tk",
    "neue-dateien.de",
    "ninfan.com",
    "slave-auctions.net",
    "svk.jp",
    "trayna.com",
    "att.net",
    "phreaker.net",
    "peachworld.com",
    "mail2abby.com",
    "mail2blackbelt.com",
    "mail2protect.com",
    "from-italy.net",
    "la.com",
    "maktoob.com",
    "terra.es",
    "eatmydirt.com",
    "srilankan.net",
    "witty.com",
    "discardmail.de",
    "mail2storage.com",
    "posteo.at",
    "mail2spain.com",
    "yesbox.net",
    "mail2mycar.com",
    "cnnsimail.com",
    "westnet.com.au",
    "posteo.pt",
    "trialbytrivia.com",
    "onewaymail.com",
    "mail2seattle.com",
    "folkfan.com",
    "mymail-in.net",
    "mail2reed.com",
    "mail2superstar.com",
    "canada.com",
    "mail2doctor.com",
    "mail2teletubbie.com",
    "mail2taurus.com",
    "mail2jim.com",
    "myownfriends.com",
    "webjump.com",
    "mail2msright.com",
    "mail2mechanic.com",
    "rochester.rr.com",
    "telecable.es",
    "mail2qatar.com",
    "mail2nauru.com",
    "mailme.lv",
    "wooow.it",
    "vlmail.com",
    "megago.com",
    "1033edge.com",
    "hotmail.com",
    "mail2vodka.com",
    "1under.com",
    "kpnplanet.nl",
    "fromkentucky.com",
    "australia.edu",
    "mail2gina.com",
    "otenet.gr",
    "chandrasekar.net",
    "mail2power.com",
    "mail2fly.com",
    "cry4helponline.com",
    "fromnewyork.net",
    "mail2tajikistan.com",
    "fastmail.im",
    "thundermail.com",
    "mail2vienna.com",
    "mail2heidi.com",
    "latino.com",
    "bimamail.com",
    "posteo.pm",
    "qq.com",
    "live.it",
    "optonline.net",
    "yahoo.co.in",
    "trash-mail.com",
    "yahoo.se",
    "ebnett.no",
    "mintemail.com",
    "icq.com",
    "beer.com",
    "lamer.hu",
    "anotherwin95.com",
    "codec.ro",
    "mail2infinity.com",
    "mail2ireland.com",
    "mail2noway.com",
    "muellmail.com",
    "myownemail.com",
    "starmail.com",
    "tempail.com",
    "weekonline.com",
    "3d-painting.com",
    "mail2rocker.com",
    "the-japanese.com",
    "comic.com",
    "lankamail.com",
    "bredband.net",
    "mail2yugoslavia.com",
    "webcity.ca",
    "mail2cambodia.com",
    "orange.fr",
    "cuteandcuddly.com",
    "programozo.hu",
    "freenet.com",
    "mail2goddess.com",
    "qwest.net",
    "pisem.net",
    "6paq.com",
    "acdcfan.com",
    "blutig.me",
    "goodnewsmail.com",
    "greenmail.net",
    "streber24.de",
    "cox.net",
    "tlen.pl",
    "bak.rr.com",
    "mailcity.com",
    "terra.cl",
    "boxemail.com",
    "chocaholic.com.au",
    "city-of-nottingham.com",
    "cybermail.net",
    "edmail.com",
    "fansworldwide.de",
    "fastchrysler.com",
    "femenino.com",
    "homemail.com",
    "kimsdisk.com",
    "mail2comedian.com",
    "mail2eritrea.com",
    "mail2heal.com",
    "mail2senegal.com",
    "mail2studio.com",
    "mail2terry.com",
    "mailandnews.com",
    "moakt.com",
    "penpen.com",
    "postmaster.twitter.com",
    "qualityservice.com",
    "sunrise-sunset.com",
    "tenchiclub.com",
    "the-master.com",
    "toomail.biz",
    "tropicalstorm.com",
    "wmail.cf",
    "live.jp",
    "hotmail.com.tw",
    "nyc.com",
    "bigblue.net.au",
    "apexmail.com",
    "mbx.cc",
    "mail2kerry.com",
    "boxfrog.com",
    "11mail.com",
    "alhilal.net",
    "fromnorthcarolina.com",
    "i-p.com",
    "mail-center.com",
    "mail2electron.com",
    "mail2frankfurt.com",
    "me-mail.hu",
    "muslimsonline.com",
    "pp.inet.fi",
    "public-files.de",
    "the-mexican.com",
    "webcammail.com",
    "yahoo.be",
    "email4u.info",
    "jet-renovation.fr",
    "racedriver.com",
    "shared-files.de",
    "temp-mail.com",
    "verizon.net",
    "solcon.nl",
    "sanook.com",
    "yepmail.net",
    "jetemail.net",
    "mail2japan.com",
    "astrosfan.com",
    "fantasticmail.com",
    "gorillaswithdirtyarmpits.com",
    "mail2helpdesk.com",
    "mail2looking.com",
    "mail2realtor.com",
    "mail2trillionaire.com",
    "rodrun.com",
    "swissmail.com",
    "usmc.net",
    "viewcastmedia.net",
    "wtvhmail.com",
    "yahoo.cz",
    "webindia123.com",
    "ua.fm",
    "secret-police.com",
    "city-of-westminster.com",
    "outlook.fr",
    "odmail.com",
    "techie.com",
    "hughes.net",
    "mail2angola.com",
    "mail2neal.com",
    "mail2hades.com",
    "email-london.co.uk",
    "telfort.nl",
    "v-sexi.com",
    "the-biker.com",
    "airforceemail.com",
    "emailstar.net",
    "politikerclub.de",
    "proconnect-mail.com",
    "posteo.fi",
    "freestamp.com",
    "pbadmail.com",
    "wideopenwest.com",
    "check.com",
    "gnwmail.com",
    "startrekmail.com",
    "ionet.net",
    "animail.net",
    "imgof.com",
    "mailinblack.com",
    "solution4u.com",
    "zweb.in",
    "flashcom.net",
    "lycos.es",
    "mail2nemesis.com",
    "ssl-mail.com",
    "mail2joann.com",
    "kaixo.com",
    "mail2song.com",
    "representative.com",
    "mail2evan.com",
    "mail2sponsor.com",
    "berkscounty.com",
    "posteo.tn",
    "mailinator.net",
    "musclemail.com",
    "studentcenter.org",
    "mail2me4u.com",
    "thepostmaster.net",
    "posteo.li",
    "truemail.co.th",
    "fromru.com",
    "fbi-agent.com",
    "posteo.lu",
    "euroseek.com",
    "mail2california.com",
    "hotmail.kz",
    "galamb.net",
    "from-spain.net",
    "mail2turbo.com",
    "ladymail.cz",
    "oicexchange.com",
    "aaamail.zzn.com",
    "mail2fairy.com",
    "coolgoose.com",
    "mail2jan.com",
    "mail2troy.com",
    "mail2china.com",
    "spamhole.com",
    "mail2uk.com",
    "homeworkcentral.com",
    "tiscali.at",
    "mail2jane.com",
    "masrawy.com",
    "sunumail.sn",
    "topteam.bg",
    "mail2ben.com",
    "e-apollo.lv",
    "journalist.com",
    "abdulnour.com",
    "travel.li",
    "poond.com",
    "oldies1041.com",
    "mail2todd.com",
    "the-wild-west.com",
    "mail2jumbo.com",
    "uol.com.mx",
    "lovelygirl.net",
    "guerillamail.com",
    "mail2denmark.com",
    "mail2close.com",
    "au.ru",
    "playful.com",
    "bigboab.com",
    "student.tuwien.ac.at",
    "swirve.com",
    "mail2clinic.com",
    "nospamfor.us",
    "games.com",
    "visto.com",
    "juno.com",
    "city-of-birmingham.com",
    "mail2cook.com",
    "student.ua.ac.be",
    "zoho.com",
    "hotmaill.com",
    "gmail.cpm",
    "mail2indiana.com",
    "myway.com",
    "pjjkp.com",
    "apollo.lv",
    "umail.iu.edu",
    "mail2jesus.com",
    "yahoo.com.au",
    "nomail2me.com",
    "imel.org",
    "fromsouthdakota.com",
    "wildmail.com",
    "mail2lipstick.com",
    "mail2wallstreet.com",
    "mail2deer.com",
    "btconnect.com",
    "cairomail.com",
    "mail2harry.com",
    "casema.nl",
    "ukcool.com",
    "mail2lou.com",
    "clixser.com",
    "epage.ru",
    "maennerversteherin.com",
    "photo-impact.eu",
    "toothfairy.com",
    "bigpond.net.au",
    "sneakemail.com",
    "mytoys-mail.de",
    "mail2ricky.com",
    "gmail.com.tw",
    "mail2uganda.com",
    "mail2adoration.com",
    "mail2cool.com",
    "iobox.com",
    "mail2debby.com",
    "mail2eli.com",
    "warmmail.com",
    "thelanddownunder.com",
    "technisamail.co.za",
    "access4less.net",
    "alex4all.com",
    "wam.co.za",
    "the-german.com",
    "nicholastse.net",
    "mail2minneapolis.com",
    "mail2jody.com",
    "emailchoice.com",
    "freemail.com.au",
    "mail2scientist.com",
    "mail2erinyes.com",
    "cloudme.com",
    "get1mail.com",
    "emailwarden.com",
    "recode.me",
    "lookugly.com",
    "the-animal.com",
    "sunpoint.net",
    "mail2arizona.com",
    "mail2willard.com",
    "sharmaweb.com",
    "mail2gsm.com",
    "twcny.rr.com",
    "extenda.net",
    "fake-mail.ga",
    "fastest.cc",
    "freundin.ru",
    "lr7.us",
    "mailmate.com",
    "pagina.de",
    "sent.at",
    "shitaway.cf",
    "stoned.com",
    "tafmail.com",
    "yandex.ua",
    "tempinbox.com",
    "mindspring.com",
    "mail2karen.com",
    "mail2psychologist.com",
    "redsfans.com",
    "mail2pisces.com",
    "frostbyte.uk.net",
    "mail2notus.com",
    "argentina.com",
    "fromdelaware.com",
    "freeola.com",
    "prontomail.com",
    "city-of-oxford.com",
    "programmer.net",
    "lover-boy.com",
    "mail2adventure.com",
    "spamfree24.de",
    "trillianpro.com",
    "austin.rr.com",
    "myfairpoint.net",
    "jetable.org",
    "hotmai.it",
    "mailc.net",
    "outgun.com",
    "dontreg.com",
    "albawaba.com",
    "backstreetboysclub.com",
    "bikeracer.com",
    "connectbox.com",
    "eelmail.com",
    "elsitio.com",
    "giga4u.de",
    "globalfree.it",
    "i-connect.com",
    "mail2batter.com",
    "mail2betty.com",
    "mail2bonn.com",
    "mail2crave.com",
    "mail2friendship.com",
    "mail2libya.com",
    "mail2mypager.com",
    "mail2pay.com",
    "mail2rare.com",
    "mail2waiter.com",
    "mail2wave.com",
    "pathfindermail.com",
    "socialworker.net",
    "stopdropandroll.com",
    "the-beauty.com",
    "the-lair.com",
    "xy9ce.tk",
    "yopmail.pp.ua",
    "cpaonline.net",
    "appleid.com",
    "2prong.com",
    "quiklinks.com",
    "motormania.com",
    "mail2save.com",
    "fastem.com",
    "lcbcmail.com",
    "netralink.com",
    "members.student.com",
    "frommississippi.com",
    "mail2rudy.com",
    "velocall.com",
    "mail2athlete.com",
    "movieluver.com",
    "alumnidirector.com",
    "nycmail.com",
    "trashmail.com",
    "cheerful.com",
    "hairdresser.net",
    "mail2lori.com",
    "wxs.nl",
    "whale-mail.com",
    "suddenlink.net",
    "fastmail.de",
    "cincinow.net",
    "tds.net",
    "vip.163.com",
    "fastmail.gr",
    "islamonline.net",
    "itelefonica.com.br",
    "go2.com.py",
    "capu.net",
    "purinmail.com",
    "hotail.com",
    "googlemail.de",
    "schweiz.org",
    "death-star.com",
    "surf3.net",
    "mailclub.fr",
    "computermail.net",
    "mbox.com.au",
    "mail2hiphop.com",
    "algeria.com",
    "sfr.fr",
    "triad.rr.com",
    "btopenworld.com",
    "tempe-mail.com",
    "swva.net",
    "megapoint.com",
    "posteo.ee",
    "wrestlingpages.com",
    "mail1st.com",
    "posteo.hr",
    "jahoopa.com",
    "space-bank.com",
    "army.net",
    "cristianemail.com",
    "ecardmail.com",
    "schoolmail.com",
    "netcom.com",
    "cyberinbox.com",
    "mail2cancer.com",
    "yogotemail.com",
    "mail2vacation.com",
    "imneverwrong.com",
    "law.com",
    "karachioye.com",
    "n2mail.com",
    "lagerlouts.com",
    "o2.co.uk",
    "mail2producer.com",
    "bachelorboy.com",
    "mail2colin.com",
    "wptamail.com",
    "e-mail.dk",
    "swipermail.zzn.com",
    "ananzi.co.za",
    "dontsendmespam.de",
    "alvilag.hu",
    "netcenter-vn.net",
    "fromalabama.com",
    "mail2karl.com",
    "mail2martha.com",
    "mail2melanie.com",
    "mail2marsha.com",
    "snakemail.com",
    "dansegulvet.com",
    "cable.net.co",
    "yourname.freeservers.com",
    "mail2sandy.com",
    "nicolastse.com",
    "tiscali.be",
    "mail2grace.com",
    "mail2movies.com",
    "broadcast.net",
    "bikerider.com",
    "mail2lauren.com",
    "irangate.net",
    "guy2.com",
    "paran.com",
    "numericable.fr",
    "mail2feeling.com",
    "rushpost.com",
    "infectgmail.com",
    "mail2fisherman.com",
    "mail2professor.com",
    "claramail.com",
    "mail2zenith.com",
    "gmail.cm",
    "mail2fanatic.com",
    "netspace.net.au",
    "fast-mail.org",
    "mail2cameroon.com",
    "netscape.com",
    "safetymail.info",
    "catholic.org",
    "live.co.uk",
    "mypartyclip.de",
    "blacksburg.net",
    "boun.cr",
    "cartelera.org",
    "centermail.de",
    "instruction.com",
    "secure-mail.cc",
    "spameater.org",
    "wirsindcool.de",
    "posteo.in",
    "mail2judy.com",
    "yahoo.in",
    "mail2000.com.tw",
    "welsh-lady.com",
    "mail2aim.com",
    "mail2hecate.com",
    "mail2monty.com",
    "mail.nu",
    "mail2southamerica.com",
    "mail2alabama.com",
    "tycoonmail.com",
    "pt.lu",
    "spambox.info",
    "great-host.in",
    "cicciociccio.com",
    "attglobal.net",
    "indocities.com",
    "ivebeenframed.com",
    "misery.net",
    "mail2lunch.com",
    "topchat.com",
    "333.com",
    "gtemail.net",
    "stargateradio.com",
    "ecompare.com",
    "mail2germany.com",
    "posteo.sg",
    "mail2barbados.com",
    "chello.nl",
    "4x4man.com",
    "redseven.de",
    "shop.de",
    "posteo.lt",
    "sinamail.com",
    "net-pager.net",
    "gocubs.com",
    "trashmail.net",
    "sacbeemail.com",
    "ecbsolutions.net",
    "yahoo.com.mx",
    "bigpond.au",
    "chammy.info",
    "dumpmail.com",
    "fettabernett.de",
    "keinpardon.de",
    "suomi24.fi",
    "jewishmail.com",
    "rotfl.com",
    "conok.com",
    "fastmail.to",
    "autorambler.ru",
    "diemailbox.de",
    "innocent.com",
    "ynnmail.com",
    "speedy.com.ar",
    "resumemail.com",
    "allracing.com",
    "angelfan.com",
    "vr9.com",
    "everytg.ml",
    "hartbot.de",
    "wolke7.net",
    "mail114.net",
    "oath.com",
    "outlawspam.com",
    "outlook.co.id",
    "yandex.pl",
    "mac-email.com",
    "direcway.com",
    "gmx.ch",
    "walla.com",
    "post.pl",
    "gmx.co.uk",
    "hvc.rr.com",
    "dsl.pipex.com",
    "name.com",
    "3xl.net",
    "e-mailanywhere.com",
    "mail2derek.com",
    "dnsmadeeasy.com",
    "xmsg.com",
    "1zhuan.com",
    "30minutesmail.com",
    "dodgit.org",
    "freemeil.gq",
    "khosropour.com",
    "kissfans.com",
    "mail.usa.com",
    "mail2care.com",
    "mail2denise.com",
    "mail2divorced.com",
    "mail2footballfan.com",
    "mail2rage.com",
    "mail2shawn.com",
    "mail2wayne.com",
    "mymacmail.com",
    "sharedmailbox.org",
    "spamcero.com",
    "thanksnospam.info",
    "posteo.pe",
    "bootybay.de",
    "freelance-france.eu",
    "gotmail.org",
    "home.de",
    "hotmail.fi",
    "magspam.net",
    "polyfaust.com",
    "spainmail.com",
    "20email.eu",
    "baldmama.de",
    "discard.gq",
    "emil.com",
    "manybrain.com",
    "streetwisemail.com",
    "war-im-urlaub.de",
    "quepasa.com",
    "reallyfast.biz",
    "ieee.org",
    "thaimail.com",
    "stny.rr.com",
    "supereva.it",
    "mail2time.com",
    "mail2monaco.com",
    "mail.az",
    "mail2savings.com",
    "orange.es",
    "buffymail.com",
    "hiphopfan.com",
    "pettypool.com",
    "mail2saturn.com",
    "mail2doglover.com",
    "portableoffice.com",
    "vtr.net",
    "cww.de",
    "mail2business.com",
    "inmail.sk",
    "postmaster.co.uk",
    "mail2cardiologist.com",
    "aol.it",
    "uol.com.br",
    "mail2dearest.com",
    "lycos.it",
    "atrus.ru",
    "collector.org",
    "email-fake.gq",
    "outlook.my",
    "mobile.me",
    "1ce.us",
    "bluebottle.com",
    "cable.comcast.com",
    "emailz.gq",
    "lovecat.com",
    "secretary.net",
    "upc.nl",
    "ezy.net",
    "garbagemail.com",
    "live.unc.edu",
    "xoxy.net",
    "hushmail.me",
    "ownmail.net",
    "mail2honey.com",
    "mail.zp.ua",
    "mobileme.com",
    "asia-mail.com",
    "bangkok.com",
    "crosshairs.com",
    "francemel.fr",
    "ieatspam.eu",
    "inmynetwork.tk",
    "mail2bar.com",
    "mail2cutey.com",
    "mail2london.com",
    "mail2mgz.com",
    "mail2mypalm.com",
    "mail2randy.com",
    "mail2stuntman.com",
    "mail2titanic.com",
    "nwytg.net",
    "topletter.com",
    "webcontact-france.eu",
    "wetrainbayarea.com",
    "pokepost.com",
    "trash2011.com",
    "wir-haben-nachwuchs.de",
    "fastmail.cn",
    "eintagsmail.de",
    "eml.pp.ua",
    "hotmail.co.za",
    "netterchef.de",
    "nextmail.ru",
    "savelife.ml",
    "terminverpennt.de",
    "wollan.info",
    "xing886.uu.gl",
    "megaboymail.com",
    "whyspam.me",
    "mail2anthony.com",
    "incamail.com",
    "mail2ellen.com",
    "mail2zurich.com",
    "luxsci.com",
    "mail2zoo.com",
    "abolition-now.com",
    "mail2museum.com",
    "nm.ru",
    "liontrucks.com",
    "mail2dale.com",
    "mail2valley.com",
    "givepeaceachance.com",
    "mail2lisa.com",
    "superdada.com",
    "optusnet.com.au",
    "mail2alaska.com",
    "eudoramail.com",
    "1internetdrive.com",
    "city2city.com",
    "emailcorner.net",
    "toolsource.com",
    "fastmail.net",
    "destin.com",
    "drotposta.hu",
    "axoskate.com",
    "ilovejesus.com",
    "noclickemail.com",
    "spamobox.com",
    "insight.rr.com",
    "hotmail.com.hk",
    "gala.net",
    "trash2009.com",
    "mailbox.gr",
    "3000.it",
    "97rock.com",
    "animalwoman.net",
    "die-optimisten.de",
    "dunloprider.com",
    "fromlouisiana.com",
    "graphic-designer.com",
    "ip4.pp.ua",
    "ireland.com",
    "mail2alec.com",
    "mail2money.com",
    "mail2teacher.com",
    "mantraonline.com",
    "mehrani.com",
    "monumentmail.com",
    "pacific-re.com",
    "personales.com",
    "surat.com",
    "weibsvolk.org",
    "mexicomail.com",
    "pacificwest.com",
    "moose-mail.com",
    "fromwashingtondc.com",
    "alexandria.cc",
    "mail2smile.com",
    "mail2arabia.com",
    "theheadoffice.com",
    "trmailbox.com",
    "mail2houston.com",
    "mail2walter.com",
    "singnet.com.sg",
    "cooperation.net",
    "1musicrow.com",
    "yopolis.com",
    "mail2bill.com",
    "bigmailbox.com",
    "mail2roy.com",
    "artlover.com",
    "city-of-brighton.org",
    "aemail4u.com",
    "woh.rr.com",
    "gmx.de",
    "hotmail.com.ar",
    "vfemail.net",
    "fastmail.us",
    "doneasy.com",
    "dcemail.com",
    "go.ru",
    "address.com",
    "ahk.jp",
    "asianwired.net",
    "baudoinconsulting.com",
    "business-man.com",
    "countrylover.com",
    "dm.w3internet.co.uk",
    "emailplanet.com",
    "emailplus.org",
    "freeghana.com",
    "freeyellow.com",
    "fromarkansas.com",
    "fromindiana.com",
    "mail.hitthebeach.com",
    "mail2clint.com",
    "mail2turkey.com",
    "mail2zack.com",
    "mvrht.com",
    "nightmail.com",
    "the-canuck.com",
    "tunisiamail.com",
    "usanetmail.com",
    "vip.gr",
    "webuser.in",
    "yahoo.nl",
    "spambox.irishspringrealty.com",
    "bk.ru",
    "live.be",
    "email.arizona.edu",
    "yahoo.ca",
    "gmail.co",
    "sogetthis.com",
    "peru.com",
    "ragingbull.com",
    "angelfire.com",
    "mail2man.com",
    "mail2air.com",
    "88.am",
    "bootmail.com",
    "brusseler.com",
    "catchamail.com",
    "hello.to",
    "hotmail.kg",
    "mail2ecuador.com",
    "mail2gilbert.com",
    "meine-fotos.info",
    "syom.com",
    "temtulsa.net",
    "truckracers.com",
    "uno.ee",
    "uole.com",
    "wegwerfmail.info",
    "yourinbox.com",
    "zhouemail.510520.org",
    "spray.se",
    "bvimailbox.com",
    "mail2dominicanrepublic.com",
    "desilota.com",
    "mail2beverly.com",
    "winmail.com.au",
    "spazmail.com",
    "mail2argentina.com",
    "thestreetfighter.com",
    "freeuk.com",
    "ravearena.com",
    "uae.ac",
    "from-brazil.com",
    "tiscali.lu",
    "terra.com",
    "skim.com",
    "eresmas.com",
    "mail2westend.com",
    "vip.qq.com",
    "charter.net",
    "poczta.onet.pl",
    "shinternet.ch",
    "mail333.com",
    "starmedia.com",
    "freegates.be",
    "boltonfans.com",
    "mail.austria.com",
    "cocoonemail.com",
    "abbeyroadlondon.co.uk",
    "avh.hu",
    "bcvibes.com",
    "britneyclub.com",
    "imaginemail.com",
    "mail2basketball.com",
    "mail2bosnia.com",
    "mail2grenada.com",
    "mail2mygsm.com",
    "mail2onfire.com",
    "mail2riley.com",
    "meloo.com",
    "metta.lk",
    "salehi.net",
    "sayhi.net",
    "starmail.org",
    "truckerz.com",
    "zipmax.com",
    "mailinator.com",
    "mailexpire.com",
    "tigermail.auburn.edu",
    "bikemechanics.com",
    "eriga.lv",
    "eramail.co.za",
    "mail2freedom.com",
    "mail2lucy.com",
    "agoodmail.com",
    "mail2margaret.com",
    "epatra.com",
    "mail2hotel.com",
    "mail2hebe.com",
    "etoast.com",
    "mail2mymac.com",
    "mail2newhampshire.com",
    "planet.nl",
    "doctors.org.uk",
    "hulapla.de",
    "mailslite.com",
    "mail-tester.com",
    "mailueberfall.de",
    "sofortmail.de",
    "spamoff.de",
    "stuffmail.de",
    "home.se",
    "devotedcouples.com",
    "the-canadian.com",
    "mail2tom.com",
    "gateway.net",
    "shotgun.hu",
    "mail2priest.com",
    "hkstarphoto.com",
    "from-africa.com",
    "fromrhodeisland.com",
    "mail2madison.com",
    "mail2holly.com",
    "mail2nick.com",
    "kichimail.com",
    "live.com.mx",
    "mail2moldova.commail2molly.com",
    "mail2gerald.com",
    "hotmail.co.nz",
    "fastmail.com.au",
    "neeva.net",
    "s0ny.net",
    "pipeline.com",
    "citeweb.net",
    "yourname.ddns.org",
    "150mail.com",
    "dirtracer.com",
    "farang.net",
    "fullmail.com",
    "techpointer.com",
    "ato.check.com",
    "didamail.com",
    "fan.theboys.com",
    "uu.net",
    "letterboxes.org",
    "posteo.net",
    "cox.com",
    "israelmail.com",
    "mailfree.gq",
    "quickhosts.com",
    "teleworm.us",
    "temporaryemail.us",
    "migmail.pl",
    "net-c.nl",
    "pokemonpost.com",
    "shitaway.usa.cc",
    "sudoworld.net",
    "whtjddn.33mail.com",
    "33mail.com",
    "amail.com",
    "contrasto.cu.cc",
    "mail.svenz.eu",
    "tempymail.com",
    "ultra.fyi",
    "dogit.com",
    "dotmsg.com",
    "net-c.fr",
    "netcmail.com",
    "btconnect.co.uk",
    "mailpokemon.com",
    "rklips.com",
    "sudoverse.net",
    "torontomail.com",
    "321media.com",
    "asiafind.com",
    "bin-wieder-da.de",
    "brazilmail.com",
    "collectiblesuperstore.com",
    "grapplers.com",
    "internet-e-mail.com",
    "je-recycle.info",
    "naui.net",
    "outlook.cl",
    "rhyta.com",
    "scotlandmail.com",
    "slipry.net",
    "sukhumvit.net",
    "used-product.fr",
    "aapt.net.au",
    "inbox.com",
    "ath.forthnet.gr",
    "2die4.com",
    "hot-shot.com",
    "emailtemporario.com.br",
    "pulp-fiction.com",
    "crazedanddazed.com",
    "die-besten-bilder.de",
    "faroweb.com",
    "fromwashington.com",
    "itloox.com",
    "mail2allan.com",
    "mail2ann.com",
    "mail2band.com",
    "mail2bangladesh.com",
    "mail2fiji.com",
    "mail2grant.com",
    "mail2hank.com",
    "mail2hip.com",
    "mail2mitch.com",
    "mail2mylaptop.com",
    "sbcglbal.net",
    "schizo.com",
    "spambob.org",
    "speedemail.net",
    "sperke.net",
    "the-eagles.com",
    "the-prayer.com",
    "u14269.ml",
    "aver.com",
    "cyber-wizard.com",
    "fastyamaha.com",
    "abyssmail.com",
    "c51vsgq.com",
    "chacuo.net",
    "dropmail.me",
    "shitaway.ml",
    "superrito.com",
    "unterderbruecke.de",
    "azmeil.tk",
    "europamel.net",
    "fastmazda.com",
    "fireman.net",
    "golfilla.info",
    "mailguard.me",
    "mailinator.org",
    "metaping.com",
    "net-c.lu",
    "polizisten-duzer.de",
    "salesperson.net",
    "tempmailer.com",
    "trash-mail.ga",
    "betriebsdirektor.de",
    "indeedemail.com",
    "locos.com",
    "playstation.sony.com",
    "uroid.com",
    "msn.nl",
    "planetmail.net",
    "quickmail.nl",
    "reincarnate.com",
    "dnainternet.net",
    "brew-master.com",
    "planetmail.com",
    "example.com",
    "myrealbox.com",
    "peoplepc.com",
    "postpro.net",
    "excite.it",
    "mail2joe.com",
    "webmails.com",
    "fastmailbox.net",
    "onmilwaukee.com",
    "blader.com",
    "domforfb4.tk",
    "fromnewmexico.com",
    "fromvirginia.com",
    "jpopmail.com",
    "mail2alan.com",
    "mail2from.com",
    "mail2julie.com",
    "mail2moscow.com",
    "mail2ned.com",
    "mail2subscribe.com",
    "mailinator.us",
    "mydotcomaddress.com",
    "netexecutive.com",
    "silkroad.net",
    "the-aliens.com",
    "username.e4ward.com",
    "visitmail.com",
    "x-networks.net",
    "yifan.net",
    "annsmail.com",
    "fax.ru",
    "spamstack.net",
    "yahoo.at",
    "bboy.zzn.com",
    "madcreations.com",
    "mail.pharmacy.com",
    "populus.net",
    "youpy.com",
    "mail.qip.ru",
    "trademailer.de",
    "rai.com.ua",
    "example.\u03B4\u03BF\u03BA\u03B9\u03BC\u03AE",
    "posteo.hn",
    "megabox.ru",
    "4hismail.com",
    "yehaa.com",
    "posteo.gl",
    "edge.net",
    "ygm.com",
    "bestweb.net",
    "nomorespamemails.com",
    "dmv.com",
    "orange.net",
    "posteo.hu",
    "mail.salu.net",
    "mciworldcom.net",
    "posteo.mx",
    "aport.ru",
    "bigpond.net",
    "cash4u.com",
    "wazabi.club",
    "fasttoyota.com",
    "grr.la",
    "spybox.de",
    "fleckens.hu",
    "inerted.com",
    "letthemeatspam.com",
    "telfortglasvezel.nl",
    "meine-dateien.info",
    "turboprinz.de",
    "wir-sind-cool.org",
    "comhem.se",
    "roadrunner.com",
    "runbox.com",
    "tx.rr.com",
    "spambog.ru",
    "mailnull.com",
    "oninet.pt",
    "home.ro",
    "homestead.com",
    "mailmij.nl",
    "zip.net",
    "bachelorgal.com",
    "clear.net.nz",
    "dogsnob.net",
    "fux0ringduh.com",
    "galaxy5.com",
    "imap.cc",
    "inbox.net",
    "kukamail.com",
    "mail2arthur.com",
    "mail2auction.com",
    "mail2diane.com",
    "mail2kathy.com",
    "mail2mors.com",
    "mail2peace.com",
    "matmail.com",
    "mor19.uu.gl",
    "mybox.it",
    "nospamthanks.info",
    "saeuferleber.de",
    "surgical.net",
    "theglobe.com",
    "weibsvolk.de",
    "starting-point.com",
    "fcc.net",
    "starpower.net",
    "a45.in",
    "emails.incisivemedia.com",
    "etranquil.net",
    "force9.co.uk",
    "indomail.com",
    "macfreak.com",
    "mobileninja.co.uk",
    "outlook.com.vn",
    "ozbytes.net.au",
    "urhen.com",
    "certifiedmail.com",
    "emails.ga",
    "mailed.ro",
    "outlook.cz",
    "turboprinzessin.de",
    "zomg.info",
    "e-mail.ua",
    "boxformail.in",
    "info-radio.ml",
    "neuro.md",
    "pokemail.net",
    "rocketship.com",
    "telstra.com.au",
    "list.ru",
    "live.com.au",
    "u.northwestern.edu",
    "exemail.com.au",
    "cfl.rr.com",
    "studenti.unimi.it",
    "quickinbox.com",
    "tamil.com",
    "mail2strong.com",
    "africamel.net",
    "c4.com",
    "chong-mail.net",
    "jerusalemmail.com",
    "mail2alicia.com",
    "mail2champaign.com",
    "mail2linda.com",
    "mail2poseidon.com",
    "mail2steven.com",
    "mail2tracey.com",
    "netc.fr",
    "nettaxi.com",
    "freemails.ga",
    "vahoo.com",
    "ephemail.net",
    "fake-mail.ml",
    "germanymail.com",
    "junkmail.gq",
    "westnet.com",
    "moscowmail.com",
    "n2baseball.com",
    "net-c.it",
    "webinbox.com",
    "virtualactive.com",
    "trashmailer.com",
    "posteo.com.br",
    "litedrop.com",
    "netmanor.com",
    "posteo.gr",
    "posteo.cz",
    "gh2000.com",
    "crosslink.net",
    "dejanews.com",
    "wow.com",
    "voo.be",
    "posteo.ru",
    "mailme.ir",
    "internetmci.com",
    "armymail.com",
    "outel.com",
    "ccnmail.com",
    "blazenet.net",
    "subnetwork.com",
    "planetdirect.com",
    "xpressmail.zzn.com",
    "bossofthemoss.com",
    "mariah-carey.ml.org",
    "discoverymail.com",
    "cybergal.com",
    "medione.net",
    "ag.us.to",
    "die-optimisten.net",
    "netc.lu",
    "outlook.in",
    "bigstring.com",
    "dispomail.eu",
    "jetable.de",
    "merda.igg.biz",
    "twcny.com",
    "xoxox.cc",
    "loobie.com",
    "posteo.me",
    "domforfb8.tk",
    "emailer.hubspot.com",
    "fake-email.pp.ua",
    "netc.it",
    "netnoir.net",
    "outlook.hu",
    "social-mailer.tk",
    "mailgate.gr",
    "cyberspace-asia.com",
    "unomail.com",
    "adoption.com",
    "maildrop.cc",
    "realtyagent.com",
    "safrica.com",
    "christianmail.net",
    "netcom.ca",
    "1mail.ml",
    "californiamail.com",
    "easytrashmail.com",
    "hackermail.com",
    "posteo.la",
    "sina.com",
    "eircom.net",
    "hotmail.my",
    "joymail.com",
    "mail2dave.com",
    "hello.hu",
    "mail2allen.com",
    "mail2beijing.com",
    "mail2hot.com",
    "mail2james.com",
    "mail2junk.com",
    "mail2maria.com",
    "mail2montana.com",
    "mail2morpheus.com",
    "mail2norway.com",
    "mail2sal.com",
    "mail2swiss.com",
    "nicegal.com",
    "the-student.net",
    "uplipht.com",
    "walkmail.net",
    "wickmail.net",
    "wovz.cu.cc",
    "yahoo.ae",
    "planetall.com",
    "888.nu",
    "sativa.ro.org",
    "0clickemail.com",
    "cyber-matrix.com",
    "emailit.com",
    "freudenkinder.de",
    "oida.icu",
    "temp-mail.de",
    "vampirehunter.com",
    "amazonses.com",
    "rootprompt.org",
    "webstable.net",
    "posteo.my",
    "mycampus.com",
    "chinalook.com",
    "kmail.com.au",
    "sharewaredevelopers.com",
    "adultmail.tv",
    "ziplink.net",
    "imail.org",
    "bev.net",
    "yawmail.com",
    "bannertown.net",
    "clrmail.com",
    "comporium.net",
    "coole-files.de",
    "openmailbox.org",
    "outlook.sg",
    "protestant.com",
    "put2.net",
    "sudoworld.com",
    "trimix.cn",
    "webname.com",
    "zetmail.com",
    "bareed.ws",
    "download-privat.de",
    "humn.ws.gy",
    "newsboysmail.com",
    "yahoo.co",
    "bt.com",
    "gti.net",
    "wanadoo.co.uk",
    "football.theboys.com",
    "posteo.cl",
    "amnestymail.com",
    "fullchannel.net",
    "homeart.com",
    "webmail.bellsouth.net",
    "nogmailspam.info",
    "reggafan.com",
    "posteo.ch",
    "email60.com",
    "mrpost.com",
    "posta.net",
    "arcademaster.com",
    "attbi.com",
    "megapathdsl.net",
    "posteo.org",
    "fixmail.tk",
    "instantemailaddress.com",
    "lvie.com.sg",
    "muehlacker.tk",
    "myspaceinc.net",
    "hurting.com",
    "n2soccer.com",
    "programist.ru",
    "toke.com",
    "7mail.ml",
    "wfgdfhj.tk",
    "ecolo-online.fr",
    "lass-es-geschehen.de",
    "liebt-dich.info",
    "madonnafan.com",
    "seckinmail.com",
    "vnet.citiz.net",
    "worker.com",
    "yahoo.hu",
    "chechnya.conf.work",
    "foothills.net",
    "knol-power.nl",
    "monemail.com",
    "mt2015.com",
    "nullbox.info",
    "outlook.co.nz",
    "outlook.sa",
    "therapist.net",
    "club-internet.fr",
    "talktalk.net",
    "21cn.com",
    "movistar.es",
    "tempemail.com",
    "myfamily.com",
    "mail2dan.com",
    "aa.net",
    "belizehome.com",
    "btcmail.pw",
    "disinfo.net",
    "feinripptraeger.de",
    "getairmail.cf",
    "harakirimail.com",
    "hunsa.com",
    "ilovetocollect.net",
    "internetegypt.com",
    "iservejesus.com",
    "kcks.com",
    "mail2fashion.com",
    "mail2luxembourg.com",
    "mail2milano.com",
    "mail2rod.com",
    "planetearthinter.net",
    "the-cowboy.com",
    "townisp.com",
    "whartontx.com",
    "activist.com",
    "adrenalinefreak.com",
    "girl4god.com",
    "kaffeeschluerfer.de",
    "mamber.net",
    "sraka.xyz",
    "copper.net",
    "inboxalias.com",
    "mail4u.info",
    "merda.nut.cc",
    "myspamless.com",
    "plus.google.com",
    "tortenboxer.de",
    "klassmaster.net",
    "lenta.ru",
    "login-email.ga",
    "phpbb.uu.gl",
    "vip.21cn.com",
    "wee.my",
    "mail-easy.fr",
    "asdasd.nl",
    "elisanet.fi",
    "instantmail.fr",
    "lovefall.ml",
    "mail.misterpinball.de",
    "vubby.com",
    "zaktouni.fr",
    "2980.com",
    "computer4u.com",
    "englandmail.com",
    "ficken.de",
    "i2pmail.org",
    "kolumbus.fi",
    "solvemail.info",
    "songwriter.net",
    "zxcv.com",
    "geography.net",
    "mailbox72.biz",
    "mypacks.net",
    "net-c.cat",
    "prydirect.info",
    "smashmail.de",
    "spamdecoy.net",
    "web-emailbox.eu",
    "googlegroups.com",
    "herp.in",
    "mt2016.com",
    "spamgoes.in",
    "blockfilter.com",
    "hacccc.com",
    "maildx.com",
    "sendspamhere.com",
    "advantimo.com",
    "domforfb3.tk",
    "inbound.plus",
    "loveyouforever.de",
    "schmusemail.de",
    "1pad.de",
    "6ip.us",
    "crapmail.org",
    "dodsi.com",
    "ftc-i.net",
    "maildrop.gq",
    "null.net",
    "smellrear.com",
    "centermail.info",
    "facebook-email.ga",
    "ano-mail.net",
    "lovesea.gq",
    "anonmails.de",
    "brennendesreich.de",
    "disciples.com",
    "emailthe.net",
    "luv2.us",
    "phus8kajuspa.cu.cc",
    "smap.4nmv.ru",
    "spambooger.com",
    "net-c.be",
    "omen.ru",
    "sonnenkinder.org",
    "teachers.org",
    "trash-mail.ml",
    "walala.org",
    "mailtemp.info",
    "my10minutemail.com",
    "totalmail.de",
    "discard.ga",
    "freemail.ms",
    "sudolife.net",
    "bund.us",
    "emailto.de",
    "netzidiot.de",
    "pemail.net",
    "housefan.com",
    "charm.net",
    "willselfdestruct.com",
    "bosnianmail.com",
    "finfin.com",
    "tempmail.it",
    "posteo.nz",
    "govolsfan.com",
    "kozmail.com",
    "hempseed.com",
    "planet-mail.com",
    "emumail.com",
    "bcpl.net",
    "itol.com",
    "ilovethemovies.com",
    "acmecity.com",
    "dca.net",
    "mail2go.com",
    "imails.info",
    "posteo.nl",
    "bla-bla.com",
    "posteo.co",
    "patmedia.net",
    "ibm.net",
    "toughguy.net",
    "giantsfan.com",
    "wickedmail.com",
    "sprynet.com",
    "safarimail.com",
    "spaceart.com",
    "onvillage.com",
    "posteo.ro",
    "privaterelay.appleid.com"
]);
var $8acea9a2b2a9060b$export$2e2bcd8739ae039 = $8acea9a2b2a9060b$var$personalEmailsDomains;

});

parcelRegister("Ie188", function(module, exports) {
$parcel$export(module.exports, "StreamhubClient", function () { return $c0688d0cc57a7567$export$df36629759e22bfa; });
parcelRequire("hhKQf");
var $b5ds0 = parcelRequire("b5ds0");
class $c0688d0cc57a7567$export$df36629759e22bfa {
    getEndpoint() {
        return this.endpoint;
    }
    async postObject(object, path, responseHandler, errorHandler) {
        try {
            const response = await (0, $b5ds0.default).post(`${this.endpoint}/streamhub/${path}`, object);
            responseHandler(response);
        } catch (error) {
            console.error("Failed to post object to endpoint", error);
            if (errorHandler) errorHandler(error);
            throw error;
        }
    }
    constructor(){
        this.endpoint = "https://www.atlassian.com/endpoint";
    }
}

});
parcelRegister("hhKQf", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("b5ds0")).default; });

var $b5ds0 = parcelRequire("b5ds0");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c9585bfbb4f1a6da$export$1c00760e9e5a4e95, AxiosError: $c9585bfbb4f1a6da$export$c1fbed17c2f6a328, CanceledError: $c9585bfbb4f1a6da$export$1ab0c6b20d94fa14, isCancel: $c9585bfbb4f1a6da$export$3b22524397b493c6, CancelToken: $c9585bfbb4f1a6da$export$fd08e3cb425f0d61, VERSION: $c9585bfbb4f1a6da$export$a4ad2735b021c132, all: $c9585bfbb4f1a6da$export$84bf76cd7afc7469, Cancel: $c9585bfbb4f1a6da$export$848c9b7ead0df967, isAxiosError: $c9585bfbb4f1a6da$export$fbafdbe06a5b5a9a, spread: $c9585bfbb4f1a6da$export$3ae0fd4797ed47c8, toFormData: $c9585bfbb4f1a6da$export$10ae0d317ea97f8b, AxiosHeaders: $c9585bfbb4f1a6da$export$4e7d6ff0f3e6520, HttpStatusCode: $c9585bfbb4f1a6da$export$a972f69c851492b3, formToJSON: $c9585bfbb4f1a6da$export$86d7c59254d6a2c9, getAdapter: $c9585bfbb4f1a6da$export$17ddc20a97d669e2, mergeConfig: $c9585bfbb4f1a6da$export$7ec1ebcfa9d8bd6a, create: $c9585bfbb4f1a6da$export$185802fd694ee1f5 } = (0, $b5ds0.default);

});
parcelRegister("b5ds0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $811a985f88316982$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");

var $cJSIh = parcelRequire("cJSIh");

var $hyhT7 = parcelRequire("hyhT7");

var $34wiJ = parcelRequire("34wiJ");

var $gzVYL = parcelRequire("gzVYL");

var $aaHKr = parcelRequire("aaHKr");

var $gblb4 = parcelRequire("gblb4");

var $bDiDT = parcelRequire("bDiDT");

var $blpvm = parcelRequire("blpvm");

var $2oCy9 = parcelRequire("2oCy9");

var $hFp7I = parcelRequire("hFp7I");

var $1cg5p = parcelRequire("1cg5p");

var $fp4Jy = parcelRequire("fp4Jy");

var $bBTya = parcelRequire("bBTya");

var $la4ol = parcelRequire("la4ol");

var $hwyJs = parcelRequire("hwyJs");

var $6JMnu = parcelRequire("6JMnu");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $811a985f88316982$var$createInstance(defaultConfig) {
    const context = new (0, $hyhT7.default)(defaultConfig);
    const instance = (0, $cJSIh.default)((0, $hyhT7.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $i7QDB.default).extend(instance, (0, $hyhT7.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $i7QDB.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $811a985f88316982$var$createInstance((0, $34wiJ.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $811a985f88316982$var$axios = $811a985f88316982$var$createInstance((0, $gzVYL.default));
// Expose Axios class to allow class inheritance
$811a985f88316982$var$axios.Axios = (0, $hyhT7.default);
// Expose Cancel & CancelToken
$811a985f88316982$var$axios.CanceledError = (0, $gblb4.default);
$811a985f88316982$var$axios.CancelToken = (0, $bDiDT.default);
$811a985f88316982$var$axios.isCancel = (0, $blpvm.default);
$811a985f88316982$var$axios.VERSION = (0, $2oCy9.VERSION);
$811a985f88316982$var$axios.toFormData = (0, $hFp7I.default);
// Expose AxiosError class
$811a985f88316982$var$axios.AxiosError = (0, $1cg5p.default);
// alias for CanceledError for backward compatibility
$811a985f88316982$var$axios.Cancel = $811a985f88316982$var$axios.CanceledError;
// Expose all/spread
$811a985f88316982$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$811a985f88316982$var$axios.spread = (0, $fp4Jy.default);
// Expose isAxiosError
$811a985f88316982$var$axios.isAxiosError = (0, $bBTya.default);
// Expose mergeConfig
$811a985f88316982$var$axios.mergeConfig = (0, $34wiJ.default);
$811a985f88316982$var$axios.AxiosHeaders = (0, $la4ol.default);
$811a985f88316982$var$axios.formToJSON = (thing)=>(0, $aaHKr.default)((0, $i7QDB.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$811a985f88316982$var$axios.getAdapter = (0, $hwyJs.default).getAdapter;
$811a985f88316982$var$axios.HttpStatusCode = (0, $6JMnu.default);
$811a985f88316982$var$axios.default = $811a985f88316982$var$axios;
var // this module should only have a default export
$811a985f88316982$export$2e2bcd8739ae039 = $811a985f88316982$var$axios;

});
parcelRegister("i7QDB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d321b63556da5196$export$2e2bcd8739ae039; });

var $cJSIh = parcelRequire("cJSIh");

var $7t0tI = parcelRequire("7t0tI");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $d321b63556da5196$var$toString } = Object.prototype;
const { getPrototypeOf: $d321b63556da5196$var$getPrototypeOf } = Object;
const { iterator: $d321b63556da5196$var$iterator, toStringTag: $d321b63556da5196$var$toStringTag } = Symbol;
const $d321b63556da5196$var$kindOf = ((cache)=>(thing)=>{
        const str = $d321b63556da5196$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $d321b63556da5196$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$d321b63556da5196$var$kindOf(thing) === type;
};
const $d321b63556da5196$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $d321b63556da5196$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $d321b63556da5196$var$isUndefined = $d321b63556da5196$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $d321b63556da5196$var$isBuffer(val) {
    return val !== null && !$d321b63556da5196$var$isUndefined(val) && val.constructor !== null && !$d321b63556da5196$var$isUndefined(val.constructor) && $d321b63556da5196$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $d321b63556da5196$var$isArrayBuffer = $d321b63556da5196$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $d321b63556da5196$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $d321b63556da5196$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $d321b63556da5196$var$isString = $d321b63556da5196$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $d321b63556da5196$var$isFunction = $d321b63556da5196$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $d321b63556da5196$var$isNumber = $d321b63556da5196$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $d321b63556da5196$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $d321b63556da5196$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $d321b63556da5196$var$isPlainObject = (val)=>{
    if ($d321b63556da5196$var$kindOf(val) !== 'object') return false;
    const prototype = $d321b63556da5196$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($d321b63556da5196$var$toStringTag in val) && !($d321b63556da5196$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $d321b63556da5196$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$d321b63556da5196$var$isObject(val) || $d321b63556da5196$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $d321b63556da5196$var$isDate = $d321b63556da5196$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $d321b63556da5196$var$isFile = $d321b63556da5196$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $d321b63556da5196$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $d321b63556da5196$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $d321b63556da5196$var$isBlob = $d321b63556da5196$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $d321b63556da5196$var$isFileList = $d321b63556da5196$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $d321b63556da5196$var$isStream = (val)=>$d321b63556da5196$var$isObject(val) && $d321b63556da5196$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $d321b63556da5196$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $d321b63556da5196$var$G = $d321b63556da5196$var$getGlobal();
const $d321b63556da5196$var$FormDataCtor = typeof $d321b63556da5196$var$G.FormData !== 'undefined' ? $d321b63556da5196$var$G.FormData : undefined;
const $d321b63556da5196$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($d321b63556da5196$var$FormDataCtor && thing instanceof $d321b63556da5196$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $d321b63556da5196$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$d321b63556da5196$var$isFunction(thing.append)) return false;
    const kind = $d321b63556da5196$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $d321b63556da5196$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $d321b63556da5196$var$isURLSearchParams = $d321b63556da5196$var$kindOfTest('URLSearchParams');
const [$d321b63556da5196$var$isReadableStream, $d321b63556da5196$var$isRequest, $d321b63556da5196$var$isResponse, $d321b63556da5196$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($d321b63556da5196$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $d321b63556da5196$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $d321b63556da5196$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($d321b63556da5196$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($d321b63556da5196$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $d321b63556da5196$var$findKey(obj, key) {
    if ($d321b63556da5196$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $d321b63556da5196$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $d321b63556da5196$var$isContextDefined = (context)=>!$d321b63556da5196$var$isUndefined(context) && context !== $d321b63556da5196$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $d321b63556da5196$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $d321b63556da5196$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $d321b63556da5196$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $d321b63556da5196$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($d321b63556da5196$var$isPlainObject(existing) && $d321b63556da5196$var$isPlainObject(val)) result[targetKey] = $d321b63556da5196$var$merge(existing, val);
        else if ($d321b63556da5196$var$isPlainObject(val)) result[targetKey] = $d321b63556da5196$var$merge({}, val);
        else if ($d321b63556da5196$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$d321b63556da5196$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++)objs[i] && $d321b63556da5196$var$forEach(objs[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $d321b63556da5196$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $d321b63556da5196$var$forEach(b, (val, key)=>{
        if (thisArg && $d321b63556da5196$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $cJSIh.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $d321b63556da5196$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $d321b63556da5196$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $d321b63556da5196$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $d321b63556da5196$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $d321b63556da5196$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $d321b63556da5196$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($d321b63556da5196$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$d321b63556da5196$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $d321b63556da5196$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $d321b63556da5196$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $d321b63556da5196$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$d321b63556da5196$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $d321b63556da5196$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $d321b63556da5196$var$isHTMLForm = $d321b63556da5196$var$kindOfTest('HTMLFormElement');
const $d321b63556da5196$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $d321b63556da5196$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $d321b63556da5196$var$isRegExp = $d321b63556da5196$var$kindOfTest('RegExp');
const $d321b63556da5196$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $d321b63556da5196$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $d321b63556da5196$var$freezeMethods = (obj)=>{
    $d321b63556da5196$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($d321b63556da5196$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$d321b63556da5196$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $d321b63556da5196$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $d321b63556da5196$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $d321b63556da5196$var$noop = ()=>{};
const $d321b63556da5196$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $d321b63556da5196$var$isSpecCompliantForm(thing) {
    return !!(thing && $d321b63556da5196$var$isFunction(thing.append) && thing[$d321b63556da5196$var$toStringTag] === 'FormData' && thing[$d321b63556da5196$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $d321b63556da5196$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($d321b63556da5196$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($d321b63556da5196$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $d321b63556da5196$var$isArray(source) ? [] : {};
                $d321b63556da5196$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$d321b63556da5196$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $d321b63556da5196$var$isAsyncFn = $d321b63556da5196$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $d321b63556da5196$var$isThenable = (thing)=>thing && ($d321b63556da5196$var$isObject(thing) || $d321b63556da5196$var$isFunction(thing)) && $d321b63556da5196$var$isFunction(thing.then) && $d321b63556da5196$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $d321b63556da5196$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $d321b63556da5196$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $d321b63556da5196$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $d321b63556da5196$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $d321b63556da5196$var$isFunction($d321b63556da5196$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $d321b63556da5196$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($d321b63556da5196$var$_global) : typeof $7t0tI !== 'undefined' && $7t0tI.nextTick || $d321b63556da5196$var$_setImmediate;
// *********************
const $d321b63556da5196$var$isIterable = (thing)=>thing != null && $d321b63556da5196$var$isFunction(thing[$d321b63556da5196$var$iterator]);
var $d321b63556da5196$export$2e2bcd8739ae039 = {
    isArray: $d321b63556da5196$var$isArray,
    isArrayBuffer: $d321b63556da5196$var$isArrayBuffer,
    isBuffer: $d321b63556da5196$var$isBuffer,
    isFormData: $d321b63556da5196$var$isFormData,
    isArrayBufferView: $d321b63556da5196$var$isArrayBufferView,
    isString: $d321b63556da5196$var$isString,
    isNumber: $d321b63556da5196$var$isNumber,
    isBoolean: $d321b63556da5196$var$isBoolean,
    isObject: $d321b63556da5196$var$isObject,
    isPlainObject: $d321b63556da5196$var$isPlainObject,
    isEmptyObject: $d321b63556da5196$var$isEmptyObject,
    isReadableStream: $d321b63556da5196$var$isReadableStream,
    isRequest: $d321b63556da5196$var$isRequest,
    isResponse: $d321b63556da5196$var$isResponse,
    isHeaders: $d321b63556da5196$var$isHeaders,
    isUndefined: $d321b63556da5196$var$isUndefined,
    isDate: $d321b63556da5196$var$isDate,
    isFile: $d321b63556da5196$var$isFile,
    isReactNativeBlob: $d321b63556da5196$var$isReactNativeBlob,
    isReactNative: $d321b63556da5196$var$isReactNative,
    isBlob: $d321b63556da5196$var$isBlob,
    isRegExp: $d321b63556da5196$var$isRegExp,
    isFunction: $d321b63556da5196$var$isFunction,
    isStream: $d321b63556da5196$var$isStream,
    isURLSearchParams: $d321b63556da5196$var$isURLSearchParams,
    isTypedArray: $d321b63556da5196$var$isTypedArray,
    isFileList: $d321b63556da5196$var$isFileList,
    forEach: $d321b63556da5196$var$forEach,
    merge: $d321b63556da5196$var$merge,
    extend: $d321b63556da5196$var$extend,
    trim: $d321b63556da5196$var$trim,
    stripBOM: $d321b63556da5196$var$stripBOM,
    inherits: $d321b63556da5196$var$inherits,
    toFlatObject: $d321b63556da5196$var$toFlatObject,
    kindOf: $d321b63556da5196$var$kindOf,
    kindOfTest: $d321b63556da5196$var$kindOfTest,
    endsWith: $d321b63556da5196$var$endsWith,
    toArray: $d321b63556da5196$var$toArray,
    forEachEntry: $d321b63556da5196$var$forEachEntry,
    matchAll: $d321b63556da5196$var$matchAll,
    isHTMLForm: $d321b63556da5196$var$isHTMLForm,
    hasOwnProperty: $d321b63556da5196$var$hasOwnProperty,
    hasOwnProp: $d321b63556da5196$var$hasOwnProperty,
    reduceDescriptors: $d321b63556da5196$var$reduceDescriptors,
    freezeMethods: $d321b63556da5196$var$freezeMethods,
    toObjectSet: $d321b63556da5196$var$toObjectSet,
    toCamelCase: $d321b63556da5196$var$toCamelCase,
    noop: $d321b63556da5196$var$noop,
    toFiniteNumber: $d321b63556da5196$var$toFiniteNumber,
    findKey: $d321b63556da5196$var$findKey,
    global: $d321b63556da5196$var$_global,
    isContextDefined: $d321b63556da5196$var$isContextDefined,
    isSpecCompliantForm: $d321b63556da5196$var$isSpecCompliantForm,
    toJSONObject: $d321b63556da5196$var$toJSONObject,
    isAsyncFn: $d321b63556da5196$var$isAsyncFn,
    isThenable: $d321b63556da5196$var$isThenable,
    setImmediate: $d321b63556da5196$var$_setImmediate,
    asap: $d321b63556da5196$var$asap,
    isIterable: $d321b63556da5196$var$isIterable
};

});
parcelRegister("cJSIh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $946420e321ec8913$export$2e2bcd8739ae039; });
'use strict';
function $946420e321ec8913$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("hyhT7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cc737cce45884ec6$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");

var $hfvLv = parcelRequire("hfvLv");

var $96b7F = parcelRequire("96b7F");

var $2xWoV = parcelRequire("2xWoV");

var $34wiJ = parcelRequire("34wiJ");

var $jPrPz = parcelRequire("jPrPz");

var $aUX8G = parcelRequire("aUX8G");

var $la4ol = parcelRequire("la4ol");

var $3GMSK = parcelRequire("3GMSK");
'use strict';
const $cc737cce45884ec6$var$validators = (0, $aUX8G.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cc737cce45884ec6$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $96b7F.default)(),
            response: new (0, $96b7F.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $34wiJ.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $aUX8G.default).assertOptions(transitional, {
            silentJSONParsing: $cc737cce45884ec6$var$validators.transitional($cc737cce45884ec6$var$validators.boolean),
            forcedJSONParsing: $cc737cce45884ec6$var$validators.transitional($cc737cce45884ec6$var$validators.boolean),
            clarifyTimeoutError: $cc737cce45884ec6$var$validators.transitional($cc737cce45884ec6$var$validators.boolean),
            legacyInterceptorReqResOrdering: $cc737cce45884ec6$var$validators.transitional($cc737cce45884ec6$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $i7QDB.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $aUX8G.default).assertOptions(paramsSerializer, {
                encode: $cc737cce45884ec6$var$validators.function,
                serialize: $cc737cce45884ec6$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $aUX8G.default).assertOptions(config, {
            baseUrl: $cc737cce45884ec6$var$validators.spelling('baseURL'),
            withXsrfToken: $cc737cce45884ec6$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $i7QDB.default).merge(headers.common, headers[config.method]);
        headers && (0, $i7QDB.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $la4ol.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $3GMSK.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $2xWoV.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $2xWoV.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $34wiJ.default)(this.defaults, config);
        const fullPath = (0, $jPrPz.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $hfvLv.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $i7QDB.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cc737cce45884ec6$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $34wiJ.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $i7QDB.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $34wiJ.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cc737cce45884ec6$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $cc737cce45884ec6$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $cc737cce45884ec6$export$2e2bcd8739ae039 = $cc737cce45884ec6$var$Axios;

});
parcelRegister("hfvLv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c8ec7a4ca75ebd77$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");

var $6F6wt = parcelRequire("6F6wt");
'use strict';
function $c8ec7a4ca75ebd77$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $c8ec7a4ca75ebd77$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $c8ec7a4ca75ebd77$export$c564cdbbe6da493;
    const _options = (0, $i7QDB.default).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $i7QDB.default).isURLSearchParams(params) ? params.toString() : new (0, $6F6wt.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("6F6wt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4d9ba1b3cfca7071$export$2e2bcd8739ae039; });

var $hFp7I = parcelRequire("hFp7I");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $4d9ba1b3cfca7071$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $4d9ba1b3cfca7071$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $hFp7I.default)(params, this, options);
}
const $4d9ba1b3cfca7071$var$prototype = $4d9ba1b3cfca7071$var$AxiosURLSearchParams.prototype;
$4d9ba1b3cfca7071$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$4d9ba1b3cfca7071$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $4d9ba1b3cfca7071$var$encode);
    } : $4d9ba1b3cfca7071$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $4d9ba1b3cfca7071$export$2e2bcd8739ae039 = $4d9ba1b3cfca7071$var$AxiosURLSearchParams;

});
parcelRegister("hFp7I", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cdc9c102b72c272e$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");

var $1cg5p = parcelRequire("1cg5p");

var $a1DcV = parcelRequire("a1DcV");

var $567QU = parcelRequire("567QU");
var $cdc9c102b72c272e$require$Buffer = $567QU.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $cdc9c102b72c272e$var$isVisitable(thing) {
    return (0, $i7QDB.default).isPlainObject(thing) || (0, $i7QDB.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $cdc9c102b72c272e$var$removeBrackets(key) {
    return (0, $i7QDB.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $cdc9c102b72c272e$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $cdc9c102b72c272e$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $cdc9c102b72c272e$var$isFlatArray(arr) {
    return (0, $i7QDB.default).isArray(arr) && !arr.some($cdc9c102b72c272e$var$isVisitable);
}
const $cdc9c102b72c272e$var$predicates = (0, $i7QDB.default).toFlatObject((0, $i7QDB.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $cdc9c102b72c272e$var$toFormData(obj, formData, options) {
    if (!(0, $i7QDB.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $a1DcV.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $i7QDB.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $i7QDB.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    const useBlob = _Blob && (0, $i7QDB.default).isSpecCompliantForm(formData);
    if (!(0, $i7QDB.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $i7QDB.default).isDate(value)) return value.toISOString();
        if ((0, $i7QDB.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $i7QDB.default).isBlob(value)) throw new (0, $1cg5p.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $i7QDB.default).isArrayBuffer(value) || (0, $i7QDB.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $cdc9c102b72c272e$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $i7QDB.default).isReactNative(formData) && (0, $i7QDB.default).isReactNativeBlob(value)) {
            formData.append($cdc9c102b72c272e$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $i7QDB.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $i7QDB.default).isArray(value) && $cdc9c102b72c272e$var$isFlatArray(value) || ((0, $i7QDB.default).isFileList(value) || (0, $i7QDB.default).endsWith(key, '[]')) && (arr = (0, $i7QDB.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $cdc9c102b72c272e$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $i7QDB.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $cdc9c102b72c272e$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($cdc9c102b72c272e$var$isVisitable(value)) return true;
        formData.append($cdc9c102b72c272e$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($cdc9c102b72c272e$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $cdc9c102b72c272e$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $i7QDB.default).isUndefined(value)) return;
        if (depth > maxDepth) throw new (0, $1cg5p.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $1cg5p.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $i7QDB.default).forEach(value, function each(el, key) {
            const result = !((0, $i7QDB.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $i7QDB.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $i7QDB.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $cdc9c102b72c272e$export$2e2bcd8739ae039 = $cdc9c102b72c272e$var$toFormData;

});
parcelRegister("1cg5p", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0df363d7ce01d5ce$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");

var $la4ol = parcelRequire("la4ol");
'use strict';
const $0df363d7ce01d5ce$var$REDACTED = '[REDACTED ****]';
function $0df363d7ce01d5ce$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $i7QDB.default).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $i7QDB.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $0df363d7ce01d5ce$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $i7QDB.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $la4ol.default)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $i7QDB.default).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $i7QDB.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $i7QDB.default).isPlainObject(source) && $0df363d7ce01d5ce$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $0df363d7ce01d5ce$var$REDACTED : visit(value);
                if (!(0, $i7QDB.default).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $0df363d7ce01d5ce$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $0df363d7ce01d5ce$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $i7QDB.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $i7QDB.default).isArray(redactKeys) && redactKeys.length > 0 ? $0df363d7ce01d5ce$var$redactConfig(config, redactKeys) : (0, $i7QDB.default).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$0df363d7ce01d5ce$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$0df363d7ce01d5ce$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$0df363d7ce01d5ce$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$0df363d7ce01d5ce$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$0df363d7ce01d5ce$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$0df363d7ce01d5ce$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$0df363d7ce01d5ce$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$0df363d7ce01d5ce$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$0df363d7ce01d5ce$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$0df363d7ce01d5ce$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$0df363d7ce01d5ce$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$0df363d7ce01d5ce$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$0df363d7ce01d5ce$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$0df363d7ce01d5ce$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $0df363d7ce01d5ce$export$2e2bcd8739ae039 = $0df363d7ce01d5ce$var$AxiosError;

});
parcelRegister("la4ol", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f67df03a03c8e90e$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");

var $aQ0t6 = parcelRequire("aQ0t6");
'use strict';
const $f67df03a03c8e90e$var$$internals = Symbol('internals');
const $f67df03a03c8e90e$var$INVALID_HEADER_VALUE_CHARS_RE = /[^\x09\x20-\x7E\x80-\xFF]/g;
function $f67df03a03c8e90e$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
function $f67df03a03c8e90e$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $f67df03a03c8e90e$var$sanitizeHeaderValue(str) {
    return $f67df03a03c8e90e$var$trimSPorHTAB(str.replace($f67df03a03c8e90e$var$INVALID_HEADER_VALUE_CHARS_RE, ''));
}
function $f67df03a03c8e90e$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $i7QDB.default).isArray(value) ? value.map($f67df03a03c8e90e$var$normalizeValue) : $f67df03a03c8e90e$var$sanitizeHeaderValue(String(value));
}
function $f67df03a03c8e90e$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $f67df03a03c8e90e$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $f67df03a03c8e90e$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $i7QDB.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $i7QDB.default).isString(value)) return;
    if ((0, $i7QDB.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $i7QDB.default).isRegExp(filter)) return filter.test(value);
}
function $f67df03a03c8e90e$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $f67df03a03c8e90e$var$buildAccessors(obj, header) {
    const accessorName = (0, $i7QDB.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $f67df03a03c8e90e$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $f67df03a03c8e90e$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $i7QDB.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $f67df03a03c8e90e$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $i7QDB.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $i7QDB.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $i7QDB.default).isString(header) && (header = header.trim()) && !$f67df03a03c8e90e$var$isValidHeaderName(header)) setHeaders((0, $aQ0t6.default)(header), valueOrRewrite);
        else if ((0, $i7QDB.default).isObject(header) && (0, $i7QDB.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $i7QDB.default).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $i7QDB.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $f67df03a03c8e90e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $i7QDB.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $f67df03a03c8e90e$var$parseTokens(value);
                if ((0, $i7QDB.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $i7QDB.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $f67df03a03c8e90e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $i7QDB.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $f67df03a03c8e90e$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $f67df03a03c8e90e$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $i7QDB.default).findKey(self, _header);
                if (key && (!matcher || $f67df03a03c8e90e$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $i7QDB.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $f67df03a03c8e90e$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $i7QDB.default).forEach(this, (value, header)=>{
            const key = (0, $i7QDB.default).findKey(headers, header);
            if (key) {
                self[key] = $f67df03a03c8e90e$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $f67df03a03c8e90e$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $f67df03a03c8e90e$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $i7QDB.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $i7QDB.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$f67df03a03c8e90e$var$$internals] = this[$f67df03a03c8e90e$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $f67df03a03c8e90e$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $f67df03a03c8e90e$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $i7QDB.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$f67df03a03c8e90e$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $i7QDB.default).reduceDescriptors($f67df03a03c8e90e$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $i7QDB.default).freezeMethods($f67df03a03c8e90e$var$AxiosHeaders);
var $f67df03a03c8e90e$export$2e2bcd8739ae039 = $f67df03a03c8e90e$var$AxiosHeaders;

});
parcelRegister("aQ0t6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7e3f1fb6d8d1f12c$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $7e3f1fb6d8d1f12c$var$ignoreDuplicateOf = (0, $i7QDB.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $7e3f1fb6d8d1f12c$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $7e3f1fb6d8d1f12c$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("a1DcV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $74c8692fc6c224f0$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $74c8692fc6c224f0$export$2e2bcd8739ae039 = null;

});




parcelRegister("96b7F", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $69fd4d4f8d6a1681$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");
'use strict';
class $69fd4d4f8d6a1681$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $i7QDB.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $69fd4d4f8d6a1681$export$2e2bcd8739ae039 = $69fd4d4f8d6a1681$var$InterceptorManager;

});

parcelRegister("2xWoV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1dabf714aa57d401$export$2e2bcd8739ae039; });

var $j5QLD = parcelRequire("j5QLD");

var $blpvm = parcelRequire("blpvm");

var $gzVYL = parcelRequire("gzVYL");

var $gblb4 = parcelRequire("gblb4");

var $la4ol = parcelRequire("la4ol");

var $hwyJs = parcelRequire("hwyJs");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $1dabf714aa57d401$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $gblb4.default)(null, config);
}
function $1dabf714aa57d401$export$2e2bcd8739ae039(config) {
    $1dabf714aa57d401$var$throwIfCancellationRequested(config);
    config.headers = (0, $la4ol.default).from(config.headers);
    // Transform request data
    config.data = (0, $j5QLD.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $hwyJs.default).getAdapter(config.adapter || (0, $gzVYL.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $1dabf714aa57d401$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $j5QLD.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $la4ol.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $blpvm.default)(reason)) {
            $1dabf714aa57d401$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $j5QLD.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $la4ol.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("j5QLD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $de676a6bdfaf183d$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");

var $gzVYL = parcelRequire("gzVYL");

var $la4ol = parcelRequire("la4ol");
'use strict';
function $de676a6bdfaf183d$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $gzVYL.default);
    const context = response || config;
    const headers = (0, $la4ol.default).from(context.headers);
    let data = context.data;
    (0, $i7QDB.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("gzVYL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c11ce3a27a09138a$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");

var $1cg5p = parcelRequire("1cg5p");

var $3GMSK = parcelRequire("3GMSK");

var $hFp7I = parcelRequire("hFp7I");

var $smWuh = parcelRequire("smWuh");

var $c8RVj = parcelRequire("c8RVj");

var $aaHKr = parcelRequire("aaHKr");
'use strict';
const $c11ce3a27a09138a$var$own = (obj, key)=>obj != null && (0, $i7QDB.default).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $c11ce3a27a09138a$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $i7QDB.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $i7QDB.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $c11ce3a27a09138a$var$defaults = {
    transitional: (0, $3GMSK.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $i7QDB.default).isObject(data);
            if (isObjectPayload && (0, $i7QDB.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $i7QDB.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $aaHKr.default)(data)) : data;
            if ((0, $i7QDB.default).isArrayBuffer(data) || (0, $i7QDB.default).isBuffer(data) || (0, $i7QDB.default).isStream(data) || (0, $i7QDB.default).isFile(data) || (0, $i7QDB.default).isBlob(data) || (0, $i7QDB.default).isReadableStream(data)) return data;
            if ((0, $i7QDB.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $i7QDB.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $c11ce3a27a09138a$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $smWuh.default)(data, formSerializer).toString();
                if ((isFileList = (0, $i7QDB.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $c11ce3a27a09138a$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $hFp7I.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $c11ce3a27a09138a$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $c11ce3a27a09138a$var$own(this, 'transitional') || $c11ce3a27a09138a$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $c11ce3a27a09138a$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $i7QDB.default).isResponse(data) || (0, $i7QDB.default).isReadableStream(data)) return data;
            if (data && (0, $i7QDB.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $c11ce3a27a09138a$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $1cg5p.default).from(e, (0, $1cg5p.default).ERR_BAD_RESPONSE, this, null, $c11ce3a27a09138a$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $c8RVj.default).classes.FormData,
        Blob: (0, $c8RVj.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $i7QDB.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $c11ce3a27a09138a$var$defaults.headers[method] = {};
});
var $c11ce3a27a09138a$export$2e2bcd8739ae039 = $c11ce3a27a09138a$var$defaults;

});
parcelRegister("3GMSK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2afb364fe699a131$export$2e2bcd8739ae039; });
'use strict';
var $2afb364fe699a131$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};

});

parcelRegister("smWuh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $05546982f7463993$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");

var $hFp7I = parcelRequire("hFp7I");

var $c8RVj = parcelRequire("c8RVj");
'use strict';
function $05546982f7463993$export$2e2bcd8739ae039(data, options) {
    return (0, $hFp7I.default)(data, new (0, $c8RVj.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $c8RVj.default).isNode && (0, $i7QDB.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("c8RVj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8d700f743a7cbd3a$export$2e2bcd8739ae039; });

var $7la8Y = parcelRequire("7la8Y");

var $aWq89 = parcelRequire("aWq89");
var $8d700f743a7cbd3a$export$2e2bcd8739ae039 = {
    ...$aWq89,
    ...(0, $7la8Y.default)
};

});
parcelRegister("7la8Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $55825cecf5b1c08e$export$2e2bcd8739ae039; });

var $1wfGk = parcelRequire("1wfGk");

var $kNwL4 = parcelRequire("kNwL4");

var $igbOz = parcelRequire("igbOz");
var $55825cecf5b1c08e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $1wfGk.default,
        FormData: $kNwL4.default,
        Blob: $igbOz.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("1wfGk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $11b4f1aa11eb99be$export$2e2bcd8739ae039; });

var $6F6wt = parcelRequire("6F6wt");
'use strict';
var $11b4f1aa11eb99be$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $6F6wt.default);

});

parcelRegister("kNwL4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f241cb549e9910a7$export$2e2bcd8739ae039; });
'use strict';
var $f241cb549e9910a7$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("igbOz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d4b2e2bd05019734$export$2e2bcd8739ae039; });
'use strict';
var $d4b2e2bd05019734$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("aWq89", function(module, exports) {
$parcel$export(module.exports, "hasBrowserEnv", function () { return $7f739726eb03d59d$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $7f739726eb03d59d$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $7f739726eb03d59d$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $7f739726eb03d59d$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $7f739726eb03d59d$export$f710a83a91838a36; });
const $7f739726eb03d59d$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $7f739726eb03d59d$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $7f739726eb03d59d$export$c0bcc9250309d66 = $7f739726eb03d59d$export$c4996c4b7b93b0bf && (!$7f739726eb03d59d$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($7f739726eb03d59d$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $7f739726eb03d59d$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $7f739726eb03d59d$export$f710a83a91838a36 = $7f739726eb03d59d$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("aaHKr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $767cc6010bf4c2be$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $767cc6010bf4c2be$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $i7QDB.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $767cc6010bf4c2be$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $767cc6010bf4c2be$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $i7QDB.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $i7QDB.default).hasOwnProp(target, name)) target[name] = (0, $i7QDB.default).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $i7QDB.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $i7QDB.default).isArray(target[name])) target[name] = $767cc6010bf4c2be$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $i7QDB.default).isFormData(formData) && (0, $i7QDB.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $i7QDB.default).forEachEntry(formData, (name, value)=>{
            buildPath($767cc6010bf4c2be$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $767cc6010bf4c2be$export$2e2bcd8739ae039 = $767cc6010bf4c2be$var$formDataToJSON;

});



parcelRegister("blpvm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8425709d751aa90b$export$2e2bcd8739ae039; });
'use strict';
function $8425709d751aa90b$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("gblb4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bc7e19d4cefba141$export$2e2bcd8739ae039; });

var $1cg5p = parcelRequire("1cg5p");
'use strict';
class $bc7e19d4cefba141$var$CanceledError extends (0, $1cg5p.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $1cg5p.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $bc7e19d4cefba141$export$2e2bcd8739ae039 = $bc7e19d4cefba141$var$CanceledError;

});

parcelRegister("hwyJs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cc205de5b5066442$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");

var $a1DcV = parcelRequire("a1DcV");

var $kPGBN = parcelRequire("kPGBN");

var $lhynA = parcelRequire("lhynA");

var $1cg5p = parcelRequire("1cg5p");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $cc205de5b5066442$var$knownAdapters = {
    http: (0, $a1DcV.default),
    xhr: (0, $kPGBN.default),
    fetch: {
        get: $lhynA.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $i7QDB.default).forEach($cc205de5b5066442$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $cc205de5b5066442$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $cc205de5b5066442$var$isResolvedHandle = (adapter)=>(0, $i7QDB.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $cc205de5b5066442$var$getAdapter(adapters, config) {
    adapters = (0, $i7QDB.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$cc205de5b5066442$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $cc205de5b5066442$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $1cg5p.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $i7QDB.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($cc205de5b5066442$var$renderReason).join('\n') : ' ' + $cc205de5b5066442$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $1cg5p.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $cc205de5b5066442$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $cc205de5b5066442$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $cc205de5b5066442$var$knownAdapters
};

});
parcelRegister("kPGBN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2a99f416eaa92c5$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");

var $9kC7J = parcelRequire("9kC7J");

var $3GMSK = parcelRequire("3GMSK");

var $1cg5p = parcelRequire("1cg5p");

var $gblb4 = parcelRequire("gblb4");

var $6SKHx = parcelRequire("6SKHx");

var $c8RVj = parcelRequire("c8RVj");

var $la4ol = parcelRequire("la4ol");

var $3Er8S = parcelRequire("3Er8S");

var $9yw1y = parcelRequire("9yw1y");
const $f2a99f416eaa92c5$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $f2a99f416eaa92c5$export$2e2bcd8739ae039 = $f2a99f416eaa92c5$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $9yw1y.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $la4ol.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $la4ol.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $9kC7J.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $1cg5p.default)('Request aborted', (0, $1cg5p.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $1cg5p.default)(msg, (0, $1cg5p.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $3GMSK.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $1cg5p.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $1cg5p.default).ETIMEDOUT : (0, $1cg5p.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $i7QDB.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $i7QDB.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $3Er8S.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $3Er8S.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $gblb4.default)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $6SKHx.default)(_config.url);
        if (protocol && !(0, $c8RVj.default).protocols.includes(protocol)) {
            reject(new (0, $1cg5p.default)('Unsupported protocol ' + protocol + ':', (0, $1cg5p.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("9kC7J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6cb38de6bff46641$export$2e2bcd8739ae039; });

var $1cg5p = parcelRequire("1cg5p");
'use strict';
function $6cb38de6bff46641$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $1cg5p.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $1cg5p.default).ERR_BAD_REQUEST : (0, $1cg5p.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

});

parcelRegister("6SKHx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $502c03176e8ec3bf$export$2e2bcd8739ae039; });
'use strict';
function $502c03176e8ec3bf$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("3Er8S", function(module, exports) {
$parcel$export(module.exports, "progressEventReducer", function () { return $2a8a296155c08b01$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $2a8a296155c08b01$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $2a8a296155c08b01$export$5d35863c355a22a9; });

var $bfrVM = parcelRequire("bfrVM");

var $43lHy = parcelRequire("43lHy");

var $i7QDB = parcelRequire("i7QDB");
const $2a8a296155c08b01$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $bfrVM.default)(50, 250);
    return (0, $43lHy.default)((e)=>{
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $2a8a296155c08b01$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $2a8a296155c08b01$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $i7QDB.default).asap(()=>fn(...args));

});
parcelRegister("bfrVM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8306c2e77fbd9ca4$export$2e2bcd8739ae039; });
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $8306c2e77fbd9ca4$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $8306c2e77fbd9ca4$export$2e2bcd8739ae039 = $8306c2e77fbd9ca4$var$speedometer;

});

parcelRegister("43lHy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2f3846b452d80828$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $2f3846b452d80828$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $2f3846b452d80828$export$2e2bcd8739ae039 = $2f3846b452d80828$var$throttle;

});


parcelRegister("9yw1y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6f50215bba184873$export$2e2bcd8739ae039; });

var $c8RVj = parcelRequire("c8RVj");

var $i7QDB = parcelRequire("i7QDB");

var $imoko = parcelRequire("imoko");

var $jW9Bl = parcelRequire("jW9Bl");

var $jPrPz = parcelRequire("jPrPz");

var $34wiJ = parcelRequire("34wiJ");

var $la4ol = parcelRequire("la4ol");

var $hfvLv = parcelRequire("hfvLv");
const $6f50215bba184873$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $6f50215bba184873$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders).forEach(([key, val])=>{
        if ($6f50215bba184873$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $6f50215bba184873$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
var $6f50215bba184873$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $34wiJ.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $i7QDB.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $la4ol.default).from(headers);
    newConfig.url = (0, $hfvLv.default)((0, $jPrPz.default)(baseURL, url, allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? $6f50215bba184873$var$encodeUTF8(auth.password) : '')));
    if ((0, $i7QDB.default).isFormData(data)) {
        if ((0, $c8RVj.default).hasStandardBrowserEnv || (0, $c8RVj.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $i7QDB.default).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $6f50215bba184873$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $c8RVj.default).hasStandardBrowserEnv) {
        if ((0, $i7QDB.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $imoko.default)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $jW9Bl.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("imoko", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d5dd27175a5438e8$export$2e2bcd8739ae039; });

var $c8RVj = parcelRequire("c8RVj");
var $d5dd27175a5438e8$export$2e2bcd8739ae039 = (0, $c8RVj.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $c8RVj.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $c8RVj.default).origin), (0, $c8RVj.default).navigator && /(msie|trident)/i.test((0, $c8RVj.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("jW9Bl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e83ae1b409b3150b$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");

var $c8RVj = parcelRequire("c8RVj");
var $e83ae1b409b3150b$export$2e2bcd8739ae039 = (0, $c8RVj.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $i7QDB.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $i7QDB.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $i7QDB.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $i7QDB.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return decodeURIComponent(cookie.slice(eq + 1));
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("jPrPz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e6f85e5dd21962c5$export$2e2bcd8739ae039; });

var $sBw0H = parcelRequire("sBw0H");

var $h5ZSF = parcelRequire("h5ZSF");
'use strict';
function $e6f85e5dd21962c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $sBw0H.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) return (0, $h5ZSF.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("sBw0H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $055fb7655bca2a9e$export$2e2bcd8739ae039; });
'use strict';
function $055fb7655bca2a9e$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("h5ZSF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c722e78a0fc9b983$export$2e2bcd8739ae039; });
'use strict';
function $c722e78a0fc9b983$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("34wiJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $23cacd21d9359a5a$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");

var $la4ol = parcelRequire("la4ol");
'use strict';
const $23cacd21d9359a5a$var$headersToObject = (thing)=>thing instanceof (0, $la4ol.default) ? {
        ...thing
    } : thing;
function $23cacd21d9359a5a$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $i7QDB.default).isPlainObject(target) && (0, $i7QDB.default).isPlainObject(source)) return (0, $i7QDB.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $i7QDB.default).isPlainObject(source)) return (0, $i7QDB.default).merge({}, source);
        else if ((0, $i7QDB.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $i7QDB.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $i7QDB.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $i7QDB.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $i7QDB.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $i7QDB.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $i7QDB.default).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $i7QDB.default).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($23cacd21d9359a5a$var$headersToObject(a), $23cacd21d9359a5a$var$headersToObject(b), prop, true)
    };
    (0, $i7QDB.default).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $i7QDB.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $i7QDB.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $i7QDB.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $i7QDB.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("lhynA", function(module, exports) {
$parcel$export(module.exports, "getFetch", function () { return $f7e5da8c6b42a22f$export$3105c6651375d4fa; });

var $c8RVj = parcelRequire("c8RVj");

var $i7QDB = parcelRequire("i7QDB");

var $1cg5p = parcelRequire("1cg5p");

var $aQOOl = parcelRequire("aQOOl");

var $dLcgm = parcelRequire("dLcgm");

var $la4ol = parcelRequire("la4ol");

var $3Er8S = parcelRequire("3Er8S");

var $9yw1y = parcelRequire("9yw1y");

var $9kC7J = parcelRequire("9kC7J");

var $5BlAL = parcelRequire("5BlAL");

var $2oCy9 = parcelRequire("2oCy9");
const $f7e5da8c6b42a22f$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $f7e5da8c6b42a22f$var$isFunction } = (0, $i7QDB.default);
const $f7e5da8c6b42a22f$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $f7e5da8c6b42a22f$var$factory = (env)=>{
    const globalObject = (0, $i7QDB.default).global ?? globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $i7QDB.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $f7e5da8c6b42a22f$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $f7e5da8c6b42a22f$var$isFunction(Request);
    const isResponseSupported = $f7e5da8c6b42a22f$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $f7e5da8c6b42a22f$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $f7e5da8c6b42a22f$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $c8RVj.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $f7e5da8c6b42a22f$var$test(()=>(0, $i7QDB.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $1cg5p.default)(`Response type '${type}' is not supported`, (0, $1cg5p.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $i7QDB.default).isBlob(body)) return body.size;
        if ((0, $i7QDB.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $c8RVj.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $i7QDB.default).isArrayBufferView(body) || (0, $i7QDB.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $i7QDB.default).isURLSearchParams(body)) body = body + '';
        if ((0, $i7QDB.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $i7QDB.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $9yw1y.default)(config);
        const hasMaxContentLength = (0, $i7QDB.default).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $i7QDB.default).isNumber(maxBodyLength) && maxBodyLength > -1;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $aQOOl.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $5BlAL.default)(url);
                if (estimated > maxContentLength) throw new (0, $1cg5p.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $1cg5p.default).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against the outbound request body before dispatch.
            // Mirrors http.js behavior (ERR_BAD_REQUEST / 'Request body larger than
            // maxBodyLength limit'). Skip when the body length cannot be determined
            // (e.g. a live ReadableStream supplied by the caller).
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await resolveBodyLength(headers, data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength) && outboundLength > maxBodyLength) throw new (0, $1cg5p.default)('Request body larger than maxBodyLength limit', (0, $1cg5p.default).ERR_BAD_REQUEST, config, request);
            }
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $i7QDB.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $3Er8S.progressEventDecorator)(requestContentLength, (0, $3Er8S.progressEventReducer)((0, $3Er8S.asyncDecorator)(onUploadProgress)));
                    data = (0, $dLcgm.trackStream)(_request.body, $f7e5da8c6b42a22f$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $i7QDB.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $i7QDB.default).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $2oCy9.VERSION), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $i7QDB.default).toFiniteNumber(response.headers.get('content-length'));
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $1cg5p.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $1cg5p.default).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $i7QDB.default).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $3Er8S.progressEventDecorator)(responseContentLength, (0, $3Er8S.progressEventReducer)((0, $3Er8S.asyncDecorator)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $1cg5p.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $1cg5p.default).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $dLcgm.trackStream)(response.body, $f7e5da8c6b42a22f$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $i7QDB.default).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $1cg5p.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $1cg5p.default).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $9kC7J.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $la4ol.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $1cg5p.default)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                err !== canceledError && (canceledError.cause = err);
                throw canceledError;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $1cg5p.default)('Network Error', (0, $1cg5p.default).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $1cg5p.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $f7e5da8c6b42a22f$var$seedCache = new Map();
const $f7e5da8c6b42a22f$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $f7e5da8c6b42a22f$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $f7e5da8c6b42a22f$var$factory(env));
        map = target;
    }
    return target;
};
const $f7e5da8c6b42a22f$var$adapter = $f7e5da8c6b42a22f$export$3105c6651375d4fa();
var $f7e5da8c6b42a22f$export$2e2bcd8739ae039 = $f7e5da8c6b42a22f$var$adapter;

});
parcelRegister("aQOOl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7e662cbd7b74039a$export$2e2bcd8739ae039; });

var $gblb4 = parcelRequire("gblb4");

var $1cg5p = parcelRequire("1cg5p");

var $i7QDB = parcelRequire("i7QDB");
const $7e662cbd7b74039a$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $1cg5p.default) ? err : new (0, $gblb4.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $1cg5p.default)(`timeout of ${timeout}ms exceeded`, (0, $1cg5p.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $i7QDB.default).asap(unsubscribe);
        return signal;
    }
};
var $7e662cbd7b74039a$export$2e2bcd8739ae039 = $7e662cbd7b74039a$var$composeSignals;

});

parcelRegister("dLcgm", function(module, exports) {
$parcel$export(module.exports, "trackStream", function () { return $a0492d4f8913b6d2$export$b0119225647bd83; });
const $a0492d4f8913b6d2$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $a0492d4f8913b6d2$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $a0492d4f8913b6d2$var$readStream(iterable))yield* $a0492d4f8913b6d2$export$71b051935044bd5d(chunk, chunkSize);
};
const $a0492d4f8913b6d2$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $a0492d4f8913b6d2$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $a0492d4f8913b6d2$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});

parcelRegister("5BlAL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4141282d5c3e42cc$export$2e2bcd8739ae039; });
/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: use UTF-8 byteLength of the encoded body as a safe upper bound.
 *
 * @param {string} url
 * @returns {number}
 */ 
var $567QU = parcelRequire("567QU");
var $4141282d5c3e42cc$require$Buffer = $567QU.Buffer;
function $4141282d5c3e42cc$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = (a >= 48 && a <= 57 || a >= 65 && a <= 70 || a >= 97 && a <= 102) && (b >= 48 && b <= 57 || b >= 65 && b <= 70 || b >= 97 && b <= 102);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    if (typeof $4141282d5c3e42cc$require$Buffer !== 'undefined' && typeof $4141282d5c3e42cc$require$Buffer.byteLength === 'function') return $4141282d5c3e42cc$require$Buffer.byteLength(body, 'utf8');
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Using body.length here would undercount non-ASCII (e.g. '€' is 1 code unit
    // but 3 UTF-8 bytes).
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}

});

parcelRegister("2oCy9", function(module, exports) {
$parcel$export(module.exports, "VERSION", function () { return $1bebb9d47525e27c$export$a4ad2735b021c132; });
const $1bebb9d47525e27c$export$a4ad2735b021c132 = "1.16.0";

});




parcelRegister("aUX8G", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7f2d021d95151bf5$export$2e2bcd8739ae039; });

var $2oCy9 = parcelRequire("2oCy9");

var $1cg5p = parcelRequire("1cg5p");
'use strict';
const $7f2d021d95151bf5$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $7f2d021d95151bf5$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $7f2d021d95151bf5$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $7f2d021d95151bf5$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $2oCy9.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $1cg5p.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $1cg5p.default).ERR_DEPRECATED);
        if (version && !$7f2d021d95151bf5$var$deprecatedWarnings[opt]) {
            $7f2d021d95151bf5$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$7f2d021d95151bf5$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $7f2d021d95151bf5$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $1cg5p.default)('options must be an object', (0, $1cg5p.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $1cg5p.default)('option ' + opt + ' must be ' + result, (0, $1cg5p.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $1cg5p.default)('Unknown option ' + opt, (0, $1cg5p.default).ERR_BAD_OPTION);
    }
}
var $7f2d021d95151bf5$export$2e2bcd8739ae039 = {
    assertOptions: $7f2d021d95151bf5$var$assertOptions,
    validators: $7f2d021d95151bf5$var$validators
};

});


parcelRegister("bDiDT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8781cc3fb9af521f$export$2e2bcd8739ae039; });

var $gblb4 = parcelRequire("gblb4");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $8781cc3fb9af521f$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $gblb4.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $8781cc3fb9af521f$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $8781cc3fb9af521f$export$2e2bcd8739ae039 = $8781cc3fb9af521f$var$CancelToken;

});

parcelRegister("fp4Jy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b36cdcdb34f62c36$export$2e2bcd8739ae039; });
'use strict';
function $b36cdcdb34f62c36$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("bBTya", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $873e3d808b046968$export$2e2bcd8739ae039; });

var $i7QDB = parcelRequire("i7QDB");
'use strict';
function $873e3d808b046968$export$2e2bcd8739ae039(payload) {
    return (0, $i7QDB.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("6JMnu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4e7c78dffd61c62f$export$2e2bcd8739ae039; });
const $4e7c78dffd61c62f$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($4e7c78dffd61c62f$var$HttpStatusCode).forEach(([key, value])=>{
    $4e7c78dffd61c62f$var$HttpStatusCode[value] = key;
});
var $4e7c78dffd61c62f$export$2e2bcd8739ae039 = $4e7c78dffd61c62f$var$HttpStatusCode;

});





parcelRegister("89erU", function(module, exports) {
$parcel$export(module.exports, "Option", function () { return $f00f8e60e73cfd39$export$36d18380658d5d20; });
/* option.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
// link colors matching the link component's anchor styles
const $f00f8e60e73cfd39$var$linkColors = {
    defaultColor: (0, $kbpa7.wacToken)("color.extended.blue700"),
    hoverColor: (0, $kbpa7.wacToken)("color.primary.black"),
    visitedColor: (0, $kbpa7.wacToken)("color.extended.purple800"),
    visitedHoverColor: (0, $kbpa7.wacToken)("color.primary.black")
};
const $f00f8e60e73cfd39$var$linkStyle = null;
const $f00f8e60e73cfd39$export$36d18380658d5d20 = ({ children: children, onClick: onClick, isSelected: isSelected = false, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "option",
        tabIndex: 0,
        onClick: onClick,
        onKeyDown: (e)=>{
            // keyboard navigation for accessibility
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                // create a synthetic mouse event for consistency
                const syntheticEvent = {
                    ...e,
                    currentTarget: e.currentTarget,
                    target: e.target
                };
                onClick(syntheticEvent);
            }
        },
        "aria-selected": isSelected,
        ...props,
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _syazlodj _4bfu1r31 _1hmsglyw _ajmmnqa1 _vwz419ii _1wyb1j6v _ect41pz4 _80omtlke _ca0qftgi _n3tdftgi _f8pj19l6 _30l319l6 _1a3b1r31 _9oik1r31 _4fpr8stv _1bnx8stv _5goinqa1 _jf4cnqa1 _16btglyw _1up4glyw _1ygb1djl _1ah3yh40 _10531e6u _1ien1q9n _n0fx1q9n _1csf1r31 _l4td1r31 _nb418stv _snj98stv _32m2nqa1 _6afsnqa1"
        ]),
        style: {
            "--_ka49s4": (0, $6ZVlx.default)($f00f8e60e73cfd39$var$linkColors.defaultColor),
            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
            "--_hxrey7": (0, $6ZVlx.default)($f00f8e60e73cfd39$var$linkColors.hoverColor),
            "--_2z8vrb": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue600")),
            "--_19vwxf9": (0, $6ZVlx.default)($f00f8e60e73cfd39$var$linkColors.visitedColor),
            "--_1w8orp1": (0, $6ZVlx.default)($f00f8e60e73cfd39$var$linkColors.visitedHoverColor)
        },
        children: children
    });
};

});


parcelRegister("e0MOs", function(module, exports) {
$parcel$export(module.exports, "QuestionField", function () { return $e9b303a7e1bca2e6$export$10bcf938e190348c; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $ff3wF = parcelRequire("ff3wF");
var $igGC3 = parcelRequire("igGC3");

var $P90vo = parcelRequire("P90vo");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");
const $e9b303a7e1bca2e6$export$10bcf938e190348c = (formType, onBlur)=>{
    const intl = (0, $8e22h.default)();
    const yourQuestionErrorMessage = intl.formatMessage({
        id: "productFeatures.yourQuestionErrorMessage",
        defaultMessage: "Please provide a question."
    });
    const yourQuestionHelperMessageSupportEn = formType === "migration-options" ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "enterpriseContactSales.yourQuestionHelper.entIdentifier",
        defaultMessage: "Include details like your SENs, ENs or Cloud URLs you're migrating from."
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "pricingQuotes.yourQuestionHelper.includeDetails.entIdentifier",
        defaultMessage: "Include details like your SENs (SEN-123456), ENs (E-XXX) or if you started a trial."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
        name: "opportunity_Description__c",
        label: intl.formatMessage({
            id: "enterpriseContactSales.yourQuestion",
            defaultMessage: "Your question"
        }) + " *",
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $P90vo.default), {
                        ...fieldProps,
                        onBlur: onBlur
                    }),
                    error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                        children: yourQuestionErrorMessage
                    }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                        children: yourQuestionHelperMessageSupportEn
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $ff3wF.HelperMessage), {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "enterpriseContactSales.yourQuestionHelper.findYourSen.entIdentifier",
                                defaultMessage: "Product admins, see how to <findYourSenLink>find your SEN</findYourSenLink> or how to <findYourEnLink>find your EN</findYourEnLink>.",
                                values: {
                                    ...(0, $kooLp.DEFAULT_VALUES),
                                    findYourSenLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                            text: text,
                                            href: "https://confluence.atlassian.com/support/how-to-find-your-support-entitlement-number-sen-229840018.html",
                                            type: "inline"
                                        }),
                                    findYourEnLink: (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                            text: text,
                                            href: "https://support.atlassian.com/subscriptions-and-billing/docs/understand-the-improved-atlassian-billing-experience/#What-are-the-key-differences",
                                            type: "inline"
                                        })
                                }
                            }),
                            " "
                        ]
                    })
                ]
            })
    });
};

});
parcelRegister("P90vo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $099bc02ae921c0e0$export$2e2bcd8739ae039; });

var $hv2Li = parcelRequire("hv2Li");

var $ejRNM = parcelRequire("ejRNM");

var $7G1Lw = parcelRequire("7G1Lw");

var $7Xg7V = parcelRequire("7Xg7V");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $gJJny = parcelRequire("gJJny");

var $iwDeu = parcelRequire("iwDeu");

var $9z3tX = parcelRequire("9z3tX");

var $5mZMz = parcelRequire("5mZMz");
var $099bc02ae921c0e0$var$_excluded = [
    "resize",
    "appearance",
    "isCompact",
    "isRequired",
    "isReadOnly",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "minimumRows",
    "theme",
    "testId",
    "maxHeight",
    "onBlur",
    "onFocus",
    "onChange",
    "tokens",
    "value"
];
function $099bc02ae921c0e0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $099bc02ae921c0e0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $099bc02ae921c0e0$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $7G1Lw.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $099bc02ae921c0e0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $099bc02ae921c0e0$var$packageName = "@atlaskit/textarea";
var $099bc02ae921c0e0$var$packageVersion = "4.7.7";
var $099bc02ae921c0e0$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $099bc02ae921c0e0$var$packageName,
    packageVersion: $099bc02ae921c0e0$var$packageVersion
};
var $099bc02ae921c0e0$var$setSmartHeight = function setSmartHeight(el) {
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    var borderHeight = (0, $9z3tX.borderWidth);
    var paddingBoxHeight = el.scrollHeight;
    var borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = "".concat(borderBoxHeight, "px");
};
var $099bc02ae921c0e0$var$TextAreaWithTokens = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var ourRef = (0, $1oC0p.useRef)(null);
    var _props$resize = props.resize, resize = _props$resize === void 0 ? 'smart' : _props$resize, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'standard' : _props$appearance, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$minimumRows = props.minimumRows, minimumRows = _props$minimumRows === void 0 ? 2 : _props$minimumRows, theme = props.theme, testId = props.testId, _props$maxHeight = props.maxHeight, maxHeight = _props$maxHeight === void 0 ? '50vh' : _props$maxHeight, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange, tokens = props.tokens, value = props.value, rest = (0, $7Xg7V.default)(props, $099bc02ae921c0e0$var$_excluded);
    (0, $1oC0p.useEffect)(function() {
        var el = ourRef.current;
        if (resize === 'smart' && el) $099bc02ae921c0e0$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    var onBlurWithAnalytics = (0, $gJJny.usePlatformLeafEventHandler)($099bc02ae921c0e0$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: 'blurred'
    }, $099bc02ae921c0e0$var$analyticsParams));
    var onFocusWithAnalytics = (0, $gJJny.usePlatformLeafEventHandler)($099bc02ae921c0e0$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: 'focused'
    }, $099bc02ae921c0e0$var$analyticsParams));
    var getTextAreaRef = function getTextAreaRef(elementRef) {
        ourRef.current = elementRef;
        if (ref && (0, $ejRNM.default)(ref) === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    var handleOnChange = (0, $1oC0p.useCallback)(function(e) {
        var el = ourRef.current;
        if (resize === 'smart' && el) $099bc02ae921c0e0$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    var controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    var baseStyles = (0, $1oC0p.useMemo)(function() {
        return (0, $9z3tX.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        });
    }, [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    var textAreaStyles = (0, $3dJ4i.css)([
        baseStyles,
        // not memoizing themeStyles as `tokens` is an unstable reference
        (0, $9z3tX.themeStyles)(tokens, appearance)
    ]);
    return (0, $3dJ4i.jsx)("textarea", (0, $hv2Li.default)({}, controlProps, {
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        css: textAreaStyles
    }, rest));
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ var $099bc02ae921c0e0$var$TextArea = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function TextArea(props, ref) {
    var _useGlobalTheme = (0, $iwDeu.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)((0, $5mZMz.Theme).Provider, {
        value: props.theme
    }, (0, $3dJ4i.jsx)((0, $5mZMz.Theme).Consumer, {
        appearance: props.appearance || 'standard',
        mode: mode
    }, function(tokens) {
        return (0, $3dJ4i.jsx)($099bc02ae921c0e0$var$TextAreaWithTokens, (0, $hv2Li.default)({
            ref: ref
        }, props, {
            tokens: tokens
        }));
    }));
}));
$099bc02ae921c0e0$var$TextArea.displayName = 'TextArea';
var $099bc02ae921c0e0$export$2e2bcd8739ae039 = $099bc02ae921c0e0$var$TextArea;

});
parcelRegister("hv2Li", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cbd7795a08f8dbef$export$2e2bcd8739ae039; });
function $cbd7795a08f8dbef$export$2e2bcd8739ae039() {
    return $cbd7795a08f8dbef$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cbd7795a08f8dbef$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("ejRNM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a6cc92f3db491900$export$2e2bcd8739ae039; });
function $a6cc92f3db491900$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a6cc92f3db491900$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a6cc92f3db491900$export$2e2bcd8739ae039(o);
}

});

parcelRegister("7G1Lw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $596dd33949a30c27$export$2e2bcd8739ae039; });

var $hWhHL = parcelRequire("hWhHL");
function $596dd33949a30c27$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $hWhHL.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("hWhHL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d0f596409a46a65c$export$2e2bcd8739ae039; });

var $ejRNM = parcelRequire("ejRNM");

var $aIy5Y = parcelRequire("aIy5Y");
function $d0f596409a46a65c$export$2e2bcd8739ae039(t) {
    var i = (0, $aIy5Y.default)(t, "string");
    return "symbol" == (0, $ejRNM.default)(i) ? i : i + "";
}

});
parcelRegister("aIy5Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7cd8760d7ae9782c$export$2e2bcd8739ae039; });

var $ejRNM = parcelRequire("ejRNM");
function $7cd8760d7ae9782c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ejRNM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ejRNM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("7Xg7V", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $017e9f2f9d5f7001$export$2e2bcd8739ae039; });

var $aaQET = parcelRequire("aaQET");
function $017e9f2f9d5f7001$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $aaQET.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("aaQET", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7683af74f22c6265$export$2e2bcd8739ae039; });
function $7683af74f22c6265$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("iwDeu", function(module, exports) {
$parcel$export(module.exports, "useGlobalTheme", function () { return $d7c9a5efdc180e8a$export$7692396083754928; });

var $3Yt1l = parcelRequire("3Yt1l");
// Create default global light theme
var $d7c9a5efdc180e8a$var$_createTheme = (0, $3Yt1l.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $d7c9a5efdc180e8a$var$Provider = $d7c9a5efdc180e8a$var$_createTheme.Provider, $d7c9a5efdc180e8a$var$Consumer = $d7c9a5efdc180e8a$var$_createTheme.Consumer, $d7c9a5efdc180e8a$export$7692396083754928 = $d7c9a5efdc180e8a$var$_createTheme.useTheme;
var $d7c9a5efdc180e8a$export$2e2bcd8739ae039 = {
    Provider: $d7c9a5efdc180e8a$var$Provider,
    Consumer: $d7c9a5efdc180e8a$var$Consumer
};

});
parcelRegister("3Yt1l", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $2e4d7c938ddd5f88$export$25d302a5b900a763; });

var $7Xg7V = parcelRequire("7Xg7V");

var $1oC0p = parcelRequire("1oC0p");
var $2e4d7c938ddd5f88$var$_excluded = [
    "children"
];
function $2e4d7c938ddd5f88$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $7Xg7V.default)(props, $2e4d7c938ddd5f88$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("9z3tX", function(module, exports) {
$parcel$export(module.exports, "borderWidth", function () { return $6f6a157085e66399$export$12879c7697ed953d; });
$parcel$export(module.exports, "getBaseStyles", function () { return $6f6a157085e66399$export$bff8031d86bb089; });
$parcel$export(module.exports, "themeStyles", function () { return $6f6a157085e66399$export$ded1c27b355b104; });

var $7G1Lw = parcelRequire("7G1Lw");

var $3dJ4i = parcelRequire("3dJ4i");

var $23wuT = parcelRequire("23wuT");

var $ieBMP = parcelRequire("ieBMP");
function $6f6a157085e66399$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6f6a157085e66399$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6f6a157085e66399$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $7G1Lw.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6f6a157085e66399$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $6f6a157085e66399$var$grid = (0, $ieBMP.gridSize)();
var $6f6a157085e66399$var$lineHeightBase = $6f6a157085e66399$var$grid * 2.5;
var $6f6a157085e66399$var$lineHeightCompact = $6f6a157085e66399$var$grid * 2;
var $6f6a157085e66399$var$compactVerticalPadding = 2;
var $6f6a157085e66399$var$verticalPadding = 6;
var $6f6a157085e66399$var$horizontalPadding = $6f6a157085e66399$var$grid;
var $6f6a157085e66399$var$transitionDuration = '0.2s';
var $6f6a157085e66399$var$fontSize = (0, $ieBMP.fontSize)();
var $6f6a157085e66399$var$fontFamily = (0, $ieBMP.fontFamily)();
var $6f6a157085e66399$var$codeFontFamily = (0, $ieBMP.codeFontFamily)();
var $6f6a157085e66399$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
var $6f6a157085e66399$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
var $6f6a157085e66399$var$borderBoxMinHeight = function borderBoxMinHeight(minimumRows, borderHeight) {
    var contentHeight = $6f6a157085e66399$var$lineHeightBase * minimumRows;
    return contentHeight + $6f6a157085e66399$var$verticalPadding * 2 + borderHeight * 2;
};
var $6f6a157085e66399$var$borderBoxMinHeightCompact = function borderBoxMinHeightCompact(minimumRows, borderHeight) {
    var contentHeightCompact = $6f6a157085e66399$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $6f6a157085e66399$var$compactVerticalPadding * 2 + borderHeight * 2;
};
var $6f6a157085e66399$var$bgAndBorderColorStyles = function bgAndBorderColorStyles(props, appearance) {
    return (0, $3dJ4i.css)($6f6a157085e66399$var$_objectSpread({
        '&:focus': {
            backgroundColor: props.backgroundColorFocus,
            borderColor: props.borderColorFocus,
            boxShadow: (0, $23wuT.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", props.borderColorFocus) : undefined
        },
        '&:not(:focus)': {
            backgroundColor: props.backgroundColor,
            borderColor: props.borderColor
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '&[data-invalid]:focus': {
            backgroundColor: props.invalidRules.backgroundColorFocus,
            borderColor: props.invalidRules.borderColorFocus,
            boxShadow: (0, $23wuT.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", props.invalidRules.borderColorFocus) : undefined
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '&[data-invalid]:not(:focus)': {
            backgroundColor: props.invalidRules.backgroundColor,
            borderColor: props.invalidRules.borderColor,
            boxShadow: (0, $23wuT.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", props.invalidRules.borderColor) : undefined
        }
    }, appearance === 'standard' ? {
        '&:disabled:focus': {
            backgroundColor: props.disabledRules.backgroundColorFocus,
            borderColor: props.disabledRules.borderColorFocus
        },
        '&:disabled:not(:focus)': {
            backgroundColor: props.disabledRules.backgroundColor,
            borderColor: props.disabledRules.borderColor
        }
    } : {}));
};
var $6f6a157085e66399$var$placeholderStyle = function placeholderStyle(placeholderTextColor) {
    return (0, $3dJ4i.css)({
        '&::placeholder': {
            color: placeholderTextColor
        }
    });
};
var $6f6a157085e66399$var$hoverBackgroundAndBorderStyles = function hoverBackgroundAndBorderStyles(props) {
    return (0, $3dJ4i.css)({
        '&:hover:not(:read-only):not(:focus)': {
            backgroundColor: props.backgroundColorHover,
            borderColor: props.borderColorHover,
            '&:disabled': {
                backgroundColor: props.disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
            '&[data-invalid]': {
                backgroundColor: props.invalidRules.backgroundColorHover,
                borderColor: props.invalidRules.borderColor,
                boxShadow: (0, $23wuT.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", props.invalidRules.borderColor) : undefined
            }
        }
    });
};
var $6f6a157085e66399$var$resizeStyle = function resizeStyle(resize) {
    if (resize === 'horizontal' || resize === 'vertical') return (0, $3dJ4i.css)({
        resize: resize
    });
    if (resize === 'auto') return (0, $3dJ4i.css)({
        resize: 'both'
    });
    return (0, $3dJ4i.css)({
        resize: 'none'
    });
};
var $6f6a157085e66399$var$borderStyle = function borderStyle(appearance) {
    return (0, $3dJ4i.css)({
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
};
var $6f6a157085e66399$var$fontFamilyStyle = function fontFamilyStyle(isMonospaced) {
    return (0, $3dJ4i.css)({
        fontFamily: isMonospaced ? $6f6a157085e66399$var$codeFontFamily : $6f6a157085e66399$var$fontFamily
    });
};
var $6f6a157085e66399$var$borderPaddingAndHeightStyles = function borderPaddingAndHeightStyles() {
    var minimumRows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var appearance = arguments.length > 1 ? arguments[1] : undefined;
    var borderWidth = (0, $23wuT.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') && appearance !== 'none' ? 1 : 2;
    var horizontalPaddingWithoutBorderWidth = $6f6a157085e66399$var$horizontalPadding - borderWidth;
    var borderHeight = borderWidth;
    return (0, $3dJ4i.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '&[data-compact]': {
            minHeight: $6f6a157085e66399$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            padding: "".concat($6f6a157085e66399$var$compactVerticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            lineHeight: $6f6a157085e66399$var$lineHeightCompact / $6f6a157085e66399$var$fontSize
        },
        '&:not([data-compact])': {
            minHeight: $6f6a157085e66399$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            padding: "".concat($6f6a157085e66399$var$verticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            lineHeight: $6f6a157085e66399$var$lineHeightBase / $6f6a157085e66399$var$fontSize
        }
    });
};
var $6f6a157085e66399$var$staticStyles = (0, $3dJ4i.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: (0, $23wuT.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? 1 : $6f6a157085e66399$export$12879c7697ed953d,
    fontSize: $6f6a157085e66399$var$fontSize,
    outline: 'none',
    overflow: 'auto',
    transition: "background-color ".concat($6f6a157085e66399$var$transitionDuration, " ease-in-out,\n               border-color ").concat($6f6a157085e66399$var$transitionDuration, " ease-in-out"),
    wordWrap: 'break-word',
    '&:disabled': $6f6a157085e66399$var$_objectSpread({
        cursor: 'not-allowed'
    }, $6f6a157085e66399$var$overrideSafariDisabledStyles),
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
var $6f6a157085e66399$export$bff8031d86bb089 = function getBaseStyles(_ref) {
    var minimumRows = _ref.minimumRows, resize = _ref.resize, appearance = _ref.appearance, isMonospaced = _ref.isMonospaced, maxHeight = _ref.maxHeight;
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $3dJ4i.css)([
        $6f6a157085e66399$var$staticStyles,
        $6f6a157085e66399$var$borderPaddingAndHeightStyles(minimumRows, appearance),
        $6f6a157085e66399$var$resizeStyle(resize),
        $6f6a157085e66399$var$borderStyle(appearance),
        $6f6a157085e66399$var$fontFamilyStyle(isMonospaced),
        {
            maxHeight: maxHeight
        }
    ]));
};
var $6f6a157085e66399$export$ded1c27b355b104 = function themeStyles(props, appearance) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $3dJ4i.css)([
        $6f6a157085e66399$var$bgAndBorderColorStyles(props, appearance),
        $6f6a157085e66399$var$hoverBackgroundAndBorderStyles(props),
        $6f6a157085e66399$var$placeholderStyle(props.placeholderTextColor),
        {
            color: props.textColor,
            '&:disabled': {
                color: props.disabledRules.textColor
            }
        }
    ]));
};

});
parcelRegister("23wuT", function(module, exports) {
$parcel$export(module.exports, "getBooleanFF", function () { return $17f511e41a1a8a75$export$470e5c2be1411c89; });

var $lsUlb = parcelRequire("lsUlb");
function $17f511e41a1a8a75$export$ba05d765b8392e5e(flagResolver) {
    (0, $lsUlb.setBooleanResolver)(flagResolver);
}
function $17f511e41a1a8a75$export$470e5c2be1411c89(name) {
    return (0, $lsUlb.resolveBooleanFlag)(name);
}

});
parcelRegister("lsUlb", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $fa07ea90a3c23f99$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $fa07ea90a3c23f99$export$6333b6aff9fc6275; });

var $ku7kS = parcelRequire("ku7kS");

var $7t0tI = parcelRequire("7t0tI");
var $fa07ea90a3c23f99$var$pkgName = '@atlaskit/platform-feature-flags';
var $fa07ea90a3c23f99$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $fa07ea90a3c23f99$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $fa07ea90a3c23f99$var$ENV_ENABLE_PLATFORM_FF = $fa07ea90a3c23f99$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $fa07ea90a3c23f99$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $fa07ea90a3c23f99$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $fa07ea90a3c23f99$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $fa07ea90a3c23f99$var$ENV_ENABLE_PLATFORM_FF || $fa07ea90a3c23f99$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $fa07ea90a3c23f99$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $fa07ea90a3c23f99$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$fa07ea90a3c23f99$var$globalVar[$fa07ea90a3c23f99$export$7e41b1b2bdee3f98] = $fa07ea90a3c23f99$var$globalVar[$fa07ea90a3c23f99$export$7e41b1b2bdee3f98] || $fa07ea90a3c23f99$var$DEFAULT_PFF_GLOBAL;
function $fa07ea90a3c23f99$export$f2b591175b3e424c(resolver) {
    $fa07ea90a3c23f99$var$globalVar[$fa07ea90a3c23f99$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $fa07ea90a3c23f99$export$6333b6aff9fc6275(flagKey) {
    if ($fa07ea90a3c23f99$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $ku7kS.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $fa07ea90a3c23f99$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $fa07ea90a3c23f99$var$globalVar[$fa07ea90a3c23f99$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("ku7kS", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $ee9c4cb0caa61734$export$1c9f709888824e05; });
var $ee9c4cb0caa61734$var$_ref, $ee9c4cb0caa61734$var$_globalThis$process, $ee9c4cb0caa61734$var$_globalThis$process$e, $ee9c4cb0caa61734$var$_globalThis$process2, $ee9c4cb0caa61734$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $ee9c4cb0caa61734$var$TESTS_MODE = ($ee9c4cb0caa61734$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($ee9c4cb0caa61734$var$_globalThis$process = globalThis.process) === null || $ee9c4cb0caa61734$var$_globalThis$process === void 0 ? void 0 : ($ee9c4cb0caa61734$var$_globalThis$process$e = $ee9c4cb0caa61734$var$_globalThis$process.env) === null || $ee9c4cb0caa61734$var$_globalThis$process$e === void 0 ? void 0 : $ee9c4cb0caa61734$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $ee9c4cb0caa61734$var$_ref !== void 0) ? $ee9c4cb0caa61734$var$_ref : false;
var $ee9c4cb0caa61734$var$DEBUG_MODE = !$ee9c4cb0caa61734$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($ee9c4cb0caa61734$var$_globalThis$process2 = globalThis.process) === null || $ee9c4cb0caa61734$var$_globalThis$process2 === void 0 ? void 0 : ($ee9c4cb0caa61734$var$_globalThis$process2$ = $ee9c4cb0caa61734$var$_globalThis$process2.env) === null || $ee9c4cb0caa61734$var$_globalThis$process2$ === void 0 ? void 0 : $ee9c4cb0caa61734$var$_globalThis$process2$.NODE_ENV) !== 'production';
var $ee9c4cb0caa61734$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$ee9c4cb0caa61734$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("ieBMP", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $d466d86798d56656$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $d466d86798d56656$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $d466d86798d56656$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $d466d86798d56656$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $d466d86798d56656$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "fontFamily", function () { return $d466d86798d56656$export$a5975749f0374264; });
$parcel$export(module.exports, "codeFontFamily", function () { return $d466d86798d56656$export$356129969ee49c55; });

var $f0Px1 = parcelRequire("f0Px1");

var $bwjoy = parcelRequire("bwjoy");
var $d466d86798d56656$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $d466d86798d56656$export$c93026a968943f95 = 'light';
var $d466d86798d56656$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $d466d86798d56656$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $d466d86798d56656$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $d466d86798d56656$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $d466d86798d56656$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $d466d86798d56656$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $d466d86798d56656$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $d466d86798d56656$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $bwjoy.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d466d86798d56656$export$6d8204c2cb2e06b8() / 4;
    (0, $f0Px1.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $d466d86798d56656$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $d466d86798d56656$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $d466d86798d56656$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $f0Px1.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $d466d86798d56656$export$ba1d834b86d72a09 = $d466d86798d56656$export$a1b3edb637fb4f35;
var $d466d86798d56656$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $bwjoy.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $bwjoy.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $bwjoy.N30A), ")")
            }
        }
    };
};

});
parcelRegister("f0Px1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aeded43a4f00de30$export$2e2bcd8739ae039; });

var $8MNDa = parcelRequire("8MNDa");

var $7t0tI = parcelRequire("7t0tI");
function $aeded43a4f00de30$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $8MNDa.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $aeded43a4f00de30$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("8MNDa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $66594e1204c86203$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $66594e1204c86203$var$printed = {};
function $66594e1204c86203$export$2e2bcd8739ae039(message) {
    if ($66594e1204c86203$var$printed[message]) return;
    $66594e1204c86203$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("bwjoy", function(module, exports) {
$parcel$export(module.exports, "R400", function () { return $8631ba4be606c8f5$export$2010d0fb4295b346; });
$parcel$export(module.exports, "B100", function () { return $8631ba4be606c8f5$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $8631ba4be606c8f5$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $8631ba4be606c8f5$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $8631ba4be606c8f5$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $8631ba4be606c8f5$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $8631ba4be606c8f5$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $8631ba4be606c8f5$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N70", function () { return $8631ba4be606c8f5$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N100", function () { return $8631ba4be606c8f5$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $8631ba4be606c8f5$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N900", function () { return $8631ba4be606c8f5$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N30A", function () { return $8631ba4be606c8f5$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN600", function () { return $8631ba4be606c8f5$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN200", function () { return $8631ba4be606c8f5$export$bfe21c59123ecf33; });
$parcel$export(module.exports, "DN90", function () { return $8631ba4be606c8f5$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN40", function () { return $8631ba4be606c8f5$export$33ff357f6620b39; });
$parcel$export(module.exports, "DN30", function () { return $8631ba4be606c8f5$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN20", function () { return $8631ba4be606c8f5$export$9776a6e503bdbf76; });
$parcel$export(module.exports, "DN10", function () { return $8631ba4be606c8f5$export$6c813d5160dff5db; });
$parcel$export(module.exports, "skeleton", function () { return $8631ba4be606c8f5$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $6MdiR = parcelRequire("6MdiR");
var $8631ba4be606c8f5$export$4b84fd0e2c617bd = '#FFEBE6';
var $8631ba4be606c8f5$export$b34b069eff244586 = '#FFBDAD';
var $8631ba4be606c8f5$export$be802dd0d8b57f35 = '#FF8F73';
var $8631ba4be606c8f5$export$60847d42f9da92a6 = '#FF7452';
var $8631ba4be606c8f5$export$4a7404f376229999 = '#FF5630';
var $8631ba4be606c8f5$export$2010d0fb4295b346 = '#DE350B';
var $8631ba4be606c8f5$export$2837b5a1a71d5c02 = '#BF2600';
var $8631ba4be606c8f5$export$8d9596b529bbb9cf = '#FFFAE6';
var $8631ba4be606c8f5$export$41060a744ab0b7ae = '#FFF0B3';
var $8631ba4be606c8f5$export$1cc05bbbf340e559 = '#FFE380';
var $8631ba4be606c8f5$export$5aae31392d72caaa = '#FFC400';
var $8631ba4be606c8f5$export$c6930421db9fa514 = '#FFAB00';
var $8631ba4be606c8f5$export$59619663aa6500fb = '#FF991F';
var $8631ba4be606c8f5$export$874739ea9e379ab6 = '#FF8B00';
var $8631ba4be606c8f5$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $8631ba4be606c8f5$export$69a3bf21b9686c2b = '#ABF5D1';
var $8631ba4be606c8f5$export$afbce1382ec95f73 = '#79F2C0';
var $8631ba4be606c8f5$export$747d86715d4175de = '#57D9A3';
var $8631ba4be606c8f5$export$940e1f69e873f202 = '#36B37E';
var $8631ba4be606c8f5$export$a49394138f7b8e85 = '#00875A';
var $8631ba4be606c8f5$export$6fa04827ac68a4fb = '#006644';
var $8631ba4be606c8f5$export$226de0355ed012f8 = '#DEEBFF';
var $8631ba4be606c8f5$export$8c13c2ee36917869 = '#B3D4FF';
var $8631ba4be606c8f5$export$ecfc1dff386a3e7a = '#4C9AFF';
var $8631ba4be606c8f5$export$215b7063051591f1 = '#2684FF';
var $8631ba4be606c8f5$export$e62e8919cca44969 = '#0065FF';
var $8631ba4be606c8f5$export$b3de0ae08da2ce64 = '#0052CC';
var $8631ba4be606c8f5$export$a6ee3d71bc067634 = '#0747A6';
var $8631ba4be606c8f5$export$363e4475840015bb = '#EAE6FF';
var $8631ba4be606c8f5$export$4b0a4417ed59760f = '#C0B6F2';
var $8631ba4be606c8f5$export$6011520a64d9a187 = '#998DD9';
var $8631ba4be606c8f5$export$a7175d4e9206bc80 = '#8777D9';
var $8631ba4be606c8f5$export$b48405b95304b5a1 = '#6554C0';
var $8631ba4be606c8f5$export$c71e4279dd54a18d = '#5243AA';
var $8631ba4be606c8f5$export$147899de772240ec = '#403294';
var $8631ba4be606c8f5$export$2cf711fe14c66f06 = '#E6FCFF';
var $8631ba4be606c8f5$export$7a8f4d33f6f9772c = '#B3F5FF';
var $8631ba4be606c8f5$export$776c9c497ef08533 = '#79E2F2';
var $8631ba4be606c8f5$export$69cb3ca10c1e330e = '#00C7E6';
var $8631ba4be606c8f5$export$9dc1ef0f3f48059b = '#00B8D9';
var $8631ba4be606c8f5$export$7c835c78b6fcdef8 = '#00A3BF';
var $8631ba4be606c8f5$export$6036577f95c3877e = '#008DA6';
var $8631ba4be606c8f5$export$29a4f05edc054374 = '#FFFFFF';
var $8631ba4be606c8f5$export$e655ef011c4aa1a2 = '#FAFBFC';
var $8631ba4be606c8f5$export$9fdfb749e33cdf97 = '#F4F5F7';
var $8631ba4be606c8f5$export$3e51e8f1440314ba = '#EBECF0';
var $8631ba4be606c8f5$export$1ce2d1575d444ceb = '#DFE1E6';
var $8631ba4be606c8f5$export$8754fc7e6d8b3000 = '#C1C7D0';
var $8631ba4be606c8f5$export$c2e91cbeada39b8b = '#B3BAC5';
var $8631ba4be606c8f5$export$5f71e19f3a7ad9de = '#A5ADBA';
var $8631ba4be606c8f5$export$eaa8c8a70ac22806 = '#97A0AF';
var $8631ba4be606c8f5$export$7c87d337fb91a97d = '#8993A4';
var $8631ba4be606c8f5$export$d6447c357493214f = '#7A869A';
var $8631ba4be606c8f5$export$f563ee71e9ee74cd = '#6B778C';
var $8631ba4be606c8f5$export$e2ef2124cf4024b1 = '#5E6C84';
var $8631ba4be606c8f5$export$eece5f492e429f08 = '#505F79';
var $8631ba4be606c8f5$export$c39c0fe0f26207ae = '#42526E';
var $8631ba4be606c8f5$export$7090862dc3038a9f = '#344563';
var $8631ba4be606c8f5$export$ad0bacf983b7ddaa = '#253858';
var $8631ba4be606c8f5$export$7d61b15e0da132af = '#172B4D';
var $8631ba4be606c8f5$export$fbda843f0a27fe96 = '#091E42';
var $8631ba4be606c8f5$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $8631ba4be606c8f5$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $8631ba4be606c8f5$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $8631ba4be606c8f5$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $8631ba4be606c8f5$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $8631ba4be606c8f5$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $8631ba4be606c8f5$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $8631ba4be606c8f5$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $8631ba4be606c8f5$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $8631ba4be606c8f5$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $8631ba4be606c8f5$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $8631ba4be606c8f5$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $8631ba4be606c8f5$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $8631ba4be606c8f5$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $8631ba4be606c8f5$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $8631ba4be606c8f5$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $8631ba4be606c8f5$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $8631ba4be606c8f5$export$2f6319cf7d736c2a = '#E6EDFA';
var $8631ba4be606c8f5$export$95126bc8884d6634 = '#DCE5F5';
var $8631ba4be606c8f5$export$8338d8c35d44ff1 = '#CED9EB';
var $8631ba4be606c8f5$export$5368d76ae4fbbda7 = '#B8C7E0';
var $8631ba4be606c8f5$export$9f0a771d16ec8d36 = '#ABBBD6';
var $8631ba4be606c8f5$export$abcf8c38338b4aa5 = '#9FB0CC';
var $8631ba4be606c8f5$export$97e81faa16a182c7 = '#8C9CB8';
var $8631ba4be606c8f5$export$bfe21c59123ecf33 = '#7988A3';
var $8631ba4be606c8f5$export$ee82aa2ea6a1558 = '#67758F';
var $8631ba4be606c8f5$export$682927c6ed76be02 = '#56637A';
var $8631ba4be606c8f5$export$91fd9994c5be9757 = '#455166';
var $8631ba4be606c8f5$export$d281fbfe3cff2df6 = '#3B475C';
var $8631ba4be606c8f5$export$3902c91d8b98a753 = '#313D52';
var $8631ba4be606c8f5$export$8e8133c1ba5845b5 = '#283447';
var $8631ba4be606c8f5$export$33ff357f6620b39 = '#202B3D';
var $8631ba4be606c8f5$export$633847cf062b69e0 = '#1B2638';
var $8631ba4be606c8f5$export$9776a6e503bdbf76 = '#121A29';
var $8631ba4be606c8f5$export$6c813d5160dff5db = '#0E1624';
var $8631ba4be606c8f5$export$3d4f271a500072a = '#0D1424';
var $8631ba4be606c8f5$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $8631ba4be606c8f5$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $8631ba4be606c8f5$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $8631ba4be606c8f5$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $8631ba4be606c8f5$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $8631ba4be606c8f5$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $8631ba4be606c8f5$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $8631ba4be606c8f5$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $8631ba4be606c8f5$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $8631ba4be606c8f5$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $8631ba4be606c8f5$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $8631ba4be606c8f5$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $8631ba4be606c8f5$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $8631ba4be606c8f5$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $8631ba4be606c8f5$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $8631ba4be606c8f5$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $8631ba4be606c8f5$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $8631ba4be606c8f5$export$8ce1fd94bee2f412 = (0, $6MdiR.default)({
    light: "var(--ds-surface, ".concat($8631ba4be606c8f5$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($8631ba4be606c8f5$export$633847cf062b69e0, ")")
});
var $8631ba4be606c8f5$export$b861914ea877b580 = (0, $6MdiR.default)({
    light: "var(--ds-background-selected, ".concat($8631ba4be606c8f5$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($8631ba4be606c8f5$export$8c13c2ee36917869, ")")
});
var $8631ba4be606c8f5$export$3f1b020df94387af = (0, $6MdiR.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($8631ba4be606c8f5$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($8631ba4be606c8f5$export$d281fbfe3cff2df6, ")")
});
var $8631ba4be606c8f5$export$c0183dbab98ca63e = (0, $6MdiR.default)({
    light: "var(--ds-surface-overlay, ".concat($8631ba4be606c8f5$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($8631ba4be606c8f5$export$8e8133c1ba5845b5, ")")
});
var $8631ba4be606c8f5$export$6f093cfa640b7166 = (0, $6MdiR.default)({
    light: "var(--ds-text, ".concat($8631ba4be606c8f5$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($8631ba4be606c8f5$export$5368d76ae4fbbda7, ")")
});
var $8631ba4be606c8f5$export$42f8e9c698766e7a = (0, $6MdiR.default)({
    light: "var(--ds-text, ".concat($8631ba4be606c8f5$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($8631ba4be606c8f5$export$5368d76ae4fbbda7, ")")
});
var $8631ba4be606c8f5$export$c2d157ca1c34b6e3 = (0, $6MdiR.default)({
    light: "var(--ds-text-selected, ".concat($8631ba4be606c8f5$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($8631ba4be606c8f5$export$b3de0ae08da2ce64, ")")
});
var $8631ba4be606c8f5$export$1905ba28d7cf066f = (0, $6MdiR.default)({
    light: "var(--ds-text-subtlest, ".concat($8631ba4be606c8f5$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($8631ba4be606c8f5$export$97e81faa16a182c7, ")")
});
var $8631ba4be606c8f5$export$bd9002130d306d39 = (0, $6MdiR.default)({
    light: "var(--ds-text-subtlest, ".concat($8631ba4be606c8f5$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($8631ba4be606c8f5$export$bfe21c59123ecf33, ")")
});
var $8631ba4be606c8f5$export$46e4a324ac90507f = (0, $6MdiR.default)({
    light: "var(--ds-text, ".concat($8631ba4be606c8f5$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($8631ba4be606c8f5$export$5368d76ae4fbbda7, ")")
});
var $8631ba4be606c8f5$export$79f3f2b82beb0d36 = (0, $6MdiR.default)({
    light: "var(--ds-text-subtlest, ".concat($8631ba4be606c8f5$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($8631ba4be606c8f5$export$97e81faa16a182c7, ")")
});
var $8631ba4be606c8f5$export$7bb0d5c671655cc4 = (0, $6MdiR.default)({
    light: $8631ba4be606c8f5$export$9fdfb749e33cdf97,
    dark: $8631ba4be606c8f5$export$8e8133c1ba5845b5
});
var $8631ba4be606c8f5$export$9c30223ca0a664fb = (0, $6MdiR.default)({
    light: "var(--ds-link, ".concat($8631ba4be606c8f5$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($8631ba4be606c8f5$export$ecfc1dff386a3e7a, ")")
});
var $8631ba4be606c8f5$export$7ed258b0728b004b = (0, $6MdiR.default)({
    light: "var(--ds-link-pressed, ".concat($8631ba4be606c8f5$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($8631ba4be606c8f5$export$215b7063051591f1, ")")
});
var $8631ba4be606c8f5$export$dfa920d8decc8a59 = (0, $6MdiR.default)({
    light: "var(--ds-link-pressed, ".concat($8631ba4be606c8f5$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($8631ba4be606c8f5$export$ecfc1dff386a3e7a, ")")
});
var $8631ba4be606c8f5$export$6069e6ad5c78f632 = (0, $6MdiR.default)({
    light: "var(--ds-border-focused, ".concat($8631ba4be606c8f5$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($8631ba4be606c8f5$export$215b7063051591f1, ")")
});
var $8631ba4be606c8f5$export$9ad721cf3b3debe0 = (0, $6MdiR.default)({
    light: "var(--ds-background-brand-bold, ".concat($8631ba4be606c8f5$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($8631ba4be606c8f5$export$ecfc1dff386a3e7a, ")")
});
var $8631ba4be606c8f5$export$2aa0182783e7e9de = (0, $6MdiR.default)({
    light: $8631ba4be606c8f5$export$b3de0ae08da2ce64,
    dark: $8631ba4be606c8f5$export$ecfc1dff386a3e7a
});
var $8631ba4be606c8f5$export$8bf7dff220b82b4a = (0, $6MdiR.default)({
    light: $8631ba4be606c8f5$export$9dc1ef0f3f48059b,
    dark: $8631ba4be606c8f5$export$69cb3ca10c1e330e
});
var $8631ba4be606c8f5$export$e13cce2a2d16a9d4 = (0, $6MdiR.default)({
    light: $8631ba4be606c8f5$export$b48405b95304b5a1,
    dark: $8631ba4be606c8f5$export$6011520a64d9a187
});
var $8631ba4be606c8f5$export$a90204d1394caf30 = (0, $6MdiR.default)({
    light: $8631ba4be606c8f5$export$4a7404f376229999,
    dark: $8631ba4be606c8f5$export$4a7404f376229999
});
var $8631ba4be606c8f5$export$594c5a8758200c32 = (0, $6MdiR.default)({
    light: $8631ba4be606c8f5$export$c6930421db9fa514,
    dark: $8631ba4be606c8f5$export$c6930421db9fa514
});
var $8631ba4be606c8f5$export$955a2ebd2fb142ae = (0, $6MdiR.default)({
    light: $8631ba4be606c8f5$export$940e1f69e873f202,
    dark: $8631ba4be606c8f5$export$940e1f69e873f202
});
var $8631ba4be606c8f5$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($8631ba4be606c8f5$export$8d43898f60b96a82, ")");
};

});
parcelRegister("6MdiR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4ef18b7d1b6339a4$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $jzjAz = parcelRequire("jzjAz");
// Unpack custom variants, and get correct value for the current theme
function $4ef18b7d1b6339a4$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $jzjAz.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $4ef18b7d1b6339a4$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $4ef18b7d1b6339a4$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $jzjAz.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("jzjAz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e3f07b238c4aba8d$export$2e2bcd8739ae039; });

var $ieBMP = parcelRequire("ieBMP");
function $e3f07b238c4aba8d$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $ieBMP.CHANNEL) in props.theme) return props.theme[0, $ieBMP.CHANNEL];
        else if ('mode' in props.theme && (0, $ieBMP.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $ieBMP.DEFAULT_THEME_MODE)
    };
}

});





parcelRegister("5mZMz", function(module, exports) {
$parcel$export(module.exports, "Theme", function () { return $3e8eee815c2e3756$export$14faa19a0f3bbeb2; });

var $3Yt1l = parcelRequire("3Yt1l");

var $kJxBd = parcelRequire("kJxBd");
var $3e8eee815c2e3756$var$disabledRules = {
    light: {
        backgroundColor: $kJxBd.disabledBackground.light,
        backgroundColorFocus: $kJxBd.disabledBackground.light,
        backgroundColorHover: $kJxBd.disabledBackground.light,
        borderColor: $kJxBd.disabledBorder.light,
        borderColorFocus: $kJxBd.defaultBorderColorFocus.light,
        textColor: $kJxBd.disabledTextColor.light
    },
    dark: {
        backgroundColor: $kJxBd.disabledBackground.dark,
        backgroundColorFocus: $kJxBd.disabledBackground.dark,
        backgroundColorHover: $kJxBd.disabledBackground.dark,
        borderColor: $kJxBd.disabledBorder.dark,
        borderColorFocus: $kJxBd.defaultBorderColorFocus.dark,
        textColor: $kJxBd.disabledTextColor.dark
    }
};
var $3e8eee815c2e3756$var$invalidRules = {
    light: {
        borderColor: $kJxBd.invalidBorderColor.light,
        borderColorFocus: $kJxBd.defaultBorderColorFocus.light,
        backgroundColor: $kJxBd.defaultBackgroundColor.light,
        backgroundColorFocus: $kJxBd.defaultBackgroundColorFocus.light,
        backgroundColorHover: $kJxBd.defaultBackgroundColorHover.light
    },
    dark: {
        borderColor: $kJxBd.invalidBorderColor.dark,
        borderColorFocus: $kJxBd.defaultBorderColorFocus.dark,
        backgroundColor: $kJxBd.defaultBackgroundColor.dark,
        backgroundColorFocus: $kJxBd.defaultBackgroundColorFocus.dark,
        backgroundColorHover: $kJxBd.defaultBackgroundColorHover.dark
    }
};
var $3e8eee815c2e3756$var$backgroundColor = {
    standard: $kJxBd.defaultBackgroundColor,
    subtle: $kJxBd.transparent,
    none: $kJxBd.transparent
};
var $3e8eee815c2e3756$var$backgroundColorFocus = {
    standard: $kJxBd.defaultBackgroundColorFocus,
    subtle: $kJxBd.defaultBackgroundColorFocus,
    none: $kJxBd.transparent
};
var $3e8eee815c2e3756$var$backgroundColorHover = {
    standard: $kJxBd.defaultBackgroundColorHover,
    subtle: $kJxBd.defaultBackgroundColorHover,
    none: $kJxBd.transparent
};
var $3e8eee815c2e3756$var$borderColor = {
    standard: $kJxBd.defaultBorderColor,
    subtle: $kJxBd.transparent,
    none: $kJxBd.transparent
};
var $3e8eee815c2e3756$var$borderColorFocus = {
    standard: $kJxBd.defaultBorderColorFocus,
    subtle: $kJxBd.defaultBorderColorFocus,
    none: $kJxBd.transparent
};
var $3e8eee815c2e3756$var$borderColorHover = {
    standard: $kJxBd.defaultBorderColor,
    subtle: $kJxBd.subtleBorderColorHover,
    none: $kJxBd.transparent
};
var $3e8eee815c2e3756$export$8c52b1fd9e189b5 = {
    borderColor: $3e8eee815c2e3756$var$borderColor,
    borderColorFocus: $3e8eee815c2e3756$var$borderColorFocus,
    backgroundColor: $3e8eee815c2e3756$var$backgroundColor,
    backgroundColorFocus: $3e8eee815c2e3756$var$backgroundColorFocus,
    backgroundColorHover: $3e8eee815c2e3756$var$backgroundColorHover,
    disabledRules: $3e8eee815c2e3756$var$disabledRules,
    invalidRules: $3e8eee815c2e3756$var$invalidRules,
    textColor: $kJxBd.textColor,
    placeholderTextColor: $kJxBd.placeholderTextColor
};
var $3e8eee815c2e3756$export$14faa19a0f3bbeb2 = (0, $3Yt1l.createTheme)(function(_ref) {
    var appearance = _ref.appearance, mode = _ref.mode;
    return {
        borderColor: $3e8eee815c2e3756$var$borderColor[appearance][mode],
        borderColorFocus: $3e8eee815c2e3756$var$borderColorFocus[appearance][mode],
        borderColorHover: $3e8eee815c2e3756$var$borderColorHover[appearance][mode],
        backgroundColorHover: $3e8eee815c2e3756$var$backgroundColorHover[appearance][mode],
        backgroundColorFocus: $3e8eee815c2e3756$var$backgroundColorFocus[appearance][mode],
        backgroundColor: $3e8eee815c2e3756$var$backgroundColor[appearance][mode],
        disabledRules: $3e8eee815c2e3756$var$disabledRules[mode],
        invalidRules: $3e8eee815c2e3756$var$invalidRules[mode],
        textColor: $kJxBd.textColor[mode],
        placeholderTextColor: $kJxBd.placeholderTextColor[mode]
    };
});

});
parcelRegister("kJxBd", function(module, exports) {
$parcel$export(module.exports, "disabledBackground", function () { return $f18212b5a9b8fba6$export$ae3cba7672df0890; });
$parcel$export(module.exports, "disabledBorder", function () { return $f18212b5a9b8fba6$export$fe505fe3c5edbdf6; });
$parcel$export(module.exports, "invalidBorderColor", function () { return $f18212b5a9b8fba6$export$7f333bbf7ddab792; });
$parcel$export(module.exports, "defaultBorderColor", function () { return $f18212b5a9b8fba6$export$dafd83031c202ca8; });
$parcel$export(module.exports, "defaultBorderColorFocus", function () { return $f18212b5a9b8fba6$export$e8320c09dc1e4012; });
$parcel$export(module.exports, "defaultBackgroundColor", function () { return $f18212b5a9b8fba6$export$b13414ee9ac9cae6; });
$parcel$export(module.exports, "defaultBackgroundColorHover", function () { return $f18212b5a9b8fba6$export$bca15982c103d57b; });
$parcel$export(module.exports, "defaultBackgroundColorFocus", function () { return $f18212b5a9b8fba6$export$21287e4b7f134f09; });
$parcel$export(module.exports, "subtleBorderColorHover", function () { return $f18212b5a9b8fba6$export$a87538d56ee366ec; });
$parcel$export(module.exports, "placeholderTextColor", function () { return $f18212b5a9b8fba6$export$5e076b2557ef7bbb; });
$parcel$export(module.exports, "textColor", function () { return $f18212b5a9b8fba6$export$32f78bffcd82ff28; });
$parcel$export(module.exports, "disabledTextColor", function () { return $f18212b5a9b8fba6$export$eb4a7d363eec53c8; });
$parcel$export(module.exports, "transparent", function () { return $f18212b5a9b8fba6$export$f4d082c200a4b4b8; });

var $23wuT = parcelRequire("23wuT");

var $bwjoy = parcelRequire("bwjoy");
var $f18212b5a9b8fba6$export$ae3cba7672df0890 = {
    light: "var(--ds-background-disabled, ".concat((0, $bwjoy.N20), ")"),
    dark: "var(--ds-background-disabled, ".concat((0, $bwjoy.DN20), ")")
};
var $f18212b5a9b8fba6$export$fe505fe3c5edbdf6 = {
    light: "var(--ds-border-disabled, ".concat((0, $bwjoy.N40), ")"),
    dark: "var(--ds-border-disabled, ".concat((0, $bwjoy.DN40), ")")
};
var $f18212b5a9b8fba6$export$7f333bbf7ddab792 = {
    light: "var(--ds-border-danger, ".concat((0, $bwjoy.R400), ")"),
    dark: "var(--ds-border-danger, ".concat((0, $bwjoy.R400), ")")
};
var $f18212b5a9b8fba6$export$dafd83031c202ca8 = {
    light: "var(--ds-border-input, ".concat((0, $23wuT.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? (0, $bwjoy.N100) : (0, $bwjoy.N40), ")"),
    dark: "var(--ds-border-input, ".concat((0, $23wuT.getBooleanFF)('platform.design-system-team.border-checkbox_nyoiu') ? (0, $bwjoy.DN200) : (0, $bwjoy.DN40), ")")
};
var $f18212b5a9b8fba6$export$e8320c09dc1e4012 = {
    light: "var(--ds-border-focused, ".concat((0, $bwjoy.B200), ")"),
    dark: "var(--ds-border-focused, ".concat((0, $bwjoy.B100), ")")
};
var $f18212b5a9b8fba6$export$b13414ee9ac9cae6 = {
    light: "var(--ds-background-input, ".concat((0, $bwjoy.N10), ")"),
    dark: "var(--ds-background-input, ".concat((0, $bwjoy.DN10), ")")
};
var $f18212b5a9b8fba6$export$bca15982c103d57b = {
    light: "var(--ds-background-input-hovered, ".concat((0, $bwjoy.N30), ")"),
    dark: "var(--ds-background-input-hovered, ".concat((0, $bwjoy.DN30), ")")
};
var $f18212b5a9b8fba6$export$21287e4b7f134f09 = {
    light: "var(--ds-background-input-pressed, ".concat((0, $bwjoy.N0), ")"),
    dark: "var(--ds-background-input-pressed, ".concat((0, $bwjoy.DN10), ")")
};
var $f18212b5a9b8fba6$export$a87538d56ee366ec = {
    light: "var(--ds-border-input, transparent)",
    dark: "var(--ds-border-input, transparent)"
};
var $f18212b5a9b8fba6$export$5e076b2557ef7bbb = {
    light: "var(--ds-text-subtlest, ".concat((0, $bwjoy.N200), ")"),
    dark: "var(--ds-text-subtlest, ".concat((0, $bwjoy.DN200), ")")
};
var $f18212b5a9b8fba6$export$32f78bffcd82ff28 = {
    light: "var(--ds-text, ".concat((0, $bwjoy.N900), ")"),
    dark: "var(--ds-text, ".concat((0, $bwjoy.DN600), ")")
};
var $f18212b5a9b8fba6$export$eb4a7d363eec53c8 = {
    light: "var(--ds-text-disabled, ".concat((0, $bwjoy.N70), ")"),
    dark: "var(--ds-text-disabled, ".concat((0, $bwjoy.DN90), ")")
};
var $f18212b5a9b8fba6$export$f4d082c200a4b4b8 = {
    light: 'transparent',
    dark: 'transparent'
};

});




parcelRegister("8Fvhz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $de9efdf87e9265fa$export$2e2bcd8739ae039; });
/* mo-resource-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $7iXNu = parcelRequire("7iXNu");
const $de9efdf87e9265fa$var$resourceCardStyling = null;
const $de9efdf87e9265fa$var$MigrationOptionsResourceCards = ()=>{
    const intl = (0, $8e22h.default)();
    const startAssessmentText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.StartAssessment",
        defaultMessage: "Find a partner"
    });
    const learnAboutMigrationText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.LearnAboutMigration",
        defaultMessage: "Learn about migration"
    });
    const browseTheGuideText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.BrowseTheGuide",
        defaultMessage: "Browse the guide"
    });
    const migrationOptionsResourceCards = [
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.MigrationAssessment",
                defaultMessage: "Migration partners"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.MigrationAssessment.dsc",
                defaultMessage: "Certified partners offer end-to-end 1:1 support for complex migrations."
            }),
            buttonText: startAssessmentText,
            url: (0, $kooLp.useLocalizedHref)("/migration/help/find-migration-partner")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.AtlassianMigration",
                defaultMessage: "Atlassian Migration Program"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.AtlassianMigration.dsc",
                defaultMessage: "Find tools, resources, and support to guide you through a migration."
            }),
            buttonText: learnAboutMigrationText,
            url: (0, $kooLp.useLocalizedHref)("/migration")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.CloudMigration",
                defaultMessage: "Cloud migration guide"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.CloudMigration.dsc",
                defaultMessage: "Explore each phase of your migration journey with our guide."
            }),
            buttonText: browseTheGuideText,
            url: (0, $kooLp.useLocalizedHref)("/migration/plan/cloud-guide")
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: migrationOptionsResourceCards.map((cardProps)=>/*#__PURE__*/ (0, $1oC0p.createElement)((0, $7iXNu.default), {
                ...cardProps,
                key: cardProps.header
            }))
    });
};
var $de9efdf87e9265fa$export$2e2bcd8739ae039 = $de9efdf87e9265fa$var$MigrationOptionsResourceCards;

});


parcelRegister("9Dk5S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2d171a99d4a2171f$export$2e2bcd8739ae039; });
/* pricing-quotes.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $3L8ZR = parcelRequire("3L8ZR");

var $lX14w = parcelRequire("lX14w");
var $ff3wF = parcelRequire("ff3wF");
var $igGC3 = parcelRequire("igGC3");
var $gacwQ = parcelRequire("gacwQ");
var $kR3EL = parcelRequire("kR3EL");

var $9BG80 = parcelRequire("9BG80");

var $2vYc0 = parcelRequire("2vYc0");

var $8KJ2x = parcelRequire("8KJ2x");

var $fJP6M = parcelRequire("fJP6M");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $1rGpC = parcelRequire("1rGpC");

var $32ng3 = parcelRequire("32ng3");

var $hhv63 = parcelRequire("hhv63");

var $2ve7k = parcelRequire("2ve7k");

var $lBgvn = parcelRequire("lBgvn");

var $3bkHm = parcelRequire("3bkHm");

var $izhAl = parcelRequire("izhAl");

var $e0MOs = parcelRequire("e0MOs");

var $9xhTf = parcelRequire("9xhTf");

var $eodOk = parcelRequire("eodOk");
const $2d171a99d4a2171f$var$containerStyle = null;
const $2d171a99d4a2171f$var$innerContainerStyle = null;
const $2d171a99d4a2171f$var$formStyle = null;
const $2d171a99d4a2171f$var$textContainer = null;
const $2d171a99d4a2171f$var$PricingQuotes = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [fieldHasError, setFieldHasError] = (0, $1oC0p.useState)({});
    const [errorMessageText, setErrorMessageText] = (0, $1oC0p.useState)("");
    const [selectedProduct, setSelectedProduct] = (0, $1oC0p.useState)("");
    const [changeContactInfo, setChangeContactInfo] = (0, $1oC0p.useState)(false);
    const [isInvalid, setIsInvalid] = (0, $1oC0p.useState)(true);
    const intl = (0, $8e22h.default)();
    const userInfo = (0, $2ve7k.useLoggedInUser)();
    const redirectPath = (0, $kooLp.useLocalizedHref)(`/enterprise/contact-thanks?formType=pricing-quotes`);
    const NEXT_PUBLIC_IDENTITY_BASE_URL = "https://id.atlassian.com";
    const getSwitchAccountURL = (continueUrlParam)=>{
        const continueUrl = continueUrlParam ? continueUrlParam : window.location.href;
        return `${NEXT_PUBLIC_IDENTITY_BASE_URL}/login/select-account?continue=${encodeURIComponent(continueUrl)}`;
    };
    const getOrAsk = intl.formatMessage({
        id: "pricingQuotes.getOrAsk",
        defaultMessage: "Get a quote or ask pricing questions about a product or service you might purchase."
    });
    const yourCompanyEmail = intl.formatMessage({
        id: "pricingQuotes.yourCompanyEmail",
        defaultMessage: "Your company email"
    }) + " *";
    const personalEmailDomainsError = intl.formatMessage({
        id: "pricingQuotes.personalEmailDomainsError",
        defaultMessage: "Personal email domains will result in an error."
    });
    const conditionalFields = (product, getState, setFieldValue)=>{
        const options = (0, $9xhTf.getProductPlans)(selectedProduct);
        const numberOfPeopleSupported = intl.formatMessage({
            id: "pricingQuotes.numberOfPeople",
            defaultMessage: "Number of people your agents will support"
        }) + " *";
        const numberOfDevelopersOnTeam = intl.formatMessage({
            id: "pricingQuotes.numberOfDevelopers",
            defaultMessage: "Number of developers on your team"
        }) + " *";
        const numberOfPeopleOnTeam = intl.formatMessage({
            id: "pricingQuotes.numberOfPeopleOnTeam",
            defaultMessage: "Number of people on your team"
        }) + " *";
        const numberOfAssets = intl.formatMessage({
            id: "productFeatures.numberOfAssets",
            defaultMessage: "Number of Assets you want to store"
        }) + " *";
        const numberOfAgentConversations = intl.formatMessage({
            id: "productFeatures.numberOfAgentConversations",
            defaultMessage: "Estimated number of virtual service agent conversations per month"
        }) + " *";
        const enterpriseRolloutTWC = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-twc");
        const serviceCollectionEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8165EnterpriseContactServiceCollection);
        const backupRestoreEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9763BackupRestoreContactForm);
        const additionalSandboxEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9608AdditionalSandboxContactForm);
        const atlassianIsolatedCloudEnabled = (0, $9xhTf.isAtlassianIsolatedCloudContactFormEnabled)();
        const sunsetCompass = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp1072SunsetCompass);
        const productsWithPlans = [
            "Jira Software",
            "Jira",
            "Confluence",
            "Jira Service Management",
            "Bitbucket",
            "Atlassian Guard",
            "Jira Product Discovery",
            ...!sunsetCompass ? [
                "Compass"
            ] : [],
            "Loom"
        ];
        if (enterpriseRolloutTWC) productsWithPlans.push("Teamwork Collection");
        if (serviceCollectionEnabled) productsWithPlans.push("Service Collection");
        if (backupRestoreEnabled) {
            productsWithPlans.push("Jira Cloud Backup and Restore");
            productsWithPlans.push("Jira Service Management Cloud Backup and Restore");
            productsWithPlans.push("Confluence Cloud Backup and Restore");
        }
        if (additionalSandboxEnabled) {
            productsWithPlans.push("Jira Additional Sandbox");
            productsWithPlans.push("Confluence Additional Sandbox");
            productsWithPlans.push("Jira Service Management Additional Sandbox");
            productsWithPlans.push("Jira Product Discovery Additional Sandbox");
        }
        return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
            children: [
                productsWithPlans.includes(product) && getState().values["platform"] === "Cloud" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                    name: "plan",
                    label: intl.formatMessage({
                        id: "pricingQuotes.plan",
                        defaultMessage: "Which plan are you interested in?"
                    }) + " *",
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2vYc0.default), {
                                    ...fieldProps,
                                    options: options,
                                    onChange: (edition)=>{
                                        const value = edition.currentTarget.value;
                                        setFieldValue("edition", value);
                                        setFieldValue("plan", value);
                                        fieldProps.onChange;
                                    }
                                }),
                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                    children: planErrorMessage
                                })
                            ]
                        })
                }),
                [
                    "Jira Software",
                    "Jira",
                    "Confluence",
                    "Jira Service Management",
                    "Bitbucket",
                    "Jira Work Management",
                    "Atlassian Access",
                    "Atlassian Guard",
                    "Opsgenie",
                    "Trello",
                    "Jira Align",
                    "Jira Product Discovery",
                    ...!sunsetCompass ? [
                        "Compass"
                    ] : [],
                    "Atlas",
                    "Loom",
                    "Jira Service Management Assets",
                    "Jira Service Management Virtual Service Agent",
                    "Teamwork Collection",
                    "Strategy Collection",
                    "Service Collection",
                    "Confluence Cloud Backup and Restore",
                    "Jira Cloud Backup and Restore",
                    "Jira Service Management Cloud Backup and Restore",
                    "Confluence Additional Sandbox",
                    "Jira Additional Sandbox",
                    "Jira Service Management Additional Sandbox",
                    "Jira Product Discovery Additional Sandbox",
                    ...atlassianIsolatedCloudEnabled ? [
                        (0, $9xhTf.ATLASSIAN_ISOLATED_CLOUD_PRODUCT)
                    ] : []
                ].includes(product) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                    name: "numberOfUsers",
                    label: product === "Jira Service Management" ? numberOfPeopleSupported : product === "Jira Align" || product === "Jira Product Discovery" || !sunsetCompass && product === "Compass" || product === "Atlas" || product === "Confluence Additional Sandbox" || product === "Jira Additional Sandbox" || product === "Jira Service Management Additional Sandbox" || product === "Jira Product Discovery Additional Sandbox" ? numberOfDevelopersOnTeam : product === "Jira Service Management Assets" ? numberOfAssets : product === "Jira Service Management Virtual Service Agent" ? numberOfAgentConversations : numberOfPeopleOnTeam,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3bkHm.NumberOfUsersInput), {
                                    ...fieldProps,
                                    onChangeHandler: (numberOfUsers)=>{
                                        setFieldValue("numberOfUsers", Number(numberOfUsers));
                                        fieldProps.onChange;
                                    }
                                }),
                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                    children: product === "Jira Service Management" ? numberOfPeopleJSMErrorMessage : product === "Jira Service Management Assets" || product === "Jira Service Management Virtual Service Agent" ? genericRequiredFieldErrorMessage : numberOfPeopleOnTeamErrorMessage
                                })
                            ]
                        })
                })
            ]
        });
    };
    const handleBlurEvent = (event)=>{
        const { name: name, value: value } = event.target;
        if (name === "email") {
            if (!value) {
                setFieldHasError({
                    ...fieldHasError,
                    [name]: true
                });
                setErrorMessageText("NOT_EMAIL");
                setIsInvalid(true);
            } else if ((0, $9xhTf.isEmailFormat)(value) && !(0, $9xhTf.isPersonalDomain)(value)) {
                setFieldHasError({
                    ...fieldHasError,
                    [name]: false
                });
                setErrorMessageText("IS_VALID");
                setIsInvalid(false);
            } else {
                setFieldHasError({
                    ...fieldHasError,
                    [name]: true
                });
                setIsInvalid(true);
                if (!(0, $9xhTf.isEmailFormat)(value)) setErrorMessageText("NOT_EMAIL");
                else if ((0, $9xhTf.isPersonalDomain)(value)) setErrorMessageText("PERSONAL_DOMAIN");
            }
        } else {
            setFieldHasError({
                ...fieldHasError,
                [name]: !value
            });
            setIsInvalid(!value);
        }
    };
    /*
      Error Messages
  */ const personalDomainErrorMessage = intl.formatMessage({
        id: "pricingQuotes.personalDomainErrorMessage",
        defaultMessage: "Enter an email with a company domain."
    });
    const notEmailErrorMessage = intl.formatMessage({
        id: "pricingQuotes.notEmailErrorMessage",
        defaultMessage: "Enter a valid email address."
    });
    const jobTitleErrorMessage = intl.formatMessage({
        id: "pricingQuotes.jobTitleErrorMessage",
        defaultMessage: "Your job title is required."
    });
    const firstNameErrorMessage = intl.formatMessage({
        id: "pricingQuotes.firstNameErrorMessage",
        defaultMessage: "Your first name is required."
    });
    const lastNameErrorMessage = intl.formatMessage({
        id: "pricingQuotes.lastNameErrorMessage",
        defaultMessage: "Your last name is required."
    });
    const companyErrorMessage = intl.formatMessage({
        id: "pricingQuotes.companyErrorMessage",
        defaultMessage: "Your company name is required."
    });
    const productErrorMessage = intl.formatMessage({
        id: "pricingQuotes.productErrorMessage",
        defaultMessage: "Select a product or service to continue."
    });
    const planErrorMessage = intl.formatMessage({
        id: "pricingQuotes.planErrorMessage",
        defaultMessage: "Select any cloud plan to continue."
    });
    const numberOfPeopleOnTeamErrorMessage = intl.formatMessage({
        id: "pricingQuotes.numberOfPeopleOnTeamErrorMessage",
        defaultMessage: "Your team size is required."
    });
    const numberOfPeopleJSMErrorMessage = intl.formatMessage({
        id: "pricingQuotes.numberOfPeopleSupportedErrorMessage",
        defaultMessage: "We need to know how many people contact your service desk."
    });
    const genericRequiredFieldErrorMessage = intl.formatMessage({
        id: "pricingQuotes.genericRequiredFieldErrorMessage",
        defaultMessage: "This field is required."
    });
    const HandleSubmit = (form)=>{
        const errors = {};
        // eslint-disable-next-line @typescript-eslint/no-for-in-array
        for(const field in form)if (form[field] === undefined || fieldHasError[field]) {
            const errorFields = [
                "email",
                "firstName",
                "lastName",
                "company",
                "title",
                "product",
                "plan",
                "numberOfUsers",
                "opportunity_Description__c"
            ];
            if (errorFields.includes(field)) errors[field] = true;
        }
        if (Object.keys(errors).length > 0) return errors;
        else return (0, $9xhTf.submitContactForm)(form, "pricing-quotes", createAnalyticsEvent).then(()=>{
            window.location.assign(redirectPath);
        }).catch(()=>{
            document.querySelector(".post-submit")?.classList.replace("post-submit", "post-submit-error");
        });
    };
    const pricingQuoteSubmitText = intl.formatMessage({
        id: "pricingQuotes.submit",
        defaultMessage: "Submit"
    });
    const loggedOutView = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hhv63.ConsentHubClientConfigProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.SelectedProductProvider), {
            selectedProduct: selectedProduct,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_syaz1533 _vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4q6fz _k48pbfng _vwz41tcg"
                ]),
                style: {
                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _1ul91ssb _p12f1o9t"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syaz1533"
                                ]),
                                style: {
                                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: getOrAsk
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                                onSubmit: HandleSubmit,
                                children: ({ formProps: formProps, setFieldValue: setFieldValue, getState: getState })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                                        ...formProps,
                                        className: (0, $2jatx.default)([
                                            "_18dc18gv _ytel1j6v _jgjs8pqr _wdh21uxz _mg90ftgi _10wcidpf _ruzhftgi _19tgidpf _1lqt1txw _1t901bp4 _1bsb1osq _hi82bfng _lmjx1k92 _1noh18gv _tyq318gv _1oya1j6v _18961uxz _1pxw1tcg _10rvglyw _1vua18gv _y9t31j6v _1krm1j6v _dmb71tcg _9bbqidpf _1qqcidpf _wzdj1rga _yh561j28 _ud0z14y2 _1c1o8pqr _1iiy18gv _1c251nn1 _1h2z17ve _iu668pqr _s58r3x1v _1kmwmzrp _dvul17ve _bxhfviql _v71b14y2 _1jd91hrf _121j1h6o _16w9idpf _lyghidpf _x68d1rga _1c8s1j28 _wqgk8pqr _16im8pqr _15re1k8s _1kylkwu8 _v0s8cs5v _1o6rg42f _1hod15vq _1rzv15vq _1k52kb7n _l85aj6kd _upgaglyw _mnhm1ule _rr0p1uxz"
                                        ]),
                                        style: {
                                            "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
                                            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                    name: "email",
                                                    label: yourCompanyEmail,
                                                    validate: (value)=>{
                                                        setFieldValue("email", value);
                                                    },
                                                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                    ...fieldProps,
                                                                    value: fieldProps.value || "",
                                                                    onBlur: handleBlurEvent
                                                                }),
                                                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                    children: errorMessageText === "PERSONAL_DOMAIN" ? personalDomainErrorMessage : notEmailErrorMessage
                                                                }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                    children: personalEmailDomainsError
                                                                })
                                                            ]
                                                        })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                                                        layout: "6-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "firstName",
                                                                label: intl.formatMessage({
                                                                    id: "pricingQuotes.forename",
                                                                    defaultMessage: "First name"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                                ...fieldProps,
                                                                                value: fieldProps.value || ""
                                                                            }),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: firstNameErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "lastName",
                                                                label: intl.formatMessage({
                                                                    id: "pricingQuotes.surname",
                                                                    defaultMessage: "Last name"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                                ...fieldProps,
                                                                                value: fieldProps.value || ""
                                                                            }),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: lastNameErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                                                        layout: "6-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "company",
                                                                label: intl.formatMessage({
                                                                    id: "pricingQuotes.company",
                                                                    defaultMessage: "Company"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                                ...fieldProps,
                                                                                value: fieldProps.value || ""
                                                                            }),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: companyErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "title",
                                                                label: intl.formatMessage({
                                                                    id: "pricingQuotes.title",
                                                                    defaultMessage: "Job title"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                                ...fieldProps,
                                                                                value: fieldProps.value || ""
                                                                            }),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: jobTitleErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                    name: "product",
                                                    label: intl.formatMessage({
                                                        id: "pricingQuotes.product",
                                                        defaultMessage: "Which product or service are you inquiring about?"
                                                    }) + " *",
                                                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.ProductSelector), {
                                                                    ...fieldProps,
                                                                    pageType: "pricing-quotes",
                                                                    onChangeHandler: (product, platform)=>{
                                                                        setFieldValue("product", product);
                                                                        setFieldValue("platform", platform);
                                                                        fieldProps.onChange;
                                                                        setSelectedProduct(product);
                                                                    }
                                                                }),
                                                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                    children: productErrorMessage
                                                                }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                    children: intl.formatMessage({
                                                                        id: "pricingQuotes.productHelper",
                                                                        defaultMessage: "If you\u2019re asking about multiple products, select the one with the most users."
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                })
                                            }),
                                            conditionalFields(selectedProduct, getState, setFieldValue),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                children: (0, $e0MOs.QuestionField)("pricing-quotes", handleBlurEvent)
                                            }),
                                            (0, $lBgvn.ConsentInfo)(setFieldValue),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gacwQ.default), {
                                                align: "start",
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), {
                                                            inputType: "button",
                                                            text: pricingQuoteSubmitText,
                                                            "aria-label": pricingQuoteSubmitText,
                                                            type: "primary",
                                                            color: isInvalid ? "gray" : "darkblue",
                                                            onClick: ()=>{
                                                                formProps.onSubmit();
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: "post-submit",
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                            children: intl.formatMessage({
                                                                id: "pricingQuotes.submitError",
                                                                defaultMessage: "An error has occurred. Please try again later."
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eodOk.default), {})
                ]
            })
        })
    });
    const loggedInView = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hhv63.ConsentHubClientConfigProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.SelectedProductProvider), {
            selectedProduct: selectedProduct,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_syaz1533 _vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4q6fz _k48pbfng _vwz41tcg"
                ]),
                style: {
                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _1ul91ssb _p12f1o9t"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syaz1533"
                                ]),
                                style: {
                                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: getOrAsk
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                                    onSubmit: HandleSubmit,
                                    children: ({ formProps: formProps, setFieldValue: setFieldValue, getState: getState })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                                            ...formProps,
                                            className: (0, $2jatx.default)([
                                                "_18dc18gv _ytel1j6v _jgjs8pqr _wdh21uxz _mg90ftgi _10wcidpf _ruzhftgi _19tgidpf _1lqt1txw _1t901bp4 _1bsb1osq _hi82bfng _lmjx1k92 _1noh18gv _tyq318gv _1oya1j6v _18961uxz _1pxw1tcg _10rvglyw _1vua18gv _y9t31j6v _1krm1j6v _dmb71tcg _9bbqidpf _1qqcidpf _wzdj1rga _yh561j28 _ud0z14y2 _1c1o8pqr _1iiy18gv _1c251nn1 _1h2z17ve _iu668pqr _s58r3x1v _1kmwmzrp _dvul17ve _bxhfviql _v71b14y2 _1jd91hrf _121j1h6o _16w9idpf _lyghidpf _x68d1rga _1c8s1j28 _wqgk8pqr _16im8pqr _15re1k8s _1kylkwu8 _v0s8cs5v _1o6rg42f _1hod15vq _1rzv15vq _1k52kb7n _l85aj6kd _upgaglyw _mnhm1ule _rr0p1uxz"
                                            ]),
                                            style: {
                                                "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
                                                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    children: intl.formatMessage({
                                                        id: "pricingQuotes.contactInfo",
                                                        defaultMessage: "You're logged in as:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                                    children: setFieldValue("email", userInfo.email)
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                                    children: setFieldValue("name", userInfo.name)
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_1wyb1k92"
                                                    ]),
                                                    children: [
                                                        userInfo.name,
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                                        userInfo.email
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1wyboqnp _syaz1ep1 _59381r31 _yha2glyw _1nmznqa1 _43ds1ep1 _1r8v1ul9 _1hw71o8l _1enu1j6v _6b8d1j28"
                                                    ]),
                                                    style: {
                                                        "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                                            href: "#changeContactInfo",
                                                            onClick: ()=>{
                                                                setChangeContactInfo(true);
                                                            },
                                                            children: [
                                                                intl.formatMessage({
                                                                    id: "pricingQuotes.updateInfo",
                                                                    defaultMessage: "Update contact info"
                                                                }),
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_z6uan7od"
                                                                    ]),
                                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                                                        label: ""
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                                            href: getSwitchAccountURL(),
                                                            children: [
                                                                intl.formatMessage({
                                                                    id: "pricingQuotes.differentAccount",
                                                                    defaultMessage: "Log in with a different Atlassian account"
                                                                }),
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_z6uan7od"
                                                                    ]),
                                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                                                        label: ""
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                        name: "title",
                                                        label: intl.formatMessage({
                                                            id: "pricingQuotes.yourJobTitle",
                                                            defaultMessage: "Your job title"
                                                        }) + " *",
                                                        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                        ...fieldProps,
                                                                        value: fieldProps.value || "",
                                                                        onBlur: handleBlurEvent
                                                                    }),
                                                                    error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                        children: jobTitleErrorMessage
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                        children: intl.formatMessage({
                                                                            id: "pricingQuotes.yourJobTitleHelper",
                                                                            defaultMessage: "We ask this to connect you to the best expert for your role."
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                        name: "product",
                                                        label: intl.formatMessage({
                                                            id: "pricingQuotes.product",
                                                            defaultMessage: "Which product or service are you inquiring about?"
                                                        }) + " *",
                                                        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.ProductSelector), {
                                                                        ...fieldProps,
                                                                        pageType: "pricing-quotes",
                                                                        onChangeHandler: (product, platform)=>{
                                                                            setFieldValue("product", product);
                                                                            setFieldValue("platform", platform);
                                                                            fieldProps.onChange;
                                                                            setSelectedProduct(product);
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                        children: intl.formatMessage({
                                                                            id: "pricingQuotes.productHelper",
                                                                            defaultMessage: "If you\u2019re asking about multiple products, select the one with the most users."
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                    })
                                                }),
                                                conditionalFields(selectedProduct, getState, setFieldValue),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                    children: (0, $e0MOs.QuestionField)("pricing-quotes", handleBlurEvent)
                                                }),
                                                (0, $lBgvn.ConsentInfo)(setFieldValue),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gacwQ.default), {
                                                    align: "start",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), {
                                                                inputType: "button",
                                                                text: pricingQuoteSubmitText,
                                                                "aria-label": pricingQuoteSubmitText,
                                                                type: "primary",
                                                                color: isInvalid ? "gray" : "darkblue",
                                                                onClick: ()=>{
                                                                    formProps.onSubmit();
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: "post-submit",
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                                children: intl.formatMessage({
                                                                    id: "pricingQuotes.submitError",
                                                                    defaultMessage: "An error has occurred. Please try again later."
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eodOk.default), {})
                ]
            })
        })
    });
    if (userInfo.isUserLoggedIn) {
        if (userInfo.email) {
            if ((0, $9xhTf.isPersonalDomain)(userInfo.email) || userInfo.email.includes("atlassian.com") || changeContactInfo) return loggedOutView;
            else return loggedInView;
        }
    }
    return loggedOutView;
};
var $2d171a99d4a2171f$export$2e2bcd8739ae039 = $2d171a99d4a2171f$var$PricingQuotes;

});
parcelRegister("eodOk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1c1ffd96b6eaa0fb$export$2e2bcd8739ae039; });
/* pq-resource-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $7iXNu = parcelRequire("7iXNu");
const $1c1ffd96b6eaa0fb$var$resourceCardStyling = null;
const $1c1ffd96b6eaa0fb$var$PricingQuotesResourceCards = ()=>{
    const intl = (0, $8e22h.default)();
    const getEstimateText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.GetEstimate",
        defaultMessage: "Get estimate"
    });
    const compareCosts = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CompareCosts",
        defaultMessage: "Compare costs"
    });
    const enterSENsText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.enterSENs",
        defaultMessage: "Enter SENs"
    });
    const pricingQuotesResourceCards = [
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CloudPricing",
                defaultMessage: "Cloud pricing calculator"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CloudPricing.dsc",
                defaultMessage: "Estimate your bill for key Cloud products on Premium plans."
            }),
            buttonText: getEstimateText,
            url: (0, $kooLp.useLocalizedHref)("/software/pricing-calculator")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CloudValue",
                defaultMessage: "Cloud value calculator"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CloudValue.dsc",
                defaultMessage: "Compare the total cost of your server products to Cloud."
            }),
            buttonText: compareCosts,
            url: (0, $kooLp.useLocalizedHref)("/migration/assess/calculate-pricing")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.DataCenter",
                defaultMessage: "Data Center comparison"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.DataCenter.dsc",
                defaultMessage: "See what it would cost to upgrade your server SENs to Data Center."
            }),
            buttonText: enterSENsText,
            url: (0, $kooLp.useLocalizedHref)("/purchase/upgrade/datacenter")
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: pricingQuotesResourceCards.map((cardProps)=>/*#__PURE__*/ (0, $1oC0p.createElement)((0, $7iXNu.default), {
                ...cardProps,
                key: cardProps.header
            }))
    });
};
var $1c1ffd96b6eaa0fb$export$2e2bcd8739ae039 = $1c1ffd96b6eaa0fb$var$PricingQuotesResourceCards;

});


parcelRegister("g06pB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dcd2ef245dc372ce$export$2e2bcd8739ae039; });
/* product-features.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $3L8ZR = parcelRequire("3L8ZR");

var $lX14w = parcelRequire("lX14w");
var $ff3wF = parcelRequire("ff3wF");
var $igGC3 = parcelRequire("igGC3");
var $gacwQ = parcelRequire("gacwQ");
var $kR3EL = parcelRequire("kR3EL");

var $9BG80 = parcelRequire("9BG80");

var $2vYc0 = parcelRequire("2vYc0");

var $8KJ2x = parcelRequire("8KJ2x");

var $fJP6M = parcelRequire("fJP6M");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $1rGpC = parcelRequire("1rGpC");

var $32ng3 = parcelRequire("32ng3");

var $hhv63 = parcelRequire("hhv63");

var $2ve7k = parcelRequire("2ve7k");

var $lBgvn = parcelRequire("lBgvn");

var $3bkHm = parcelRequire("3bkHm");

var $izhAl = parcelRequire("izhAl");

var $e0MOs = parcelRequire("e0MOs");

var $9xhTf = parcelRequire("9xhTf");

var $dzInA = parcelRequire("dzInA");
const $dcd2ef245dc372ce$var$containerStyle = null;
const $dcd2ef245dc372ce$var$innerContainerStyle = null;
const $dcd2ef245dc372ce$var$formStyle = null;
const $dcd2ef245dc372ce$var$textContainer = null;
const $dcd2ef245dc372ce$var$ProductFeatures = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [fieldHasError, setFieldHasError] = (0, $1oC0p.useState)({});
    const [errorMessageText, setErrorMessageText] = (0, $1oC0p.useState)("");
    const [selectedProduct, setSelectedProduct] = (0, $1oC0p.useState)("");
    const [changeContactInfo, setChangeContactInfo] = (0, $1oC0p.useState)(false);
    const [isInvalid, setIsInvalid] = (0, $1oC0p.useState)(true);
    const intl = (0, $8e22h.default)();
    const userInfo = (0, $2ve7k.useLoggedInUser)();
    const redirectPath = (0, $kooLp.useLocalizedHref)(`/enterprise/contact-thanks?formType=product-features`);
    const NEXT_PUBLIC_IDENTITY_BASE_URL = "https://id.atlassian.com";
    const getSwitchAccountURL = (continueUrlParam)=>{
        const continueUrl = continueUrlParam ? continueUrlParam : window.location.href;
        return `${NEXT_PUBLIC_IDENTITY_BASE_URL}/login/select-account?continue=${encodeURIComponent(continueUrl)}`;
    };
    const getOrAsk = intl.formatMessage({
        id: "productFeatures.getOrAsk",
        defaultMessage: "Ask us about the functionality and features of a product or service you might purchase."
    });
    const yourCompanyEmail = intl.formatMessage({
        id: "productFeatures.yourCompanyEmail",
        defaultMessage: "Your company email"
    }) + " *";
    const personalEmailDomainsError = intl.formatMessage({
        id: "productFeatures.personalEmailDomainsError",
        defaultMessage: "Personal email domains will result in an error."
    });
    const conditionalFields = (product, getState, setFieldValue)=>{
        const options = (0, $9xhTf.getProductPlans)(selectedProduct);
        const numberOfPeopleSupported = intl.formatMessage({
            id: "productFeatures.numberOfPeople",
            defaultMessage: "Number of people your agents will support"
        }) + " *";
        const numberOfDevelopersOnTeam = intl.formatMessage({
            id: "productFeatures.numberOfDevelopers",
            defaultMessage: "Number of developers on your team"
        }) + " *";
        const numberOfPeopleOnTeam = intl.formatMessage({
            id: "productFeatures.numberOfPeopleOnTeam",
            defaultMessage: "Number of people on your team"
        }) + " *";
        const numberOfAssets = intl.formatMessage({
            id: "productFeatures.numberOfAssets",
            defaultMessage: "Number of Assets you want to store"
        }) + " *";
        const numberOfAgentConversations = intl.formatMessage({
            id: "productFeatures.numberOfAgentConversations",
            defaultMessage: "Estimated number of virtual service agent conversations per month"
        }) + " *";
        const enterpriseRolloutTWC = (0, $3L8ZR.default).checkGate("gwp-enterprise-rollout-gate-twc");
        const serviceCollectionEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8165EnterpriseContactServiceCollection);
        const backupRestoreEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9763BackupRestoreContactForm);
        const additionalSandboxEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9608AdditionalSandboxContactForm);
        const atlassianIsolatedCloudEnabled = (0, $9xhTf.isAtlassianIsolatedCloudContactFormEnabled)();
        const sunsetCompass = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp1072SunsetCompass);
        const productsWithPlans = [
            "Jira Software",
            "Jira",
            "Confluence",
            "Jira Service Management",
            "Bitbucket",
            "Atlassian Guard",
            "Jira Product Discovery",
            ...!sunsetCompass ? [
                "Compass"
            ] : [],
            "Loom"
        ];
        if (enterpriseRolloutTWC) productsWithPlans.push("Teamwork Collection");
        if (serviceCollectionEnabled) productsWithPlans.push("Service Collection");
        if (backupRestoreEnabled) {
            productsWithPlans.push("Jira Cloud Backup and Restore");
            productsWithPlans.push("Jira Service Management Cloud Backup and Restore");
            productsWithPlans.push("Confluence Cloud Backup and Restore");
        }
        if (additionalSandboxEnabled) {
            productsWithPlans.push("Jira Additional Sandbox");
            productsWithPlans.push("Confluence Additional Sandbox");
            productsWithPlans.push("Jira Service Management Additional Sandbox");
            productsWithPlans.push("Jira Product Discovery Additional Sandbox");
        }
        return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
            children: [
                productsWithPlans.includes(product) && getState().values["platform"] === "Cloud" && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                    name: "plan",
                    label: intl.formatMessage({
                        id: "productFeatures.plan",
                        defaultMessage: "Which plan are you interested in?"
                    }) + " *",
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2vYc0.default), {
                                    ...fieldProps,
                                    options: options,
                                    onChange: (edition)=>{
                                        const value = edition.currentTarget.value;
                                        setFieldValue("edition", value);
                                        setFieldValue("plan", value);
                                        fieldProps.onChange;
                                    }
                                }),
                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                    children: planErrorMessage
                                })
                            ]
                        })
                }),
                [
                    "Jira Software",
                    "Jira",
                    "Confluence",
                    "Jira Service Management",
                    "Bitbucket",
                    "Jira Work Management",
                    "Atlassian Access",
                    "Atlassian Guard",
                    "Opsgenie",
                    "Trello",
                    "Jira Align",
                    "Jira Product Discovery",
                    ...!sunsetCompass ? [
                        "Compass"
                    ] : [],
                    "Atlas",
                    "Rovo",
                    "Loom",
                    "Jira Service Management Assets",
                    "Jira Service Management Virtual Service Agent",
                    "Teamwork Collection",
                    "Strategy Collection",
                    "Service Collection",
                    "Confluence Cloud Backup and Restore",
                    "Jira Cloud Backup and Restore",
                    "Jira Service Management Cloud Backup and Restore",
                    "Confluence Additional Sandbox",
                    "Jira Additional Sandbox",
                    "Jira Service Management Additional Sandbox",
                    "Jira Product Discovery Additional Sandbox",
                    ...atlassianIsolatedCloudEnabled ? [
                        (0, $9xhTf.ATLASSIAN_ISOLATED_CLOUD_PRODUCT)
                    ] : []
                ].includes(product) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                    name: "numberOfUsers",
                    label: product === "Jira Service Management" ? numberOfPeopleSupported : product === "Jira Align" || product === "Jira Product Discovery" || !sunsetCompass && product === "Compass" || product === "Atlas" || product === "Confluence Additional Sandbox" || product === "Jira Additional Sandbox" || product === "Jira Service Management Additional Sandbox" || product === "Jira Product Discovery Additional Sandbox" ? numberOfDevelopersOnTeam : product === "Jira Service Management Assets" ? numberOfAssets : product === "Jira Service Management Virtual Service Agent" ? numberOfAgentConversations : numberOfPeopleOnTeam,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3bkHm.NumberOfUsersInput), {
                                    ...fieldProps,
                                    onChangeHandler: (numberOfUsers)=>{
                                        setFieldValue("numberOfUsers", Number(numberOfUsers));
                                        fieldProps.onChange;
                                    }
                                }),
                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                    children: product === "Jira Service Management" ? numberOfPeopleJSMErrorMessage : product === "Jira Service Management Assets" || product === "Jira Service Management Virtual Service Agent" ? genericRequiredFieldErrorMessage : numberOfPeopleOnTeamErrorMessage
                                })
                            ]
                        })
                })
            ]
        });
    };
    // @ts-ignore
    const handleBlurEvent = (event)=>{
        const { name: name, value: value } = event.currentTarget;
        if (name === "email") {
            if (!value) {
                setFieldHasError({
                    ...fieldHasError,
                    [name]: true
                });
                setErrorMessageText("NOT_EMAIL");
                setIsInvalid(true);
            } else if ((0, $9xhTf.isEmailFormat)(value) && !(0, $9xhTf.isPersonalDomain)(value)) {
                setFieldHasError({
                    ...fieldHasError,
                    [name]: false
                });
                setErrorMessageText("IS_VALID");
                setIsInvalid(false);
            } else {
                setFieldHasError({
                    ...fieldHasError,
                    [name]: true
                });
                setIsInvalid(true);
                if (!(0, $9xhTf.isEmailFormat)(value)) setErrorMessageText("NOT_EMAIL");
                else if ((0, $9xhTf.isPersonalDomain)(value)) setErrorMessageText("PERSONAL_DOMAIN");
            }
        } else {
            setFieldHasError({
                ...fieldHasError,
                [name]: !value
            });
            setIsInvalid(!value);
        }
    };
    /*
      Error Messages
  */ const personalDomainErrorMessage = intl.formatMessage({
        id: "productFeatures.personalDomainErrorMessage",
        defaultMessage: "Enter an email with a company domain."
    });
    const notEmailErrorMessage = intl.formatMessage({
        id: "productFeatures.notEmailErrorMessage",
        defaultMessage: "Enter a valid email address."
    });
    const jobTitleErrorMessage = intl.formatMessage({
        id: "productFeatures.jobTitleErrorMessage",
        defaultMessage: "Your job title is required."
    });
    const firstNameErrorMessage = intl.formatMessage({
        id: "productFeatures.firstNameErrorMessage",
        defaultMessage: "Your first name is required."
    });
    const lastNameErrorMessage = intl.formatMessage({
        id: "productFeatures.lastNameErrorMessage",
        defaultMessage: "Your last name is required."
    });
    const companyErrorMessage = intl.formatMessage({
        id: "productFeatures.companyErrorMessage",
        defaultMessage: "Your company name is required."
    });
    const productErrorMessage = intl.formatMessage({
        id: "productFeatures.productErrorMessage",
        defaultMessage: "Select a product or service to continue."
    });
    const planErrorMessage = intl.formatMessage({
        id: "productFeatures.planErrorMessage",
        defaultMessage: "Select any cloud plan to continue."
    });
    const numberOfPeopleOnTeamErrorMessage = intl.formatMessage({
        id: "productFeatures.numberOfPeopleOnTeamErrorMessage",
        defaultMessage: "Your team size is required."
    });
    const numberOfPeopleJSMErrorMessage = intl.formatMessage({
        id: "productFeatures.numberOfPeopleSupportedErrorMessage",
        defaultMessage: "We need to know how many people contact your service desk."
    });
    const genericRequiredFieldErrorMessage = intl.formatMessage({
        id: "productFeatures.genericRequiredFieldErrorMessage",
        defaultMessage: "This field is required."
    });
    const HandleSubmit = (form)=>{
        const errors = {};
        // eslint-disable-next-line @typescript-eslint/no-for-in-array
        for(const field in form)if (form[field] === undefined || fieldHasError[field]) {
            const errorFields = [
                "email",
                "firstName",
                "lastName",
                "company",
                "title",
                "product",
                "plan",
                "numberOfUsers",
                "opportunity_Description__c"
            ];
            if (errorFields.includes(field)) errors[field] = true;
        }
        if (Object.keys(errors).length > 0) return errors;
        else return (0, $9xhTf.submitContactForm)(form, "product-features", createAnalyticsEvent).then(()=>{
            window.location.assign(redirectPath);
        }).catch(()=>{
            document.querySelector(".post-submit")?.classList.replace("post-submit", "post-submit-error");
        });
    };
    const loggedOutView = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hhv63.ConsentHubClientConfigProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.SelectedProductProvider), {
            selectedProduct: selectedProduct,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_syaz1533 _vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4q6fz _k48pbfng _vwz41tcg"
                ]),
                style: {
                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _1ul91ssb _p12f1o9t"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syaz1533"
                                ]),
                                style: {
                                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: getOrAsk
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                                onSubmit: HandleSubmit,
                                children: ({ formProps: formProps, setFieldValue: setFieldValue, getState: getState })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                                        ...formProps,
                                        className: (0, $2jatx.default)([
                                            "_18dc18gv _ytel1j6v _jgjs8pqr _wdh21uxz _mg90ftgi _10wcidpf _ruzhftgi _19tgidpf _1lqt1txw _1t901bp4 _1bsb1osq _hi82bfng _lmjx1k92 _1noh18gv _tyq318gv _1oya1j6v _18961uxz _1pxw1tcg _10rvglyw _1vua18gv _y9t31j6v _1krm1j6v _dmb71tcg _9bbqidpf _1qqcidpf _wzdj1rga _yh561j28 _ud0z14y2 _1c1o8pqr _1iiy18gv _1c251nn1 _1h2z17ve _iu668pqr _s58r3x1v _1kmwmzrp _dvul17ve _bxhfviql _v71b14y2 _1jd91hrf _121j1h6o _16w9idpf _lyghidpf _x68d1rga _1c8s1j28 _wqgk8pqr _16im8pqr _15re1k8s _1kylkwu8 _v0s8cs5v _1o6rg42f _1hod15vq _1rzv15vq _1k52kb7n _l85aj6kd _upgaglyw _mnhm1ule _rr0p1uxz"
                                        ]),
                                        style: {
                                            "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
                                            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                    name: "email",
                                                    label: yourCompanyEmail,
                                                    validate: (value)=>{
                                                        setFieldValue("email", value);
                                                    },
                                                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                    ...fieldProps,
                                                                    value: fieldProps.value || "",
                                                                    onBlur: handleBlurEvent
                                                                }),
                                                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                    children: errorMessageText === "PERSONAL_DOMAIN" ? personalDomainErrorMessage : notEmailErrorMessage
                                                                }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                    children: personalEmailDomainsError
                                                                })
                                                            ]
                                                        })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kR3EL.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                                                        layout: "6-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "firstName",
                                                                label: intl.formatMessage({
                                                                    id: "productFeatures.forename",
                                                                    defaultMessage: "First name"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                                ...fieldProps,
                                                                                value: fieldProps.value || "",
                                                                                onBlur: handleBlurEvent
                                                                            }),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: firstNameErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "lastName",
                                                                label: intl.formatMessage({
                                                                    id: "productFeatures.surname",
                                                                    defaultMessage: "Last name"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                                ...fieldProps,
                                                                                value: fieldProps.value || "",
                                                                                onBlur: handleBlurEvent
                                                                            }),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: lastNameErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1rGpC.Row), {
                                                        layout: "6-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "company",
                                                                label: intl.formatMessage({
                                                                    id: "productFeatures.company",
                                                                    defaultMessage: "Company"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                                ...fieldProps,
                                                                                value: fieldProps.value || "",
                                                                                onBlur: handleBlurEvent
                                                                            }),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: companyErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            }),
                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                                name: "title",
                                                                label: intl.formatMessage({
                                                                    id: "productFeatures.title",
                                                                    defaultMessage: "Job title"
                                                                }) + " *",
                                                                children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                                ...fieldProps,
                                                                                value: fieldProps.value || "",
                                                                                onBlur: handleBlurEvent
                                                                            }),
                                                                            error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                                children: jobTitleErrorMessage
                                                                            })
                                                                        ]
                                                                    })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                    name: "product",
                                                    label: intl.formatMessage({
                                                        id: "productFeatures.product",
                                                        defaultMessage: "Which product or service are you inquiring about?"
                                                    }) + " *",
                                                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.ProductSelector), {
                                                                    ...fieldProps,
                                                                    onChangeHandler: (product, platform)=>{
                                                                        setFieldValue("product", product);
                                                                        setFieldValue("platform", platform);
                                                                        setSelectedProduct(product);
                                                                    }
                                                                }),
                                                                error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                    children: productErrorMessage
                                                                }) || /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                    children: intl.formatMessage({
                                                                        id: "productFeatures.productHelper",
                                                                        defaultMessage: "If you\u2019re asking about multiple products, select the one with the most users."
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                })
                                            }),
                                            conditionalFields(selectedProduct, getState, setFieldValue),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                children: (0, $e0MOs.QuestionField)("product-features", handleBlurEvent)
                                            }),
                                            (0, $lBgvn.ConsentInfo)(setFieldValue),
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gacwQ.default), {
                                                align: "start",
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), {
                                                            inputType: "button",
                                                            text: intl.formatMessage({
                                                                id: "productFeatures.submit",
                                                                defaultMessage: "Submit"
                                                            }),
                                                            type: "primary",
                                                            color: isInvalid ? "gray" : "darkblue",
                                                            onClick: ()=>{
                                                                formProps.onSubmit();
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                        className: "post-submit",
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                            children: intl.formatMessage({
                                                                id: "productFeatures.submitError",
                                                                defaultMessage: "An error has occurred. Please try again later."
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dzInA.default), {})
                ]
            })
        })
    });
    const loggedInView = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hhv63.ConsentHubClientConfigProvider), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.SelectedProductProvider), {
            selectedProduct: selectedProduct,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_syaz1533 _vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4q6fz _k48pbfng _vwz41tcg"
                ]),
                style: {
                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _1ul91ssb _p12f1o9t"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syaz1533"
                                ]),
                                style: {
                                    "--_ybu31g": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light900"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: getOrAsk
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                                    onSubmit: HandleSubmit,
                                    children: ({ formProps: formProps, setFieldValue: setFieldValue, getState: getState })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                                            ...formProps,
                                            className: (0, $2jatx.default)([
                                                "_18dc18gv _ytel1j6v _jgjs8pqr _wdh21uxz _mg90ftgi _10wcidpf _ruzhftgi _19tgidpf _1lqt1txw _1t901bp4 _1bsb1osq _hi82bfng _lmjx1k92 _1noh18gv _tyq318gv _1oya1j6v _18961uxz _1pxw1tcg _10rvglyw _1vua18gv _y9t31j6v _1krm1j6v _dmb71tcg _9bbqidpf _1qqcidpf _wzdj1rga _yh561j28 _ud0z14y2 _1c1o8pqr _1iiy18gv _1c251nn1 _1h2z17ve _iu668pqr _s58r3x1v _1kmwmzrp _dvul17ve _bxhfviql _v71b14y2 _1jd91hrf _121j1h6o _16w9idpf _lyghidpf _x68d1rga _1c8s1j28 _wqgk8pqr _16im8pqr _15re1k8s _1kylkwu8 _v0s8cs5v _1o6rg42f _1hod15vq _1rzv15vq _1k52kb7n _l85aj6kd _upgaglyw _mnhm1ule _rr0p1uxz"
                                            ]),
                                            style: {
                                                "--_1avknp6": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.red")),
                                                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                    children: intl.formatMessage({
                                                        id: "productFeatures.contactInfo",
                                                        defaultMessage: "You're logged in as:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                                    children: setFieldValue("email", userInfo.email)
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                                    children: setFieldValue("name", userInfo.name)
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                                    className: (0, $2jatx.default)([
                                                        "_1wyb1k92"
                                                    ]),
                                                    children: [
                                                        userInfo.name,
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                                        userInfo.email
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1wyboqnp _syaz1ep1 _59381r31 _yha2glyw _1nmznqa1 _43ds1ep1 _1hw71o8l _1r8v1ul9 _1enu1j6v _6b8d1j28"
                                                    ]),
                                                    style: {
                                                        "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                                            href: "#changeContactInfo",
                                                            onClick: ()=>setChangeContactInfo(true),
                                                            children: [
                                                                intl.formatMessage({
                                                                    id: "productFeatures.updateInfo",
                                                                    defaultMessage: "Update contact info"
                                                                }),
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_z6uan7od"
                                                                    ]),
                                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                                                        label: ""
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
                                                            href: getSwitchAccountURL(),
                                                            children: [
                                                                intl.formatMessage({
                                                                    id: "productFeatures.differentAccount",
                                                                    defaultMessage: "Log in with a different Atlassian account"
                                                                }),
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                                    className: (0, $2jatx.default)([
                                                                        "_z6uan7od"
                                                                    ]),
                                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                                                        label: ""
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                        name: "title",
                                                        label: intl.formatMessage({
                                                            id: "productFeatures.yourJobTitle",
                                                            defaultMessage: "Your job title"
                                                        }) + " *",
                                                        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                                                                        ...fieldProps,
                                                                        value: fieldProps.value || "",
                                                                        onBlur: handleBlurEvent
                                                                    }),
                                                                    error && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.ErrorMessage), {
                                                                        children: jobTitleErrorMessage
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                        children: intl.formatMessage({
                                                                            id: "productFeatures.yourJobTitleHelper",
                                                                            defaultMessage: "We ask this to connect you to the best expert for your role."
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
                                                        name: "product",
                                                        label: intl.formatMessage({
                                                            id: "productFeatures.product",
                                                            defaultMessage: "Which product or service are you inquiring about?"
                                                        }) + " *",
                                                        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izhAl.ProductSelector), {
                                                                        ...fieldProps,
                                                                        onChangeHandler: (product, platform)=>{
                                                                            setFieldValue("product", product);
                                                                            setFieldValue("platform", platform);
                                                                            setSelectedProduct(product);
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ff3wF.HelperMessage), {
                                                                        children: intl.formatMessage({
                                                                            id: "productFeatures.productHelper",
                                                                            defaultMessage: "If you\u2019re asking about multiple products, select the one with the most users."
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                    })
                                                }),
                                                conditionalFields(selectedProduct, getState, setFieldValue),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kR3EL.default), {
                                                    children: (0, $e0MOs.QuestionField)("product-features", handleBlurEvent)
                                                }),
                                                (0, $lBgvn.ConsentInfo)(setFieldValue),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $gacwQ.default), {
                                                    align: "start",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), {
                                                                inputType: "button",
                                                                text: intl.formatMessage({
                                                                    id: "productFeatures.submit",
                                                                    defaultMessage: "Submit"
                                                                }),
                                                                type: "primary",
                                                                color: isInvalid ? "gray" : "darkblue",
                                                                onClick: ()=>{
                                                                    formProps.onSubmit();
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: "post-submit",
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                                children: intl.formatMessage({
                                                                    id: "productFeatures.submitError",
                                                                    defaultMessage: "An error has occurred. Please try again later."
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dzInA.default), {})
                ]
            })
        })
    });
    if (userInfo.isUserLoggedIn) {
        if (userInfo.email) {
            if ((0, $9xhTf.isPersonalDomain)(userInfo.email) || userInfo.email.includes("atlassian.com") || changeContactInfo) return loggedOutView;
            else return loggedInView;
        }
    }
    return loggedOutView;
};
var $dcd2ef245dc372ce$export$2e2bcd8739ae039 = $dcd2ef245dc372ce$var$ProductFeatures;

});
parcelRegister("dzInA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a1d3e4edc8eee72b$export$2e2bcd8739ae039; });
/* pf-resource-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $7iXNu = parcelRequire("7iXNu");
const $a1d3e4edc8eee72b$var$resourceCardsStyling = null;
const $a1d3e4edc8eee72b$var$ProductFeaturesResourceCards = ()=>{
    const intl = (0, $8e22h.default)();
    const roadMapsText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.ViewRoadmaps",
        defaultMessage: "View roadmaps"
    });
    const advancedFeaturesText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.AdvancedFeatures",
        defaultMessage: "See advanced features"
    });
    const browseResourcesText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.BrowseResources",
        defaultMessage: "Browse resources"
    });
    const productFeaturesResourceCards = [
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.FeatureRoadmaps",
                defaultMessage: "Feature Roadmaps"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.FeatureRoadmaps.dsc",
                defaultMessage: "See what's in our pipeline for Cloud and Data Center products."
            }),
            buttonText: roadMapsText,
            url: (0, $kooLp.useLocalizedHref)("/roadmap/cloud")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.CloudPremium",
                defaultMessage: "Cloud Premium products"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.CloudPremium.dsc",
                defaultMessage: "Learn about advanced product features for enterprises."
            }),
            buttonText: advancedFeaturesText,
            url: (0, $kooLp.useLocalizedHref)("/software/premium")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.EnterpriseResources",
                defaultMessage: "More enterprise resources"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ProductFeatures.ResourceCard.EnterpriseResources.dsc",
                defaultMessage: "View resources, filtered by Cloud and Data Center product features."
            }),
            buttonText: browseResourcesText,
            url: (0, $kooLp.useLocalizedHref)("/enterprise/resources?format=&topic=product-features&platform=")
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: productFeaturesResourceCards.map((cardProps)=>/*#__PURE__*/ (0, $1oC0p.createElement)((0, $7iXNu.default), {
                ...cardProps,
                key: cardProps.header
            }))
    });
};
var $a1d3e4edc8eee72b$export$2e2bcd8739ae039 = $a1d3e4edc8eee72b$var$ProductFeaturesResourceCards;

});


parcelRegister("5mbMi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5cfb88b10600634a$export$2e2bcd8739ae039; });
/* technical-support.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $fJP6M = parcelRequire("fJP6M");

var $kooLp = parcelRequire("kooLp");
const $5cfb88b10600634a$var$containerStyle = null;
const $5cfb88b10600634a$var$innerContainerStyle = null;
const $5cfb88b10600634a$var$textContainer = null;
const $5cfb88b10600634a$var$buttonStyle = null;
const $5cfb88b10600634a$var$buttonContainer = null;
const $5cfb88b10600634a$var$TechnicalSupport = ()=>{
    const intl = (0, $8e22h.default)();
    const contactSupportText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.techical-support.contact-support",
        defaultMessage: "Contact support"
    });
    const supportServiceText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.techical-support.support-service",
        defaultMessage: ` If your question is related to purchasing additional support services, select \u{201C}product features\u{201D} or \u{201C}pricing & quotes\u{201D}.`
    });
    const assistanceText = intl.formatMessage({
        id: "enterpriseContactSalesTemplate.techical-support.assistance",
        defaultMessage: "For assistance with a service you already pay for, please raise a support ticket."
    });
    const localizedURL = "https://support.atlassian.com" + (0, $kooLp.useLocalizedHref)("/contact/");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_vchhusvi _1e0c1txw _1n261g80 _1bah1yb4 _p12f1fra _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _ect4y94u"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ae4v1y6m _vchhusvi _1e0c1txw _i0dlf1ug _16jlcs5v _1o9zkb7n _1n261g80 _p12f1c1k _1ul91ssb"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1pfh14y2 _6rth1l7b _1wybgktf _k48p1nn1 _1dyznl7k _vwz41f4h _s7n41q9y _syazvwuj"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: supportServiceText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            children: assistanceText
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_1pfh1ylp"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.default), {
                        text: contactSupportText,
                        "aria-label": contactSupportText,
                        color: "darkblue",
                        url: localizedURL,
                        dataEventProps: {
                            "data-product-key": "jiraSoftwareFeature",
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-label": contactSupportText
                        },
                        className: (0, $2jatx.default)([
                            "_18s81ag2 _k48pbfng _1tke1ylp _3fcw1g80 _s7n41q9y _d5ymcfaq _ect4lnmy _6rth1tcg"
                        ])
                    })
                })
            ]
        })
    });
};
var $5cfb88b10600634a$export$2e2bcd8739ae039 = $5cfb88b10600634a$var$TechnicalSupport;

});






//# sourceMappingURL=enterprise-contact-sales-page.1dbb5765.js.map
